(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ngClickCopy'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('training-requirements', {
            parent: 'training_menu',
            url: '/training-requirements?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.training.trainingRequirements.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/training-requirements/training-requirements.html',
                    controller: 'TrainingRequirementsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: '(u.last_name),asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('TrainingRequirements', TrainingRequirements);

    TrainingRequirements.$inject = ['$resource', 'DateUtils'];

    function TrainingRequirements($resource, DateUtils) {
        var resourceUrl = 'api/training-requirements';

        return $resource(resourceUrl, {} , {
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.validToDate = DateUtils.convertDateTimeFromServer(data.validToDate);
                    }
                    return data;
                }
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingRequirementsController', TrainingRequirementsController);

    TrainingRequirementsController.$inject = ['$scope', '$state', '$stateParams', 'TrainingRequirements', 'paginationConstants', 'pagingParams', 'ParseLinks'];

    function TrainingRequirementsController ($scope, $state, $stateParams, TrainingRequirements, paginationConstants, pagingParams, ParseLinks) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            TrainingRequirements.get({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== '(u.last_name)') {
                    result.push('(u.last_name)');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trainingRequirements = data;
                vm.page = pagingParams.page;

                console.log('onSuccess -> data');
                console.log(data);
            }
            function onError(error) {}
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingRecordDialogController', TrainingRecordDialogController);

    TrainingRecordDialogController.$inject = ['$rootScope','$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TrainingRecord', 'TrainingRepositoryTrainingEventSelect', 'User', 'Company'];

    function TrainingRecordDialogController ($rootScope, $timeout, $scope, $stateParams, $uibModalInstance, entity, TrainingRecord, TrainingRepositoryTrainingEventSelect, User, Company) {
        var vm = this;

        vm.trainingRecord = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.isIndependentStudy = vm.trainingRecord.trainingEvent != null && vm.trainingRecord.trainingEvent.training.trainingType == 'INDEPENDENT';
        vm.trainingevents = TrainingRepositoryTrainingEventSelect.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.trainingRecord.id !== null) {
                TrainingRecord.update(vm.trainingRecord, onSaveSuccess, onSaveError);
            } else {
                vm.trainingRecord.company = $rootScope.getSelectedCompanyFromServer();
                TrainingRecord.save(vm.trainingRecord, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:trainingRecordUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.signupDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingRecordDetailController', TrainingRecordDetailController);

    TrainingRecordDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrainingRecord', 'TrainingEvent', 'User', 'Company'];

    function TrainingRecordDetailController($scope, $rootScope, $stateParams, previousState, entity, TrainingRecord, TrainingEvent, User, Company) {
        var vm = this;

        vm.trainingRecord = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:trainingRecordUpdate', function(event, result) {
            vm.trainingRecord = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingRecordDeleteController',TrainingRecordDeleteController);

    TrainingRecordDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrainingRecord'];

    function TrainingRecordDeleteController($uibModalInstance, entity, TrainingRecord) {
        var vm = this;

        vm.trainingRecord = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TrainingRecord.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('training-record', {
            parent: 'training_menu',
            url: '/training-record?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.trainingRecord.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/training-record/training-records.html',
                    controller: 'TrainingRecordController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trainingRecord');
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingEventSignup');
                    $translatePartialLoader.addPart('trainingEvent');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('training-record-detail', {
            parent: 'training_menu',
            url: '/training-record/{id}',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.trainingRecord.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/training-record/training-record-detail.html',
                    controller: 'TrainingRecordDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trainingRecord');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrainingRecord', function($stateParams, TrainingRecord) {
                    return TrainingRecord.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'training-record',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('training-record-detail.edit', {
            parent: 'training-record-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-record/training-record-dialog.html',
                    controller: 'TrainingRecordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TrainingRecord', function(TrainingRecord) {
                            return TrainingRecord.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('training-record.new', {
            parent: 'training-record',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-record/training-record-dialog.html',
                    controller: 'TrainingRecordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                signupDate: null,
                                examPassed: null,
                                traineeSignedDate: null,
                                id: null,
                                validToDate: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('training-record', null, { reload: 'training-record' });
                }, function() {
                    $state.go('training-record');
                });
            }]
        })
        .state('training-record.edit', {
            parent: 'training-record',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-record/training-record-dialog.html',
                    controller: 'TrainingRecordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TrainingRecord', function(TrainingRecord) {
                            return TrainingRecord.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training-record', null, { reload: 'training-record' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('training-record.delete', {
            parent: 'training-record',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-record/training-record-delete-dialog.html',
                    controller: 'TrainingRecordDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TrainingRecord', function(TrainingRecord) {
                            return TrainingRecord.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training-record', null, { reload: 'training-record' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('TrainingRecord', TrainingRecord);

    TrainingRecord.$inject = ['$resource', 'DateUtils'];

    function TrainingRecord ($resource, DateUtils) {
        var resourceUrl =  'api/training-records/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.signupDate = DateUtils.convertDateTimeFromServer(data.signupDate);
                        data.traineeSignedDate = DateUtils.convertDateTimeFromServer(data.traineeSignedDate);
                        data.validToDate = DateUtils.convertDateTimeFromServer(data.validToDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    
    angular.module('abcQualityMatchApp')
           .factory('TrainingRepositoryTrainingEventSelect', TrainingRepositoryTrainingEventSelect);
    TrainingRepositoryTrainingEventSelect.$inject = ['$resource'];
    function TrainingRepositoryTrainingEventSelect($resource, DateUtils) {
        var resourceUrl = 'api/training-events/training-record-select-list';
        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingRecordController', TrainingRecordController);

    TrainingRecordController.$inject = ['$scope', '$state', 'TrainingRecord', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TrainingRecordController ($scope, $state, TrainingRecord, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            TrainingRecord.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trainingRecords = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('TrainingEventPrepare', TrainingEventPrepare);

    TrainingEventPrepare.$inject = ['$resource', 'DateUtils'];

    function TrainingEventPrepare ($resource, DateUtils) {
        var resourceUrl =  'api/training-events-preparenew';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                params: {trainingId: '@trainingId'},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.start = DateUtils.convertDateTimeFromServer(data.start);
                        data.end = DateUtils.convertDateTimeFromServer(data.end);
                    }
                    return data;
                }
            },
        });
    }
    
    angular
        .module('abcQualityMatchApp')
        .factory('TrainingEventEnder', TrainingEventEnder);

    TrainingEventEnder.$inject = ['$resource', 'DateUtils'];
    
    function TrainingEventEnder ($resource, DateUtils) {
        var resourceUrl =  'api/training-events-end-event';

        return $resource(resourceUrl, {}, {
            'update': { 
                method:'PUT' 
            }
        });
    }
    
    
    angular
        .module('abcQualityMatchApp')
        .factory('TrainingEventProgress', TrainingEventProgress);

    TrainingEventProgress.$inject = ['$resource', 'DateUtils'];
    
    function TrainingEventProgress ($resource, DateUtils) {
        var resourceUrl =  'api/training-events-update-progress';

        return $resource(resourceUrl, {}, {
            'update': { 
                method:'PUT' 
            }
        });
    }
    
    
    
    angular
        .module('abcQualityMatchApp')
        .factory('TrainingEventSignupList', TrainingEventSignupList);

    TrainingEventSignupList.$inject = ['$resource', 'DateUtils'];
    function TrainingEventSignupList ($resource) {
        var resourceUrl =  'api/training-event-signups/for-event/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
        
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingEventInstructorViewController', TrainingEventInstructorViewController);

    TrainingEventInstructorViewController.$inject = ['$translate','$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TrainingEventProgress', 'TrainingEventEnder'];

    function TrainingEventInstructorViewController ($translate, $timeout, $scope, $stateParams, $uibModalInstance, entity, TrainingEventProgress, TrainingEventEnder) {
        var vm = this;

        vm.trainingEvent = entity;
        vm.clear = clear;
        vm.save = save;
        vm.endTraining = false;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            if (vm.endTraining){
                TrainingEventEnder.update(vm.trainingEvent, onSaveSuccess, onSaveError);
            }
            else{
                TrainingEventProgress.update(vm.trainingEvent, onSaveSuccess, onSaveError); 
            }
        }
        
        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:trainingEventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        
        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingEventDialogController', TrainingEventDialogController);

    TrainingEventDialogController.$inject =
        ['$translate','$timeout', '$scope',
            '$stateParams', '$uibModalInstance', 'entity',
            'TrainingEvent', 'Company', 'User',
            'Training', 'TrainingEventSignupList', 'UserGroup'];

    function TrainingEventDialogController(
        $translate, $timeout, $scope,
        $stateParams, $uibModalInstance, entity,
        TrainingEvent, Company, User,
        Training, TrainingEventSignupList, UserGroup) {

        var vm = this;

        vm.trainingEvent = entity;
        vm.trainingEvent.signups = [];
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.newSignup = createEmptySignup();
        vm.addSignup = addSignup;
        vm.deleteSignup = deleteSignup;

        vm.userGroupSelectList = UserGroup.selectList();
        vm.newUserGroupForSignupLimitLimit = null;

        if (vm.trainingEvent.id){
            loadSignups();
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });


        function loadSignups() {
            TrainingEventSignupList.query({id: vm.trainingEvent.id}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.trainingEvent.signups = data;
            }
            function onError(error) {
                console.log("failed");
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.trainingEvent.id !== null) {
                TrainingEvent.update(vm.trainingEvent, onSaveSuccess, onSaveError);
            } else {
                TrainingEvent.save(vm.trainingEvent, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:trainingEventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }


        function addSignup() {

            if (vm.newSignup.user === null){
                return;
            }
            vm.newSignup.signupDate = new Date();

            var userAlreadySignedup = vm.trainingEvent.signups.find(function(signup){return signup.user.id == vm.newSignup.user.id});
            if (userAlreadySignedup){
                vm.newSignup = createEmptySignup();
                return;
            }


            vm.trainingEvent.signups.push(vm.newSignup);
            vm.newSignup = createEmptySignup();
            return false;
        }

        function deleteSignup(index){
            vm.trainingEvent.signups.splice(index,1);
            return false;

        }

        function createEmptySignup(){
            return {
                user: null,
                signupDate: null,
                signupAccepted: true,
                examPassed: false
            };
        }

        vm.deleteSignupLimitGroup = function(index){
            vm.trainingEvent.userGroupSignupLimits.splice(index,1);
        };

        vm.addUserGroupLimit = function(){

            if (vm.newUserGroupForSignupLimitLimit != null) {

                var alreadyAdded = false;
                vm.trainingEvent.userGroupSignupLimits.forEach(function (groupLimit) {
                    if (groupLimit.userGroup.id == vm.newUserGroupForSignupLimitLimit.id) {
                        alreadyAdded = true;
                    }
                });
                if (!alreadyAdded) {

                    var groupLimit ={
                        id: null,
                        userGroup: vm.newUserGroupForSignupLimitLimit
                    }

                    vm.trainingEvent.userGroupSignupLimits.push(groupLimit);
                }
            }
            vm.newUserGroupForSignupLimitLimit = null;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingEventDetailController', TrainingEventDetailController);

    TrainingEventDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TrainingEventSignupList'];

    function TrainingEventDetailController($scope, $rootScope, $stateParams, previousState, entity, TrainingEventSignupList) {
        var vm = this;

        vm.trainingEvent = entity;
        vm.trainingEvent.signups = [];
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:trainingEventUpdate', function(event, result) {
            vm.trainingEvent = result;
            vm.trainingEvent.signups = [];
            loadSignups();
        });
        $scope.$on('$destroy', unsubscribe);
        
        loadSignups();
        
        function loadSignups() {
            TrainingEventSignupList.query({id: vm.trainingEvent.id}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.trainingEvent.signups = data;
            }
            function onError(error) {
                console.log("failed");
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingEventDeleteController',TrainingEventDeleteController);

    TrainingEventDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrainingEvent'];

    function TrainingEventDeleteController($uibModalInstance, entity, TrainingEvent) {
        var vm = this;

        vm.trainingEvent = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        vm.showDeleteHint = false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TrainingEvent.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                },onError);
        }
        
        function onError(result){
            if (result.status === 409){
                vm.showDeleteHint = true; 
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('training-event', {
            parent: 'training_menu',
            url: '/training-event?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.trainingEvent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/training-event/training-events.html',
                    controller: 'TrainingEventController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'start,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trainingEvent');
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('trainingEventSignup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('training-event-detail', {
            parent: 'training_menu',
            url: '/training-event/{id}',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.trainingEvent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/training-event/training-event-detail.html',
                    controller: 'TrainingEventDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trainingEvent');
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('trainingEventSignup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrainingEvent', function($stateParams, TrainingEvent) {
                    return TrainingEvent.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'training-event',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('training-event-detail.edit', {
            parent: 'training-event-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-event/training-event-dialog.html',
                    controller: 'TrainingEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TrainingEvent', function(TrainingEvent) {
                            return TrainingEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('training-event.new', {
            parent: 'training-event',
            url: '/new?trainingId',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-event/training-event-dialog.html',
                    controller: 'TrainingEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TrainingEventPrepare', function(TrainingEventPrepare) {
                            return TrainingEventPrepare.get({trainingId : $stateParams.trainingId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training-event', null, { reload: 'training-event' });
                }, function() {
                    $state.go('training-event');
                });
            }]
        })
        .state('training-event.edit', {
            parent: 'training-event',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-event/training-event-dialog.html',
                    controller: 'TrainingEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TrainingEvent', function(TrainingEvent) {
                            return TrainingEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training-event', null, { reload: 'training-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('training-event.delete', {
            parent: 'training-event',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-event/training-event-delete-dialog.html',
                    controller: 'TrainingEventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TrainingEvent', function(TrainingEvent) {
                            return TrainingEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training-event', null, { reload: 'training-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('training-event.instuctor-view', {
            parent: 'training-event',
            url: '/{id}/instructor',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training-event/training-event-instructor-view.html',
                    controller: 'TrainingEventInstructorViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TrainingEvent', function(TrainingEvent) {
                            return TrainingEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training-event', null, { reload: 'training-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular.module('abcQualityMatchApp')
           .factory('TrainingEvent', TrainingEvent);
    TrainingEvent.$inject = ['$resource', 'DateUtils'];
    function TrainingEvent($resource, DateUtils) {
        var resourceUrl = 'api/training-events/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.start = DateUtils.convertDateTimeFromServer(data.start);
                        data.end = DateUtils.convertDateTimeFromServer(data.end);
                        data.validToDate = DateUtils.convertDateTimeFromServer(data.validToDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'getAvailableForSignUp': {
                url: 'api/training-events-available_for_signup',
                method: 'GET',
                isArray: true
            },
            'getIndependentTrainingAvailableForSignUp': {
                url: 'api/training-events/independent-studies-available-for-user',
                method: 'GET',
                isArray: true},
        });
    }

    angular.module('abcQualityMatchApp').filter('trainingEventViewFormat', ['dateFilter',function (dateFilter) {
        return function (trainingEvent) {
            var start = dateFilter(trainingEvent.start,'short');
            var end = '';
            if (trainingEvent.end){
                end = dateFilter(trainingEvent.end,'short');
            }
            return trainingEvent.training.name + ' ' + start + ' - ' + end ;
        };
    }]);


angular
        .module('abcQualityMatchApp')
        .factory('TrainingEventSignup', TrainingEventSignup);

    TrainingEventSignup.$inject = ['$resource', 'DateUtils'];

    function TrainingEventSignup ($resource, DateUtils) {
        var resourceUrl =  'api/training-event-signups/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.signupDate = DateUtils.convertDateTimeFromServer(data.signupDate);
                    }
                    return data;
                }
            }
        });
    }

})();

(function() {
    'use strict';
    
    angular
        .module('abcQualityMatchApp')
        .controller('TrainingEventController', TrainingEventController);

    TrainingEventController.$inject = ['$scope', '$state', 'TrainingEvent', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'TrainingForNewTrainingEvent'];

    function TrainingEventController ($scope, $state, TrainingEvent, ParseLinks, AlertService, paginationConstants, pagingParams, TrainingForNewTrainingEvent) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.trainings = TrainingForNewTrainingEvent.query();

        loadAll();
        
        

        function loadAll () {
            TrainingEvent.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trainingEvents = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('abcQualityMatchApp').component('trainingMaterial', {
          templateUrl: 'app/training-main/training/training-material.component.html',  
          bindings: {training: '<'},
          controller: TrainingMaterialController
        });

    TrainingMaterialController.$inject = ['$scope', 'TrainingRelatedMaterial','AlertService']
    function TrainingMaterialController(scope, TrainingRelatedMaterial, AlertService) {

        var ctrl = this;
        ctrl.trainingMaterials = [];

        loadAll();

        function loadAll () {
            TrainingRelatedMaterial.Materials.query( {trainingId: ctrl.training.id}, onSuccess, onError);
            function onSuccess(data) {
                ctrl.trainingMaterials = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function() {
    'use strict';


    angular
        .module('abcQualityMatchApp').filter('trainingMaterialEncodeFilename', function() {

            return function(name){ return  window.encodeURIComponent(name) };
        });

    angular
        .module('abcQualityMatchApp').filter('trainingMaterialLinkUrlAddProtocoll', function() {
            return function(url) {
                if (!url.match('^.+://')){
                    url = 'http://' + url;
                }
                return url;
            }
        });

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingDialogController', TrainingDialogController);

    TrainingDialogController.$inject = ['$uibModal','$rootScope','$translate', '$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Training', 'User','DataUtils', 'TrainingMaterial','TrainingRelatedMaterial' ,'AlertService'];

    function TrainingDialogController($uibModal, $rootScope, $translate, $timeout, $scope, $stateParams, $uibModalInstance, entity, Training, User, DataUtils, TrainingMaterial, TrainingRelatedMaterial, AlertService) {
        var vm = this;

        vm.training = entity;
        vm.training.addedMaterialids =[];
        vm.clear = clear;
        vm.save = save;
        vm.uploadingTrainingMaterial = false;



        vm.addNewChecklistItemName = addNewChecklistItemName;
        vm.deleteChecklistItem = deleteChecklistItem;
        vm.moveChecklistItem = moveChecklistItem;
        vm.addExamQuestion = addExamQuestion;
        vm.deleteExamQuestion = deleteExamQuestion;
        vm.moveExamQuestion = moveExamQuestion;


        vm.trainingMaterials = [];
        vm.uploadTrainingMaterial = uploadTrainingMaterial;
        vm.deleteTrainingMaterial = deleteTrainingMaterial;
        vm.showAddMaterialLinkDialog = showAddMaterialLinkDialog;
        vm.moveTrainingMaterial = moveTrainingMaterial;
        vm.selectedFileTooLarge = false;

        loadTrainingMaterials();

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.training.id !== null) {
                Training.update(vm.training, onSaveSuccess, onSaveError);
            } else {
                Training.save(vm.training, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:trainingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        function addNewChecklistItemName() {

            var newItem = {
                name: "",
                listIndex: vm.training.checklistItems.length
            };
            vm.training.checklistItems.push(newItem);
            return false;
        }

        function deleteChecklistItem(index) {
            vm.training.checklistItems.splice(index,1);
            updateListIndexes(vm.training.checklistItems);
            return false;
        }

        function moveChecklistItem(index, direction) {
            if(direction === "up") {
                vm.training.checklistItems[index-1].listIndex++;
                vm.training.checklistItems[index].listIndex--;
            }
            else {
                vm.training.checklistItems[index+1].listIndex--;
                vm.training.checklistItems[index].listIndex++;
            }
            vm.training.checklistItems.sort(function(a,b){
                return a.listIndex - b.listIndex;
            });
            updateListIndexes(vm.training.checklistItems);
        }


        function addExamQuestion(){
            var question = { questionText: '',
                             expectedAnswer: true,
                             listIndex: vm.training.checklistItems.length,
                         };
            vm.training.examQuestions.push(question);

            return false;
        }

        function deleteExamQuestion(index) {
            vm.training.examQuestions.splice(index,1);
            updateListIndexes(vm.training.examQuestions);
            return false;
        }

        function moveExamQuestion(index, direction) {
            if(direction === "up") {
                vm.training.examQuestions[index-1].listIndex++;
                vm.training.examQuestions[index].listIndex--;
            }
            else {
                vm.training.examQuestions[index+1].listIndex--;
                vm.training.examQuestions[index].listIndex++;
            }
            vm.training.examQuestions.sort(function(a,b){
                return a.listIndex - b.listIndex;
            });
            updateListIndexes(vm.training.examQuestions);
        }

        function updateListIndexes(list){
            list.forEach(function(currentValue, index, array) {
                currentValue.listIndex = index;
            });
        }


        function moveTrainingMaterial(index, direction){
            var tm = vm.trainingMaterials[index];

            var step = 1;
            if (direction === 'down'){
                step = -1;
            }

            var parameters = {
                newListIndex: tm.listIndex + step

            };

            if (vm.training.id > 0){
                parameters.trainingId = vm.training.id;
            }
            if (vm.training.addedMaterialids.length > 0){
                parameters.addedMaterialIds = vm.training.addedMaterialids.join();
            }


            TrainingRelatedMaterial.Order.updateListIndex({trainingMaterialId: tm.id,  inParams:parameters}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.trainingMaterials = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }


        }


        function loadTrainingMaterials() {

            var parameters = {};
            if (vm.training.id > 0){
                parameters.trainingId = vm.training.id;
            }
            if (vm.training.addedMaterialids.length > 0){
                parameters.addedMaterialIds = vm.training.addedMaterialids.join();
            }


            TrainingRelatedMaterial.Materials.query(parameters, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.trainingMaterials = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.setFileContent = function ($file, $invalidFiles) {

            vm.selectedFileTooLarge = false;
            if ($invalidFiles && $invalidFiles.length > 0){
                invalidFileSelected($invalidFiles);
                return;
            }

            if ($file == null) {
                return;
            }

            var trainingMaterial = {
                name: $file.name,
                fileContentContentType: $file.type,
                company: {},
                training: null
            };
            if (vm.training.id){
                trainingMaterial.training = vm.training;
            }


            DataUtils.toBase64($file, function(base64Data) {
                trainingMaterial.fileContent = base64Data;
                vm.uploadTrainingMaterial(trainingMaterial);
            });
        };

        function invalidFileSelected($invalidFiles){

            console.log('invalid file selected ' + JSON.stringify($invalidFiles));
            vm.selectedFileTooLarge = true;
            $timeout(function(){vm.selectedFileTooLarge = false;}, 3000);


        }

        function uploadTrainingMaterial(trainingMaterial){
            vm.selectedFileTooLarge = false;
            vm.uploadingTrainingMaterial = true;

            trainingMaterial.listIndex = vm.trainingMaterials.length;


            TrainingMaterial.save(trainingMaterial, onSuccess, onError);

            function onSuccess(trainingMaterial){
                console.log('uploaded '+  + trainingMaterial.id);
                if (trainingMaterial.training == null){
                    vm.training.addedMaterialids.push(trainingMaterial.id);
                }
                vm.uploadingTrainingMaterial = false;
                loadTrainingMaterials();
            }
            function onError (err) {
                vm.uploadingTrainingMaterial = false;
                console.log("failed to upload trainingmaterial " + err);
            }
        }

        function deleteTrainingMaterial(tm){
            TrainingMaterial.delete(tm, onSuccess, onError);

            function onSuccess(trainingMaterial){
                console.log('deleted training material');
                loadTrainingMaterials();
            }
            function onError (err) {
                console.log("failed to delete trainingmaterial " + err);
            }


        }

        function showAddMaterialLinkDialog(){

            $uibModal.open({
                templateUrl: 'app/training-main/training/training-material-add-link-dialog.html',
                controller: 'TrainingMaterialLinkController',
                controllerAs: 'vm',
                size: 'sm'
            }).result.then(function (newTrainingMaterialLinkUrl) {
                console.log("adding material link " + newTrainingMaterialLinkUrl);

                if (newTrainingMaterialLinkUrl == null || newTrainingMaterialLinkUrl.trim().length == 0){
                    console.log("newTrainingMaterialLinkUrl was empty");
                    return;
                }

                var trainingMaterial = {
                    name: "",
                    company: {},
                    training: null,
                    linkUrl: newTrainingMaterialLinkUrl
                };

                if (vm.training.id){
                    trainingMaterial.training = vm.training;
                }
                vm.uploadTrainingMaterial(trainingMaterial);
            });

        }

    }


    angular
            .module('abcQualityMatchApp')
            .controller('TrainingMaterialLinkController', TrainingMaterialLinkController);

    TrainingMaterialLinkController.$inject = ['$uibModalInstance', '$timeout'];

    function TrainingMaterialLinkController($uibModalInstance, $timeout) {
        var vm = this;
        vm.newTrainingMaterialLinkUrl = "";

        $timeout(function (){
            angular.element('#materialLink').focus();
        });

        vm.closeDialog = function() {
            $uibModalInstance.dismiss('cancel');
        }
        vm.save = function() {
            $uibModalInstance.close(vm.newTrainingMaterialLinkUrl);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingDetailController', TrainingDetailController);

    TrainingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Training', 'Company'];

    function TrainingDetailController($scope, $rootScope, $stateParams, previousState, entity, Training, Company) {
        var vm = this;

        vm.training = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:trainingUpdate', function(event, result) {
            vm.training = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
  
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingDeleteController',TrainingDeleteController);

    TrainingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Training'];

    function TrainingDeleteController($uibModalInstance, entity, Training) {
        var vm = this;

        vm.training = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Training.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('training', {
            parent: 'training_menu',
            url: '/training?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.training.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/training/trainings.html',
                    controller: 'TrainingController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('trainingExamQuestion');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('training-detail', {
            parent: 'training_menu',
            url: '/training/{id}',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.training.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/training/training-detail.html',
                    controller: 'TrainingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('trainingExamQuestion');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Training', function($stateParams, Training) {
                    return Training.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'training',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('training-detail.edit', {
            parent: 'training-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training/training-dialog.html',
                    controller: 'TrainingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Training', function(Training) {
                            return Training.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('training.new', {
            parent: 'training',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training/training-dialog.html',
                    controller: 'TrainingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                trainingPoints: null,
                                validForYears: null,
                                trainingType: null,
                                id: null,
                                checklistItems: [],
                                examQuestions: [],
                                organization: null,
                                examPassRequiredPercent: null,
                                deleted:false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('training', null, { reload: 'training' });
                }, function() {
                    $state.go('training');
                });
            }]
        })
        .state('training.edit', {
            parent: 'training',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training/training-dialog.html',
                    controller: 'TrainingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Training', function(Training) {
                            return Training.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training', null, { reload: 'training' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('training.delete', {
            parent: 'training',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/training/training-delete-dialog.html',
                    controller: 'TrainingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Training', function(Training) {
                            return Training.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('training', null, { reload: 'training' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('Training', Training);

    Training.$inject = ['$resource'];

    function Training($resource) {
        var resourceUrl = 'api/trainings/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
    
    
    angular.module('abcQualityMatchApp')
           .factory('TrainingForNewTrainingEvent', TrainingForNewTrainingEvent);
    TrainingForNewTrainingEvent.$inject = ['$resource'];
    function TrainingForNewTrainingEvent($resource) {
        var resourceUrl = 'api/trainings/for-new-training-event-creation';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            
        });
    }
    
    
    

    angular
            .module('abcQualityMatchApp')
            .factory('TrainingRelatedMaterial', TrainingRelatedMaterial);
    TrainingRelatedMaterial.$inject = ['$resource'];

    function TrainingRelatedMaterial($resource) {
        var resourceUrl = 'api/training-materials/for-training';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }


    function TrainingRelatedMaterial($resource, DateUtils) {

        return {
            Materials: $resource('api/training-materials/for-training', {}, {'query': {method: 'GET', isArray: true}}),
            Order: $resource('api/training-materials/update-list-index/:trainingMaterialId', {}, {'updateListIndex': 
                        {method: 'POST', isArray: true,
                        params: '@inParams'
                    }
            }),
        };
    }


    angular
            .module('abcQualityMatchApp')
            .factory('TrainingMaterial', TrainingMaterial);

    TrainingMaterial.$inject = ['$resource'];

    function TrainingMaterial($resource) {
        var resourceUrl = 'api/training-materials/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }


})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingController', TrainingController);

    TrainingController.$inject = ['$scope', '$state', 'Training', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TrainingController ($scope, $state, Training, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Training.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trainings = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('training_menu', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .controller('TraineeTrainingSignUpDialogController', TraineeTrainingSignUpDialogController);

    TraineeTrainingSignUpDialogController.$inject = [
        '$uibModal', '$location', '$scope',
        '$rootScope', '$stateParams', 'previousState',
        'independentStudyTraining', 'trainingEvent','TraineeEventSignup',
        '$state'
        ];

    function TraineeTrainingSignUpDialogController(
        $uibModal, $location, $scope,
        $rootScope, $stateParams, previousState,
        independentStudyTraining, trainingEvent, TraineeEventSignup,
        $state) {
        var vm = this;

        vm.trainingEvent = trainingEvent;
        vm.independentStudyTraining = independentStudyTraining;
        vm.eventNotTakingSignUps = false;

        if (vm.independentStudyTraining != null){
            vm.training = independentStudyTraining;
        }
        else{
            vm.training = trainingEvent.training;
        }

        vm.signedUp = $stateParams.signedUp === 'true';

        vm.previousState = previousState.name;
        vm.confirmSignup = confirmSignup;
        vm.isSaving = false;
        vm.failureReason = null;


        function confirmSignup() {
            $uibModal.open({
                templateUrl: 'app/training-main/trainee/trainee-training-signup-confirm-dialog.html',
                controller: 'TrainingSignupConfirmController',
                controllerAs: 'vm',
                size: 'sm'
            }).result.then(function (confirmd) {
               if (confirmd){
                   signup();
               }
            });
        }


        function signup() {
            vm.isSaving = false;

            if (vm.independentStudyTraining){
                TraineeEventSignup.signupToIndependentStydyTraining({trainingId: vm.independentStudyTraining.id}, onSuccess, onFailure);
            }
            else{
                TraineeEventSignup.signupToTrainingEvent({trainingEventId: vm.trainingEvent.id}, onSuccess, onFailure);
            }

        }

        function onSuccess(result) {
            vm.isSaving = false;
            //location.path('/trainee/records');
            $state.go('^');
        }

        function onFailure(result) {
            vm.isSaving = false;
            if (result.status === 409){
                vm.failureReason = result.data.reason;
            }
        }

    }


    angular
            .module('abcQualityMatchApp')
            .controller('TrainingSignupConfirmController', TrainingSignupConfirmController);

    TrainingSignupConfirmController.$inject = ['$uibModalInstance'];

    function TrainingSignupConfirmController($uibModalInstance) {
        var vm = this;

        vm.closeDialog = function() {
            $uibModalInstance.dismiss('cancel');
        }
        vm.confirm = function() {
            $uibModalInstance.close(true);
        }
    }


})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TraineeStudyController', TraineeStudyController);

    TraineeStudyController.$inject = ['$timeout', '$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TraineeEventSignupExamPassed'];

    function TraineeStudyController($timeout, $scope, $rootScope, $stateParams, previousState, entity, TraineeEventSignupExamPassed) {
        var vm = this;

        vm.trainingEventSignup = entity;
        vm.trainingEvent = entity.trainingEvent;
        vm.previousState = previousState.name;
        vm.examCheckPassed = null;
        vm.checkExam = checkExam;
        vm.showExam = false;

        if (vm.trainingEventSignup.examPassed){
            vm.examCheckPassed = true;
        }

        vm.confirmMaterials = function() {
            vm.showExam = true;
        };
        
        function checkExam(){
            vm.isSaving = false;
            vm.examCheckPassed = null;
            
            var numberOfCorrectAnswers = 0;
            
            vm.trainingEvent.training.examQuestions.forEach(function(examQuestion){
                if (examQuestion.answer === examQuestion.expectedAnswer){
                        ++numberOfCorrectAnswers;
                }
            });
            
            var numberOfQuestions = vm.trainingEvent.training.examQuestions.length;
            var correctPercent = 100;
            
            if (numberOfQuestions > 0){
                correctPercent = Math.round(numberOfCorrectAnswers / numberOfQuestions * 100); 
            }
            
            var passed = true;
            if (vm.trainingEvent.training.examPassRequiredPercent){
                passed = correctPercent >= vm.trainingEvent.training.examPassRequiredPercent;
            }

            if (passed){
                vm.examCheckPassed = true;
                TraineeEventSignupExamPassed.setExamPassed({trainingEventSignupId: vm.trainingEventSignup.id}, onSaveSuccess, onSaveError);
            }
            else {
                vm.examCheckPassed = false;
                $timeout(function () { vm.examCheckPassed = null; }, 3000); 
                
            }
        }

        function onSaveSuccess (result) {
            
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TraineeSignDialogController', TraineeSignDialogController);

    TraineeSignDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TrainingRecord', 'TrainingEvent', 'User', 'Company'];

    function TraineeSignDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TrainingRecord, TrainingEvent, User, Company) {
        var vm = this;

        vm.trainingRecord = entity;
        vm.clear = clear;
        vm.save = save;
        
        vm.signed = vm.trainingRecord.traineeSignedDate != null;


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function save(){
            
            if (!vm.signed || vm.trainingRecord.traineeSignedDate != null){
                return;
            }
            vm.isSaving = false;
            
            vm.trainingRecord.traineeSignedDate = new Date();
            TrainingRecord.update(vm.trainingRecord, onSaveSuccess, onSaveError);
            
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:trainingRecordUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TraineeRecordController', TraineeRecordController);

    TraineeRecordController.$inject = ['$scope', '$state', 'TraineeRecord', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','TraineeEventSignup'];

    function TraineeRecordController ($scope, $state, TraineeRecord, ParseLinks, AlertService, paginationConstants, pagingParams,TraineeEventSignup) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.trainingEventSignups = [];

        vm.trainingRecordsExamRequired = [];
        vm.trainingRecordsSigningRequired = [];
        vm.deleteSignup = deleteSignup;
        vm.deletingSignup = false;

        loadAll();
        loadSignups();
        loadExamOrSigningRequired();
        
        function loadSignups(){
            TraineeEventSignup.query({}, success, onError);
            
            function success(data){
                vm.trainingEventSignups = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        function loadExamOrSigningRequired(){
            TraineeRecord.ExamOrSigningRequired.query({}, success, onError);
            
            function success(data){
                vm.trainingRecordsExamRequired = data.filter(function(tr){return !tr.examPassed;});
                vm.trainingRecordsSigningRequired = data.filter(function(tr){return tr.examPassed && tr.traineeSignedDate == null;});
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        


        function loadAll () {
            TraineeRecord.UserRecords.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
  
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trainingRecords = data;
                vm.page = pagingParams.page;              
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function deleteSignup(trainingEventSignupId){
           TraineeEventSignup.deleteSignup({trainingEventSignupId: trainingEventSignupId}, onSuccess, onFailure);

           function onSuccess(result) {
               vm.deletingSignup = false;
               loadSignups();
           }

           function onFailure(result) {
               vm.deletingSignup  = false;
           }

        }
    }
    
    
    
    
    
    
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TraineeExamDialogController', TraineeExamDialogController);

    TraineeExamDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TrainingRecord', 'TrainingEvent', 'User', 'Company'];

    function TraineeExamDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TrainingRecord, TrainingEvent, User, Company) {
        var vm = this;

        vm.trainingRecord = entity;
        vm.checkExam = checkExam;
        vm.clear = clear;
        vm.examCheckPassed = null;


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function checkExam(){
            vm.isSaving = false;
            vm.examCheckPassed = null;
            
            var numberOfCorrectAnswers = 0;
            
            vm.trainingRecord.trainingEvent.training.examQuestions.forEach(function(examQuestion){
                if (examQuestion.answer === examQuestion.expectedAnswer){
                        ++numberOfCorrectAnswers;
                }
            });
            
            var numberOfQuestions = vm.trainingRecord.trainingEvent.training.examQuestions.length;
            var correctPercent = 100;
            
            if (numberOfQuestions > 0){
                correctPercent = Math.round(numberOfCorrectAnswers / numberOfQuestions * 100); 
            }
            var passed = true;
            
            if (vm.trainingRecord.trainingEvent.training.examPassRequiredPercent){
                passed = correctPercent >= vm.trainingRecord.trainingEvent.training.examPassRequiredPercent;
            }

            if (passed){
                vm.examCheckPassed = true;
                vm.trainingRecord.examPassed = true;
                TrainingRecord.update(vm.trainingRecord, onSaveSuccess, onSaveError);
            }else {
                vm.examCheckPassed = false;
                $timeout(function () { vm.examCheckPassed = null; }, 3000); 
                
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:trainingRecordUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .controller('TraineeTrainingAvailableController', TraineeTrainingAvailableController);

    TraineeTrainingAvailableController.$inject = [
        '$uibModal','$location', '$scope',
        '$state', 'Training', 'ParseLinks',
        'AlertService','paginationConstants',
        'pagingParams', 'TraineeEventSignup','TrainingEvent'];

    function TraineeTrainingAvailableController(
        $uibModal, $location, $scope,
        $state, Training, ParseLinks,
        AlertService, paginationConstants,
        pagingParams, TraineeEventSignup, TrainingEvent) {
        var vm = this;

        vm.independentStudyTrainings = [];
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.confirmSignupToIndependentStudyTraining = confirmSignupToIndependentStudyTraining;
        vm.confirmSignupToTrainingEvent = confirmSignupToTrainingEvent;
        vm.isSigningUp = false;
        vm.failureReason = null;

        loadSelfStudies();
        loadAvailableTrainingEvents();

        function loadAvailableTrainingEvents() {
            TrainingEvent.getAvailableForSignUp({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trainingEvents = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadSelfStudies() {
            TrainingEvent.getIndependentTrainingAvailableForSignUp({}, onSuccess, onError);

            function onSuccess(data) {
                vm.independentStudyTrainings = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function confirmSignupToTrainingEvent(trainingEvent) {
            vm.failureReason = null;

            $uibModal.open({
                templateUrl: 'app/training-main/trainee/trainee-training-signup-confirm-dialog.html',
                controller: 'TrainingSignupConfirmController',
                controllerAs: 'vm',
                size: 'sm'
            }).result.then(function (confirmd) {
               if (confirmd){
                   vm.isSigningUp = true;
                   TraineeEventSignup.signupToTrainingEvent({trainingEventId: trainingEvent.id}, onSignupSuccess, onSignupFailure);
               }
            });
        }

        function confirmSignupToIndependentStudyTraining(independentStudyTraining) {
            vm.failureReason = null;

            $uibModal.open({
                templateUrl: 'app/training-main/trainee/trainee-training-signup-confirm-dialog.html',
                controller: 'TrainingSignupConfirmController',
                controllerAs: 'vm',
                size: 'sm'
            }).result.then(function (confirmd) {
               if (confirmd){
                   vm.isSigningUp = true;
                   TraineeEventSignup.signupToIndependentStydyTraining({trainingId: independentStudyTraining.id}, onSignupSuccess, onSignupFailure);
               }
            });
        }

        function onSignupSuccess(result) {
            vm.isSigningUp = false;
            //$location.path('/trainee/records');
            $state.reload();
        }

        function onSignupFailure(result) {
            vm.isSigningUp = false;
            if (result.status === 409){
                vm.failureReason = result.data.reason;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trainee-available', {
            parent: 'training_menu',
            url: '/trainee/available-training?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/trainee/trainee-availabe-training.html',
                    controller: 'TraineeTrainingAvailableController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'start,asc',
                    squash: true
                },
                search: null

            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('trainingExamQuestion');
                    $translatePartialLoader.addPart('trainingRecord');
                    $translatePartialLoader.addPart('trainingEventSignup');
                    $translatePartialLoader.addPart('trainingEvent');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('trainingExamQuestion');
                    return $translate.refresh();
                }]
            }
        })
        .state('trainee-independent-study-signup', {
            parent: 'trainee-available',
            url: '/signup-independent-study/{trainingId}?signedUp',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.training.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/trainee/trainee-training-signup.html',
                    controller: 'TraineeTrainingSignUpDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('trainingExamQuestion');
                    return $translate.refresh();
                }],
                independentStudyTraining: ['$stateParams', 'Training', function($stateParams, Training) {
                    return Training.get({id : $stateParams.trainingId}).$promise;
                }],
                trainingEvent : [function(){return null;}],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'trainee-available',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('trainee-training-event-signup', {
            parent: 'trainee-available',
            url: '/signup-training-event/{trainingEventId}?signedUp',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.training.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/trainee/trainee-training-signup.html',
                    controller: 'TraineeTrainingSignUpDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('trainingExamQuestion');
                    return $translate.refresh();
                }],
                independentStudyTraining: [function(){return null;}],
                trainingEvent: ['$stateParams', 'TrainingEvent', function($stateParams, TrainingEvent) {
                    return TrainingEvent.get({id : $stateParams.trainingEventId}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'trainee-available',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('trainee-records', {
            parent: 'training_menu',
            url: '/trainee/records?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.trainingRecord.myTrainingsTitle'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/trainee/trainee-records.html',
                    controller: 'TraineeRecordController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'trainingEvent.start,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trainingRecord');
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingEventSignup');
                    $translatePartialLoader.addPart('trainingEvent');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('trainingExamQuestion');
                    return $translate.refresh();
                }]
            }
        })
        .state('trainee-records.exam', {
            parent: 'trainee-records',
            url: '/{id}/exam',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/trainee/trainee-exam-dialog.html',
                    controller: 'TraineeExamDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TrainingRecord', function(TrainingRecord) {
                            return TrainingRecord.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('trainee-records', null, { reload: 'trainee-records' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('trainee-records.sign', {
            parent: 'trainee-records',
            url: '/{id}/sign',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/training-main/trainee/trainee-sign-dialog.html',
                    controller: 'TraineeSignDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TrainingRecord', function(TrainingRecord) {
                            return TrainingRecord.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('trainee-records', null, { reload: 'trainee-records' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('trainee-records-study', {
            parent: 'trainee-records',
            url: '/study/{signupId}',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.trainingEvent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/training-main/trainee/trainee-study.html',
                    controller: 'TraineeStudyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('trainingEvent');
                    $translatePartialLoader.addPart('training');
                    $translatePartialLoader.addPart('trainingType');
                    $translatePartialLoader.addPart('trainingEventSignup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TrainingEventSignup', function($stateParams, TrainingEventSignup) {
                    return TrainingEventSignup.get({id : $stateParams.signupId}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'training-event',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('TraineeRecord', TraineeRecord);

    TraineeRecord.$inject = ['$resource', 'DateUtils'];

    function TraineeRecord ($resource, DateUtils) {

        return {
            UserRecords: $resource('api/training-records/user', {}, {'query': {method: 'GET', isArray: true}}),
            ExamOrSigningRequired: $resource('api/training-records/user/exam-or-signing-required', {}, {'query': {method: 'GET', isArray: true}}),
        };
    }

    angular
        .module('abcQualityMatchApp')
        .factory('TraineeEventSignup', TraineeEventSignup);

    TraineeEventSignup.$inject = ['$resource', 'DateUtils'];

    function TraineeEventSignup ($resource, DateUtils) {
        var resourceUrl =  'api/training-event-signups/for-user/:trainingEventSignupId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'signupToIndependentStydyTraining': {
                params: {trainingId: '@trainingId'},
                method:'POST'
            },
            'signupToTrainingEvent': {
                params: {trainingEventId: '@trainingEventId'},
                method:'POST'
            },
            'deleteSignup': {
                method:'DELETE'
            }
        });
    }


    angular
        .module('abcQualityMatchApp')
        .factory('TraineeEventSignupExamPassed', TraineeEventSignupExamPassed);

    TraineeEventSignupExamPassed.$inject = ['$resource', 'DateUtils'];

    function TraineeEventSignupExamPassed ($resource, DateUtils) {
        var resourceUrl =  'api/training-event-signups/exam-passed';

        return $resource(resourceUrl, {}, {
            'setExamPassed': {
                params: {trainingEventSignupId: '@trainingEventSignupId'},
                method:'POST'
            }
        });
    }


})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TicketDialogController', TicketDialogController);

    TicketDialogController.$inject = ['$scope', '$uibModalInstance'];

    function TicketDialogController ($scope, $uibModalInstance) {
        var vm = this;
        vm.ticketTypes = [{name:"Poikkeamailmotus", qId:3}, {name:"Kehitysehdotus", qId:4}];
        vm.selectedType = vm.ticketTypes[0];
        vm.pl = null;
        vm.vt = null;
        
        
        vm.clear = function() {
            $uibModalInstance.close();
        };
        
        vm.save = function() {
            $uibModalInstance.close();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ticket', {
            parent: 'app',
            url: '/ticket',
            data: {
                authorities: ['ROLE_COMPANY_USER', 'ROLE_COMPANY_ADMIN', 'ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/ticket/ticket.html',
                    controller: 'TicketController',
                    controllerAs: 'vm'
                }
            }
        })       
        .state('ticket-new', {
            parent: 'ticket',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_USER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/ticket/ticket-dialog.html',
                    controller: 'TicketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'                    
                }).result.then(function() {
                    $state.go('home', null, { reload: 'home' });
                }, function() {
                    $state.go('home');
                });
            }]
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TicketController', TicketController);

    TicketController.$inject = ['$scope', 'Principal', '$state'];

    function TicketController($scope, Principal, $state) {
        var vm = this;        
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task-verification-list', {
            parent: 'functions_menu',
            url: '/task-verification-list?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN','VERIFICATION','VERIFICATION_BY_PRODUCT_LINE'],
                pageTitle: 'abcQualityMatchApp.taskList.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/task/task-verification-list/task-verification-list.html',
                    controller: 'TaskVerificationListController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'tic.title,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskVerification');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TaskVerificationListController', TaskVerificationListController);

    TaskVerificationListController.$inject = ['$scope', '$state','TaskVerificationRedone', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal'];

    function TaskVerificationListController ($scope, $state, TaskVerificationRedone, ParseLinks, AlertService, paginationConstants, pagingParams, Principal) {
        var vm = this;
        window.vvm = vm;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAllTaskVerifications();

        function loadAllTaskVerifications() {
            TaskVerificationRedone.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'tic.title') {
                    result.push('tic.title');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taskVerifications = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task-verification', {
            parent: 'functions_menu',
            url: '/task-verification/{parentTaskId}/{questionnaireId}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN','VERIFICATION','VERIFICATION_BY_PRODUCT_LINE'],
                pageTitle: 'abcQualityMatchApp.taskVerification.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/task/task-verification/task-verification.html',
                    controller: 'TaskVerificationController',
                    controllerAs: 'vm'
                }
            },
            params: {},
            resolve: {
                questionnaire: ['Questionnaire', '$stateParams', function (Questionnaire, $stateParams) {
                        console.log("id:"+$stateParams.questionnaireId);
                        return Questionnaire.get({id: $stateParams.questionnaireId}).$promise;
                }],
                tasks: ['TaskVerificationRedone', '$stateParams', function (TaskVerificationRedone, $stateParams) {
                        return TaskVerificationRedone.getTasksToVerify({parentTaskId: $stateParams.parentTaskId, questionnaireId: $stateParams.questionnaireId}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {                    
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('information');
                    $translatePartialLoader.addPart('questionnaire');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('taskVerification');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .controller('TaskVerificationController', TaskVerificationController);

    TaskVerificationController.$inject = ['$scope', '$state', '$stateParams','TaskVerificationRedone', 'AlertService', 'questionnaire', 'tasks', 'TicketStateTypeList', 'DataUtils'];

    function TaskVerificationController($scope, $state, $stateParams, TaskVerificationRedone, AlertService, questionnaire, tasks, TicketStateTypeList, DataUtils) {
        var vm = this;
        window.vvm = vm;
        vm.questionnaire = questionnaire;
        vm.tasks = tasks;
        vm.questions = new Array();
        vm.verificationTasks = new Array();
        vm.ticketStates = new Array();

        loadTicketStates();
        loadAll();

        function loadAll() {

            TaskVerificationRedone.getVerificationAnswers({parentTaskId: $stateParams.parentTaskId, questionnaireId: vm.questionnaire.id}, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.taskEvents = data;
                var taskMap = new Map();
                for (var i = 0; i < tasks.length; i++) {
                    taskMap.set(tasks[i].id, i);
                }

                vm.questionnaire.sections.forEach(function (section) {
                    section.questions.forEach(function (question) {
                        var newQuestion = angular.copy(question);
                        var answerArray = new Array(tasks.length);
                        vm.taskEvents.forEach(function (row) {
                            if (row.questionId == question.id) {
                                answerArray[taskMap.get(row.taskId)] = row;
                            }
                        });
                        newQuestion.answerArray = answerArray;
                        vm.questions.push(newQuestion);
                    });
                });

                vm.tasks.forEach(function (task) {
                    var verificationTask = {};
                    verificationTask.id = task.id;
                    verificationTask.state = angular.copy(task.mainTicket.state);
                    verificationTask.comment = null;
                    if (vm.verificationTasks.length > 0) {
                        verificationTask.copy = true;
                    } else {
                        verificationTask.copy = false;
                    }
                    vm.verificationTasks.push(verificationTask);

                    var answerArray = new Array();
                    vm.taskEvents.forEach(function (row) {
                        if (row.taskId == task.id) {
                            answerArray.push(row);
                        }
                    });
                    task.answerArray = answerArray;
                });
                loadAttachments();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadTicketStates() {
            TicketStateTypeList.query({"ticketType": 'TASK', "size": 1000, "sort": "listIndex,asc"}, onSuccess, onError);

            function onSuccess(data, header) {
                data.forEach( function (ticket) {
                    if (ticket.ticketStateType === "DONE" || ticket.ticketStateType === "VERIFIED") {
                        vm.ticketStates.push(ticket);
                    }
                });
            }

            function onError() { }
        }

        vm.save = function () {
            TaskVerificationRedone.verifyTasks(vm.verificationTasks, onSaveSuccess, onSaveError);

            function onSaveSuccess() {
                $state.go("home");
            }

            function onSaveError() {
                alert("Virhe tapahtui lomaketta tallennettaessa.");
            }
        }

        vm.answerClassCheck = function (answer) {
            if (answer == undefined || answer.answerAnomaly == undefined || answer.answerAnomaly == false) {
                return "";
            } else if (answer.answerAnomalyConfirmed == true) {
                return "alert-warning";
            } else {
                return "bg-danger";
            }
        };

        vm.taskClassCheck = function (task) {
            if (task.answerArray == null || task.answerArray == undefined || task.answerArray.length == 0) {
                return "";
            } else if (task.answerArray[0].qaAnomaly == false) {
                return "";
            } else if (task.answerArray[0].qaAnomalyConfirmed == true) {
                return "alert-warning";
            } else {
                return "bg-danger";
            }
        };

        vm.copy = function () {
            vm.verificationTasks.forEach(function (verificationTask) {
                if (verificationTask.copy) {
                    verificationTask.state = angular.copy(vm.verificationTasks[0].state);
                    verificationTask.comment = vm.verificationTasks[0].comment;
                }
            });
        }

        vm.roundAnswerValueIfDecimal = function (answerType, value) {
            if (answerType != "decimal"){
                return value;
            }else{
                if (value != null) {
                    var parts = value.split(".");
                    if (parts.length > 1) {
                        // If value already has enough decimals?
                        if (parts[1].length >= 2) {
                            return value;
                        }
                    }
                    return parseFloat(value).toFixed(2);
                }
            }
        }

        function loadAttachments() {
            vm.questions.forEach(function (question) {
                question.answerArray.forEach(function (answer) {
                    console.log('task verification ', answer);
                    answer.storageFiles = new Array();
                    
                    TaskVerificationRedone.getAnswerAttachments(answer, onSuccess, onError);
                    function onSuccess(data, header) {
                        console.log(data)
                        data.forEach(function (storageFile) {
                            storageFile.visible = false;
                        })
                        answer.storageFiles = data;
                    }
                    function onError() {
                        alert("Virhe tapahtui liitetta hakiessa.");
                    }
                })
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task-list', {
            parent: 'functions_menu',
            url: '/task-list?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.taskList.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/task/task-list/task-list.html',
                    controller: 'TaskListController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: '(start_time),asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('taskEvent');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .controller('TaskListController', TaskListController);

    TaskListController.$inject = ['$scope', '$state', 'TaskEvent', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal'];

    function TaskListController($scope, $state, TaskEvent, ParseLinks, AlertService, paginationConstants, pagingParams, Principal) {
        var vm = this;
        window.vvm = vm;
        vm.account = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        getAccount();
        loadAll();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
            });
        }

        function loadAll () {
            TaskEvent.Company.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== '(start_time)') {
                    result.push('(start_time)');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taskEvents = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        vm.confirm = function (taskId, recurrenceDateId) {
            TaskEvent.Confirm.confirm({"taskId": taskId, "recurrenceDateId": recurrenceDateId}, onSuccess, onError);
            function onSuccess(data, headers) {
                $state.reload();
            }
            function onError(error) {
                console.log("failed");
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('task-fulfilment', {
            parent: 'app',
            url: '/task-fulfilment/{taskId}?recurrenceDateId&returnToView',
            params : {
                taskId: null,
                recurrenceDateId: null,
                returnToView: null
            },
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/task/task-fulfilment/task-fulfilment.html',
                    controller: 'TaskExecutionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('question');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('ticketMaterial');
                    $translatePartialLoader.addPart('anomalyEvent');
                    $translatePartialLoader.addPart('information');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('questionnaire');
                    return $translate.refresh();
                }],
                taskFulfillmentDTO: ['$stateParams', 'Task', function($stateParams, Task) {
                    var params = {
                        taskId: $stateParams.taskId,
                        recurrenceDateId: $stateParams.recurrenceDateId
                    };
                    return Task.getTaskFulfillment(params).$promise;
                }],
            }
        })
    }
})();

(function () {
    'use strict';

    angular.module('abcQualityMatchApp')
           .controller('TaskExecutionController', TaskExecutionController);

    TaskExecutionController.$inject = [
        '$scope', '$state', '$rootScope',
        'taskFulfillmentDTO', '$log',
        'Task','$stateParams',
        'QuestionnaireUtils'];

    function TaskExecutionController(
        $scope, $state,  $rootScope,
        taskFulfillmentDTO, $log,
        Task, $stateParams,
        QuestionnaireUtils) {

        var vm = this;
        console.log('state ->', $state.params);
        vm.files = [];
        window.vvm = vm;
        vm.returnToView = 'home';
        if ($stateParams.returnToView){
            vm.returnToView = $stateParams.returnToView;
        }

        vm.taskFulfillmentDTO = taskFulfillmentDTO;

        vm.manualAnomaly = false;
        vm.questionnaire = taskFulfillmentDTO.questionnaire;
        vm.currentSection = 0;
        vm.questionnaire.anomalyCategories = Task.getAnomalyCategorySelectList();

        vm.ticketState = null;
        vm.taskFulfillmentDTO.settableTaskTicketStates.forEach(function(state){
            if (taskFulfillmentDTO.ticketStateId === state.id){
                vm.ticketState = state;
            }
        });

        vm.oldQuestionnaireAnswer = taskFulfillmentDTO.questionnaireAnswer;
        vm.comparisonQuestionnaireAnswer = taskFulfillmentDTO.comparisonQuestionnaireAnswer;
        vm.comparisons = [];

        if (vm.oldQuestionnaireAnswer != null) {
            vm.manualAnomaly = vm.oldQuestionnaireAnswer.anomaly;
        }
    
        var deleteAttachment = $rootScope.$on('abcQualityMatchApp:deleteAttachment', function(event, result) {
            // console.log('delete attachment -> answer ->', result.answer);
            // console.log('delete attachment -> attachment ->', result.attachment);
            var storageFile = result.attachment.storageFile;
        
            Task.deleteAnswerAttachment( {id: storageFile.id }, onSuccess, onError);
            function onSuccess(response) {
                console.log('Delete file success ->', response)
                vm.questionnaire.sections.forEach(function (section) {
                    section.questions.forEach(function (question) {
                        if (question.answer === result.answer) {
                            // console.log('match');
                            question.answer.attachments = question.answer.attachments.filter(function(value, index, arr){ 
                                return value !== result.attachment;
                            });
                            
                        }
                    });
                });
            }
            function onError(error) {
                console.log('Could not delete file ->', error);
                alert("Tiedoston poistaminen ei onnistunut");
            }
                    
        });
        $scope.$on('$destroy', deleteAttachment);        

        createAnswersForQuestionnaire();

        vm.showSaveButton = function () {
            if (vm.questionnaire.sections.length === 0) {
                return true;
            }
            return vm.currentSection === vm.questionnaire.sections.length - 1;
        };

        // file upload
        vm.setFileContent = function ($file, $invalidFiles) {
            console.log("File upload");
            vm.selectedFileTooLarge = false;
            if ($invalidFiles && $invalidFiles.length > 0) {
                invalidFileSelected($invalidFiles);
                return;
            }

            if ($file == null) {
                return;
            }

            var ticketMaterial = {
                name: $file.name,
                fileContentContentType: $file.type,
                company: {},
                ticket: null
            };
            if (vm.task.ticketId > 0) {
                ticketMaterial.ticket = {id:vm.task.ticketId};
            }


            DataUtils.toBase64($file, function (base64Data) {
                ticketMaterial.fileContent = base64Data;
                vm.uploadTicketMaterial(ticketMaterial);
            });
        };

        function invalidFileSelected($invalidFiles) {

            console.log('invalid file selected ' + JSON.stringify($invalidFiles));
            vm.selectedFileTooLarge = true;
            $timeout(function () {
                vm.selectedFileTooLarge = false;
            }, 3000);

        }

        function createAnswersForQuestionnaire() {
            var comparisonAnswerMap = new Map();
            if (!!vm.comparisonQuestionnaireAnswer && !!vm.comparisonQuestionnaireAnswer.answers) {
                vm.comparisonQuestionnaireAnswer.answers.forEach(function (answer) {
                    comparisonAnswerMap.set(answer.question.id, answer);
                });
            }

            var answerMap = new Map();
            if (vm.oldQuestionnaireAnswer != null) {
                vm.oldQuestionnaireAnswer.answers.forEach(function (answer) {
                    answerMap.set(answer.question.id, answer);
                });
            }

            vm.questionnaire.sections.forEach(function (section) {
                section.questions.forEach(function (question) {
                    var answer = answerMap.get(question.id);

                    if (!answer) {
                        answer = {};
                        answer.questionRootVersionId = question.rootVersionId;
                        answer.answerType = question.questionType;
                        answer.anomaly = false;
                        answer.anomalyConfirmed = false;
                        if (answer.answerType === "multi") {
                            answer.optionAnswers = [];
                        } else {
                            answer.value = null;
                        }
                    } else {
                        answer = angular.copy(answer);
                    }
                    question.answer = answer;

                    var comparisonAnswer = comparisonAnswerMap.get(question.id);
                    if (comparisonAnswer != null) {
                        comparisonAnswer = angular.copy(comparisonAnswer);
                        var comparisonQuestion = angular.copy(question)
                        comparisonQuestion.answer = comparisonAnswer;
                        vm.comparisons.push(comparisonQuestion);
                    }
                });
            });
            vm.containsUnansweredQuestions = QuestionnaireUtils.hasUnansweredRequiredQuestions(vm.questionnaire);
        }

        function onSaveSuccess() {
            $state.go(vm.returnToView);
        }

        vm.cancel = function() {
            $state.go(vm.returnToView);
        };

        function onSaveError() {
            alert("Virhe tapahtui lomaketta tallennettaessa.");
        }

        vm.saveAnswers = function () {
            console.log('Save answers !');
            var questionnaireAnswer = {};
            if (vm.oldQuestionnaireAnswer != null) {
                questionnaireAnswer = angular.copy(vm.oldQuestionnaireAnswer);
                questionnaireAnswer.answers = [];
            } else {
                questionnaireAnswer.id = null;
                questionnaireAnswer.answerTime = new Date();
                questionnaireAnswer.questionnaire = {id: vm.questionnaire.id};
                questionnaireAnswer.user = null;
                questionnaireAnswer.answers = [];
                questionnaireAnswer.anomalyConfirmed = false;
            }

            questionnaireAnswer.anomaly = vm.manualAnomaly;

            vm.questionnaire.sections.forEach(function (section) {
                section.questions.forEach(function (questionOriginal) {
                    var answer = angular.copy(questionOriginal.answer);
                    var question = angular.copy(questionOriginal);
                    question.answer = null; // removing this so that received json makes sense.
                    answer.question = question;
                    questionnaireAnswer.answers.push(answer);
                });
            });

            var taskFulfilmentToSave = {};
            taskFulfilmentToSave.questionnaireAnswer = questionnaireAnswer;
            taskFulfilmentToSave.taskId = vm.taskFulfillmentDTO.taskId;
            taskFulfilmentToSave.recurrenceDateId = vm.taskFulfillmentDTO.recurrenceDateId;
            taskFulfilmentToSave.ticketStateId = vm.ticketState.id;
            console.log('saving ->', taskFulfilmentToSave);
            Task.saveUpdateTaskFulfillment(taskFulfilmentToSave, onSaveSuccess, onSaveError);
        };

        vm.onAnswerChange = function(){
            vm.containsUnansweredQuestions = QuestionnaireUtils.hasUnansweredRequiredQuestions(vm.questionnaire);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TaskExecutionsController', TaskExecutionsController);

    TaskExecutionsController.$inject = [
        '$scope', '$rootScope', '$stateParams',
        'previousState', 'Task',
        'DateUtils', 'ParseLinks', 'AlertService',
        'paginationConstants','pagingParams','$state', 'task', 'TaskVerificationRedone'];

    function TaskExecutionsController(
        $scope, $rootScope, $stateParams,
        previousState,  Task,
        DateUtils, ParseLinks, AlertService,
        paginationConstants, pagingParams, $state, task, TaskVerificationRedone) {

        var vm = this;
        vm.previousState = previousState.name + "(" + JSON.stringify(previousState.params) +")";

        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {fromDate: false, toDate:false };

        vm.filtering = {
            taskId: pagingParams.taskId,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate
        };

        vm.task = task;


        vm.executionsPerPage = 50;


        loadAll();

        function loadAll () {
            console.log('Load All');
            var parameters = {
                page: pagingParams.page - 1,
                size: vm.executionsPerPage
            };

            parameters = addFilteringParameters(parameters);

            Task.getExecutionsTables(parameters, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.taskExecutionsTables = data;
                vm.page = pagingParams.page;

                vm.hasNextPage = headers('hasNextPage') === 'true';
                vm.hasPreviousPage = vm.page > 1;
                loadAttachments();
            }
            function onError(error) {
                console.log(JSON.stringify(error));
                AlertService.error(error.data.message);
            }
        }

        function loadAttachments() {
            // console.log('Load Attachments', vm.taskExecutionsTables);
            vm.taskExecutionsTables.forEach(function(table) {
                table.questionnaire.questions.forEach(function (question) {
                    question.answers.forEach(function(answer) {
                        // console.log(answer);
                        // call get storage files
                        answer.storageFiles = new Array();
                        TaskVerificationRedone.getAnswerAttachments(answer, onSuccess, onError);
    
                        function onSuccess(data, header) {
                            console.log(data)
                            data.forEach(function (storageFile) {
                                storageFile.visible = false;
                            })
                            answer.storageFiles = data;
                        }
                        function onError() {
                            alert("Virhe tapahtui liitetta hakiessa.");
                        }
    
                    });
                });
            });
        }

        function addFilteringParameters(parameters) {

            parameters.taskId = vm.filtering.taskId;

            parameters.fromDate = null;
            if (vm.filtering.fromDate) {
                parameters.fromDate = DateUtils.convertLocalDateToServer(vm.filtering.fromDate);
            }

            parameters.toDate = null;
            if (vm.filtering.toDate) {
                parameters.toDate = DateUtils.convertLocalDateToServer(vm.filtering.toDate);
            }
            return parameters;
        }

        vm.refreshSearch = function(){
            vm.loadPage(1);
        };

        vm.loadPage = function(page) {
            vm.page = page;
            vm.transition();
        };

        vm.transition = function() {
            var parameters = {
                page: vm.page
            };
            parameters = addFilteringParameters(parameters);

            $state.transitionTo($state.$current, parameters);
        };



        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.setFloatPrecision = function(value) {
            var parts = value.toString().split(".");
            if (parts.length > 1){
                // If value already has enough decimals?
                if(parts[1].length >= 2){
                    return value;
                }
            }
            return parseFloat(value).toFixed(2);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task-execution-counts', {
            parent: 'functions_menu',
            url: '/task-execution-counts?page&sort&search&fromDate&toDate',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN','VERIFICATION','VERIFICATION_BY_PRODUCT_LINE', 'TASK_EXECUTIONS_VIEW'],
                pageTitle: 'abcQualityMatchApp.task.taskExecutions.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/task/task-execution-counts/task-execution-counts.html',
                    controller: 'TaskExecutionCountsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: '(task_ticket_title),asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', 'DateUtils', function ($stateParams, PaginationUtil, DateUtils) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        fromDate: DateUtils.convertLocalDateFromServer($stateParams.fromDate),
                        toDate: DateUtils.convertLocalDateFromServer($stateParams.toDate),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frequence');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('ticketMaterial');
                    $translatePartialLoader.addPart('recurrence');
                    return $translate.refresh();
                }]
            }
        })
        .state('task-executions-tables', {
            parent: 'functions_menu',
            url: '/task-execution/{taskId}?page&fromDate&toDate',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN','VERIFICATION','VERIFICATION_BY_PRODUCT_LINE', 'TASK_EXECUTIONS_VIEW'],
                pageTitle: 'abcQualityMatchApp.task.taskExecutions.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/task/task-execution-counts/task-executions/task-executions.html',
                    controller: 'TaskExecutionsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', 'DateUtils', function ($stateParams, PaginationUtil, DateUtils) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        fromDate: DateUtils.convertLocalDateFromServer($stateParams.fromDate),
                        toDate: DateUtils.convertLocalDateFromServer($stateParams.toDate),
                        taskId: $stateParams.taskId
                    };
                }],
                task: ['Task','$stateParams', function(Task, $stateParams) {
                    return Task.get({id : $stateParams.taskId}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('frequence');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('ticketMaterial');
                    $translatePartialLoader.addPart('recurrence');
                    $translatePartialLoader.addPart('taskVerification');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'task-execution-counts',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TaskExecutionCountsController', TaskExecutionCountsController);

    TaskExecutionCountsController.$inject = [
        '$scope', '$state', 'Task',
        'ParseLinks', 'AlertService', 'paginationConstants',
        'pagingParams', '$uibModal', 'DateUtils'];

    function TaskExecutionCountsController (
        $scope, $state, Task,
        ParseLinks, AlertService, paginationConstants,
        pagingParams, $uibModal, DateUtils) {

        var vm = this;
        window.vvm = vm;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {fromDate: false, toDate:false };

        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.taskExecutions = null;

        vm.filtering = {
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate
        };

        if (!vm.filtering.fromDate){
            var firstOfJanuary = new Date();
            firstOfJanuary.setMonth(0);
            firstOfJanuary.setDate(1);
            //defaulting to first day of this year
            vm.filtering.fromDate = firstOfJanuary;
        }
        if (!vm.filtering.toDate){
            vm.filtering.toDate = new Date();
        }


        loadAll();

        function loadAll () {

            var parameters = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            };

            parameters = addFilteringParameters(parameters);

            Task.getExecutionCounts(parameters, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'task_id') {
                    result.push('task_id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taskExecutions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function addFilteringParameters(parameters) {
            parameters.fromDate = null;
            if (vm.filtering.fromDate) {
                parameters.fromDate = DateUtils.convertLocalDateToServer(vm.filtering.fromDate);
            }

            parameters.toDate = null;
            if (vm.filtering.toDate) {
                parameters.toDate = DateUtils.convertLocalDateToServer(vm.filtering.toDate);
            }
            return parameters;
        }

        vm.refreshSearch = function(){
            loadPage(1);
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {

            var parameters = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            };
            parameters = addFilteringParameters(parameters);

            $state.transitionTo($state.$current, parameters);
        }

        vm.getParametersForTaskVerification = function(taskId){
            var parameters = {taskId: taskId};

            if (vm.filtering.fromDate) {
                parameters.fromDate = DateUtils.convertLocalDateToServer(vm.filtering.fromDate);
            }

            parameters.toDate = null;
            if (vm.filtering.toDate) {
                parameters.toDate = DateUtils.convertLocalDateToServer(vm.filtering.toDate);
            }
            return parameters;
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TaskDetailsController', TaskDetailsController);

    TaskDetailsController.$inject = ['$uibModalInstance', 'verifiedTaskDto'];

    function TaskDetailsController($uibModalInstance, taskDto) {
        var vm = this;

        vm.task = taskDto.task
        vm.questionnaireAnswer = taskDto.questionnaireAnswer;

        vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TaskDialogController', TaskDialogController);

    TaskDialogController.$inject = ['$translate', '$timeout', '$scope', '$stateParams',        '$uibModalInstance',
                                    'entity',     'Task',     'User',   'TicketStateTypeList', 'uiDatetimePickerConfig',
                                    'QuestionnaireCompany', 'UserGroup', 'ProductLine',
                                    'TicketRelatedMaterial', 'TicketMaterial', 'DataUtils',
                                     'AlertService'];

    function TaskDialogController ($translate, $timeout, $scope, $stateParams,         $uibModalInstance,
                                     entity,     Task,      User,   TicketStateTypeList, uiDatetimePickerConfig,
                                     QuestionnaireCompany, UserGroup, ProductLine,
                                     TicketRelatedMaterial, TicketMaterial, DataUtils,
                                     AlertService) {
        var vm = this;
        window.vvm = vm;
        vm.task = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.addedMaterialids =[];
        vm.uploadingTicketMaterial = false;
        vm.ticketMaterials = [];
        vm.uploadTicketMaterial = uploadTicketMaterial;
        vm.deleteTicketMaterial = deleteTicketMaterial;
        vm.selectedFileTooLarge = false;
        loadTicketMaterials();


        vm.usergroups = UserGroup.query({"size": 1000});
        vm.productLines = ProductLine.query({"size": 1000});
        vm.ticketstates = TicketStateTypeList.query({"ticketType":'TASK', "size": 1000, "sort":"listIndex,asc"});
        vm.questionnaires = QuestionnaireCompany.QueryByType.query({"questionnaireType":'NORMAL', "size": 1000});
        vm.clickAllDay = clickAllDay;

        vm.picker = {
            timepickerOptions: {
                showMeridian: false
            }
        };

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.task.addedMaterialids = vm.addedMaterialids;
            if (vm.task.id !== null) {
                Task.update(vm.task, onSaveSuccess, onSaveError);
            } else {
                Task.save(vm.task, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:taskUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;
        vm.datePickerOpenStatus.until = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
            uiDatetimePickerConfig.buttonBar.today.text = $translate.instant('global.datepicker.today');
            uiDatetimePickerConfig.buttonBar.now.text = $translate.instant('global.datepicker.now');
            uiDatetimePickerConfig.buttonBar.time.text = $translate.instant('global.datepicker.time');
            uiDatetimePickerConfig.buttonBar.date.text = $translate.instant('global.datepicker.date');
            uiDatetimePickerConfig.buttonBar.clear.text = $translate.instant('global.datepicker.clear');
            uiDatetimePickerConfig.buttonBar.close.text = $translate.instant('global.datepicker.close');
        }

        function clickAllDay() {
            if (vm.task.allDay && vm.task.freq == 'HOURLY') {
                vm.task.freq = null;
            }
        }






        // Material

        function loadTicketMaterials() {

            var parameters = {};
            if (vm.task != null && vm.task.ticketId > 0) {
                parameters.ticketId = vm.task.ticketId;
            }
            if (vm.addedMaterialids.length > 0) {
                parameters.addedMaterialIds = vm.addedMaterialids.join();
            }


            TicketRelatedMaterial.Materials.query(parameters, onSuccess, onError);
            function onSuccess(data) {
                vm.ticketMaterials = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.setFileContent = function ($file, $invalidFiles) {

            vm.selectedFileTooLarge = false;
            if ($invalidFiles && $invalidFiles.length > 0) {
                invalidFileSelected($invalidFiles);
                return;
            }

            if ($file == null) {
                return;
            }

            var ticketMaterial = {
                name: $file.name,
                fileContentContentType: $file.type,
                company: {},
                ticket: null
            };
            if (vm.task.ticketId > 0) {
                ticketMaterial.ticket = {id:vm.task.ticketId};
            }


            DataUtils.toBase64($file, function (base64Data) {
                ticketMaterial.fileContent = base64Data;
                vm.uploadTicketMaterial(ticketMaterial);
            });
        };

        function invalidFileSelected($invalidFiles) {

            console.log('invalid file selected ' + JSON.stringify($invalidFiles));
            vm.selectedFileTooLarge = true;
            $timeout(function () {
                vm.selectedFileTooLarge = false;
            }, 3000);


        }

        function uploadTicketMaterial(ticketMaterial) {
            vm.selectedFileTooLarge = false;
            vm.uploadingTicketMaterial = true;

            ticketMaterial.listIndex = vm.ticketMaterials.length;


            TicketMaterial.save(ticketMaterial, onSuccess, onError);

            function onSuccess(ticketMaterial) {
                console.log('uploaded ' + +ticketMaterial.id);
                if (ticketMaterial.ticket == null) {
                    vm.addedMaterialids.push(ticketMaterial.id);
                }
                vm.uploadingTicketMaterial = false;
                loadTicketMaterials();
            }
            function onError(err) {
                vm.uploadingTicketMaterial = false;
                console.log("failed to upload ticketmaterial " + err);
            }
        }

        function deleteTicketMaterial(tm) {
            TicketMaterial.delete(tm, onSuccess, onError);

            function onSuccess(ticketMaterial) {
                console.log('deleted ticket material');
                loadTicketMaterials();
            }
            function onError(err) {
                console.log("failed to delete ticketmaterial " + err);
            }


        }







    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TaskDetailController', TaskDetailController);

    TaskDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Task'];

    function TaskDetailController($scope, $rootScope, $stateParams, previousState, entity, Task) {
        var vm = this;

        vm.task = entity;
        vm.previousState = previousState.name + "(" + JSON.stringify(previousState.params) +")";

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:taskUpdate', function(event, result) {
            vm.task = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TaskDeleteController',TaskDeleteController);

    TaskDeleteController.$inject = ['$uibModalInstance', 'entity', 'Task'];

    function TaskDeleteController($uibModalInstance, entity, Task) {
        var vm = this;

        vm.task = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Task.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TaskActivateController', TaskActivateController);

    TaskActivateController.$inject = ['$translate', '$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'Task', 'uiDatetimePickerConfig'];

    function TaskActivateController ($translate, $timeout, $scope, $stateParams, $uibModalInstance,
                                   entity, Task, uiDatetimePickerConfig) {
        var vm = this;
        window.vvm = vm;
        vm.task = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.picker = {
            timepickerOptions: {
                showMeridian: false
            }
        };

        vm.task.start = new Date();
        // Set end date +1 hour by default
        vm.task.end = new Date();
        vm.task.end.setHours(vm.task.end.getHours() + 1);

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            // Set done time to null
            vm.task.doneTime = null;
            Task.activateTask(vm.task, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;
        vm.datePickerOpenStatus.until = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
            uiDatetimePickerConfig.buttonBar.today.text = $translate.instant('global.datepicker.today');
            uiDatetimePickerConfig.buttonBar.now.text = $translate.instant('global.datepicker.now');
            uiDatetimePickerConfig.buttonBar.time.text = $translate.instant('global.datepicker.time');
            uiDatetimePickerConfig.buttonBar.date.text = $translate.instant('global.datepicker.date');
            uiDatetimePickerConfig.buttonBar.clear.text = $translate.instant('global.datepicker.clear');
            uiDatetimePickerConfig.buttonBar.close.text = $translate.instant('global.datepicker.close');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('task_menu', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task', {
            parent: 'functions_menu',
            url: '/task?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.task.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/task/tasks.html',
                    controller: 'TaskController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frequence');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('ticketMaterial');
                    $translatePartialLoader.addPart('recurrence');
                    return $translate.refresh();
                }]
            }
        })
        .state('task-detail', {
            parent: 'functions_menu',
            url: '/task/{id}',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.task.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/task/task-detail.html',
                    controller: 'TaskDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('frequence');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('ticketMaterial');
                    $translatePartialLoader.addPart('recurrence');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Task', function($stateParams, Task) {
                    return Task.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'task',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('task-detail.edit', {
            parent: 'task-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/task/task-dialog.html',
                    controller: 'TaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Task', function (Task) {
                            return Task.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('^', {}, {reload: false});
                }, function () {
                    $state.go('^');
                });
            }]
        })
        .state('task.new', {
            parent: 'task',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/task/task-dialog.html',
                    controller: 'TaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                subject: null,
                                description: null,
                                start: null,
                                end: null,
                                allDay: false,
                                id: null,
                                useRecurrence:false,
                                freq: null,
                                count: null,
                                interval: null,
                                assignedTo: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('task', null, { reload: 'task' });
                }, function() {
                    $state.go('task');
                });
            }]
        })
        .state('task.activate', {
            parent: 'task',
            url: '/{id}/activate',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/task/task-activate.html',
                    controller: 'TaskActivateController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task', null, { reload: 'task' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('task.edit', {
            parent: 'task',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/task/task-dialog.html',
                    controller: 'TaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task', null, { reload: 'task' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('task.delete', {
            parent: 'task',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/task/task-delete-dialog.html',
                    controller: 'TaskDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task', null, { reload: 'task' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-detail.task-edit', {
            parent: 'project-detail',
            url: '/phase/{phaseId}/task/edit/{taskId}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/task/task-dialog.html',
                    controller: 'TaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.taskId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-detail.task-new', {
            parent: 'project-detail',
            url: '/phase/{phaseId}/task/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/task/task-dialog.html',
                    controller: 'TaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                subject: null,
                                description: null,
                                start: null,
                                end: null,
                                allDay: false,
                                id: null,
                                useRecurrence:false,
                                freq: null,
                                count: null,
                                interval: null,
                                assignedTo: null,
                                projectPhase: {
                                    id: $stateParams.phaseId
                                }
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-detail.task-delete', {
            parent: 'project-detail',
            url: '/phase/{phaseId}/task/delete/{taskId}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/task/task-delete-dialog.html',
                    controller: 'TaskDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.taskId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('root-cause-analysis-detail.newCorrectiveTask', {
            parent: 'root-cause-analysis-detail',
            url: '/newcorrectivetask',
            data: {
                authorities: ['ROLE_COMPANY_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/task/task-dialog.html',
                    controller: 'TaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                subject: null,
                                description: null,
                                start: null,
                                end: null,
                                allDay: false,
                                id: null,
                                useRecurrence:false,
                                freq: null,
                                count: null,
                                interval: null,
                                assignedTo: null,
                                linkAsCorrectiveTaskToRootCauseAnalysisId: $stateParams.id
                            };
                        },

                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('Task', Task);

    Task.$inject = ['$resource', 'DateUtils'];

    function Task($resource, DateUtils) {
        return $resource('api/tasks/:id', {}, {
            //List of TaskSimplified where task is assigned to or editable by user
            'getAssignedOrEditableByUser': {
                url: 'api/tasks/assigned-or-editable-by-user',
                method: 'GET',
                isArray: true},
            //List task executions
            'getExecutionCounts': {
                url: 'api/tasks/execution-counts',
                method: 'GET',
                isArray: true},
            'getExecutionsTables': {
                url: 'api/tasks/executions-tables/:taskId',
                method: 'GET',
                isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.start = DateUtils.convertDateTimeFromServer(data.start);
                        data.end = DateUtils.convertDateTimeFromServer(data.end);
                        data.until = DateUtils.convertDateTimeFromServer(data.until);
                        data.doneTime = DateUtils.convertDateTimeFromServer(data.doneTime);
                    }
                    return data;
                }
            },

            'delete' : {
                method: 'DELETE',
                url: 'api/tasks/:id'
            },

            'update': {method: 'PUT'},

            //List of Task related to project phase
            'getProjectPhaseTasks':{method: 'GET',
                               isArray: true,
                               url: 'api/tasks/project-phase/:projectPhaseId/tasks'
            },
            'saveUpdateTaskFulfillment':{
                url: 'api/tasks/fulfillment',
                method:'PUT'
            },
            'getTaskFulfillment':{
                url: 'api/tasks/fulfillment/:taskId',
                method:'GET'
            },
            'getAnomalyCategorySelectList': {
                url:'/api/anomaly-categories/select-list',
                method:'GET',
                isArray:true
            },
            'saveAnswerAttachment': {
                url:'api/tasks/upload-answer-attachment/tasks/fulfillment',
                method:'PUT',
            },
            'deleteAnswerAttachment': {
                url:'/api/tasks/delete-answer-attachment/:id',
                method:'DELETE',
            },
            'activateTask': {
                method: 'POST',
                url: '/api/tasks/activate-task'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TaskController', TaskController);

    TaskController.$inject = ['$scope', '$state', 'Task', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TaskController ($scope, $state, Task, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;
        window.vvm = vm;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.tasks = null;

        loadAll();

        function loadAll () {
            Task.getAssignedOrEditableByUser({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tasks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('functions_menu', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('UserPreferences', UserPreferences);

    UserPreferences.$inject = ['$resource'];

    function UserPreferences ($resource) {
        var resourceUrl =  'api/user-preferences';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('UserGroupAuthority', UserGroupAuthority);

    UserGroupAuthority.$inject = ['$resource'];

    function UserGroupAuthority ($resource) {
        var resourceUrl =  'api/user-group-authorities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('User', User);

    User.$inject = ['$resource','DateUtils'];

    function User ($resource, DateUtils) {
        var service = $resource('api/users/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.activeFromDate = DateUtils.convertDateTimeFromServer(data.activeFromDate);
                    data.activeToDate = DateUtils.convertDateTimeFromServer(data.activeToDate);
                    return data;
                }
            },
            'getManagementList': {url: 'api/users/management-list', method: 'GET', isArray: true},
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'getUsersSpreadsheet':{url: 'api/users/export-spreadsheet', method: 'GET', isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('TicketRelatedMaterial', TicketRelatedMaterial);
    TicketRelatedMaterial.$inject = ['$resource'];

    function TicketRelatedMaterial($resource, DateUtils) {

        return {
            Materials: $resource('api/ticket-materials/for-ticket', {}, {'query': {method: 'GET', isArray: true}}),
            Order: $resource('api/ticket-materials/update-list-index/:ticketMaterialId', {}, {'updateListIndex': 
                        {method: 'POST', isArray: true,
                        params: '@inParams'
                    }
            }),
        };
    }
})();

(function() {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('TicketMaterial', TicketMaterial);

    TicketMaterial.$inject = ['$resource'];

    function TicketMaterial($resource) {
        var resourceUrl = 'api/ticket-materials/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('TaskVerificationRedone', TaskVerificationRedone);

    TaskVerificationRedone.$inject = ['$resource'];

    function TaskVerificationRedone($resource) {
        var resourceUrl = 'api/task-verifications';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'getVerificationAnswers':{url: 'api/task-verifications/verification-answers/:parentTaskId/:questionnaireId', method:'GET', isArray:true},
            'getTasksToVerify': {url: 'api/task-verifications/tasks/:parentTaskId/:questionnaireId', method:'GET', isArray:true},
            'verifyTasks': {url: 'api/task-verifications/verify-tasks', method:'POST'},

            'getAnswerAttachments': {
                url:'/api/task-verifications/get-answer-attachments/:answerId',
                method:'GET',
                isArray: true
            }

        });


    }
})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('TaskEvent', TaskEvent);

    TaskEvent.$inject = ['$resource'];

    function TaskEvent ($resource) {
        var resourceUrl =  'api/tasks/task-events';

         return {
            UserLatest: $resource(resourceUrl, {}, {'query': {method: 'GET', isArray: true}}),
            Company: $resource(resourceUrl + '/company', {}, {'query': {method: 'GET', isArray: true}}),
            Confirm: $resource(resourceUrl + '/confirm/:taskId/:recurrenceDateId', {}, {'confirm': {method: 'GET', isArray: false}})
        };
    }
})();

(function () {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('QuestionnaireCompany', QuestionnaireCompany);

    QuestionnaireCompany.$inject = ['$resource'];

    function QuestionnaireCompany($resource) {
        var resourceUrl = 'api/questionnaires/';

        return {
            Query: $resource(resourceUrl + 'company', {}, {'query': {method: 'GET', isArray: true}}),
            Copy: $resource(resourceUrl + 'company/copy/:id', {}, {'copy': {method: 'POST', isArray: false}}),
            CopyToEditForCompany: $resource(resourceUrl + 'company/copy-to-edit-for-company/:id', {}, {'copytoeditforcompany': {method: 'GET', isArray: false}}),
            CopyToEditForAdmin: $resource(resourceUrl + 'company/copy-to-edit-for-admin/:id', {}, {'copytoeditforadmin': {method: 'GET', isArray: false}}),
            QueryByType: $resource(resourceUrl + 'company/:questionnaireType', {}, {'query': {method: 'GET', isArray: true}}),
            QueryByTypes: $resource(resourceUrl + 'company/types', {}, {'query': {method: 'GET', isArray: true}})
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('Questionnaire', Questionnaire);

    Questionnaire.$inject = ['$resource'];

    function Questionnaire ($resource) {
        var resourceUrl =  'api/questionnaires/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'getCompanyTemplates': { method: 'GET', isArray: true, url:'api/questionnaires/company-templates'},

            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('Information', Information);

    Information.$inject = ['$resource','DateUtils'];

    function Information($resource, DateUtils) {

        return $resource('', {}, {

            'save': {
                url: 'api/information',
                method: 'POST',
            },
            'update': {
                url: 'api/information',
                method: 'PUT',
            },

            'query': {/*unused*/},
            'get': {/*unused*/},

            'getInformationDialogLoadDTO': {
                method: 'GET',
                url:'api/information/dialogLoadDTO/:id',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.information.submitDate = DateUtils.convertDateTimeFromServer(data.information.submitDate);
                        data.questionnaireAnswer.answerTime = DateUtils.convertDateTimeFromServer(data.questionnaireAnswer.answerTime);
                    }
                    return data;
                }, isArray: false},
            "informationEventsQuery":{
                url: 'api/information/events',
                method: 'GET',
                isArray: true},
            'informationEventsByIds':{
                url: 'api/information/events-by-ids',
                method: 'GET',
                isArray: true},
            'uploadInformationImportSheet':{
                url:'/api/information/information-import-sheet/upload',
                method:'POST'
            }
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal($q, Account) {
        var _identity,
                _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            hasGroupAuthority: hasGroupAuthority,
            hasGroupOrUserAuthority: hasGroupOrUserAuthority,
            hasGroup: hasGroup,
            hasUserId: hasUserId,
            hasFolderReadPermission: hasFolderReadPermission,
            hasFolderWritePermission: hasFolderWritePermission,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            forcedPasswordChange:forcedPasswordChange
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.combinedAuthorities) {
                return false;
            }
            if (_identity.authorities && hasRecursiveAuthorities(authorities)) {
                return true;
            }
            return _identity.userGroupAuthorities && hasGroupAuthorities(authorities);
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return hasAnyAuthority([authority]);
            }, function () {
                return false;
            });
        }

        function hasGroupAuthority(authorities) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                hasAnyAuthority(authorities);
            }, function () {
                return false;
            });
        }

        function hasGroupOrUserAuthority(authorities) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                hasAnyAuthority(authorities);
            }, function () {
                return false;
            });
        }

        function hasGroup(group) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.userGroups && _id.userGroups.indexOf(group) !== -1;
            }, function () {
                return false;
            });
        }

        function hasUserId(userId) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.id == userId;
            }, function () {
                return false;
            });
        }

        function hasFolderReadPermission(folder) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                if (!_id.combinedAuthorities) {
                    return false;
                }
//                console.log(folder);
                if (hasAnyAuthority(['ROLE_COMPANY_ADMIN','DOCUMENT_ADMIN'])) {
                    return true;
                }
                if (!_id.userGroupAuthorities) {
                    return false;
                }
                return hasFolderReadRights(folder);
            }, function () {
                return false;
            });
        }

        function hasFolderWritePermission(folder) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                if (!_id.combinedAuthorities) {
                    return false;
                }
//                console.log(folder);
                if (hasAnyAuthority(['ROLE_COMPANY_ADMIN','DOCUMENT_ADMIN'])) {
                    return true;
                }
                if (!_id.userGroupAuthorities) {
                    return false;
                }
                return hasFolderWriteRights(folder);
            }, function () {
                return false;
            });
        }

        function hasRecursiveAuthorities(authorities) {
            var allAuthorities = ['ROLE_ADMIN', 'ROLE_COMPANY_ADMIN', 'ROLE_COMPANY_SUPERVISOR', 'ROLE_COMPANY_USER'];
            var recursiveAuthorities = [];

            for (var i = 0; i < allAuthorities.length; i++) {
                if (_identity.authorities.indexOf(allAuthorities[i]) !== -1) {
                    recursiveAuthorities = allAuthorities.slice(i);
                    break;
                }
            }

            for (var i = 0; i < recursiveAuthorities.length; i++) {
                if (authorities.indexOf(recursiveAuthorities[i]) !== -1) {
                    return true;
                }
            }
            return false;
        }

        function hasGroupAuthorities(authorities) {
            if (!_identity.userGroupAuthorities) {
                return false;
            }
            for (var i = 0; i < _identity.userGroupAuthorities.length; i++) {
                if (authorities.indexOf(_identity.userGroupAuthorities[i]) !== -1) {
                    return true;
                }
            }
            return false;
        }

        function hasFolderReadRights(folder) {
            var found = folder.permissions.some(function (permission) {
                if (_identity.userGroups.indexOf(permission.userGroup.id) !== -1) {
                    return true;
                }
            });
            if (found) {
                return true;
            }
            if (folder.parentFolder != undefined) {
                return hasFolderReadRights(folder.parentFolder);
            }
        }

        function hasFolderWriteRights(folder) {
            var found = folder.permissions.some(function (permission) {
                if (_identity.userGroups.indexOf(permission.userGroup.id) !== -1 && permission.writePermission) {
                    return true;
                }
            });
            if (found) {
                return true;
            }
            if (folder.parentFolder != undefined) {
                return hasFolderWriteRights(folder.parentFolder);
            }
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                    .then(getAccountThen)
                    .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }
        function forcedPasswordChange(){
            return _identity.forcedPasswordChangeOnNextLogin;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('hasUserId', hasUserId);

    hasUserId.$inject = ['Principal'];

    function hasUserId(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var userId = attrs.hasUserId.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasUserId(parseInt(userId))
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (userId.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('hasGroupOrUserAuthority', hasGroupOrUserAuthority);

    hasGroupOrUserAuthority.$inject = ['Principal'];

    function hasGroupOrUserAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasGroupOrUserAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasGroupOrUserAuthority(authorities)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('hasGroupAuthority', hasGroupAuthority);

    hasGroupAuthority.$inject = ['Principal'];

    function hasGroupAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasGroupAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasGroupAuthority(authorities)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('hasGroup', hasGroup);

    hasGroup.$inject = ['Principal'];

    function hasGroup(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var group = attrs.hasGroup.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasGroup(parseInt(group))
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (group.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('hasFolderWritePermission', hasFolderWritePermission);

    hasFolderWritePermission.$inject = ['Principal'];

    function hasFolderWritePermission(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var folder = attrs.hasFolderWritePermission.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasFolderWritePermission(folder)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (folder.length > 0) {
                folder = JSON.parse(folder);
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('hasFolderReadPermission', hasFolderReadPermission);

    hasFolderReadPermission.$inject = ['Principal'];

    function hasFolderReadPermission(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var folder = attrs.hasFolderReadPermission.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasFolderReadPermission(folder)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (folder.length > 0) {
                folder = JSON.parse(folder);
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('Anomaly', Anomaly);

    Anomaly.$inject = ['$resource'];

    function Anomaly ($resource) {
        var resourceUrl =  'api/questionnaire-answers/anomalies';

        return {
            UserLatest: $resource(resourceUrl, {}, {'query': {method: 'GET', isArray: true}}),
            Company: $resource(resourceUrl + '/company', {}, {'query': {method: 'GET', isArray: true}}),
            QuestionnaireAnswer: $resource(resourceUrl + '/reject/:questionnaireAnswerId', {}, {'reject': {method: 'GET', isArray: false}}),
            Answer: $resource(resourceUrl + '/reject/:questionnaireAnswerId/:answerId', {}, {'reject': {method: 'GET', isArray: false}}),
            EventsByIds: $resource(resourceUrl + '/events-by-ids', {}, {'query': {method: 'GET', isArray: true}}),
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('report_menu', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('report', {
            parent: 'report_menu',
            url: '/report',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN','REPORT'],
                pageTitle: 'abcQualityMatchApp.report.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/report/report.html',
                    controller: 'ReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('report');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function () {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('Report', Report);

    Report.$inject = ['$resource'];

    function Report($resource) {
        var resourceUrl = 'api/report/';

        return {
            Stats: $resource(resourceUrl + 'stats', {}, {'query': {method: 'GET', isArray: false}})
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ReportController', ReportController);

    ReportController.$inject = ['$scope', '$state'];

    function ReportController ($scope, $state) {
        var vm = this;
    }
})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .controller('QuestionnaireEditSectionDialogController', QuestionnaireEditSectionDialogController);

    QuestionnaireEditSectionDialogController.$inject = ['$uibModalInstance'];

    function QuestionnaireEditSectionDialogController($uibModalInstance) {
        var vm = this;
        vm.newSectionName;
        
        vm.closeDialog = function() {
            $uibModalInstance.dismiss('cancel');
        }
        
        vm.save = function() {
            var section = {
              title: vm.newSectionName,
              listIndex: -1,
              questions: []
            };
            $uibModalInstance.close(section);
        }
    }
    
})();
(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('QuestionnaireEditQuestionController',QuestionnaireEditQuestionController);

    QuestionnaireEditQuestionController.$inject = ['$uibModalInstance', 'entity', 'AbcListUtils'];

    function QuestionnaireEditQuestionController($uibModalInstance, entity, AbcListUtils) {
        var vm = this;
        vm.question = entity;
        vm.newOptionValue;
        vm.questionnaireType = entity.questionnaireType;
        vm.cancel = cancel;
        vm.save = save;
        vm.addNewOption = addNewOption;
        vm.deleteOption = deleteOption;
        vm.setDefault = setDefault;
        vm.setAnomaly = setAnomaly;
        vm.moveOption = moveOption;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            $uibModalInstance.close(vm.question);
        }

        function addNewOption() {
            var option = {
                listIndex: vm.question.options.length,
                name: '',
                allowWriteIn: false,
                anomalyOption: false,
                deleted: false
            }
            AbcListUtils.addNewToLast(option, vm.question.options);
            return false;
        }

        function deleteOption(index) {
            vm.question.options.splice(index, 1);
            AbcListUtils.refreshListIndexes(vm.question.options);
            return false;
        }

        function setDefault(index) {
            for(var i=0; i < vm.question.options.length; i++) {
                if(i == index) {
                    vm.question.options[i].defaultSelection = !vm.question.options[i].defaultSelection;
                }
                else {
                    vm.question.options[i].defaultSelection = false;
                }
            }
        }

        function setAnomaly(index) {
            for(var i=0; i < vm.question.options.length; i++) {
                if(i == index) {
                    vm.question.options[i].anomalyOption = !vm.question.options[i].anomalyOption;
                }
            }
        }

        function moveOption(index, direction) {
            AbcListUtils.moveUpOrDown(index, direction, vm.question.options);

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('QuestionnairesListController', QuestionnairesListController);

    QuestionnairesListController.$inject =
        ['$scope', '$state', 'Principal', 'QuestionnaireCompany',
            'Questionnaire', 'ParseLinks', 'AlertService',
            'paginationConstants'];

    function QuestionnairesListController (
        $scope, $state, Principal, QuestionnaireCompany,
        Questionnaire, ParseLinks, AlertService,
        paginationConstants) {


        var vm = this;

        //Id of company whow's questionnaires are show or undefined/null for template questionnaires
        vm.companyId = $state.params.companyId;

        vm.questionnaires = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.account = null;


        if (vm.companyId) {
            vm.templateQuestionnaires = Questionnaire.getCompanyTemplates();
        }

        loadAll();


        function loadAll () {

            var params = {
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            };

            if (vm.companyId) {
                QuestionnaireCompany.Query.query(params, onSuccess, onError);
            }
            else {
                Questionnaire.query(params, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }



            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.questionnaires.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.questionnaires = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        $scope.copy = function(copyQuestionnaireId) {
            console.log("CopyScope");
            console.log(copyQuestionnaireId);
            QuestionnaireCompany.Copy.copy({id: copyQuestionnaireId},null, onSuccess, onError);

            function onSuccess(data, headers) {
                $scope.$emit('abcQualityMatchApp:questionnaireUpdate', data);
                reset();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .controller('QuestionnaireEditDialogController', QuestionnaireEditDialogController);

    QuestionnaireEditDialogController.$inject =
        ['$scope', 'entity', 'Questionnaire',
            '$timeout', '$state',
            '$uibModal', '$log',
            'AbcListUtils'];

    function QuestionnaireEditDialogController(
        $scope, entity, Questionnaire,
        $timeout, $state,
        $uibModal, $log,
        AbcListUtils) {


        var vm = this;
        window.vvm = vm;
        vm.questionnaire = entity;
        vm.companyId = $state.params.companyId;
        vm.copyMode = $state.params.copyMode;
        if (vm.copyMode){
            vm.copyingFromQUestionnaireTitle = vm.questionnaire.title;
        }

        vm.questionTypes = ['integer', 'decimal', 'multi', 'freetext'];

        vm.clear = function () {
            $state.go('^', {}, { reload: false });
        }

        vm.addSection = function () {
            console.log("add section");

            var newSection = {
                title: '',
                listIndex: vm.questionnaire.sections.length,
                questions: []
            };
            vm.questionnaire.sections.push(newSection);
        };



        vm.addQuestion = function (section, type) {
            $uibModal.open({
                templateUrl: 'app/questionnaire-edit/questions/question-' + type + '.html',
                controller: 'QuestionnaireEditQuestionController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: function () {
                        var question = {
                            questionType: type
                        };
                        question.questionnaireType = vm.questionnaire.questionnaireType;
                        if(type === "multi") {
                            question.options = [];
                            question.renderType = 'CHECKBOX';
                        }
                        if(type === "freetext") {
                            question.size = 'SHORT';
                        }
                        if (type == 'decimal' || type == 'integer'){
                            question.interpretation = 'NONE';
                        }

                        return question;
                    }
                }
            }).result.then(function (newQuestion) {
                newQuestion.listIndex = section.questions.length;
                section.questions.push(newQuestion);
                AbcListUtils.refreshListIndexes(section.questions);
            });
        }



        vm.editQuestion = function (section, index) {
            console.log("edit question: " + index);
            var question = section.questions[index];
            question.questionnaireType = vm.questionnaire.questionnaireType;
            $uibModal.open({
                bindings: {
                    resolve: '='
                },
                templateUrl: 'app/questionnaire-edit/questions/question-' + question.questionType + '.html',
                controller: 'QuestionnaireEditQuestionController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    entity: function () {
                        return question;
                    }
                }
            });
        };

        vm.deleteQuestion = function (section, index) {
            console.log("delete question: " + index);
            section.questions.splice(index, 1);
            AbcListUtils.refreshListIndexes(section.questions);
        };

        vm.moveQuestion = function (section, index, direction) {
            console.log("move question in list postion: "  + index + " " + direction );
            AbcListUtils.moveUpOrDown(index, direction, section.questions);
        };


        vm.moveSection = function (index, direction) {
            console.log("move section in list postion: "  + index + " " + direction );
            AbcListUtils.moveUpOrDown(index, direction, vm.questionnaire.sections);
        };

        vm.deleteSection = function (index) {
            console.log("delete section: " + index);
            vm.questionnaire.sections.splice(index, 1);
            AbcListUtils.refreshListIndexes(vm.questionnaire.sections);
        };


        vm.save = function () {
            console.log("save");
            vm.isSaving = true;

            if (vm.questionnaire.id){
                Questionnaire.update(vm.questionnaire, onSaveSuccess, onSaveError);
            }
            else{
                if (vm.companyId){
                    vm.questionnaire.company = {id: vm.companyId};
                }
                Questionnaire.save(vm.questionnaire, onSaveSuccess, onSaveError);
            }


            function onSaveSuccess(result) {
                $scope.$emit('abcQualityMatchApp:questionnaireUpdate', result);
                $state.go('^', {}, { reload: true });
                vm.isSaving = false;
            }

            function onSaveError() {
                vm.isSaving = false;
            }
        };

        vm.selectQuestionnaireType = function() {
            //Ensuring that anomalyType is set only when questionnaireType is "ANOMALY"
            if (!(vm.questionnaire.questionnaireType === 'ANOMALY')) {
                vm.questionnaire.anomalyType = null;
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('QuestionnaireDeleteController',QuestionnaireDeleteController);

    QuestionnaireDeleteController.$inject = ['$uibModalInstance','entity', 'Questionnaire'];

    function QuestionnaireDeleteController($uibModalInstance, entity, Questionnaire) {
        var vm = this;

        vm.questionnaire = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Questionnaire.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('questionnaire-company', {
            parent: 'company_admin',
            url: '/questionnaire-company/{companyId}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire-edit/questionnaires-company-list.html',
                    controller: 'QuestionnairesListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('questionnaireEdit');
                    $translatePartialLoader.addPart('questionnaire');
                    $translatePartialLoader.addPart('question');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('questionnaireType');
                    $translatePartialLoader.addPart('anomalyType');
                    return $translate.refresh();
                }]
            }
        })
        .state('questionnaire-company.new', {
            parent: 'questionnaire-company',
            url: '/new',
            params : {
                companyId: null
            },
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire-edit/questionnaire-edit-dialog.html',
                    controller: 'QuestionnaireEditDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        title: null,
                        description: null,
                        sections: [],
                        deleted: false,
                        company: null
                    };
                }
            }
        })
        .state('questionnaire-company.edit', {
            parent: 'questionnaire-company',
            url: '/edit/{id}',
            params : {
                companyId: null
            },
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire-edit/questionnaire-edit-dialog.html',
                    controller: 'QuestionnaireEditDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['Questionnaire', '$stateParams', function (Questionnaire, $stateParams) {
                    return Questionnaire.get({id: $stateParams.id}).$promise;
                }]
            }
        })
        .state('questionnaire-company.copy', {
                parent: 'questionnaire-company',
                url: '/copy/{id}',
                params : {
                    companyId: null,
                    copyMode: true
                },
                data: {
                    authorities: ['ROLE_COMPANY_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/questionnaire-edit/questionnaire-edit-dialog.html',
                        controller: 'QuestionnaireEditDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['QuestionnaireCompany', '$stateParams', function (QuestionnaireCompany, $stateParams) {
                        return QuestionnaireCompany.CopyToEditForCompany.copytoeditforcompany({id: $stateParams.id}).$promise;
                    }]
                }
            })
        .state('questionnaire-company.delete', {
            parent: 'questionnaire-company',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/questionnaire-edit/questionnaire-delete-dialog.html',
                    controller: 'QuestionnaireDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Questionnaire', function (Questionnaire) {
                            return Questionnaire.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('^', null, {reload: true});
                }, function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('questionnaire-admin', {
            parent: 'admin',
            url: '/questionnaire-admin',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire-edit/questionnaires-admin-list.html',
                    controller: 'QuestionnairesListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('questionnaireEdit');
                        $translatePartialLoader.addPart('questionnaire');
                        $translatePartialLoader.addPart('question');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('questionnaireType');
                        $translatePartialLoader.addPart('anomalyType');
                        return $translate.refresh();
                    }]
            }
        })
        .state('questionnaire-admin.new', {
            parent: 'questionnaire-admin',
            url: '/new',
            params : {
                companyId: null
            },
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire-edit/questionnaire-edit-dialog.html',
                    controller: 'QuestionnaireEditDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        title: null,
                        description: null,
                        sections: [],
                        deleted: false,
                        company: null
                    };
                }
            }
        })
        .state('questionnaire-admin.edit', {
            parent: 'questionnaire-admin',
            url: '/edit/{id}',
            params : {
                companyId: null
            },
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire-edit/questionnaire-edit-dialog.html',
                    controller: 'QuestionnaireEditDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['Questionnaire', '$stateParams', function (Questionnaire, $stateParams) {
                        return Questionnaire.get({id: $stateParams.id}).$promise;
                }]
            }
        })
            .state('questionnaire-admin.copy', {
                parent: 'questionnaire-admin',
                url: '/copy/{id}',
                params : {
                    companyId: null,
                    copyMode: true
                },
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/questionnaire-edit/questionnaire-edit-dialog.html',
                        controller: 'QuestionnaireEditDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['QuestionnaireCompany', '$stateParams', function (QuestionnaireCompany, $stateParams) {
                        return QuestionnaireCompany.CopyToEditForAdmin.copytoeditforadmin({id: $stateParams.id}).$promise;
                    }]
                }
            })
        .state('questionnaire-admin.delete', {
            parent: 'questionnaire-admin',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/questionnaire-edit/questionnaire-delete-dialog.html',
                        controller: 'QuestionnaireDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Questionnaire', function (Questionnaire) {
                                    return Questionnaire.get({id: $stateParams.id}).$promise;
                                }]
                        }
                    }).result.then(function () {
                        $state.go('questionnaire-admin', null, {reload: 'questionnaire-admin'});
                    }, function () {
                        $state.go('^');
                    });
                }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProjectPhaseDialogController', ProjectPhaseDialogController);

    ProjectPhaseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProjectPhase', 'Project', 'User', 'UserGroup', 'TicketStateTypeList', '$rootScope', 'uiDatetimePickerConfig', '$translate'];

    function ProjectPhaseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProjectPhase, Project, User, UserGroup, TicketStateTypeList, $rootScope, uiDatetimePickerConfig, $translate) {
        var vm = this;
        window.vvm = vm;

        vm.projectPhase = entity;
        vm.clear = clear;
        vm.save = save;
        vm.usergroups = UserGroup.query({"size": 1000});
        vm.ticketstates = TicketStateTypeList.query({"ticketType": 'PROJECT_PHASE', "size": 1000, "sort":"listIndex,asc"});
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
console.log(entity);
        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectPhase.id !== null) {
                ProjectPhase.update(vm.projectPhase, onSaveSuccess, onSaveError);
            } else {
                vm.projectPhase.ticket.company = $rootScope.getSelectedCompanyFromServer();
                ProjectPhase.save(vm.projectPhase, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:projectPhaseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.doneTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
            uiDatetimePickerConfig.buttonBar.today.text = $translate.instant('global.datepicker.today');
            uiDatetimePickerConfig.buttonBar.now.text = $translate.instant('global.datepicker.now');
            uiDatetimePickerConfig.buttonBar.time.text = $translate.instant('global.datepicker.time');
            uiDatetimePickerConfig.buttonBar.date.text = $translate.instant('global.datepicker.date');
            uiDatetimePickerConfig.buttonBar.clear.text = $translate.instant('global.datepicker.clear');
            uiDatetimePickerConfig.buttonBar.close.text = $translate.instant('global.datepicker.close');
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('ProjectPhase', ProjectPhase);

    ProjectPhase.$inject = ['$resource', 'DateUtils'];

    function ProjectPhase ($resource, DateUtils) {
        var resourceUrl =  'api/project-phases/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProjectDialogController', ProjectDialogController);

    ProjectDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
                                       'entity', 'Project', 'User', 'UserGroup', 'TicketStateTypeList',
                                       '$rootScope', 'uiDatetimePickerConfig', '$translate',
                                       'TicketRelatedMaterial', 'TicketMaterial', 'DataUtils',
                                        'AlertService'];

    function ProjectDialogController ($timeout, $scope, $stateParams, $uibModalInstance,
                                         entity, Project, User, UserGroup, TicketStateTypeList,
                                         $rootScope, uiDatetimePickerConfig, $translate,
                                         TicketRelatedMaterial, TicketMaterial, DataUtils,
                                         AlertService) {
        var vm = this;
        window.vvm = vm;

        vm.project = entity;
        vm.clear = clear;
        vm.save = save;
        vm.usergroups = UserGroup.query({"size": 1000});
        vm.ticketstates = TicketStateTypeList.query({"ticketType": 'PROJECT', "size": 1000, "sort":"listIndex,asc"});
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.picker = {
            timepickerOptions: {
                showMeridian: false
            }
        };

        vm.addedMaterialids =[];
        vm.uploadingTicketMaterial = false;
        vm.ticketMaterials = [];
        vm.uploadTicketMaterial = uploadTicketMaterial;
        vm.deleteTicketMaterial = deleteTicketMaterial;
        vm.selectedFileTooLarge = false;
        loadTicketMaterials();


        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            vm.project.addedMaterialids = vm.addedMaterialids;

            if (vm.project.id !== null) {
                Project.CRUD.update(vm.project, onSaveSuccess, onSaveError);
            } else {
                vm.project.ticket.company = $rootScope.getSelectedCompanyFromServer();
                Project.CRUD.save(vm.project, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:projectUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.doneTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
            uiDatetimePickerConfig.buttonBar.today.text = $translate.instant('global.datepicker.today');
            uiDatetimePickerConfig.buttonBar.now.text = $translate.instant('global.datepicker.now');
            uiDatetimePickerConfig.buttonBar.time.text = $translate.instant('global.datepicker.time');
            uiDatetimePickerConfig.buttonBar.date.text = $translate.instant('global.datepicker.date');
            uiDatetimePickerConfig.buttonBar.clear.text = $translate.instant('global.datepicker.clear');
            uiDatetimePickerConfig.buttonBar.close.text = $translate.instant('global.datepicker.close');
        }




        // Material

        function loadTicketMaterials() {

            var parameters = {};
            if (vm.project != null && vm.project.ticket.id > 0) {
                parameters.ticketId = vm.project.ticket.id;
            }
            if (vm.addedMaterialids.length > 0) {
                parameters.addedMaterialIds = vm.addedMaterialids.join();
            }

            TicketRelatedMaterial.Materials.query(parameters, onSuccess, onError);
            function onSuccess(data) {
                vm.ticketMaterials = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.setFileContent = function ($file, $invalidFiles) {

            vm.selectedFileTooLarge = false;
            if ($invalidFiles && $invalidFiles.length > 0) {
                invalidFileSelected($invalidFiles);
                return;
            }

            if ($file == null) {
                return;
            }

            var ticketMaterial = {
                name: $file.name,
                fileContentContentType: $file.type,
                company: {},
                ticket: null
            };

            if (vm.project.ticket != null && vm.project.ticket.id > 0) {
                ticketMaterial.ticket = vm.project.ticket;
            }

            DataUtils.toBase64($file, function (base64Data) {
                ticketMaterial.fileContent = base64Data;
                vm.uploadTicketMaterial(ticketMaterial);
            });
        };

        function invalidFileSelected($invalidFiles) {

            console.log('invalid file selected ' + JSON.stringify($invalidFiles));
            vm.selectedFileTooLarge = true;
            $timeout(function () {
                vm.selectedFileTooLarge = false;
            }, 3000);


        }

        function uploadTicketMaterial(ticketMaterial) {
            vm.selectedFileTooLarge = false;
            vm.uploadingTicketMaterial = true;

            ticketMaterial.listIndex = vm.ticketMaterials.length;


            TicketMaterial.save(ticketMaterial, onSuccess, onError);

            function onSuccess(ticketMaterial) {
                console.log('uploaded ' + +ticketMaterial.id);
                if (ticketMaterial.ticket == null) {
                    vm.addedMaterialids.push(ticketMaterial.id);
                }
                vm.uploadingTicketMaterial = false;
                loadTicketMaterials();
            }
            function onError(err) {
                vm.uploadingTicketMaterial = false;
                console.log("failed to upload ticketmaterial " + err);
            }
        }

        function deleteTicketMaterial(tm) {
            TicketMaterial.delete(tm, onSuccess, onError);

            function onSuccess(ticketMaterial) {
                console.log('deleted ticket material');
                loadTicketMaterials();
            }
            function onError(err) {
                console.log("failed to delete ticketmaterial " + err);
            }


        }



    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProjectDetailController', ProjectDetailController);

    ProjectDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Project', 'ProjectPhase', 'Task', 'AlertService', '$translate'];

    function ProjectDetailController($scope, $rootScope, $stateParams, previousState, entity, Project, ProjectPhase, Task, AlertService, $translate) {
        var vm = this;
        window.vvm = vm;

        vm.project = entity;

        vm.previousState = 'project';

        // for making navigation from root cause analysis work at least until user goes opens a dialog on this page
        if ('root-cause-analysis-detail' === previousState.name){
            vm.previousState = previousState.name + "(" + JSON.stringify(previousState.params) +")";
        }
        if ('root-cause-analysis' === previousState.name){
            vm.previousState = previousState.name;
        }
        vm.deletePhase = deletePhase;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:projectUpdate', function(event, result) {
            vm.project = result;
        });
        $scope.$on('$destroy', unsubscribe);

        loadPhases();

        function loadPhases() {
            vm.project.doneCount = 0;
            vm.project.allCount = 0;
            Project.Phases.query({"id": vm.project.id}, onPhaseSuccess, onPhaseError);

            function onPhaseSuccess(data, headers) {
                vm.project.allCount = data.length;
                vm.phases = data;
                vm.phases.forEach(function (phase) {
                    if (phase.ticket.state.ticketStateType == 'DONE') {
                        vm.project.doneCount++;
                    }
                    phase.doneCount = 0;
                    phase.allCount = 0;
                    Task.getProjectPhaseTasks({"projectPhaseId": phase.id}, onTaskSuccess, onTaskError);
                });
            }
            function onPhaseError(error) {
                console.log("failed");
            }

            function onTaskSuccess(data, headers) {
                if (data != undefined && data != null && data.length > 0) {
                    vm.phases.forEach(function (phase) {
                        if (phase.id == data[0].projectPhase.id) {
                            phase.allCount = data.length;
                            data.forEach(function (task) {
                                if (task.mainTicket.state.ticketStateType == 'DONE') {
                                    phase.doneCount++;
                                }
                            });
                            phase.tasks = data;
                        }
                    });
                }

            }
            function onTaskError(error) {
                console.log("failed");
            }
        }

        function deletePhase(phase) {
            ProjectPhase.delete(phase, onSuccess, onError);

            function onSuccess(phase) {
                console.log('deleted project phase');
                loadPhases();
            }
            function onError(err) {
                console.log("failed to delete project phase " + err);
                AlertService.error($translate.instant("abcQualityMatchApp.projectPhase.delete.fail"));
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProjectDeleteController',ProjectDeleteController);

    ProjectDeleteController.$inject = ['$uibModalInstance', 'entity', 'Project'];

    function ProjectDeleteController($uibModalInstance, entity, Project) {
        var vm = this;

        vm.project = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Project.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project', {
            parent: 'functions_menu',
            url: '/project?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT'],
                pageTitle: 'abcQualityMatchApp.project.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/project/project/projects.html',
                    controller: 'ProjectController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('ticketMaterial');
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-detail', {
            parent: 'project',
            url: '/project/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT'],
                pageTitle: 'abcQualityMatchApp.project.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/project/project/project-detail.html',
                    controller: 'ProjectDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('ticketMaterial');
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('projectPhase');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('frequence');
                    $translatePartialLoader.addPart('recurrence');
                    $translatePartialLoader.addPart('information');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Project', function($stateParams, Project) {
                    return Project.CRUD.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('project-detail.edit', {
            parent: 'project-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/project/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.CRUD.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project.new', {
            parent: 'project',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/project/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                ticket: {
                                    id: null,
                                    priority: 0
                                }
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: 'project' });
                }, function() {
                    $state.go('project');
                });
            }]
        })
        .state('information.project-new', {
            parent: 'information',
            url: '/{id}/project/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/project/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                ticket: {
                                    id: null,
                                    priority: 0
                                },
                                information : {
                                    id: $stateParams.id
                                }
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: 'project' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('root-cause-analysis-detail.newCorrectiveProject', {
            parent: 'root-cause-analysis-detail',
            url: '/newcorrectiveproject',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/project/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                ticket: {
                                    id: null,
                                    priority: 0
                                },
                                linkAsCorrectiveProjectToRootCauseAnalysisId: $stateParams.id
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project.edit', {
            parent: 'project',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/project/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.CRUD.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: 'project' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project.delete', {
            parent: 'project',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/project/project/project-delete-dialog.html',
                    controller: 'ProjectDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.CRUD.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: 'project' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-detail.phase-edit', {
            parent: 'project-detail',
            url: '/phase/edit/{phaseId}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/project/project-phase/project-phase-dialog.html',
                    controller: 'ProjectPhaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectPhase', function(ProjectPhase) {
                            return ProjectPhase.get({id : $stateParams.phaseId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-detail.phase-new', {
            parent: 'project-detail',
            url: '/phase/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'PROJECT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/project/project-phase/project-phase-dialog.html',
                    controller: 'ProjectPhaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                ticket: {
                                    priority: 0
                                },
                                project: {
                                    id : $stateParams.id
                                }                                
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        ;
    }

})();

(function () {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('Project', Project);

    Project.$inject = ['$resource', 'DateUtils'];

    function Project($resource, DateUtils) {
        var resourceUrl = 'api/projects/:id';

        return {
            CRUD: $resource(resourceUrl, {}, {
                'query': {method: 'GET', isArray: true},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                            data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                            data.ticket.doneTime = DateUtils.convertDateTimeFromServer(data.ticket.doneTime);
                        }
                        return data;
                    }
                },
                'update': {
                    method: 'PUT',
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                        copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                        return angular.toJson(copy);
                    }
                },
                'save': {
                    method: 'POST',
                    transformRequest: function (data) {
                        var copy = angular.copy(data);
                        copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                        copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                        return angular.toJson(copy);
                    }
                }
            }),
            Phases: $resource(resourceUrl + '/phases', {}, {'query': {method: 'GET', isArray: true}}),
            UsersOpenProjects: $resource('api/projects/open', {}, {'query': {method: 'GET', isArray: true}})
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProjectController', ProjectController);

    ProjectController.$inject = ['$scope', '$state', 'Project', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$translate'];

    function ProjectController ($scope, $state, Project, ParseLinks, AlertService, paginationConstants, pagingParams, $translate) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.deleteProject = deleteProject;

        loadAll();

        function loadAll () {
            Project.CRUD.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.projects = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function deleteProject(project) {
            Project.CRUD.delete(project, onSuccess, onError);

            function onSuccess(project) {
                console.log('deleted project');
                loadAll();
            }
            function onError(err) {
                console.log("failed to delete project " + err);
                AlertService.error($translate.instant("abcQualityMatchApp.project.delete.fail"));
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$scope', '$state', '$http', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'Company'];

    function NavbarController($scope, $state, $http, Auth, Principal, ProfileService, LoginService, Company) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.defaultLogoUrl = "content/images/ABC_QualityMatch_logo.png"
        loadCurrentAccount();

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        $scope.$root.$on('authenticationSuccess', function () {
            loadCurrentAccount();
        });

        function loadCurrentAccount() {
            Principal.identity().then(function (account) {
                vm.currentAccount = account;
                loadLogo();
            });
        }

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function loadLogo() {
            vm.hasLogo = false;
            Company.getLogoId({}, onGetLogoIdSuccess, setDefaultLogo);
        }

        function setDefaultLogo() {
            vm.hasLogo = false;
        }

        function onGetLogoIdSuccess(result) {
            if (!result.logoId){
                setDefaultLogo();
                return;
            }
            vm.logoUrl = "/api/companies/get-logo/" + result.logoId;
            vm.hasLogo = true;

        }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        $scope.companySelected = function (company) {
            $scope.$root.setSelectedCompanyToServer(company);
            $state.go('home');
            loadLogo();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp').filter('ticketMaterialEncodeFilename', function () {

        return function (name) {
            return  window.encodeURIComponent(name)
        };
    });

    angular
        .module('abcQualityMatchApp').filter('ticketMaterialLinkUrlAddProtocoll', function() {
            return function(url) {
                if (!url.match('^.+://')){
                    url = 'http://' + url;
                }
                return url;
            }
        });

    angular
            .module('abcQualityMatchApp')
            .controller('InformationDialogController', InformationDialogController);

    InformationDialogController.$inject = [
        '$scope', 'Principal', '$state', '$anchorScroll','$location',
        'newInformationQuestionnaire',
        'hiddenParams', '$log',
        'TicketStateTypeList', 'Product', 'ProductLine',
        'User', 'Information',
        'UserGroup',
        'ReasonCode', 'uiDatetimePickerConfig', '$translate',
        'TicketRelatedMaterial', 'TicketMaterial', 'DataUtils',
        'informationDialogLoadDTO', 'IssueSignificance','AlertService'];

    function InformationDialogController(
        $scope, Principal, $state, $anchorScroll,$location,
        newInformationQuestionnaire,
        hiddenParams, $log,
        TicketStateTypeList, Product, ProductLine,
        User, Information,
        UserGroup,
        ReasonCode, uiDatetimePickerConfig, $translate,
        TicketRelatedMaterial, TicketMaterial, DataUtils,
        informationDialogLoadDTO, IssueSignificance, AlertService) {

        var vm = this;
        window.vvm = vm;
        $location.hash('page_top');
        $anchorScroll();
        vm.returnToView = 'home';
        if (hiddenParams.returnToView){
            vm.returnToView = hiddenParams.returnToView;
        }


        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.submitDate = false;

        vm.openCalendar = openCalendar;
        vm.picker = {
            timepickerOptions: {
                showMeridian: false
            }
        };

        if (informationDialogLoadDTO){
            // Dialog is used for editing existing information
            vm.questionnaireAnswer = informationDialogLoadDTO.questionnaireAnswer;
            vm.questionnaire = informationDialogLoadDTO.questionnaireAnswer.questionnaire
            vm.information = informationDialogLoadDTO.information;
            vm.disabled = !informationDialogLoadDTO.currentUserEditAllowed;
        }
        else {
            // Dialog is used for creating new information
            vm.questionnaire = newInformationQuestionnaire;
            vm.questionnaireAnswer = null;
            vm.information = {
                ticket: {
                    priority:null,
                    title: hiddenParams.questionnaireSectionTitle,
                    description: hiddenParams.questionTitle
                },
                issueSignificances: [],
                significanceAssesmentDone: false
            };
            vm.information.submitDate = new Date();
            vm.disabled = false;
        }

        vm.currentSection = 0;
        vm.hiddenParams = hiddenParams;

        vm.issueSignificances = [];
        vm.secondaryInformationVisible = hasSomethingDefinedInSecondaryInformation(vm.information);

        vm.productlines = ProductLine.query({"size": 1000});
        vm.usergroups = UserGroup.query({"size": 1000});
        vm.reasoncodes = ReasonCode.forInformationType({"questionnaireType": vm.questionnaire.questionnaireType});
        loadTicketStates();

        loadIssueSignificances();

        vm.addedMaterialids =[];
        vm.uploadingTicketMaterial = false;
        vm.ticketMaterials = [];
        vm.uploadTicketMaterial = uploadTicketMaterial;
        vm.deleteTicketMaterial = deleteTicketMaterial;
        vm.moveTicketMaterial = moveTicketMaterial;
        vm.selectedFileTooLarge = false;

        createAnswersForQuestionnaire();
        loadTicketMaterials();

        vm.showSaveButton = function () {
            if (vm.questionnaire.sections.length === 0) {
                return true;
            }
            return vm.currentSection === vm.questionnaire.sections.length - 1;
        };


        function loadTicketStates () {
            TicketStateTypeList.query({"ticketType": 'INFORMATION', "size": 1000, "sort":"listIndex,asc"}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.ticketstates = data;
                if (!vm.information.id) {
                    vm.information.ticket.state = vm.ticketstates[0];
                }
            }
            function onError(error) {
            }
        }

        function loadIssueSignificances(){
            IssueSignificance.query({}, onSuccess);

            function onSuccess(issueSignificances){
                vm.issueSignificances = issueSignificances;

                //adding already set but since deleted significance
                vm.information.issueSignificances.forEach(function(significance){
                    if (-1 === vm.issueSignificances.findIndex(function(sig){return sig.id == significance.id;})){
                        vm.issueSignificances.push(significance);
                    }
                });

                // setting selected significances to selected state
                vm.issueSignificances.forEach(function(significance){
                        significance.selected = -1 < vm.information.issueSignificances.findIndex(function(sig){return sig.id == significance.id;});
                });
            }
        }

        function createAnswersForQuestionnaire() {
            var answerMap = new Map();
            if (vm.questionnaireAnswer != null) {
                vm.questionnaireAnswer.answers.forEach(function (answer) {
                    answerMap.set(answer.question.id, answer);
                });
            }

            vm.questionnaire.sections.forEach(function (section) {
                section.questions.forEach(function (question) {
                    $log.debug(question.id);
                    $log.debug(answerMap.get(question.id));
                    var answer = answerMap.get(question.id);

                    if (!answer) {
                        answer = {};
                        answer.questionRootVersionId = question.rootVersionId;
                        answer.answerType = question.questionType;
                        answer.anomaly = false;
                        answer.anomalyConfirmed = false;
                        if (answer.answerType === "multi") {
                            answer.optionAnswers = [];
                        } else {
                            answer.value = null;
                        }
                    } else {
                        answer = angular.copy(answer);
                    }
                    question.answer = answer;

                });
            });

        }

        function onSaveSuccess() {

            $state.go(vm.returnToView);
        }

        vm.cancel = function() {
            $state.go(vm.returnToView);
        };

        function onSaveError() {
            alert("Virhe tapahtui lomaketta tallennettaessa.");
        }

        vm.saveAnswers = function () {
            var questionnaireAnswer = {};
            if (vm.questionnaireAnswer != null) {
                questionnaireAnswer = angular.copy(vm.questionnaireAnswer);
                questionnaireAnswer.answers = [];
            } else {
                questionnaireAnswer.id = null;
                questionnaireAnswer.answerTime = new Date();
                questionnaireAnswer.questionnaire = {};
                questionnaireAnswer.questionnaire.id = vm.questionnaire.id;
                questionnaireAnswer.user = null;
                questionnaireAnswer.answers = [];
                questionnaireAnswer.anomalyConfirmed = false;
            }

            questionnaireAnswer.anomaly = false;


            vm.questionnaire.sections.forEach(function (section) {
                section.questions.forEach(function (questionOriginal) {
                    var answer = angular.copy(questionOriginal.answer);
                    var question = angular.copy(questionOriginal);
                    question.answer = null;
                    answer.question = question;
                    answer.anomaly = false;

                    questionnaireAnswer.answers.push(answer);
                });
            });


            vm.information.issueSignificances = vm.issueSignificances.filter(function(sig){return sig.selected});

            if (vm.questionnaireAnswer != null) {
                $log.debug("Update with information");
                var dto = {};
                dto.questionnaireAnswer = questionnaireAnswer;
                dto.information = vm.information;
                Information.update(dto, onSaveSuccess, onSaveError);
            } else {
                $log.debug("Save with information");
                var dto = {};

                if (vm.hiddenParams.anomalyQuestionnaireAnswerId != null && vm.hiddenParams.anomalyQuestionnaireAnswerId > 0) {
                    dto.anomalyQuestionnaireAnswerId = vm.hiddenParams.anomalyQuestionnaireAnswerId;
                    dto.anomalyAnswerId = vm.hiddenParams.anomalyAnswerId;
                }

                dto.questionnaireAnswer = questionnaireAnswer;
                dto.information = vm.information;
                dto.addedMaterialids = vm.addedMaterialids;
                Information.save(dto, onSaveSuccess, onSaveError);
            }
        };







        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
            uiDatetimePickerConfig.buttonBar.today.text = $translate.instant('global.datepicker.today');
            uiDatetimePickerConfig.buttonBar.now.text = $translate.instant('global.datepicker.now');
            uiDatetimePickerConfig.buttonBar.time.text = $translate.instant('global.datepicker.time');
            uiDatetimePickerConfig.buttonBar.date.text = $translate.instant('global.datepicker.date');
            uiDatetimePickerConfig.buttonBar.clear.text = $translate.instant('global.datepicker.clear');
            uiDatetimePickerConfig.buttonBar.close.text = $translate.instant('global.datepicker.close');
        }

        // Material

        function moveTicketMaterial(index, direction) {
            var tm = vm.ticketMaterials[index];

            var step = 1;
            if (direction === 'down') {
                step = -1;
            }

            var parameters = {
                newListIndex: tm.listIndex + step

            };

            if (vm.information.ticket.id > 0) {
                parameters.ticketId = vm.information.ticket.id;
            }
            if (vm.addedMaterialids.length > 0) {
                parameters.addedMaterialIds = vm.addedMaterialids.join();
            }


            TicketRelatedMaterial.Order.updateListIndex({ticketMaterialId: tm.id, inParams: parameters}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.ticketMaterials = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }


        function loadTicketMaterials() {

            var parameters = {};
            if (vm.information != null && vm.information.ticket != undefined && vm.information.ticket.id > 0) {
                parameters.ticketId = vm.information.ticket.id;
            }
            if (vm.addedMaterialids.length > 0) {
                parameters.addedMaterialIds = vm.addedMaterialids.join();
            }


            TicketRelatedMaterial.Materials.query(parameters, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.ticketMaterials = data;

                if (!vm.secondaryInformationVisible && vm.ticketMaterials.length > 0){
                    //Case where sencondary section has no properties set and is therefore closed at edit start
                    vm.secondaryInformationVisible = true;
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.setFileContent = function ($file, $invalidFiles) {

            vm.selectedFileTooLarge = false;
            if ($invalidFiles && $invalidFiles.length > 0) {
                invalidFileSelected($invalidFiles);
                return;
            }

            if ($file == null) {
                return;
            }

            var ticketMaterial = {
                name: $file.name,
                fileContentContentType: $file.type,
                company: {},
                ticket: null
            };
            if (vm.information != null && vm.information.ticket != undefined && vm.information.ticket.id) {
                ticketMaterial.ticket = vm.information.ticket;
            }


            DataUtils.toBase64($file, function (base64Data) {
                ticketMaterial.fileContent = base64Data;
                vm.uploadTicketMaterial(ticketMaterial);
            });
        };

        function invalidFileSelected($invalidFiles) {

            console.log('invalid file selected ' + JSON.stringify($invalidFiles));
            vm.selectedFileTooLarge = true;
            $timeout(function () {
                vm.selectedFileTooLarge = false;
            }, 3000);


        }

        function uploadTicketMaterial(ticketMaterial) {
            vm.selectedFileTooLarge = false;
            vm.uploadingTicketMaterial = true;

            ticketMaterial.listIndex = vm.ticketMaterials.length;


            TicketMaterial.save(ticketMaterial, onSuccess, onError);

            function onSuccess(ticketMaterial) {
                console.log('uploaded ' + +ticketMaterial.id);
                if (ticketMaterial.ticket == null) {
                    vm.addedMaterialids.push(ticketMaterial.id);
                }
                vm.uploadingTicketMaterial = false;
                loadTicketMaterials();
            }
            function onError(err) {
                vm.uploadingTicketMaterial = false;
                console.log("failed to upload ticketmaterial " + err);
            }
        }

        function deleteTicketMaterial(tm) {
            TicketMaterial.delete(tm, onSuccess, onError);

            function onSuccess(ticketMaterial) {
                console.log('deleted ticket material');
                loadTicketMaterials();
            }
            function onError(err) {
                console.log("failed to delete ticketmaterial " + err);
            }


        }


        vm.toggleSecondaryVisible = function(){
            vm.secondaryInformationVisible = !vm.secondaryInformationVisible;
        };

        function hasSomethingDefinedInSecondaryInformation(information){
            var ticketHasData = false;
            if (information.ticket) {
                ticketHasData = information.ticket.place ||
                information.ticket.priority ||
                information.ticket.productLine ||
                information.ticket.product ||
                information.ticket.productBatch ||
                information.ticket.assignedTo ||
                information.ticket.assignedToUserGroup;
            }

            return ticketHasData ||
            information.reasonCode ||
            information.standardSection ||
            information.immediateActions ||
            information.productActions ||
            information.correctiveActions;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('information_menu', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('information', {
                parent: 'functions_menu',
                url: '/information?page&sort&search&searchTerm&questionnareTypes&fromDate&toDate&productId&ticketStateTypeId&productLineId&reasonCodeId&productionUnitId',
                data: {
                    authorities: ['ROLE_COMPANY_USER'],
                    pageTitle: 'abcQualityMatchApp.information.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/information/information.html',
                        controller: 'InformationController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: '(submit_date),desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            searchTerm: $stateParams.searchTerm,
                            fromDate: $stateParams.fromDate,
                            toDate: $stateParams.toDate,
                            productId: $stateParams.productId,
                            productLineId: $stateParams.productLineId,
                            statusId: $stateParams.statusId,
                            ticketStateTypeId: $stateParams.ticketStateTypeId,
                            questionnareTypes: $stateParams.questionnareTypes,
                            productionUnitId : $stateParams.productionUnitId
                        };
                    }],

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('information');
                        $translatePartialLoader.addPart('informationEvent');
                        $translatePartialLoader.addPart('questionnaireType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    userPreferences: ['UserPreferences', function (UserPreferences) {
                        return UserPreferences.get().$promise;
                    }]
                }
            })
            .state('newInformation', {
                parent: 'information',
                url: '/new-information/{questionnaireId}/',
                params : {
                    anomalyQuestionnaireAnswerId: null,
                    anomalyAnswerId: null,
                    questionnaireSectionTitle: null,
                    questionTitle: null,
                    returnToView: null
                },
                data: {
                    authorities: ['ROLE_COMPANY_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/information/information-dialog.html',
                        controller: 'InformationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('question');
                        $translatePartialLoader.addPart('ticket');
                        $translatePartialLoader.addPart('ticketMaterial');
                        $translatePartialLoader.addPart('anomalyEvent');
                        $translatePartialLoader.addPart('information');
                        $translatePartialLoader.addPart('questionnaire');
                        return $translate.refresh();
                    }],
                    newInformationQuestionnaire: ['$stateParams', 'Questionnaire', function($stateParams, Questionnaire) {
                        return Questionnaire.get({id : $stateParams.questionnaireId}).$promise;
                    }],
                    informationDialogLoadDTO: [ function() {
                        return null;
                    }],
                    hiddenParams: ['$stateParams', function($stateParams) {
                        return {
                            anomalyQuestionnaireAnswerId: $stateParams.anomalyQuestionnaireAnswerId,
                            anomalyAnswerId: $stateParams.anomalyAnswerId,
                            questionnaireSectionTitle: $stateParams.questionnaireSectionTitle,
                            questionTitle: $stateParams.questionTitle,
                            returnToView: $stateParams.returnToView
                        };
                    }]
                }
            })
            .state('editInformation', {
                parent: 'information',
                url: '/edit-information/{id}',
                params : {
                    returnToView: null
                },
                data: {
                    authorities: ['ROLE_COMPANY_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/information/information-dialog.html',
                        controller: 'InformationDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('question');
                        $translatePartialLoader.addPart('ticket');
                        $translatePartialLoader.addPart('ticketMaterial');
                        $translatePartialLoader.addPart('anomalyEvent');
                        $translatePartialLoader.addPart('information');
                        $translatePartialLoader.addPart('questionnaire');
                        return $translate.refresh();
                    }],
                    newInformationQuestionnaire: [function() {
                        return null;
                    }],
                    informationDialogLoadDTO: ['$stateParams', 'Information', function($stateParams, Information) {
                        return Information.getInformationDialogLoadDTO({id : $stateParams.id}).$promise;

                    }],
                    hiddenParams: ['$stateParams', function($stateParams) {
                        return {
                            returnToView: $stateParams.returnToView
                        };
                    }]
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('InformationController', InformationController);

    InformationController.$inject = ['$scope',
        '$state', 'Information', 'ParseLinks',
        'AlertService', 'paginationConstants', 'pagingParams',
        'QuestionnaireCompany', 'DataUtils',
        'userPreferences', 'UserPreferences', 'DateUtils',
        '$stateParams', 'TicketState', 'Product', 'ProductLine', 'ReasonCode'];

    function InformationController($scope,
                                   $state, Information, ParseLinks,
                                   AlertService, paginationConstants, pagingParams,
                                   QuestionnaireCompany, DataUtils,
                                   userPreferences, UserPreferences, DateUtils,
                                   $stateParams, TicketState, Product, ProductLine, ReasonCode) {
        var vm = this;

        vm.savingPreferences = false;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = 50;
        vm.userPreferences = userPreferences;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {fromDate: false, toDate: false};
        vm.informationQuestionnairesTypes = ["ANOMALY", "CLOSE_CALL",
            "DANGER", "PROPOSITION", "CHANGE_NOTIFICATION",
            "BULLETIN_NOTIFICATION", "INJURY_NOTIFICATION", "RECLAMATION_NOTIFICATION", "INITIATIVE_NOTIFICATION"];

        vm.informationQuestionnaires = QuestionnaireCompany.QueryByTypes.query({
            types: vm.informationQuestionnairesTypes.join(),
            "size": 1000
        });

        vm.addToFilterByQuestionnaireTypes = ""; //"" means slect shows placeholder
        vm.filterByQuestionnaireTypes = [];

        if (pagingParams.questionnareTypes) {
            vm.filterByQuestionnaireTypes = pagingParams.questionnareTypes.split(',');
        }
        vm.cacheBuster = new Date().getTime();
        vm.createRootCauseAnalysisForSelected = createRootCauseAnalysisForSelected;
        vm.uploadImportSheet = uploadImportSheet;

        if ($stateParams.toDate) {
            vm.filteringToDate = DateUtils.convertLocalDateFromServer($stateParams.toDate);
        }
        if ($stateParams.fromDate) {
            vm.filteringFromDate = DateUtils.convertLocalDateFromServer($stateParams.fromDate);
        }
        if ($stateParams.searchTerm) {
            vm.filteringSearchTerm = $stateParams.searchTerm;
        }
        if ($stateParams.productId) {
            vm.filteringProductId = $stateParams.productId;
        }
        if ($stateParams.productLineId) {
            vm.filteringProductLineId = $stateParams.productLineId;
        }
        if ($stateParams.ticketStateTypeId) {
            vm.filteringTicketStateTypeId = $stateParams.ticketStateTypeId;
        }
        if ($stateParams.reasonCodeId) {
            vm.filteringReasonCodeId = $stateParams.reasonCodeId;
        }
        if ($stateParams.productionUnitId) {
            vm.filteringProductionUnitId = $stateParams.productionUnitId;
        }

        loadAll();
        loadProductLines();
        loadReasonCodes();
        loadStatusCodes();
        if(vm.filteringProductId){
            loadProduct();
        }

        vm.productSelected = function () {
            if (vm.filteringProduct) {
                vm.filteringProductId = vm.filteringProduct.id;
            }else{
                vm.filteringProductId = null;
            }
            vm.refreshSearch();

        }

        vm.refreshSearch = function () {
            if (vm.addToFilterByQuestionnaireTypes == "ALL") {
                vm.filterByQuestionnaireTypes = [];
            } else if (vm.addToFilterByQuestionnaireTypes != "") {
                var index = vm.filterByQuestionnaireTypes.indexOf(vm.addToFilterByQuestionnaireTypes);
                if (index == -1) {
                    vm.filterByQuestionnaireTypes.push(vm.addToFilterByQuestionnaireTypes);
                }
            }
            vm.addToFilterByQuestionnaireTypes = "";
            loadPage(1);
        };

        vm.removeFilterQuestionnaireType = function (type) {
            var index = vm.filterByQuestionnaireTypes.indexOf(type);
            if (index > -1) {
                vm.filterByQuestionnaireTypes.splice(index, 1);
            }
            loadPage(1);
        };

        function addFilteringParameters(parameters) {

            if (vm.filteringFromDate) {
                parameters.fromDate = DateUtils.convertLocalDateToServer(vm.filteringFromDate);
            }
            if (vm.filteringToDate) {
                parameters.toDate = DateUtils.convertLocalDateToServer(vm.filteringToDate);
            }
            if (vm.filteringSearchTerm) {
                parameters.searchTerm = vm.filteringSearchTerm;
            }
            if (vm.filteringProductId) {
                parameters.productId = vm.filteringProductId;
            }
            if (vm.filteringProductLineId) {
                parameters.productLineId = vm.filteringProductLineId;
            }
            if (vm.filteringReasonCodeId) {
                parameters.reasonCodeId = vm.filteringReasonCodeId;
            }
            if (vm.filteringProductionUnitId){
                parameters.productionUnitId = vm.filteringProductionUnitId;
            }
            if (vm.filteringTicketStateTypeId){
                parameters.ticketStateTypeId = vm.filteringTicketStateTypeId;
            }

            return parameters;
        }

        function loadAll() {
            var parameters = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                questionnareTypes: vm.filterByQuestionnaireTypes.join(),
                sort: sort()
            };

            parameters = addFilteringParameters(parameters);
            vm.informationExportParameters = parameters;
            Information.informationEventsQuery(parameters, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.information = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadProduct() {

            Product.get({'id': vm.filteringProductId}, onSuccess, onError);

            function onSuccess(product) {
                vm.filteringProduct = product;
            }

            function onError(error) {
                console.log("failed loading products");
            }
        }

        function loadProductLines() {
            ProductLine.query({"size": 1000, "sort": "name,asc"}, onSuccess, onError);

            function onSuccess(productLines, headers) {
                vm.productLines = productLines;
            }

            function onError(error) {
                console.log("failed loading productLines");
            }
        }

        function loadStatusCodes() {
            TicketState.query({"size": 1000, "sort": "name,asc"}, onSuccess, onError)

            function onSuccess(statusCode, headers) {
                var opts=[];
                for (var key in statusCode) {
                    if (statusCode[key].ticketType == "INFORMATION") {
                        opts.push({id: statusCode[key].id, name: statusCode[key].name})
                    }
                }
                vm.statusCodes = opts;
            }

            function onError(error) {
                console.log("failed loading statusCodes ", error)
            }
        }

        function loadReasonCodes() {
            ReasonCode.query({"size": 1000, "sort": "name,asc"}, onSuccess, onError);

            function onSuccess(reasonCode, headers) {
                vm.reasonCodes = reasonCode;
            }

            function onError(error) {
                console.log("failed loading reasonCodes");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {

            var parameters = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                size: pagingParams.size
            };
            parameters = addFilteringParameters(parameters);
            if (vm.filterByQuestionnaireTypes.length > 0) {
                parameters.questionnareTypes = vm.filterByQuestionnaireTypes.join();
            }
            vm.informationExportParameters = parameters;
            console.log("transition parameters " + JSON.stringify(parameters));
            $state.transitionTo($state.$current, parameters);
        }

        function createRootCauseAnalysisForSelected() {
            var ids = [];
            vm.information.forEach(function (info) {
                if (info.selectionChecked) {
                    ids.push(info.id);
                }
            });

            if (ids.length === 0) {
                console.log('Nothing selected');
                return;
            }

            $state.go('root-cause-analysis.new', {inf: ids})
        }


        function uploadImportSheet($file) {

            if ($file == null) {
                return;
            }

            var fileDTO = {};

            DataUtils.toBase64($file, function (base64Data) {
                fileDTO.fileContent = base64Data;
                vm.upload(fileDTO);
            });
        }

        vm.upload = function (fileDTO) {
            vm.uploadingImportSheet = true;
            vm.importError = null;
            Information.uploadInformationImportSheet(fileDTO, onSuccess, onError);

            function onSuccess() {
                console.log('uploaded ');
                vm.importError = null;
                vm.uploadingImportSheet = false;
                $state.reload();
            }

            function onError(err) {
                vm.uploadingImportSheet = false;
                console.log("failed to upload import sheet " + JSON.stringify(err.data));

                vm.importError = {};
                if (err.data) {
                    vm.importError = err.data;

                    if (vm.importError.missingRequiredFields) {
                        vm.importError.missingRequiredFields = vm.importError.missingRequiredFields.join(", ");
                    }
                }
            }
        }

        vm.toggleVisibleColumn = function (colName) {

            var index = vm.userPreferences.informationPage.hiddenColumns.indexOf(colName);
            if (index > -1) {
                vm.userPreferences.informationPage.hiddenColumns.splice(index, 1);
            } else {
                vm.userPreferences.informationPage.hiddenColumns.push(colName);
            }

            vm.savingPreferences = true;
            UserPreferences.save(vm.userPreferences, prefSaveSuccess, prefSaveFail);

            function prefSaveSuccess(newPrefs) {
                vm.userPreferences = newPrefs;
                vm.savingPreferences = false;
                $state.reload();
            }

            function prefSaveFail() {
                vm.savingPreferences = false;
            }

        };

        vm.isHiddenColumn = function (colName) {
            return vm.userPreferences.informationPage.hiddenColumns.indexOf(colName) !== -1;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('anomaly', {
            parent: 'functions_menu',
            url: '/anomaly?page&sort&search&searchTerm&fromDate&toDate&questionnaireId&answerAuthorUserId&taskId',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.anomaly.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/information/anomaly/anomaly.html',
                    controller: 'AnomalyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: '(answer_time),desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchTerm: $stateParams.searchTerm,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate,
                        answerAuthorUserId: $stateParams.answerAuthorUserId,
                        questionnaireId: $stateParams.questionnaireId,
                        taskId: $stateParams.taskId
                    };
                }],
                filterAnswerAuthorUser: ['$stateParams', 'User', function($stateParams, User) {
                    if ($stateParams.answerAuthorUserId) {
                        return User.get({id: $stateParams.answerAuthorUserId}).$promise;
                    }
                    return null;
                }],

                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('information');
                    $translatePartialLoader.addPart('anomalyEvent');
                    $translatePartialLoader.addPart('informationEvent');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .controller('AnomalyController', AnomalyController);

    AnomalyController.$inject = ['$timeout',
        '$scope', '$state', 'Anomaly',
        'ParseLinks', 'AlertService', 'paginationConstants',
        'pagingParams', 'QuestionnaireCompany','User','filterAnswerAuthorUser',
        'DateUtils', 'Task', '$translate'];

    function AnomalyController($timeout, $scope, $state,
                               Anomaly, ParseLinks, AlertService,
                               paginationConstants, pagingParams,
                               QuestionnaireCompany, User, filterAnswerAuthorUser,
                               DateUtils, Task,$translate) {
        var vm = this;

        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {fromDate: false, toDate:false };

        vm.refreshSearch = refreshSearch;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.allQuestionnaires = null;
        vm.informationQuestionnaires = null;
        vm.tasks = null;

        vm.pdfDownloadParameters = {};

        vm.createRootCauseAnalysisForSelected = createRootCauseAnalysisForSelected;

        vm.filtering = {
            searchTerm: pagingParams.searchTerm,
            fromDate: pagingParams.fromDate,
            toDate: pagingParams.toDate,
            taskId: pagingParams.taskId,
            answerAuthorUserId:  pagingParams.answerAuthorUserId,
            questionnaireId: pagingParams.questionnaireId
        };

        var noFilteringDefined =
            typeof vm.filtering.fromDate === "undefined" &&
            typeof vm.filtering.toDate === "undefined" &&
            typeof vm.filtering.searchTerm === "undefined" &&
            typeof vm.filtering.taskId === "undefined" &&
            typeof vm.filtering.answerAuthorUserId === "undefined" &&
            typeof vm.filtering.questionnaireId === "undefined";

        if (noFilteringDefined){
            var firstOfJanuary = new Date();
            firstOfJanuary.setMonth(0);
            firstOfJanuary.setDate(1);
            //defaulting to first day of this year
            vm.filtering.fromDate = firstOfJanuary.toISOString().slice(0,10);
        }

        vm.filteringFromDate = null;
        vm.filteringToDate = null;

        if (vm.filtering.fromDate){
            vm.filteringFromDate = DateUtils.convertLocalDateFromServer(vm.filtering.fromDate);
        }
        if (vm.filtering.toDate){
            vm.filteringToDate = DateUtils.convertLocalDateFromServer(vm.filtering.toDate);
        }




        vm.filterAnswerAuthorUser = filterAnswerAuthorUser;

        $scope.$watch('vm.filterAnswerAuthorUser',function(newVal, oldVal){
            if (typeof newVal === "undefined"){
                return;
            }
            if (!oldVal){
                oldVal = null;
            }
            if (newVal != oldVal) {
                refreshSearch();
            }
        });



        $timeout(function (){
            angular.element('#seachTerm').focus();
        });

        loadAll();
        loadQuestionnaires();
        loadTasks();

        function addFilteringParameters(parameters) {
            if (vm.filterAnswerAuthorUser) {
                vm.filtering.answerAuthorUserId = vm.filterAnswerAuthorUser.id;
                parameters.answerAuthorUserId = vm.filterAnswerAuthorUser.id;
            }
            else {
                vm.filtering.answerAuthorUserId = null;
            }

            if (vm.filteringFromDate) {
                vm.filtering.fromDate = DateUtils.convertLocalDateToServer(vm.filteringFromDate);
                parameters.fromDate = DateUtils.convertLocalDateToServer(vm.filteringFromDate);
            }
            else {
                vm.filtering.fromDate = null;
            }
            if (vm.filteringToDate) {
                vm.filtering.toDate = DateUtils.convertLocalDateToServer(vm.filteringToDate);
                parameters.toDate = DateUtils.convertLocalDateToServer(vm.filteringToDate);
            }
            else {
                vm.filtering.toDate = null;
            }

            if (vm.filtering.searchTerm ){
                parameters.searchTerm = vm.filtering.searchTerm;
            }
            if (vm.filtering.taskId ){
                parameters.taskId = vm.filtering.taskId;
            }
            if (vm.filtering.questionnaireId ){
                parameters.questionnaireId = vm.filtering.questionnaireId;
            }

            return parameters;

        }

        function loadAll() {

            var parameters = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            };

            parameters = addFilteringParameters(parameters);

            vm.pdfDownloadParameters = JSON.parse(JSON.stringify(parameters));;
            vm.pdfDownloadParameters.fileName = $translate.instant('abcQualityMatchApp.anomalyEvent.pdfExportFileName');
            vm.pdfDownloadParameters.page = 0;
            vm.pdfDownloadParameters.size = 10000;
            vm.pdfDownloadParameters.cacheBuster = new Date().getTime();

            console.log("loadAll parameters " + JSON.stringify(parameters));


            Anomaly.Company.query(parameters, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== '(row)') {
                    result.push('(row)');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.anomaly = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function refreshSearch(){
            loadPage(1);
        }

        function loadQuestionnaires() {
            QuestionnaireCompany.Query.query({"size": 1000, "sort":"title,asc"}, onSuccess, onError);

            function onSuccess(questionnaires, headers) {

                vm.allQuestionnaires = questionnaires;
                vm.informationQuestionnaires = questionnaires.filter(function(questionnaire){
                    return (questionnaire.questionnaireType === "ANOMALY");
                });
            }
            function onError(error) {
                console.log("failed loading questionnaires");
            }
        }

        function loadTasks() {
            Task.getAssignedOrEditableByUser({"size": 1000, "sort":"(title),asc"}, onSuccess, onError);

            function onSuccess(tasks, headers) {
                vm.tasks = tasks;
            }
            function onError(error) {
                console.log("failed loading tasks");
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();


        }

        function transition() {

            var parameters = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            };
            parameters = addFilteringParameters(parameters);

            console.log("transition parameters " + JSON.stringify(parameters));
            $state.transitionTo($state.$current, parameters);
        }

        vm.reject = function (qaId, answerId) {
            Anomaly.Answer.reject({"questionnaireAnswerId": qaId, "answerId": answerId}, onSuccess, onError);
            function onSuccess(data, headers) {
                $state.reload();
            }
            function onError(error) {
                console.log("failed");
            }
        }

        function createRootCauseAnalysisForSelected(){
            var ids = [];
            vm.anomaly.forEach(function (anom){
               if (anom.selectionChecked){
                   ids.push(anom.row);
               }
            });

            if (ids.length == 0){
                console.log('Nothing selected');
                return;
            }

            $state.go('root-cause-analysis.new', {aes: ids})
        }


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

    }
})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .controller('UserHomeController', UserHomeController);

    UserHomeController.$inject = [];

    function UserHomeController() {
        var vm = this;
    }

})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('taskEvent');
                        $translatePartialLoader.addPart('informationEvent');
                        $translatePartialLoader.addPart('information');
                        $translatePartialLoader.addPart('anomalyEvent');
                        $translatePartialLoader.addPart('questionnaireType');
                        $translatePartialLoader.addPart('taskVerification');
                        $translatePartialLoader.addPart('project');
                        $translatePartialLoader.addPart('ticket');
                        $translatePartialLoader.addPart('ticketMaterial');
                        $translatePartialLoader.addPart('login');
                        $translatePartialLoader.addPart('document');
                        $translatePartialLoader.addPart('documentFile');
                        return $translate.refresh();
                    }]
            }
        })
                .state('home-admin', {
                    parent: 'home',
                    url: '/home-admin',
                    data: {
                        authorities: ["ROLE_ADMIN"]
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/home/admin-home.html',
                            controller: 'AdminHomeController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                return $translate.refresh();
                            }]
                    }

                })
                .state('home-company-admin', {
                    parent: 'home',
                    url: '/home-company-admin',
                    data: {
                        authorities: ["ROLE_COMPANY_ADMIN"]
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/home/company-admin-home.html',
                            controller: 'CompanyAdminHomeController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                return $translate.refresh();
                            }]
                    }

                })
                .state('home-company-supervisor', {
                    parent: 'home',
                    url: '/home-company-supervisor',
                    data: {
                        authorities: ["ROLE_COMPANY_SUPERVISOR"]
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/home/company-supervisor-home.html',
                            controller: 'CompanySupervisorHomeController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                return $translate.refresh();
                            }]
                    }

                })
                .state('home-user', {
                    parent: 'home',
                    url: '/home-user',
                    data: {
                        authorities: ["ROLE_COMPANY_USER"]
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/home/user-home.html',
                            controller: 'UserHomeController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                return $translate.refresh();
                            }]
                    }

                });
    }
})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', '$state', '$rootScope', '$timeout', 'Auth'];

    function HomeController($scope, Principal, $state, $rootScope, $timeout, Auth) {
        var vm = this;

        vm.authenticationError = false;
        vm.login = login;

        vm.username = null;
        vm.password = null;
        vm.rememberMe = true;

        vm.account = null;
        vm.isAuthenticated = null;


        $timeout(function (){angular.element('#username').focus();});

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });
        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                if (account == null){
                    return;
                }
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if (account.forcedPasswordChangeOnNextLogin){
                    $state.go('forced-password-change');
                }
                else if (account.authorities) {

                    if (Principal.hasAnyAuthority(["ROLE_ADMIN"])) {
                        $state.go("home-admin");
                    } else if (Principal.hasAnyAuthority(["ROLE_COMPANY_ADMIN"])) {
                        $state.go("home-company-admin");
                    } else if (Principal.hasAnyAuthority(["ROLE_COMPANY_SUPERVISOR"])) {
                        $state.go("home-company-supervisor");
                    } else if (Principal.hasAnyAuthority(["ROLE_COMPANY_USER"])) {
                        $state.go("home-user");
                    } else {
                    }
                }
            });
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                console.log("call reset")
                $rootScope.resetCompany();

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('CompanySupervisorHomeController', CompanySupervisorHomeController);

    CompanySupervisorHomeController.$inject = [];

    function CompanySupervisorHomeController () {
        var vm = this;        
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('CompanyAdminHomeController', CompanyAdminHomeController);

    CompanyAdminHomeController.$inject = [];

    function CompanyAdminHomeController () {
        var vm = this;        
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('AdminHomeController', AdminHomeController);

    AdminHomeController.$inject = [];

    function AdminHomeController () {
        var vm = this;  
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('DocumentFileStateChangeDialogController', DocumentFileStateChangeDialogController);

    DocumentFileStateChangeDialogController.$inject = ['documentFile', 'useCase', '$uibModalInstance', 'DocumentFile'];

    function DocumentFileStateChangeDialogController(documentFile, useCase, $uibModalInstance, DocumentFile) {
        var vm = this;

        vm.documentFile = documentFile;
        vm.useCase = useCase;


        vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function() {

            var newState;
            if (vm.useCase == 'inspect'){
                newState = 'INSPECTED';
            }
            else if (vm.useCase === 'approve'){
                newState = 'APPROVED';
            }
            else if (vm.useCase == 'publish'){
                newState = 'PUBLISHED';
            }
            else{
                throw "useCase must be inspect, approve, or publish"
            }

            vm.isSaving = true;
            DocumentFile.stateChange({fileId: vm.documentFile.id, newState: newState}, null, onSaveSuccess, onSaveError);

            function onSaveSuccess (result) {
                vm.isSaving = false;
                $uibModalInstance.close(result);

            }

            function onSaveError () {
                vm.isSaving = false;
            }
        };





    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .component('notableDocumentsListView', {
            templateUrl: 'app/document/notable-documents-list-component/notable-documents-list-component.html',
            controllerAs: 'vm',
            controller: NotableDocumentsListView
        });

    NotableDocumentsListView.$inject = ['DocumentFile', '$state','$uibModal'];
    function NotableDocumentsListView(DocumentFile, $state, $uibModal) {
        var vm = this;
        vm.notableFiles = null;

        load();

        function load() {
            DocumentFile.getNotableFiles({}, onSuccess, onError);
            function onSuccess(data) {
                vm.notableFiles = data;
            }
            function onError(error) {
                console.log("failed");
            }
        }

        vm.openStateChangeDialog = function(documentFile, useCase){
            console.log("state change dialog for %s to new useCase: %s", documentFile.id, useCase);

            $uibModal.open({
                templateUrl: 'app/document/state-change-dialog/document-state-change-dialog.html',
                controller: 'DocumentFileStateChangeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    documentFile: documentFile,
                    useCase: function (){return useCase;}
                }
            }).result.then(function(result) {
                $state.reload();
            });

        };

    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('DocumentTreeViewController', DocumentTreeViewController);

    DocumentTreeViewController.$inject = [
        '$scope', '$state', '$stateParams',
        'DocumentFolder', 'AlertService', '$translate',
        'DocumentTree','DocumentTreeUtils'];

    function DocumentTreeViewController (
        $scope, $state, $stateParams,
        DocumentFolder, AlertService, $translate,
        DocumentTree, DocumentTreeUtils) {

        var vm = this;

        vm.fsItems = [];
        vm.searchTerms = null;
        vm.searchMatchCount = 0;
        vm.rootFolders = [];

        vm.filterBySearchTerms = function(searchTerms){
            vm.searchTerms = searchTerms;
            if (!vm.searchTerms){
                DocumentTreeUtils.setDefaultOpenStates(vm.rootFolders);
                return;
            }
            vm.rootFolders.forEach(function(folder){
                DocumentTreeUtils.closeFolder(folder, vm.searchTerms);
            });

            vm.rootFolders.forEach(function(folder){
                vm.searchMatchCount = DocumentTreeUtils.setFilterMatchFlags(folder, vm.searchTerms);
            });
        };

        loadTreeRoot();

        function loadTreeRoot() {
            var params = {};
            DocumentTree.getPublishedFolderTree(params, onSuccess, onError);

            function onSuccess(rootFolders) {
                vm.rootFolders = rootFolders;
                var openFolderIds = [];
                vm.fsItems.forEach(function(isItem){
                    if (isItem.rowType === 'folder' && isItem.open){
                        openFolderIds.push(isItem.id);
                    }
                });
                vm.fsItems = DocumentTreeUtils.rootFoldersToFlatFsItemList(rootFolders, openFolderIds);

                if (openFolderIds.length === 0){
                    DocumentTreeUtils.setDefaultOpenStates(vm.rootFolders);
                }

                if (vm.searchTerms) {
                    vm.filterBySearchTerms();
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.reload = function(){
            loadTreeRoot();
        };

        vm.folderClick = function(folder){
            folder.open = !folder.open;
            if (!folder.open){
                DocumentTreeUtils.closeFolder(folder);
            }
        };
    }
})();












(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('DocumentTreeUtils', DocumentTreeUtils);

    function DocumentTreeUtils () {

        var service = {
            setFilterMatchFlags: setFilterMatchFlags,
            rootFoldersToFlatFsItemList: rootFoldersToFlatFsItemList,
            closeFolder: closeFolder,
            setDefaultOpenStates: setDefaultOpenStates
        };
        return service;

        function setFilterMatchFlags(folder, searchTerm){
            var matches = 0;

            folder.subFolders.forEach(function(sub){
                matches = matches + setFilterMatchFlags(sub, searchTerm);
            });

            folder.files.forEach(function(file){
                var fileMatch = isMatch(file.name, searchTerm) || isMatch(file.classification, searchTerm);
                file.filterMatch = fileMatch;
                if (fileMatch){
                    ++matches;
                }
            });

            if (isMatch(folder.name, searchTerm)){
               ++matches;
            }
            folder.filterMatch = matches > 0;
            return matches;
        }

        function isMatch(text, searchTerm){
            if (!text){
                return false;
            }
            return text.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
        }

        function closeFolder(folder){
            folder.open = false;

            folder.subFolders.forEach(function(sub){
                closeFolder(sub);
            });
        }

        function setDefaultOpenStates(rootFolders){
            rootFolders.forEach(function(folder){
                folder.open = true;
                folder.subFolders.forEach(function(sub){
                    closeFolder(sub);
                });
            });
        }

        function rootFoldersToFlatFsItemList(rootFolders, openFolderIds){
            var list = [];
            rootFolders.forEach(function(folder){
                toFlatList(folder, 0, openFolderIds).forEach(function(sub){list.push(sub);});
            });
            return list;
        }

        function toFlatList(folder, nestingLevel, openFolderIds){
            var list = [];
            folder.nestingLevel = nestingLevel;
            folder.open = openFolderIds.indexOf(folder.id) !== -1;
            folder.rowType = 'folder';
            folder.trackingId = 'folder' + folder.id;
            list.push(folder);

            folder.subFolders.forEach(function(sub){
                sub.parentFolder = folder;
                var subList = toFlatList(sub, nestingLevel + 1, openFolderIds);
                subList.forEach(function(subTree){
                    list.push(subTree);
                });
            });

            folder.files.forEach(function(file){
                file.rowType = 'file';
                file.parentFolder = folder;
                file.trackingId = 'file' + file.id;
                list.push(file);
            });
            return list;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-tree', {
            parent: 'document_menu',
            url: '/document-tree?openFolderIds&showDeleted',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.documentFolder.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/document/document-tree/document-tree.html',
                    controller: 'DocumentTreeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                openFolderIds: ['$stateParams', function($stateParams){ return $stateParams.openFolderIds;}],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentFile');
                    $translatePartialLoader.addPart('documentFolder');
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-tree.file-versioning', {
            parent: 'document-tree',
            url: '/file/versioning/{rootVersionId}?tab',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.documentFile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/document/document-tree/document-file/document-file-detail.html',
                    controller: 'DocumentFileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentFile');
                    $translatePartialLoader.addPart('documentFolder');
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                documentFileVersioning: ['$stateParams', 'DocumentFile', function($stateParams, DocumentFile) {
                    return DocumentFile.getVersioningForRootId({rootVersionId : $stateParams.rootVersionId}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-tree',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-tree-view', {
            parent: 'document_menu',
            url: '/document-tree-view?openFolderIds',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'abcQualityMatchApp.documentFolder.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/document/document-tree/tree-view/document-tree-view.html',
                    controller: 'DocumentTreeViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                openFolderIds: ['$stateParams', function($stateParams){ return $stateParams.openFolderIds;}],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentFile');
                    $translatePartialLoader.addPart('documentFolder');
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        ;
    }

})();

(function () {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('DocumentTree', DocumentTree);

    DocumentTree.$inject = ['$resource'];

    function DocumentTree($resource) {
        var resourceUrl = 'api/document-folders';

        return $resource(resourceUrl, {}, {
            'getEditableFolderTree': {method: 'GET',
                isArray: true,
                url: 'api/document-folders/editable-folder-tree'},

            'getPublishedFolderTree':{
                isArray: true,
                url: 'api/document-folders/published-folder-tree'
            },
            'getWritableFolderSelectTree':{
                url: 'api/document-folders/writable-folder-select-tree'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp').filter('documentFileEncodeFilename', function () {
        return function (name) {
            return  window.encodeURIComponent(name)
        };
    });

    angular
        .module('abcQualityMatchApp')
        .controller('DocumentTreeController', DocumentTreeController);

    DocumentTreeController.$inject = ['$scope', '$state', '$stateParams',
        'DocumentFolder', 'AlertService', '$translate',
        'DocumentTree', 'DocumentFile', '$uibModal',
        'DocumentTreeUtils'];

    function DocumentTreeController ($scope, $state, $stateParams,
        DocumentFolder, AlertService, $translate,
        DocumentTree, DocumentFile, $uibModal,
        DocumentTreeUtils) {
        var vm = this;

        vm.fsItems = [];
        vm.searchTerms = null;
        vm.searchMatchCount = 0;
        vm.rootFolders = [];
        vm.showDeleted = $stateParams.showDeleted;

        vm.filterBySearchTerms = function(searchTerms){
            vm.searchTerms = searchTerms;
            if (!vm.searchTerms){
                DocumentTreeUtils.setDefaultOpenStates(vm.rootFolders);
                return;
            }
            vm.rootFolders.forEach(function(folder){
                DocumentTreeUtils.closeFolder(folder, vm.searchTerms);
            });

            vm.rootFolders.forEach(function(folder){
                vm.searchMatchCount = DocumentTreeUtils.setFilterMatchFlags(folder, vm.searchTerms);
            });
        };

        loadTreeRoot();

        function loadTreeRoot() {
            var params = {};
            params.includeDeleted = vm.showDeleted;
            DocumentTree.getEditableFolderTree(params, onSuccess, onError);

            function onSuccess(rootFolders) {
                var openFolderIds = [];
                vm.fsItems.forEach(function(isItem){
                    if (isItem.rowType === 'folder' && isItem.open){
                        openFolderIds.push(isItem.id);
                    }
                });

                vm.rootFolders = rootFolders;
                vm.fsItems = DocumentTreeUtils.rootFoldersToFlatFsItemList(rootFolders, openFolderIds);

                if (openFolderIds.length === 0){
                    DocumentTreeUtils.setDefaultOpenStates(vm.rootFolders);
                }

                if (vm.searchTerms) {
                    vm.filterBySearchTerms(vm.searchTerms);
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        vm.reload = function(){
            loadTreeRoot();
        };

        vm.openCreateNewFileDialog = function(folderId){

            var documentFile = {
                name: null,
                id: null,
                publicFile: false,
                folderId: folderId,
                state: 'DRAFT',
                maintainers:[]
            };


            $uibModal.open({
                templateUrl: 'app/document/document-tree/document-file/edit-dialog/document-file-edit-dialog.html',
                controller: 'DocumentFileEditDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve:{
                    documentFile: function (){return documentFile;},
                    useCase: function(){return 'newFile';}
                }
            }).result.then(function(result) {
                $state.reload();
            });
        };


        vm.openCreateNewFolderDialog = function(){

            var folder = {
                name: null,
                id: null,
                permissions: [],
                parentFolderId: null
            };

            $uibModal.open({
                templateUrl: 'app/document/document-tree/document-folder/document-folder-dialog.html',
                controller: 'DocumentFolderDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: folder
                    }
            }).result.then(function(result) {
                $state.reload();
            });

        };

        vm.openEditFolderDialog = function(folderId){

            $uibModal.open({
                templateUrl: 'app/document/document-tree/document-folder/document-folder-dialog.html',
                controller: 'DocumentFolderDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['DocumentFolder', function(DocumentFolder){return DocumentFolder.CRUD.get({id:folderId}).$promise; }]
                }
            }).result.then(function(result) {
                $state.reload();
            });

        };

        vm.undeleteFolder = function(folderId){
            DocumentFolder.CRUD.undelete({id:folderId}, {}, onSuccess, onError);

            function onSuccess() {
                loadTreeRoot();
            }
            function onError(err) {
                AlertService.error($translate.instant("abcQualityMatchApp.documentFolder.undelete.fail"));
            }
        };

        vm.undeleteFile = function(fileId){
            DocumentFile.undelete({id:fileId}, {}, onSuccess, onError);

            function onSuccess() {
                loadTreeRoot();
            }
            function onError(err) {
                AlertService.error($translate.instant("abcQualityMatchApp.documentFile.undelete.fail"));
            }
        };


        vm.deleteDocumentFolder = function(folderId) {
            DocumentFolder.CRUD.delete({id:folderId}, onSuccess, onError);

            function onSuccess() {
                console.log('deleted folder');
                loadTreeRoot();
            }
            function onError(err) {
                console.log("failed to delete folder " + err);
                AlertService.error($translate.instant("abcQualityMatchApp.documentFolder.delete.fail"));
            }
        };

        vm.deleteDocumentFile = function(fileId) {
            DocumentFile.delete({id:fileId}, onSuccess, onError);

            function onSuccess() {
                console.log('deleted file');
                loadTreeRoot();
            }

            function onError(err) {
                console.log("failed to delete file " + err);
            }
        };

        vm.folderClick = function(folder){
            folder.open = !folder.open;
            if (!folder.open){
                DocumentTreeUtils.closeFolder(folder);
            }
        };
    }
})();












(function() {
    'use strict';
    angular.module('abcQualityMatchApp').component('documentFolderSelect', {
        templateUrl: 'app/document/document-tree/document-folder/document-folder-select-component/document-folder-select-component.html',
        restrict: 'E',
        bindings: {
            folderId: '=',              //Currently selected folder's id or null/undefined for root
            disableFromFolderId: '<',  //disable selecting folder with this id or any of its subfolders (to prevent folder loop)
            validSelection: '=?',       // Sets value to true if valid selection has been made
            allowInitialValue: '<' //Allow selecting what ever folder was initially given as folderId
        },
        controller: DocumentFolderSelectController
    });

    DocumentFolderSelectController.$inject = ['DocumentTree', '$translate'];
    function DocumentFolderSelectController(DocumentTree, $translate) {
        var ctrl = this;

        ctrl.selectedFolder = null;
        ctrl.initialValue = ctrl.folderId;


        ctrl.folders = [];

        init();

        ctrl.selectFolder = function(folder){

            if (!folder || folder.disabled || !folder.writable){
                return;
            }

            ctrl.selectedFolder = folder;
            ctrl.folderId = ctrl.selectedFolder.id;
            ctrl.validSelection = true;
        };

        function init(){
            DocumentTree.getWritableFolderSelectTree({}, onSuccess, onError);

            function onSuccess(rootFolder) {
                ctrl.folders = rootFoldersToFlatList(rootFolder);

                ctrl.folders.forEach(function(dir){
                    if (dir.id == ctrl.folderId){
                        ctrl.selectFolder(dir);
                    }
                });
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function rootFoldersToFlatList(rootFolder){

            rootFolder.nestingLevel = 0;

            var list = [rootFolder];

            rootFolder.subFolders.forEach(function(folder){
                toFlatList(folder, 1, false).forEach(function(sub){list.push(sub);});
            });

            list.forEach(function (folder) {
                if (ctrl.allowInitialValue && folder.id == ctrl.initialValue) {
                    folder.writable = true;
                    folder.disabled = false;
                }
            });

            return list;
        }

        function toFlatList(folder, nestingLevel, disabled){
            var list = [];
            folder.nestingLevel = nestingLevel;
            folder.indent = Array(folder.nestingLevel +1).join("&nbsp;");

            disabled = disabled || ctrl.disableFromFolderId == folder.id;
            folder.disabled = disabled;

            list.push(folder);

            folder.subFolders.forEach(function(sub){
                sub.parentFolder = folder;
                var subList = toFlatList(sub, nestingLevel + 1, disabled);
                subList.forEach(function(subTree){
                    list.push(subTree);
                });
            });

            return list;
        }





    }

})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('DocumentFolderDialogController', DocumentFolderDialogController);

    DocumentFolderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DocumentFolder', '$rootScope', 'UserGroup'];

    function DocumentFolderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DocumentFolder, $rootScope, UserGroup) {
        var vm = this;
        window.vvm = vm;
        vm.validParentFolderSelected = false;

        vm.documentFolder = entity;
        vm.clear = clear;
        vm.save = save;
        vm.userGroups = UserGroup.query({"size": 1000});
        
        vm.newPermission = createEmptyPermission();
        vm.addPermission = addPermission;
        vm.deletePermission = deletePermission;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documentFolder.id !== null) {
                DocumentFolder.CRUD.update(vm.documentFolder, onSaveSuccess, onSaveError);
            } else {
                DocumentFolder.CRUD.save(vm.documentFolder, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:documentFolderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function addPermission() {
            
            if (vm.newPermission.userGroup === null){
                return;
            } 
            
            var userGroupAlready = vm.documentFolder.permissions.find(function(permission){return permission.userGroup.id == vm.newPermission.userGroup.id});
            if (userGroupAlready){
                vm.newPermission = createEmptyPermission();
                return;
            }
            
            
            vm.documentFolder.permissions.push(vm.newPermission);
            vm.newPermission = createEmptyPermission();
            return false;
        }
        
        function deletePermission(index){
            vm.documentFolder.permissions.splice(index,1);
            return false;
            
        }
        
        function createEmptyPermission(){
            return {
                userGroup: null,
                writePermission: false
            };
        }

    }
})();

(function () {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('DocumentFolder', DocumentFolder);

    DocumentFolder.$inject = ['$resource'];

    function DocumentFolder($resource) {
        var resourceUrl = 'api/document-folders';

        return {
            CRUD: $resource(resourceUrl + '/:id', {}, {
                'query': {method: 'GET', isArray: true},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                'update': {method: 'PUT'},
                'undelete': {
                    url: 'api/document-folders/undelete',
                    method: 'PUT'}
            }),
            SubFolders: $resource(resourceUrl + '/sub/:id', {}, {'query': {method: 'GET', isArray: true}})
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('DocumentFileEditDialogController', DocumentFileEditDialogController);

    DocumentFileEditDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'documentFile', 'DocumentFile', 'useCase'];

    function DocumentFileEditDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, documentFile, DocumentFile, useCase) {
        var vm = this;

        vm.useCase = useCase;

        vm.fileContent = null;

        vm.allowFileSelect = vm.useCase === 'newFile' || vm.useCase === 'newVersion' || vm.useCase === 'nextVersionEdit';
        vm.requireFileSelect = vm.useCase === 'newFile' || vm.useCase === 'newVersion';
        vm.allowStateSelect = vm.useCase !== 'metadataCorrection';

        vm.isSaving = false;

        vm.documentFile = documentFile;
        vm.save = save;


        vm.datePickerOpenStatus = {
            validityEndDate: false,
            validityEndAlertDate: false

        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.preparingSelectedFile = false;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        function save () {
            vm.isSaving = true;

            var saveDTO = {
                documentFile: vm.documentFile,
                fileContent: vm.fileContent
            };

            if (vm.useCase === 'newFile'){
                DocumentFile.save(saveDTO, onSaveSuccess, onSaveError);
            }
            else if (vm.useCase === 'newVersion'){
                DocumentFile.createNewVersion(saveDTO, onSaveSuccess, onSaveError);
            }
            else if (vm.useCase === 'metadataCorrection'){
                saveDTO.fileContent = null;
                DocumentFile.update(saveDTO, onSaveSuccess, onSaveError);
            }
            else if (vm.useCase === 'nextVersionEdit'){
                DocumentFile.update(saveDTO, onSaveSuccess, onSaveError);
            }
            else{
                vm.isSaving = false;
                console.log("error no useCase set")
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:documentFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.setFileContent = function ($file, $invalidFiles) {

            vm.selectedFileTooLarge = false;
            if ($invalidFiles && $invalidFiles.length > 0) {
                vm.selectedFileTooLarge = true;
                $timeout(function () {
                    vm.selectedFileTooLarge = false;
                }, 3000);
                return;
            }

            if ($file == null) {
                vm.fileContent = null;
                vm.documentFile.fileName = null;
                vm.documentFile.fileContentContentType = null;
                return;
            }

            vm.preparingSelectedFile = true;
            DataUtils.toBase64($file, function (base64Data) {

                vm.fileContent = base64Data;
                vm.documentFile.fileName = $file.name;
                vm.documentFile.fileContentContentType = $file.type;

                if (!vm.documentFile.name){
                    vm.documentFile.name = $file.name;
                }

                $timeout(function () {
                    vm.preparingSelectedFile = false;
                    console.log("done setting file data");
                }, 1);


            });
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('DocumentFileDetailController', DocumentFileDetailController);

    DocumentFileDetailController.$inject = [
        '$state', '$scope', '$rootScope',
        '$stateParams', 'previousState', 'documentFileVersioning',
        '$uibModal', 'DocumentFile'];

    function DocumentFileDetailController(
        $state, $scope, $rootScope,
        $stateParams, previousState, documentFileVersioning,
        $uibModal, DocumentFile) {

        var vm = this;

        vm.documentFileVersioning = documentFileVersioning;
        vm.previousState = previousState.name;
        vm.archivedVisible = [];


        vm.TAB_INDEXES = {
            curreent: 0,
            next: 1,
            archived: 2
        };


        if (vm.documentFileVersioning.currentVersion){
            vm.activeTab = vm.TAB_INDEXES.current;
        }
        else {
            vm.activeTab = vm.TAB_INDEXES.next;
        }

        if ($stateParams.tab == 'current'){
            vm.activeTab = vm.TAB_INDEXES.current;
        }
        else if ($stateParams.tab == 'next'){
            vm.activeTab = vm.TAB_INDEXES.next;
        }


        function reloadFileVersioning(){
            DocumentFile.getVersioningForRootId({rootVersionId : vm.documentFileVersioning.rootVersionId} ,onSuccess, onFail);

            function onSuccess(updatedVersioning){
                vm.documentFileVersioning = updatedVersioning;
            }
            function onFail(){
                console.log("failed to load changes");
            }
        }



        vm.toggleArchivedVisible = function(index){
            vm.archivedVisible[index] = !vm.archivedVisible[index];
        }

        vm.editCurrentVersion = function(){
            openEditDialog(vm.documentFileVersioning.currentVersion, 'metadataCorrection');
        };

        vm.editNextVersion = function(){
            openEditDialog(vm.documentFileVersioning.nextVersion, 'nextVersionEdit');
        };

        vm.createNextVersion = function(){

            var documentFile = angular.copy(vm.documentFileVersioning.currentVersion);
            documentFile.state="DRAFT";
            documentFile.fileContent = null;
            documentFile.fileName = null;
            documentFile.fileContentContentType = null;

            documentFile.validityEndDate = null;
            documentFile.validityEndAlertDate = null;
            documentFile.lastReviewDate = null;
            documentFile.approvalDate = null;
            documentFile.inspectionDate = null;
            documentFile.publishedDate = null;

            openEditDialog(documentFile, 'newVersion');
        };



        function openEditDialog(documentFile, useCase){
                $uibModal.open({
                    templateUrl: 'app/document/document-tree/document-file/edit-dialog/document-file-edit-dialog.html',
                    controller: 'DocumentFileEditDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    backdrop: 'static',
                    resolve:{
                        documentFile: function (){return angular.copy(documentFile);},
                        useCase: function(){return useCase;}
                    }
                }).result.then(function(result) {
                    reloadFileVersioning();

                });
        }

    }
})();

(function () {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('DocumentFile', DocumentFile);

    DocumentFile.$inject = ['$resource','DateUtils'];

    function DocumentFile($resource, DateUtils) {
        var resourceUrl = 'api/document-files/:id';

        function convertDatesFromServer(documentFile){
            if (documentFile) {
                documentFile = angular.fromJson(documentFile);
                documentFile.validityEndDate = DateUtils.convertLocalDateFromServer(documentFile.validityEndDate);
                documentFile.validityEndAlertDate = DateUtils.convertLocalDateFromServer(documentFile.validityEndAlertDate);
                documentFile.approvalDate = DateUtils.convertLocalDateFromServer(documentFile.approvalDate);
                documentFile.inspectionDate = DateUtils.convertLocalDateFromServer(documentFile.inspectionDate);
                documentFile.lastReviewDate = DateUtils.convertLocalDateFromServer(documentFile.lastReviewDate);
                documentFile.publishedDate = DateUtils.convertLocalDateFromServer(documentFile.publishedDate);
            }
            return documentFile;
        }

        function converDateToServer(documentFileSaveDTO){
            var copy = angular.copy(documentFileSaveDTO);
            copy.documentFile.validityEndDate = DateUtils.convertLocalDateToServer(documentFileSaveDTO.documentFile.validityEndDate);
            copy.documentFile.validityEndAlertDate = DateUtils.convertLocalDateToServer(documentFileSaveDTO.documentFile.validityEndAlertDate);
            copy.documentFile.approvalDate = DateUtils.convertLocalDateToServer(documentFileSaveDTO.documentFile.approvalDate);
            copy.documentFile.inspectionDate = DateUtils.convertLocalDateToServer(documentFileSaveDTO.documentFile.inspectionDate);
            copy.documentFile.lastReviewDate = DateUtils.convertLocalDateToServer(documentFileSaveDTO.documentFile.lastReviewDate);
            copy.documentFile.publishedDate = DateUtils.convertLocalDateToServer(documentFileSaveDTO.documentFile.publishedDate);
            return angular.toJson(copy);
        }

        return $resource(resourceUrl, {},{
            'get': {
                method: 'GET',
                transformResponse: convertDatesFromServer
            },
            'update': {
                method: 'PUT',
                transformRequest:converDateToServer
            },
            'undelete': {
                url: 'api/document-files/undelete',
                method: 'PUT'},
            'save': {
                method: 'POST',
                transformRequest:converDateToServer
            },
            'createNewVersion': {
                method: 'PUT',
                url: 'api/document-files/new-version',
                transformRequest:converDateToServer
            },
            'getVersioningForRootId': {
                method:'GET',
                url:'api/document-files/versioning/:rootVersionId',
                transformResponse: function(versioningDTO){
                    if (versioningDTO){
                        versioningDTO = angular.fromJson(versioningDTO);
                        versioningDTO.nextVersion = convertDatesFromServer(versioningDTO.nextVersion);
                        versioningDTO.currentVersion = convertDatesFromServer(versioningDTO.currentVersion);
                    }
                    return versioningDTO;
                }
            },
            'getNotableFiles':{
                method: 'GET',
                url: 'api/document-files/notable-files'
            },
            'stateChange':{
                method: 'POST',
                url: 'api/document-files/state-change'
            }
        });
    }
})();

(function() {
    'use strict';
    angular.module('abcQualityMatchApp').component('documentFileDetailsView', {
        templateUrl: 'app/document/document-tree/document-file/details-view/document-file-details-view.html',
        restrict: 'E',
        bindings: {
            documentFile: '<'
        },
        controller: DocumentFileDetailsViewController
    });

    DocumentFileDetailsViewController.$inject = ['$scope']
    function DocumentFileDetailsViewController(scope) {
        var ctrl = this;

    }




})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('document_menu', {
            abstract: true,
            parent: 'app'
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('QuestionnaireUtils', QuestionnaireUtils);

    function QuestionnaireUtils() {
        var service = {
            checkIfAnswered: checkIfAnswered,
            hasUnansweredRequiredQuestions: hasUnansweredRequiredQuestions
        };
        return service;

        function checkIfAnswered(question) {
            if (question.questionType === "multi") {
                return (question.answer.optionAnswers.length > 0);
            }
            if (question.questionType === "integer") {
                return (typeof question.answer.value == 'number');
            }
            if (question.questionType === "decimal") {
                return (typeof question.answer.value == 'number');
            }
            if (question.questionType === "freetext") {
                return !!question.answer.value && question.answer.value.length > 0;
            }
            console.log('unknown question type '+ question.questionType);
            return false;
        }

        function hasUnansweredRequiredQuestions(questionnaire) {
            var hasUnansweredRequired = false;
            questionnaire.sections.forEach(function (section) {
                if (hasUnansweredRequired) {
                    return;
                }
                section.questions.forEach(function (question) {
                    if (hasUnansweredRequired) {
                        return;
                    }
                    hasUnansweredRequired = question.required && !checkIfAnswered(question);
                });
            });
            return hasUnansweredRequired;
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function () {

'use strict';

angular.module('ngClickCopy', [])
        .service('ngCopy', ['$window', 'AlertService', function ($window, AlertService) {
                var body = angular.element($window.document.body);
                var textarea = angular.element('<textarea/>');
                textarea.css({
                    position: 'fixed',
                    opacity: '0'
                });

                return function (toCopy) {
                    textarea.val(toCopy);
                    body.append(textarea);
                    textarea[0].select();

                    try {
                        var successful = document.execCommand('copy');
                        if (successful) {
                            AlertService.success("Copied to clipboard");
                        }
                        if (!successful) {
                            throw successful;
                        }
                    } catch (err) {
                        window.prompt("Copy to clipboard: Ctrl+C, Enter", toCopy);
                    }

                    textarea.remove();
                }
            }])
        .directive('ngClickCopy', ['ngCopy', function (ngCopy) {
                return {
                    restrict: 'A',
                    link: function (scope, element, attrs) {
                        element.bind('click', function (e) {
                            ngCopy(attrs.ngClickCopy);
                        });
                    }
                }
            }])
    })();
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    '{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    '/ {{$ctrl.queryCount}}' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('abcQualityMatchApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

/*
 * Directive for popping up a delete confirmation dialog
 * 
 * usage:
 *  Add attribute confirmed-delete="f(something)" to get confirmation dialog when the element is clicked and
 *  f(someting) gets executed on confirmation.
 *  
 *  Set attribute confirmed-delete-message="message translation key" to customize confirmation question.
 * 
 * Example:
 *  <button
 *     confirmed-delete="vm.deletesometing($index)" 
       confirmed-delete-message="abcQualityMatchApp.training.examQuestions_deleteConfirm"
    >
 * 
 */
(function() {
    'use strict';


    angular.module('abcQualityMatchApp')
        .directive('confirmedDelete', ConfirmedDelete);

    ConfirmedDelete.$inject = ['$uibModal','$translate'];
    function ConfirmedDelete($uibModal, $translate) {
        return {
            restrict: 'A',
            
            link: function(scope, element, attrs){
                
                var message = attrs.confirmedDeleteMessage;
                if (!message){
                    message = null;
                }
                if (message){
                    message = $translate.instant(message);
                }
                
               $(element).on('click', function(e) {
                   
                    $uibModal.open({
                        templateUrl: 'app/components/util/confirmed-delete-dialog.html',
                        controller: 'DeleteConfirmController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'sm',
                        resolve:{
                            message: function (){return message;}
                        }
                    }).result.then(function () {
                        scope.$eval(attrs.confirmedDelete);
                    }); 
               });
            }
      };
    }



    angular.module('abcQualityMatchApp')
            .controller('DeleteConfirmController', DeleteConfirmController);

    DeleteConfirmController.$inject = ['$uibModalInstance', 'message'];

    function DeleteConfirmController($uibModalInstance, message) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.confirmDelete = confirmDelete;
        vm.customMessage = message;

        function closeDialog() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete() {
            $uibModalInstance.close(true); 
        }
        
    }
    /////////////////////////////////////

    angular.module('abcQualityMatchApp')
        .directive('confirmedUndelete', ConfirmedUndelete);

    ConfirmedUndelete.$inject = ['$uibModal','$translate'];
    function ConfirmedUndelete($uibModal, $translate) {
        return {
            restrict: 'A',

            link: function(scope, element, attrs){

                var message = attrs.confirmedUndeleteMessage;
                if (!message){
                    message = null;
                }
                if (message){
                    message = $translate.instant(message);
                }

                $(element).on('click', function(e) {

                    $uibModal.open({
                        templateUrl: 'app/components/util/confirmed-undelete-dialog.html',
                        controller: 'UndeleteConfirmController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'sm',
                        resolve:{
                            message: function (){return message;}
                        }
                    }).result.then(function () {
                        scope.$eval(attrs.confirmedUndelete);
                    });
                });
            }
        };
    }



    angular.module('abcQualityMatchApp')
        .controller('UndeleteConfirmController', UndeleteConfirmController);

    UndeleteConfirmController.$inject = ['$uibModalInstance', 'message'];

    function UndeleteConfirmController($uibModalInstance, message) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.confirmUndelete = confirmUndelete;
        vm.customMessage = message;

        function closeDialog() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmUndelete() {
            $uibModalInstance.close(true);
        }

    }
    
    
    
    
    
    
    
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    /**
     * Renders user object into "lastName, firstName" or login if names not set
     */
    angular.module('abcQualityMatchApp').filter('fullUserName', function() {
        return function(user) {

          var out = "";
          if (user){
              if (user.lastName){
                  out = user.lastName;
              }
              if (out.length > 0 && user.firstName){
                  out = out + ", " + user.firstName;
              }
              else if (user.firstName){
                  out = user.firstName;
              }
              if (out.length === 0){
                  out = user.login;
              }
          }
          return out;
        };
    });

    /**
     * Renders truthy value as checkmark and false as " "
     */
    angular.module('abcQualityMatchApp').filter('checkMark', function() {
        return function(value) {

            var mark = " ";
            if (value){
                mark = "\u2714"; // unicode: 'heavy checkmark'
            }
            return mark;
        };
    });

    /**
     * Renders ReasonCode object into "code name"
     */
    angular.module('abcQualityMatchApp').filter('codeAndName', function() {
        return function(reasonCode) {

          var out = "";
          if (reasonCode){
            out = reasonCode.code + " " + reasonCode.name;
          }
          return out;
        };
    });

    /**
     * Renders product object into "product number: product name"
     */
    angular.module('abcQualityMatchApp').filter('productNumberAndName', function() {
        return function(product) {

            var out = "";
            if (product){
                out = product.number + " " + product.name;
            }
            return out;
        };
    });

    /**
     * Translates anomaly reporting status
     */
    angular.module('abcQualityMatchApp').filter('anomalyReported', AnomalyReported);
    AnomalyReported.$inject = ['$translate'];
    function AnomalyReported($translate) {
        return function (anomaly) {

            var out = "";
//            if (!((anomaly.qaAnomaly && !anomaly.qaAnomalyConfirmed) || (anomaly.answerAnomaly && !anomaly.answerAnomalyConfirmed))) {
            if (anomaly.reported) {
                out = $translate.instant('abcQualityMatchApp.anomalyEvent.reported.true');
            } else {
                out = $translate.instant('abcQualityMatchApp.anomalyEvent.reported.false');
            }
            return out;
        };
    };


    /**
     * Renders informationEvent as time and title
     */
    angular.module('abcQualityMatchApp').filter('informationEventFormat', ['dateFilter',function (dateFilter) {
        return function (event) {
            if (!event){
                return "";
            }

            var time = dateFilter(event.created,'shortDate');
            return time + " " + event.title;
        };
    }]);

    /**
     * Renders anomalyEvent
     */
    angular.module('abcQualityMatchApp').filter('anomalyEventFormat', ['dateFilter',function (dateFilter) {
        return function (event) {
            if (!event){
                return "";
            }

            var time = dateFilter(event.answerTime,'shortDate');
            return time + " " + event.questionnaireTitle + " / " + event.questionTitle;
        };
    }]);

    /**
     * Renders json to queryString
     */
    angular.module('abcQualityMatchApp').filter('toQueryString', ['$httpParamSerializer',function ($httpParamSerializer) {
        return function (params) {
            var qs = $httpParamSerializer(params);
            return "?" + qs;
        };
    }]);


    /**
     * Wraps matching part of given text into span with class highlightedMatch
     */
    angular.module('abcQualityMatchApp').filter('highlightMatch', ['$sce', function($sce) {
        return function(text, phrase) {
            if (phrase && text) {
                text = text.replace(new RegExp('(' + phrase + ')', 'gi'),
                    '<span class="highlightedMatch">$1</span>');
            }
            return $sce.trustAsHtml(text);
        };
    }]);


    /**
     * Renders trainingEvent instructor and outside instructor name.
     */
    angular.module('abcQualityMatchApp').filter('trainingEventInstructor', ['fullUserNameFilter', function(fullUserName) {
        return function(trainingEvent) {
            var out = fullUserName(trainingEvent.instructor);
            if (trainingEvent.outsideInstructor){
                 out = out + " / " + trainingEvent.outsideInstructor;
            }
            return out;
        };
    }]);

})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('AbcListUtils', AbcListUtils);

    function AbcListUtils () {
        var service = {
            stableSortByListIndex: stableSortByListIndex,
            refreshListIndexes:    refreshListIndexes,
            setDeletedOnIdex: setDeletedOnIdex,
            addNewToLast: addNewToLast,
            moveUpOrDown: moveUpOrDown,
            moveDeletedLast: moveDeletedLast,
            findById:findById
        };
        return service;


        function addNewToLast(element, list){
            list.push(element);
            moveDeletedLast(list);
            refreshListIndexes(list);
        }

        function setDeletedOnIdex(index, list){
            stableSortByListIndex(list); // for making sure list is in listIndex order initially
            list[index].deleted = true;
            moveDeletedLast(list);
            refreshListIndexes(list);
        }


        function stableSortByListIndex(list){
            var idsInOriginalOrder = [];
            list.forEach(function(element){idsInOriginalOrder.push(element.id)});

            list.sort(function(a,b){
                var diff = a.listIndex - b.listIndex;
                if (diff == 0){
                    diff = idsInOriginalOrder.indexOf(a.id) - idsInOriginalOrder.indexOf(b.id);
                }
                return diff;
            });
            return list;
        }

        function refreshListIndexes(elements){
            elements.forEach(function (element, index){element.listIndex = index});
        }

        function moveDeletedLast(list){
            var deleted = [];
            list.forEach(function(element){
                if (element.deleted){
                    deleted.push(element);
                }
            });
            deleted.forEach(function(element){
                list.splice(list.indexOf(element),1);
                list.push(element);
            });
        }

        function moveUpOrDown(index, direction, list) {
            stableSortByListIndex(list);
            if(direction === "up") {
                list[index-1].listIndex++;
                list[index].listIndex--;
            }
            else {
                list[index+1].listIndex--;
                list[index].listIndex++;
            }
            stableSortByListIndex(list);
            refreshListIndexes(list);
        }


        /**
         * Find item from list where item.id === id
         * @param id
         * @param list
         * @returns item with given id or null if not found
         */
        function findById(id, list){

            for (var i=0;i< list.length; ++i){
                if (list[i].id === id){
                    return list[i];
                }
            }
            return null;
        }

    }
})();

(function() {
    'use strict';
    angular.module('abcQualityMatchApp').component('usersMultipleSelect', {
          templateUrl: 'app/components/users-multiple-select/users-multiple-select-component.html',
          restrict: 'E',
          bindings: {
              users: '=',
              placeholder:'@'
          },
          controller: UsersMultipleSelectController
        });

    UsersMultipleSelectController.$inject = ['$scope']
    function UsersMultipleSelectController(scope) {
        var ctrl = this;
        ctrl.newUser = null;

        ctrl.addUser = function () {
            if (ctrl.newUser != null) {
                var alreadyAdded = false;
                ctrl.users.forEach(function (user) {
                    if (user.id == ctrl.newUser.id) {
                        alreadyAdded = true;
                    }
                });
                if (!alreadyAdded) {
                    ctrl.users.push(ctrl.newUser);
                }
            }
            ctrl.newUser = null;
        };

        ctrl.deleteUser = function (index) {
            ctrl.users.splice(index,1);
            return false;
        };

    }

})();

(function() {
    'use strict';
    angular.module('abcQualityMatchApp').component('userSelect', {
          templateUrl: 'app/components/user-select/user-select-component.html',
          restrict: 'E',
          bindings: {
              user: '=',
              onSelect: '&',
              placeholder:'@',
              viewonly: '<'
          },
          controller: UserSelectController
        });

    UserSelectController.$inject = ['$timeout','$scope', 'User']
    function UserSelectController($timeout,scope, User) {
        var ctrl = this;

        ctrl.getUsers = function(val){
            return User.query({searchTerm: val,
                                          sort:'last_name,asc'}
                                        ).$promise;
        };

        ctrl.setSelected = function(){
            $timeout(function (){
                if (ctrl.onSelect) {
                    ctrl.onSelect();
                }
            });
        };
    }

})();

(function() {
    'use strict';

    angular.module('abcQualityMatchApp').component('ticketMaterial', {
          templateUrl: 'app/components/ticket-material/ticket-material.component.html',  
          bindings: {task: '<',
                     ticket: '<'
                     },
          controller: TicketMaterialController
        });

    TicketMaterialController.$inject = ['$scope', 'TicketRelatedMaterial','AlertService']
    function TicketMaterialController(scope, TicketRelatedMaterial, AlertService) {

        var ctrl = this;
        ctrl.ticketMaterials = [];
        
        if (ctrl.task){
            ctrl.ticketId = ctrl.task.ticketId;
        }
        else if (ctrl.ticket){
            ctrl.ticketId = ctrl.ticket.id;
        }

        loadAll();

        function loadAll () {
            TicketRelatedMaterial.Materials.query( {ticketId: ctrl.ticketId}, onSuccess, onError);
            function onSuccess(data) {
                ctrl.ticketMaterials = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function () {
    'use strict';

    var stats = {
        templateUrl: 'app/components/report/stats/stats.html',
        controllerAs: 'vm',
        controller: ['Report', '$state', function (Report, $state) {
                var vm = this;
                vm.stats = Report.Stats.query({});
            }]
    };

    angular
            .module('abcQualityMatchApp')
            .component('stats', stats);


})();
(function() {
    'use strict';
    angular.module('abcQualityMatchApp').component('questionnaireAnswersView', {
        templateUrl: 'app/components/questionnaire-answers-view/questionnaire-answers-view.component.html',
        controllerAs: 'vm',
        bindings: {
            questionnaireAnswer: '<'
        },
        restrict: 'E',
        controller: QuestionnaireAnswersView
    });

    QuestionnaireAnswersView.$inject = ['$scope', 'AlertService'];
    function QuestionnaireAnswersView(scope, AlertService) {
        var vm = this;

        setupQestionAnswerRelations(this.questionnaireAnswer);



        function setupQestionAnswerRelations(questionnareAnswer) {

            var answerMap = new Map();
            questionnareAnswer.answers.forEach(function (answer) {
                answerMap.set(answer.question.id, answer);
            });

            questionnareAnswer.questionnaire.sections.forEach(function (section) {
                section.questions.forEach(function (question) {
                    var answer = answerMap.get(question.id);

                    if (!answer) {
                        answer = {};
                        answer.questionRootVersionId = question.rootVersionId;
                        answer.answerType = question.questionType;
                        answer.anomaly = false;
                        answer.anomalyConfirmed = false;
                        if (answer.answerType === "multi") {
                            answer.optionAnswers = [];
                        } else {
                            answer.value = null;
                        }
                    }
                    question.answer = answer;
                });
            });
        }
    } // end of QuestionnaireAnswersView

})();


(function() {
    'use strict';

    var questionnaireAnswerSection = {
        templateUrl: 'app/components/questionnaire-answer-section/questionnaire-answer-section.html',
        bindings: {
            section: '=',
            comparisons: '<',
            viewonly: '<',
            onAnswerChange: '&',
            questionnaire: '<',
            editForm: '<?'
        }
    };

    angular
        .module('abcQualityMatchApp')
        .component('questionnaireAnswerSection', questionnaireAnswerSection);


})();

(function() {
    'use strict';

    var questionnaireAnswerQuestion = {
        templateUrl: 'app/components/questionnaire-answer-question/questionnaire-answer-question.html',
        bindings: {
            question: '=',
            comparisons: '<',
            viewonly: '<',
            onAnswerChange: '<',
            questionnaire: '<',
            editForm: '<?'
        },
        controllerAs: 'vm',
        controller: function() {
            var vm = this;
        }
    };

    angular
        .module('abcQualityMatchApp')
        .component('questionnaireAnswerQuestion', questionnaireAnswerQuestion);


})();

(function() {
    'use strict';

    angular.module('abcQualityMatchApp').component('questionnaireAnswerMultiQuestion', {
        templateUrl: 'app/components/questionnaire-answer-multi-question/questionnaire-answer-multi-question.html',
        bindings: {
            question: '=',
            viewonly: '<',
            onAnswerChange: '&',
            questionnaire: '<',
            editForm: '<?'
        },
        controllerAs: 'vm',
        controller: QuestionnaireAnswerMultiQuestionComponent
    });

    QuestionnaireAnswerMultiQuestionComponent.$inject = ['AbcListUtils', 'QuestionnaireUtils', '$scope', '$uibModal'];
    function QuestionnaireAnswerMultiQuestionComponent(AbcListUtils, QuestionnaireUtils, $scope, $uibModal) {

        var vm = this;

        window.foo = vm;
        vm.radioButtonSelectedOptionId = null;
        vm.dropDownSelectedOption = null;
        vm.singleButtonSelectedIndex = null;

        vm.checkBoxSelectionChange = checkBoxSelectionChange;
        vm.radioButtonChange = radioButtonChange;
        vm.singleButtonClick = singleButtonClick;
        vm.dropdownSelectionChange = dropdownSelectionChange;
        vm.answerInputChange = answerInputChange;

        vm.$onInit = function() {
            if (vm.question.renderType === "DROPDOWN") {
                if (vm.question.answer.optionAnswers[0]){
                    vm.dropDownSelectedOption = vm.question.answer.optionAnswers[0].choice;
                }
                else if (shouldSetDefaultSelection()){
                    vm.question.options.forEach(function(opt) {
                        if (opt.defaultSelection){
                            vm.dropDownSelectedOption = opt;
                        }
                    });
                    dropdownSelectionChange();
                }
            }
            else if (vm.question.renderType === "RADIOBUTTON") {
                if (vm.question.answer.optionAnswers[0]){
                    vm.radioButtonSelectedOptionId = vm.question.answer.optionAnswers[0].choice.id;
                }
                else if (shouldSetDefaultSelection()){
                    vm.question.options.forEach(function(opt) {
                        if (opt.defaultSelection){
                            vm.radioButtonSelectedOptionId = opt.id;
                        }
                    });
                    radioButtonChange();
                }
            }
            else if (vm.question.renderType === "CHECKBOX"){
                vm.question.options.forEach(function(opt) {
                    opt.selected = false;
                    vm.question.answer.optionAnswers.forEach(function (optAnswer) {
                        if (optAnswer.choice.id === opt.id){
                            opt.selected = true;
                        }
                    });
                });

                if (shouldSetDefaultSelection()){
                    vm.question.options.forEach(function(opt) {
                        opt.selected = opt.defaultSelection;
                    });
                    checkBoxSelectionChange();
                }
            }
            else if(vm.question.renderType === 'SINGLE_BUTTON'){
                AbcListUtils.stableSortByListIndex(vm.question.options);
                vm.singleButtonSelectedIndex = 0;

                if (vm.question.answer.optionAnswers[0]){
                    vm.question.options.forEach(function(opt, index) {
                        if (vm.question.answer.optionAnswers[0].choice.id === opt.id){
                            vm.singleButtonSelectedIndex = index;
                        }
                    });
                }
                if (shouldSetDefaultSelection()){
                    vm.question.options.forEach(function(opt, index) {
                        if (opt.defaultSelection) {
                            vm.singleButtonSelectedIndex = index;
                        }
                    });
                }
                setSingleButtonSelectionIndex(vm.singleButtonSelectedIndex);
            }
            else{
                console.log("unknown render type "+ vm.question.renderType);
            }

            vm.answerInputChange();
        };

        function shouldSetDefaultSelection(){
            return !vm.question.answer.id && !vm.viewonly && vm.question.answer.optionAnswers.length === 0;
        }

        function dropdownSelectionChange(){
            if (!vm.dropDownSelectedOption){
                return;
            }
            vm.question.answer.optionAnswers = [];
            vm.question.answer.optionAnswers.push(createAnswerOption(vm.dropDownSelectedOption));
            vm.answerInputChange();
        }

        function checkBoxSelectionChange(){
            vm.question.answer.optionAnswers = [];
            vm.question.options.forEach(function(opt) {
                if (opt.selected){
                    vm.question.answer.optionAnswers.push(createAnswerOption(opt));
                }
            });
            vm.answerInputChange();
        }

        function radioButtonChange() {
            vm.question.answer.optionAnswers = [];
            vm.question.options.forEach(function(opt) {
                if (opt.id === vm.radioButtonSelectedOptionId){
                    vm.question.answer.isAnswered=true;
                    vm.question.answer.optionAnswers.push(createAnswerOption(opt));
                }
            });
            vm.answerInputChange();
        }

        function answerInputChange(){
            var answerCausesException = false;
            if (vm.questionnaire.questionnaireType === "NORMAL" && vm.question.answer.optionAnswers.length > 0) {
                vm.question.answer.optionAnswers.forEach(function (optAnswer){
                    if (optAnswer.choice.anomalyOption ) {
                        answerCausesException = true;
                    }
                });
            }

            vm.question.answer.anomaly = answerCausesException || !!vm.question.answer.anomalyCategory;
            vm.question.answer.isAnswered = QuestionnaireUtils.checkIfAnswered(vm.question);
            vm.onAnswerChange();
        }

        function singleButtonClick() {
            setSingleButtonSelectionIndex(vm.singleButtonSelectedIndex + 1);
            vm.answerInputChange();
        }

        function setSingleButtonSelectionIndex(index) {
            if (index >= vm.question.options.length) {
                index = 0;
            }
            vm.singleButtonSelectedIndex = index;
            vm.question.answer.optionAnswers = [];
            vm.question.answer.optionAnswers.push(createAnswerOption(vm.question.options[index]));
        }

        function createAnswerOption(questionOption){
            var optionAnswer = {};
            optionAnswer.id = null;
            optionAnswer.writeIn = null;
            optionAnswer.choice = questionOption;
            return optionAnswer;
        }

        vm.deleteAttachment = function(answer, attachment) {
            $scope.$emit("abcQualityMatchApp:deleteAttachment",{answer: answer, attachment: attachment});
        }

        vm.addAttachment = function(answer) {      
            $uibModal.open({
                templateUrl: 'app/components/questionnaire-answer-attachment/answer-attachment-dialog.html',
                controller: 'AnswerAttachmentDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve:{}
            }).result.then(function(result) {
                console.log('add attachment dialog closing ', result);
                console.log('answer', answer);
                if (!answer.attachments) {
                    answer.attachments=[];    
                }
                answer.attachments.push(
                    {
                        id: null,
                        storageFile: result
                    }
                )
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .component('questionnaireAnswerIntegerQuestion', {
            templateUrl: 'app/components/questionnaire-answer-integer-question/questionnaire-answer-integer-question.html',
            bindings: {
                question: '=',
                viewonly: '<',
                onAnswerChange: '&',
                questionnaire: '<',
                editForm: '<?'
            },
            controllerAs: 'vm',
            controller: QuestionnaireAnswerIntegerQuestion
        });

    QuestionnaireAnswerIntegerQuestion.$inject = ['QuestionnaireUtils', '$scope', '$uibModal'];
    function QuestionnaireAnswerIntegerQuestion(QuestionnaireUtils, $scope, $uibModal){

        var vm = this;
        if (vm.viewonly) {
            vm.inputName = '' + vm.question.id + '-view';
        }
        else{
            vm.inputName = '' + vm.question.id + '-answerInput';
        }

        vm.answerInputChange = function () {
            var answerCausesException = false;
            if (vm.questionnaire.questionnaireType === "NORMAL") {
                if (vm.question.answer.value != null) {
                    if (vm.question.minimumValue != null && vm.question.minimumValue > vm.question.answer.value) {
                        answerCausesException = true;
                    }
                    if (vm.question.maximumValue != null && vm.question.maximumValue < vm.question.answer.value) {
                        answerCausesException = true;
                    }
                }
            }
            vm.question.answer.anomaly = answerCausesException || !!vm.question.answer.anomalyCategory;
            vm.question.answer.isAnswered = QuestionnaireUtils.checkIfAnswered(vm.question);
            vm.onAnswerChange();
        };


        vm.preventInvalidInput = function(e) {
            //console.log('key \'' +  e.key + '\' keycode: ' + e.keyCode);

            if (e.keyCode === 109 || //numbad minus
                e.keyCode === 189 || //minus
                e.key === '-'
             ){
                return; // accept negative sign
            }

            // prevent invalid chars
            if (e.key === ' ' ||
                e.key === '.' ||
                e.key === ',' ||
                e.keyCode === 108 || //numpad decimal key
                e.keyCode === 110 || //numpad decimal key IE
                e.keyCode === 190 || //dot
                (e.key.length === 1 && (isNaN(Number(e.key) )))){ // single char that is not a number
                e.preventDefault();
            }
        };

        vm.deleteAttachment = function(answer, attachment) {
            $scope.$emit("abcQualityMatchApp:deleteAttachment",{answer: answer, attachment: attachment});
        }

        vm.addAttachment = function(answer) {      
            $uibModal.open({
                templateUrl: 'app/components/questionnaire-answer-attachment/answer-attachment-dialog.html',
                controller: 'AnswerAttachmentDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve:{}
            }).result.then(function(result) {
                console.log('add attachment dialog closing ', result);
                console.log('answer', answer);
                if (!answer.attachments) {
                    answer.attachments=[];    
                }
                answer.attachments.push(
                    {
                        id: null,
                        storageFile: result
                    }
                )
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .component('questionnaireAnswerFreetextQuestion', {
            templateUrl: 'app/components/questionnaire-answer-freetext-question/questionnaire-answer-freetext-question.html',
            bindings: {
                Task: '<',
                question: '<',
                answer: '=',
                viewonly: '<',
                onAnswerChange: '&',
                deleteAttachment: '&',
                questionnaire: '<',
                editForm: '<?'
            },
            controllerAs: 'vm',
            controller: QuestionnaireAnswerFreetextQuestion
        });

    QuestionnaireAnswerFreetextQuestion.$inject = ['QuestionnaireUtils', '$scope', '$uibModal'];
    function QuestionnaireAnswerFreetextQuestion(QuestionnaireUtils, $scope, $uibModal) {

        var vm = this;

        if (vm.viewonly) {
            vm.inputName = '' + vm.question.id + '-view';
        }
        else{
            vm.inputName = '' + vm.question.id + '-answerInput';
        }

        vm.rowCount = 5;
        if (vm.question.size === 'LONG') {
            vm.rowCount = 15;
        }

        vm.deleteAttachment = function(answer, attachment) {
            console.log('delete attachment attachment ->', attachment);
            console.log('delete attachment answer ->', answer);
            $scope.$emit("abcQualityMatchApp:deleteAttachment",{answer: answer, attachment: attachment});
        }

        vm.addAttachment = function(answer) {
            console.log('Lisää modalin avaus ', answer);            
            $uibModal.open({
                templateUrl: 'app/components/questionnaire-answer-attachment/answer-attachment-dialog.html',
                controller: 'AnswerAttachmentDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve:{}
            }).result.then(function(result) {
                console.log('add attachment dialog closing ', result);
                console.log('answer', answer);
                if (!answer.attachments) {
                    answer.attachments=[];    
                }
                answer.attachments.push(
                    {
                        id: null,
                        storageFile: result
                    }
                )
            });
        }

        vm.answerInputChange = function () {
            var answerCausesException = false;
            if (vm.questionnaire.questionnaireType === "NORMAL") {
                answerCausesException = !!vm.question.answer.anomalyCategory;
            }

            vm.question.answer.anomaly = answerCausesException || !!vm.question.answer.anomalyCategory;
            vm.question.answer.isAnswered = QuestionnaireUtils.checkIfAnswered(vm.question);
            vm.onAnswerChange();
        };
    }

})();

(function () {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .component('questionnaireAnswerDecimalQuestion', {
            templateUrl: 'app/components/questionnaire-answer-decimal-question/questionnaire-answer-decimal-question.html',
            bindings: {
                question: '=',
                viewonly: '<',
                onAnswerChange: '&',
                questionnaire: '<',
                editForm: '<?'
            },
            controllerAs: 'vm',
            controller: questionnaireAnswerDecimalQuestion
        });

    questionnaireAnswerDecimalQuestion.$inject = ['QuestionnaireUtils', '$scope', '$uibModal'];
    function questionnaireAnswerDecimalQuestion(QuestionnaireUtils, $scope, $uibModal) {

        var vm = this;
        if (vm.viewonly) {
            vm.inputName = '' + vm.question.id + '-view';
        }
        else{
            vm.inputName = '' + vm.question.id + '-answerInput';
        }

        vm.answerInputChange = function () {
            var answerCausesException = false;
            if (vm.questionnaire.questionnaireType === "NORMAL" ) {
                if (vm.question.answer.value != null) {
                    if (vm.question.minimumValue != null && vm.question.minimumValue > vm.question.answer.value) {
                        answerCausesException = true;
                    }
                    if (vm.question.maximumValue != null && vm.question.maximumValue < vm.question.answer.value) {
                        answerCausesException = true;
                    }
                }
            }
            vm.question.answer.anomaly = answerCausesException || !!vm.question.answer.anomalyCategory;
            vm.question.answer.isAnswered = QuestionnaireUtils.checkIfAnswered(vm.question);
            vm.onAnswerChange();
        };

        vm.preventInvalidInput = function(e) {

            //console.log('key \'' +  e.key + '\' keycode: ' + e.keyCode);

            if (e.keyCode === 109 || //numbad minus
                e.keyCode === 189 || //minus
                e.key === '-' ||
                e.key === '.' ||
                e.keyCode === 108 || //numpad decimal key
                e.keyCode === 110 || //numpad decimal key IE
                e.keyCode === 190 ||  //dot
                e.keyCode === 188  //dot
            ){
                return; // accept negative sign and decimal separator
            }

            // prevent invalid chars
            if (e.key.length === 1 && (isNaN(Number(e.key) ))){ // single char that is not a number
                e.preventDefault();
            }
        };

        vm.deleteAttachment = function(answer, attachment) {
            $scope.$emit("abcQualityMatchApp:deleteAttachment",{answer: answer, attachment: attachment});
        }

        vm.addAttachment = function(answer) {
            $uibModal.open({
                templateUrl: 'app/components/questionnaire-answer-attachment/answer-attachment-dialog.html',
                controller: 'AnswerAttachmentDialogController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: 'static',
                resolve:{}
            }).result.then(function(result) {
                console.log('add attachment dialog closing ', result);
                console.log('answer', answer);
                if (!answer.attachments) {
                    answer.attachments=[];    
                }
                answer.attachments.push(
                    {
                        id: null,
                        storageFile: result
                    }
                )
            });
        }

    }
})();

(function() {

    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('AnswerAttachmentDialogController',AnswerAttachmentDialogController);

    AnswerAttachmentDialogController.$inject = ['$uibModalInstance', '$timeout', '$scope', '$state', '$stateParams', 'Task', 'DataUtils'];

    function AnswerAttachmentDialogController($uibModalInstance, $timeout, $scope, $state, $stateParams, Task, DataUtils) {
        var vm = this;

        vm.file = null;
        vm.fileContent = null;
        vm.clear = clear;
        vm.add = add;
        vm.camera = camera;
        vm.takePhoto = takePhoto;
        vm.fileSelected = fileSelected;
        vm.isCamera=false;
        vm.isSnapshot=false;
        vm.image_data_url = '';
        vm.selectedFileTooLarge = false;

        console.log('answer attachment dialog controller', $stateParams);

        function clear () {
            console.log('Clear');
            $uibModalInstance.dismiss('Clear');
        }

        function camera() {
            if (vm.isCamera) {
                vm.isCamera=false;
            } else {
                vm.isCamera=true;
                enableCamera();
            }
        }
        function enableCamera() {
            // turns camera on (if there is any)
            navigator.mediaDevices.getUserMedia({ video: true, audio: false })
            .then(function(stream) {
                video.srcObject = stream;
            })
            .catch(function(err) {
              console.log('media device error ->', err);
            });
        }

        function takePhoto() {
            console.log('take photo');
            vm.isSnapshot = true;

            var video = angular.element("#video");
            var snapshot = angular.element("#snapshot");

            // get image from live camera feed -> put it on canvas
            var ctx = snapshot[0].getContext('2d')
            ctx.drawImage(video[0], 0, 0, snapshot[0].width, snapshot[0].height);
            // image data
            vm.image_data_url = snapshot[0].toDataURL('image/jpeg');
            // hide camera
            vm.isCamera = false;
            // data url of the image -> get connten excluding the mimetype
            vm.fileContent = vm.image_data_url.split(",")[1];

            vm.file = {
                name: 'SNAPSHOT_' + Math.floor(Date.now() / 1000),
                type: 'image/jpeg',
            }
        }

        function add () {
            if (vm.file) {
                console.log('add -> file content');
                var dataDTO = {
                    id: null,
                    companyId: null,
                    fileName: vm.file.name,
                    contentType: vm.file.type,
                    content: vm.fileContent
                }
                console.log('dataDTO', dataDTO);

                Task.saveAnswerAttachment(dataDTO, onSuccess, onError);

                function onSuccess(response) {
                    console.log('Task saveAnswerAttachment success response ->', response)
                    $uibModalInstance.close(response);
                }
                function onError(error) {
                    console.log('Task saveAnswerAttachment error ->', error);
                    alert('Tallennus ei onnistunut');
                }
            }
        }

        function fileSelected ($file, $invalidFiles) {
            //console.log('file selected !', $file);

            vm.selectedFileTooLarge = false;
            if ($invalidFiles && $invalidFiles.length > 0) {
                invalidFileSelected($invalidFiles);
                return;
            }

            if ($file != null) {
                vm.file = $file;
                DataUtils.toBase64($file, function (base64Data) {
                    vm.fileContent = base64Data;
                });
            }
        }

        function invalidFileSelected($invalidFiles) {

            console.log('invalid file selected ' + JSON.stringify($invalidFiles));
            vm.selectedFileTooLarge = true;
            $timeout(function () {
                vm.selectedFileTooLarge = false;
            }, 3000);

        }

    }
})();

(function() {
    'use strict';
    angular.module('abcQualityMatchApp').component('questionnaireAnswer', {
        templateUrl: 'app/components/questionnaire-answer/questionnaire-answer.html',
        bindings: {
            questionnaire:"=",
            comparisons: '<',
            viewonly: '<',
            onAnswerChange: '&',
            editForm: '<?'
        },
        controllerAs: 'vm',
        controller: QuestionnaireAnswerComponent
    });

    QuestionnaireAnswerComponent.$inject=['$location', '$anchorScroll','QuestionnaireUtils'];
    function QuestionnaireAnswerComponent($location, $anchorScroll, QuestionnaireUtils) {

        var vm = this;
        vm.showAnswered = true;
        vm.currentSection = 0;
        vm.hasPrevSection = false;
        vm.hasNextSection = false;

        vm.$onInit = function() {
            vm.questionnaire.sections.forEach(function(section) {
                section.questions.forEach(function(question){
                    question.answer.isAnswered = QuestionnaireUtils.checkIfAnswered(question);
                });
            });
            updateHasNextPreviousSectionEnabled();
        };

        vm.goToQuestion = function(section, question){
            vm.currentSection = getSectionIndex(section);
            $location.hash("question"+question.id);
            $anchorScroll();
            updateHasNextPreviousSectionEnabled();
        };

        vm.goToSection = function (section){
            vm.currentSection = getSectionIndex(section);
            updateHasNextPreviousSectionEnabled();
        };

        function getSectionIndex(section){
            for (var i = 0; i < vm.questionnaire.sections.length; i++) {
                if(vm.questionnaire.sections[i].id === section.id){
                    return i;
                }
            }
            console.log('error section not found');
            return 0;
        }

        vm.nextSection = function () {
            if (vm.hasNextSection) {
                vm.currentSection++;
            }
            updateHasNextPreviousSectionEnabled();
        };

        vm.prevSection = function () {
            if (vm.hasPrevSection) {
                vm.currentSection--;
            }
            updateHasNextPreviousSectionEnabled();
        };

        function updateHasNextPreviousSectionEnabled(){
            vm.hasPrevSection = vm.currentSection > 0;
            vm.hasNextSection = vm.currentSection < vm.questionnaire.sections.length - 1;
        }
    }
})();

(function() {
    'use strict';
    angular.module('abcQualityMatchApp').component('productSelect', {
        templateUrl: 'app/components/product-select/product-select-component.html',
        restrict: 'E',
        bindings: {
            product: '=',
            filteringProductId: '@',
            onSelect: '&',
            placeholder:'@',
            viewonly: '<'
        },
        controller: ProductSelectController
    });

    ProductSelectController.$inject = ['$timeout','$scope', 'Product']
    function ProductSelectController($timeout, scope, Product) {
        var ctrl = this;

        ctrl.getProducts = function(val){
            return Product.query({
                searchTerm: val,
                sort:'name,number,id',
                includeArchived: 0
            }).$promise;
        };

        ctrl.setSelected = function(){
            $timeout(function (){
                if (ctrl.onSelect) {
                    ctrl.onSelect();
                }
            });

        };

        ctrl.evaluateChange = function(){
            if(ctrl.product === null){
                $timeout(function (){
                    if (ctrl.onSelect) {
                        ctrl.onSelect();
                    }
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');
                
                console.log("call reset")
                $rootScope.resetCompany();

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fi': 'Suomi',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'fi'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';
    angular.module('abcQualityMatchApp').component('informationEventSelect', {
          templateUrl: 'app/components/information-select/information-select-component.html',
          restrict: 'E',
          bindings: { onSelect: '&' },
          controller: InformationSelectController
        });

    InformationSelectController.$inject = ['$scope', 'Information','AlertService', '$http']
    function InformationSelectController(scope, Information, AlertService, $http) {
        var ctrl = this;

        this.selected = null;

        ctrl.getInformation = function(val){
            return Information.informationEventsQuery({searchTerm: val,
                                             sort:'submit_date,desc&sort=id'
            }).$promise;
        }

        ctrl.setSelected = function(){
            console.log("selected " + JSON.stringify(this.selected));
            this.onSelect({selected: this.selected});
            this.selected = null;
        }
    }




})();

(function () {
    'use strict';

    var verificationEvents = {
        templateUrl: 'app/components/home/verification-events/verification-events.html',
        controllerAs: 'vm',
        controller: ['TaskVerificationRedone', function (TaskVerificationRedone) {
                var vm = this;
                vm.taskVerifications = null;

                loadTaskVerifications();

                function loadTaskVerifications() {

                    var params = {
                        sort: '(done_time_min),asc',
                        'unverifiedOnly':true
                    };

                    TaskVerificationRedone.query(params, onSuccess, onError);
                    function onSuccess(data, headers) {
                        vm.taskVerifications = data;
                    }
                    function onError(error) {
                        console.log("failed");
                    }
                }
            }]
    };

    angular
            .module('abcQualityMatchApp')
            .component('verificationEvents', verificationEvents);


})();

(function () {
    'use strict';

    var tasks = {
        templateUrl: 'app/components/home/tasks/tasks.html',
        controllerAs: 'vm',
        controller: ['TaskEvent','$state', function (TaskEvent, $state) {
                var vm = this;
                window.vvm = vm;
                vm.dateCategories = [{dateCategory: 'LATE'}, {dateCategory: 'TODAY'}, {dateCategory: 'TOMORROW'}, {dateCategory: 'THIS_WEEK'}, {dateCategory: 'NEXT_WEEK'}];
                vm.tasks = null;

                loadTasks();

                function loadTasks() {
                    TaskEvent.UserLatest.query({}, onSuccess, onError);
                    function onSuccess(data, headers) {
                        vm.tasks = data;
                        vm.dateCategories.forEach(function (parent) {
                            parent.children = vm.tasks.filter(function (value) {
                                return value.dateCategory === parent.dateCategory;
                            });
                        });
                    }
                    function onError(error) {
                        console.log("failed");
                    }
                }
                
                vm.confirm = function (taskId, recurrenceDateId) {
                    TaskEvent.Confirm.confirm({"taskId": taskId, "recurrenceDateId": recurrenceDateId}, onSuccess, onError);
                    function onSuccess(data, headers) {
                        $state.reload();
                    }
                    function onError(error) {
                        console.log("failed");
                    }
                }
                
                vm.taskClassCheck = function (task) {
                    if (task.dateCategory == 'LATE') {
                        return "bg-danger";
                    } else {
                        return "";
                    }
                };
            }]
    };

    angular
            .module('abcQualityMatchApp')
            .component('tasks', tasks);


})();
(function () {
    'use strict';

    var openProjects = {
        templateUrl: 'app/components/home/projects/open-projects.html',
        controllerAs: 'vm',
        controller: ['Project', function (Project) {
                var vm = this;
                vm.projects = null;

                loadProjects();

                function loadProjects() {
                    Project.UsersOpenProjects.query({}, onSuccess, onError);
                    function onSuccess(data, headers) {
                        vm.projects = data;
                    }
                    function onError(error) {
                        console.log("failed");
                    }
                }
            }]
    };

    angular
            .module('abcQualityMatchApp')
            .component('openProjects', openProjects);


})();
(function () {
    'use strict';

    var informations = {
        templateUrl: 'app/components/home/informations/informations.html',
        controllerAs: 'vm',
        controller: ['Information', 'QuestionnaireCompany', function (Information, QuestionnaireCompany) {
                var vm = this;
                vm.informations = null;
                vm.informationQuestionnaires = null;
                vm.questioinnaireTypes = ["ANOMALY",
                    "CLOSE_CALL","DANGER","PROPOSITION",
                    "CHANGE_NOTIFICATION", "BULLETIN_NOTIFICATION", "INJURY_NOTIFICATION",
                    "RECLAMATION_NOTIFICATION", "INITIATIVE_NOTIFICATION"];

                loadInformations();
                loadInformationQuestionnaires();

                function loadInformations() {
                    Information.informationEventsQuery({
                        page: 0,
                        size: 10,
                        //sort: 'submit_date,desc',
                        sort: ['(submit_date),asc','id'],
                        ticketStateType: 'NEW'
                    }, onSuccess, onError);

                    function onSuccess(data, headers) {
                        data.reverse();
                        vm.informations = data;
                    }
                    function onError(error) {
                        console.log("failed");
                    }
                }

                function loadInformationQuestionnaires() {
                    QuestionnaireCompany.QueryByTypes.query({types: vm.questioinnaireTypes.join(), "size": 1000}, onSuccess, onError);
                    function onSuccess(data, headers) {
                        vm.informationQuestionnaires = data;
                    }
                    function onError(error) {
                        console.log("failed");
                    }
                }
            }]
    };

    angular
            .module('abcQualityMatchApp')
            .component('informations', informations);


})();

(function () {
    'use strict';

    var anomalies = {
        templateUrl: 'app/components/home/anomalies/anomalies.html',
        controllerAs: 'vm',
        controller: ['Anomaly', 'QuestionnaireCompany', '$state', function (Anomaly, QuestionnaireCompany, $state) {
                var vm = this;
                vm.anomalies = null;
                vm.informationQuestionnaires = null;                

                loadAnomalies();
                loadInformationQuestionnaires();

                function loadAnomalies() {
                    Anomaly.UserLatest.query({}, onSuccess, onError);
                    function onSuccess(data, headers) {
                        vm.anomalies = data;
                    }
                    function onError(error) {
                        console.log("failed");
                    }
                }
                
                function loadInformationQuestionnaires() {
                    QuestionnaireCompany.QueryByType.query({"questionnaireType": 'ANOMALY', "size": 1000}, onSuccess, onError);
                    function onSuccess(data, headers) {
                        vm.informationQuestionnaires = data;
                    }
                    function onError(error) {
                        console.log("failed");
                    }
                }

                vm.reject = function (qaId, answerId) {
                    Anomaly.Answer.reject({"questionnaireAnswerId": qaId, "answerId": answerId}, onSuccess, onError);
                    function onSuccess(data, headers) {
                        $state.go("home");
                    }
                    function onError(error) {
                        console.log("failed");
                    }
                }
            }]
    };

    angular
            .module('abcQualityMatchApp')
            .component('anomalies', anomalies);


})();
(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';
    angular.module('abcQualityMatchApp').component('anomalyEventAddSelect', {
          templateUrl: 'app/components/anomaly-event-add-select/anomaly-event-add-select-component.html',  
          restrict: 'E', 
          bindings: { onSelect: '&' },
          controller: AnomalyEventAddSelectController
        });

    AnomalyEventAddSelectController.$inject = ['$scope', 'Anomaly','$http']
    function AnomalyEventAddSelectController(scope, Anomaly, $http) {
        var ctrl = this;
        
        this.selected = null;
        
        ctrl.getAnomalyEvents = function(val){
            return Anomaly.Company.query({searchTerm: val,
                                          sort:'(answer_time),desc'}
                                        ).$promise;
        }
        
        ctrl.setSelected = function(){
            console.log("selected " + JSON.stringify(this.selected));
            this.onSelect({selected: this.selected});
            this.selected = null;
        }
    }
    
    
    
    
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('abcQualityMatchApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('abcQualityMatchApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('abcQualityMatchApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('abcQualityMatchApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = [
        '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'User', 'JhiLanguageService',
        'Principal', 'UserGroup', 'ProductLine'];

    function UserManagementDialogController (
        $scope, $stateParams, $uibModalInstance,
        entity, User, JhiLanguageService,
        Principal, UserGroup, ProductLine) {

        var vm = this;

        $scope.password="";
        $scope.confirmPassword = "";
        $scope.changePassword = true;

        $scope.doNotMatch = false;

        vm.newUserGroup = null;
        vm.newProductLine = null;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {activeFromDate: false, activeToDate:false };
        vm.currentAccount = null;
        vm.authorities = ['ROLE_COMPANY_USER', 'ROLE_COMPANY_SUPERVISOR', 'ROLE_COMPANY_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;
 
        if (vm.user.login) {
            vm.originalLogin = vm.user.login;
            vm.newUser = false;
        } else {
            vm.newUser = true;
        }
        vm.userGroups = UserGroup.selectList();
        vm.productLines = ProductLine.selectList();

        if (vm.user.id != null) {
            $scope.changePassword = false;
            vm.user.forcedPasswordChangOnNextLogin = false;
        }

        if (vm.user.activated){
            vm.activityType = 'ACTIVE';
        }
        else{
            vm.activityType = 'INACTIVE';
        }

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
            if(account.authorities.indexOf("ROLE_ADMIN") !== -1) {
            	vm.authorities = ['ROLE_COMPANY_USER', 'ROLE_COMPANY_SUPERVISOR', 'ROLE_COMPANY_ADMIN','ROLE_ADMIN'];
            } else {
            	vm.authorities = ['ROLE_COMPANY_USER', 'ROLE_COMPANY_SUPERVISOR', 'ROLE_COMPANY_ADMIN'];
            }
        });

        vm.addUserGroup = function () {
            if (vm.newUserGroup != null) {
                var alreadyAdded = false;
                vm.user.userGroupLites.forEach(function (group) {
                    if (group.id == vm.newUserGroup.id) {
                        alreadyAdded = true;
                    }
                });
                if (!alreadyAdded) {
                    vm.user.userGroupLites.push(vm.newUserGroup);
                }
            }
            vm.newUserGroup = null;
        }

        vm.deleteUserGroup = function (index) {
            vm.user.userGroupLites.splice(index,1);
            return false;
        }

        vm.addProductLine = function () {
            if (vm.newProductLine != null) {
                var alreadyAdded = false;
                vm.user.productLineLites.forEach(function (productLine) {
                    if (productLine.id == vm.newProductLine.id) {
                        alreadyAdded = true;
                    }
                });
                if (!alreadyAdded) {
                    vm.user.productLineLites.push(vm.newProductLine);
                }
            }
            vm.newProductLine = null;
        }

        vm.deleteProductLine = function (index) {
            vm.user.productLineLites.splice(index,1);
            return false;
        }

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.user.activated = vm.activityType != 'INACTIVE';

            vm.isSaving = true;
            if ($scope.changePassword && $scope.password !== $scope.confirmPassword) {
        		$scope.doNotMatch = true;
        		$scope.isSaving = false;
        		return;
        	} else if ($scope.changePassword){
        		$scope.doNotMatch = false;
        		if ($scope.password !== "") {
        			vm.user.password = $scope.password;
        		} else {
        			alert($translate.instant('user-management.emptyPassword'));
        			return;
        		}
        	}

            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        vm.radioButtonChange = function(option) {
            vm.user.authorities[0] = option;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        
        vm.setActive = setActive;
        vm.load($stateParams.id);

        function load (id) {
            User.get({id: id}, function(result) {
                vm.user = result;
            });
        }
        
        
        function setActive (user, isActivated) {
            user.activated = isActivated;
            user.activeFromDate = null;
            user.activeToDate= null;
            User.update(user, function (user) {
                vm.user = user;
            });
        }
    }
    
    
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            User.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'company_admin',
            url: '/user-management?page&sort&searchTerm&status',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        searchTerm: $stateParams.searchTerm,
                        status: $stateParams.status
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-detail', {
            parent: 'company_admin',
            url: '/user/:id',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true,
                                activeFromDate: null,
                                activeToDate: null,
                                langKey: 'fi', createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: ['ROLE_COMPANY_USER'],
                                userGroupLites: [],
                                productLineLites: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['$timeout','Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController($timeout, Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_COMPANY_USER', 'ROLE_COMPANY_SUPERVISOR', 'ROLE_COMPANY_ADMIN','ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.refreshSearch = refreshSearch;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm. status = 'ALL';
        vm.searchTerm = null;

        if (pagingParams.searchTerm){
            vm.searchTerm = pagingParams.searchTerm;
        }
        if (pagingParams.status){
            vm.status = pagingParams.status;
        }

        $timeout(function (){
            angular.element('#seachTerm').focus();
        });

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function refreshSearch(){
            loadPage(1);
        }


        function setActive (user, isActivated) {
            user.activated = isActivated;
            user.activeFromDate = null;
            user.activeToDate= null;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll() {
            User.getManagementList({
                searchTerm: vm.searchTerm,
                status: vm.status,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        vm.spreadsheetDownloadParams ={
            searchTerm: vm.searchTerm,
            status: vm.status,
            page: pagingParams.page - 1,
            size: vm.itemsPerPage,
            sort: sort()
        };

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                searchTerm: vm.searchTerm,
                status: vm.status
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('UserGroupDialogController', UserGroupDialogController);

    UserGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'UserGroup', 'User', 'Training'];

    function UserGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, UserGroup, User, Training) {
        var vm = this;
        window.vvm = vm;
        vm.userGroup = entity;
        vm.clear = clear;
        vm.save = save;
        vm.authorities = UserGroup.getUserGroupAuthorityTypes();
        vm.newUser = null;
        vm.newAuthority = null;
        vm.trainingSelectList = Training.query();
        vm.newTraining = null;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.userGroup.id !== null) {
                UserGroup.update(vm.userGroup, onSaveSuccess, onSaveError);
            } else {
                UserGroup.save(vm.userGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:userGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.addUser = function () {
            if (vm.newUser != null) {
                var alreadyAdded = false;
                vm.userGroup.users.forEach(function (userGroupUser) {
                    if (userGroupUser.id == vm.newUser.id) {
                        alreadyAdded = true;
                    }
                });
                if (!alreadyAdded) {
                    vm.userGroup.users.push(vm.newUser);
                    vm.newUser = null;
                }
            }
        };

        vm.deleteUser = function (index) {
            vm.userGroup.users.splice(index,1);
            return false;
        };

        vm.addAuthority = function () {
            if (vm.newAuthority != null) {
                vm.newAuthority.forEach(function (a) {
                    var alreadyAdded = false;
                    vm.userGroup.userGroupAuthorities.forEach(function (authority) {
                        if (authority.name == a) {
                            alreadyAdded = true;
                        }
                    });
                    if (!alreadyAdded) {
                        vm.userGroup.userGroupAuthorities.push({name: a});
                    }
                });
            }
            vm.newAuthority = null;
        };

        vm.deleteAuthority = function (index) {
            vm.userGroup.userGroupAuthorities.splice(index,1);
            return false;
        };


        vm.deleteExpectedTraining = function(index){
            vm.userGroup.expectedTrainings.splice(index,1);
        };
        vm.addExpectedTraining = function(){
            if (vm.newTraining != null){
                var alreadyAdded = false;
                vm.userGroup.expectedTrainings.forEach(function(expt){
                    if (expt.training.id == vm.newTraining.id){
                        alreadyAdded = true;
                    }
                })

                if (!alreadyAdded){
                    var newExpectedTraining = {id: null, training: vm.newTraining, required: false};
                    vm.userGroup.expectedTrainings.push(newExpectedTraining);
                }
                vm.newTraining = null;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('UserGroupDetailController', UserGroupDetailController);

    UserGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'UserGroup', 'User', 'UserGroupAuthority', 'Company'];

    function UserGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, UserGroup, User, UserGroupAuthority, Company) {
        var vm = this;

        vm.userGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:userGroupUpdate', function(event, result) {
            vm.userGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('UserGroupDeleteController',UserGroupDeleteController);

    UserGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserGroup'];

    function UserGroupDeleteController($uibModalInstance, entity, UserGroup) {
        var vm = this;

        vm.userGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UserGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-group', {
            parent: 'company_admin',
            url: '/user-group?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.userGroup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/user-group/user-groups.html',
                    controller: 'UserGroupController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userGroup');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('userGroupAuthorityType');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-group-detail', {
            parent: 'company_admin',
            url: '/user-group/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.userGroup.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/user-group/user-group-detail.html',
                    controller: 'UserGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userGroup');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('userGroupAuthorityType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'UserGroup', function($stateParams, UserGroup) {
                    return UserGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'user-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('user-group-detail.edit', {
            parent: 'user-group-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/user-group/user-group-dialog.html',
                    controller: 'UserGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserGroup', function(UserGroup) {
                            return UserGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-group.new', {
            parent: 'user-group',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/user-group/user-group-dialog.html',
                    controller: 'UserGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null,
                                users: [],
                                userGroupAuthorities: [],
                                expectedTrainings: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-group', null, { reload: 'user-group' });
                }, function() {
                    $state.go('user-group');
                });
            }]
        })
        .state('user-group.edit', {
            parent: 'user-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/user-group/user-group-dialog.html',
                    controller: 'UserGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserGroup', function(UserGroup) {
                            return UserGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-group', null, { reload: 'user-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-group.delete', {
            parent: 'user-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/user-group/user-group-delete-dialog.html',
                    controller: 'UserGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserGroup', function(UserGroup) {
                            return UserGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-group', null, { reload: 'user-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('UserGroup', UserGroup);

    UserGroup.$inject = ['$resource'];

    function UserGroup ($resource) {
        var resourceUrl =  'api/user-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'selectList':{url: 'api/user-groups/select-list', method: 'GET', isArray: true },

            // UserGroupAuthorityType enum values
            'getUserGroupAuthorityTypes':{url: '/api/user-groups/authority-types', method: 'GET', isArray: true }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('UserGroupController', UserGroupController);

    UserGroupController.$inject = ['$scope', '$state', 'UserGroup', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function UserGroupController ($scope, $state, UserGroup, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            UserGroup.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.userGroups = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('TicketStateTypeList', TicketStateTypeList);

    TicketStateTypeList.$inject = ['$resource'];

    function TicketStateTypeList ($resource) {
        var resourceUrl =  'api/ticket-states/temp/:ticketType';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TicketStateDialogController', TicketStateDialogController);

    TicketStateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TicketState', 'ticketType'];

    function TicketStateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TicketState, ticketType) {
        var vm = this;

        vm.ticketState = entity;
        vm.clear = clear;
        vm.save = save;
        vm.type = ticketType.type;
        console.log("TicketType");
        console.log(ticketType);

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticketState.id !== null) {
                TicketState.update(vm.ticketState, onSaveSuccess, onSaveError);
            } else {
                TicketState.save(vm.ticketState, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:ticketStateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TicketStateDetailController', TicketStateDetailController);

    TicketStateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TicketState', 'Company', 'ticketType'];

    function TicketStateDetailController($scope, $rootScope, $stateParams, previousState, entity, TicketState, Company, ticketType) {
        var vm = this;

        vm.ticketState = entity;
        vm.previousState = previousState.name;
        vm.type = ticketType.type;
        console.log("TicketType");
        console.log(ticketType);

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:ticketStateUpdate', function(event, result) {
            vm.ticketState = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TicketStateDeleteController',TicketStateDeleteController);

    TicketStateDeleteController.$inject = ['$uibModalInstance', 'entity', 'TicketState', 'ticketType'];

    function TicketStateDeleteController($uibModalInstance, entity, TicketState, ticketType) {
        var vm = this;

        vm.ticketState = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.type = ticketType.type;
        console.log("TicketType");
        console.log(ticketType);

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TicketState.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket-state', {
            parent: 'company_admin',
            url: '/ticket-state/:ticketType?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.ticketState.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/ticket-state/ticket-states.html',
                    controller: 'TicketStateController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', '$stateParams', function ($translate, $translatePartialLoader, $stateParams) {
                    $translatePartialLoader.addPart('ticketState');
                    $translatePartialLoader.addPart('ticketType');
                    $translatePartialLoader.addPart('ticketStateType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                ticketType: ['$stateParams', function($stateParams) {
                   return {
                       type: $stateParams.ticketType
                   };     
                }]
            }
        })        
        .state('ticket-state-detail', {
            parent: 'company_admin',
            url: '/ticket-state/{ticketType}/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.ticketState.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/ticket-state/ticket-state-detail.html',
                    controller: 'TicketStateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketState');
                    $translatePartialLoader.addPart('ticketType');
                    $translatePartialLoader.addPart('ticketStateType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TicketState', function($stateParams, TicketState) {
                    return TicketState.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticket-state',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }],
                ticketType: ['$stateParams', function($stateParams) {
                   return {
                       type: $stateParams.ticketType
                   };     
                }]
            }
        })
        .state('ticket-state-detail.edit', {
            parent: 'ticket-state-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/ticket-state/ticket-state-dialog.html',
                    controller: 'TicketStateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketState', function(TicketState) {
                            return TicketState.get({id : $stateParams.id}).$promise;
                        }],
                        ticketType: ['$stateParams', function($stateParams) {
                            return {
                                type: $stateParams.ticketType
                            };     
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-state.new', {
            parent: 'ticket-state',
            url: '/new/:ticketType',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/ticket-state/ticket-state-dialog.html',
                    controller: 'TicketStateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                listIndex: null,
                                ticketType: $stateParams.ticketType,
                                ticketStateType: null,
                                id: null
                            };
                        },
                        ticketType: ['$stateParams', function($stateParams) {
                            return {
                                type: $stateParams.ticketType
                            };     
                         }]
                    }
                }).result.then(function() {
                    $state.go('ticket-state', null, { reload: 'ticket-state' });
                }, function() {
                    $state.go('ticket-state');
                });
            }]
        })
        .state('ticket-state.edit', {
            parent: 'ticket-state',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/ticket-state/ticket-state-dialog.html',
                    controller: 'TicketStateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketState', function(TicketState) {
                            return TicketState.get({id : $stateParams.id}).$promise;
                        }],
                        ticketType: ['$stateParams', function($stateParams) {
                            return {
                                type: $stateParams.ticketType
                            };     
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-state', null, { reload: 'ticket-state' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-state.delete', {
            parent: 'ticket-state',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/ticket-state/ticket-state-delete-dialog.html',
                    controller: 'TicketStateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TicketState', function(TicketState) {
                            return TicketState.get({id : $stateParams.id}).$promise;
                        }],
                        ticketType: ['$stateParams', function($stateParams) {
                            return {
                                type: $stateParams.ticketType
                            };     
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-state', null, { reload: 'ticket-state' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('TicketState', TicketState);

    TicketState.$inject = ['$resource'];

    function TicketState ($resource) {
        var resourceUrl =  'api/ticket-states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TicketStateController', TicketStateController);

    TicketStateController.$inject = ['$scope', '$state', 'TicketState', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'ticketType', 'TicketStateTypeList'];

    function TicketStateController ($scope, $state, TicketState, ParseLinks, AlertService, paginationConstants, pagingParams, ticketType, TicketStateTypeList) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.type = ticketType.type;
        console.log("TicketType");
        console.log(ticketType);

        loadAll();

        function loadAll () {
            TicketStateTypeList.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                ticketType: vm.type
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.ticketStates = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RootCauseAnalysisFactorDialogController', RootCauseAnalysisFactorDialogController);

    RootCauseAnalysisFactorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RootCauseAnalysisFactor', 'Company'];

    function RootCauseAnalysisFactorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RootCauseAnalysisFactor, Company) {
        var vm = this;

        vm.rootCauseAnalysisFactor = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rootCauseAnalysisFactor.id !== null) {
                RootCauseAnalysisFactor.update(vm.rootCauseAnalysisFactor, onSaveSuccess, onSaveError);
            } else {
                RootCauseAnalysisFactor.save(vm.rootCauseAnalysisFactor, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:rootCauseAnalysisFactorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RootCauseAnalysisFactorDetailController', RootCauseAnalysisFactorDetailController);

    RootCauseAnalysisFactorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RootCauseAnalysisFactor', 'Company'];

    function RootCauseAnalysisFactorDetailController($scope, $rootScope, $stateParams, previousState, entity, RootCauseAnalysisFactor, Company) {
        var vm = this;

        vm.rootCauseAnalysisFactor = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:rootCauseAnalysisFactorUpdate', function(event, result) {
            vm.rootCauseAnalysisFactor = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RootCauseAnalysisFactorDeleteController',RootCauseAnalysisFactorDeleteController);

    RootCauseAnalysisFactorDeleteController.$inject = ['$uibModalInstance', 'entity', 'RootCauseAnalysisFactor'];

    function RootCauseAnalysisFactorDeleteController($uibModalInstance, entity, RootCauseAnalysisFactor) {
        var vm = this;

        vm.rootCauseAnalysisFactor = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RootCauseAnalysisFactor.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('root-cause-analysis-factor', {
            parent: 'company_admin',
            url: '/root-cause-analysis-factor?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.rootCauseAnalysisFactor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factors.html',
                    controller: 'RootCauseAnalysisFactorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rootCauseAnalysisFactor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('root-cause-analysis-factor-detail', {
            parent: 'company_admin',
            url: '/root-cause-analysis-factor/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.rootCauseAnalysisFactor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-detail.html',
                    controller: 'RootCauseAnalysisFactorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rootCauseAnalysisFactor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RootCauseAnalysisFactor', function($stateParams, RootCauseAnalysisFactor) {
                    return RootCauseAnalysisFactor.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'root-cause-analysis-factor',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('root-cause-analysis-factor-detail.edit', {
            parent: 'root-cause-analysis-factor-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-dialog.html',
                    controller: 'RootCauseAnalysisFactorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RootCauseAnalysisFactor', function(RootCauseAnalysisFactor) {
                            return RootCauseAnalysisFactor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('root-cause-analysis-factor.new', {
            parent: 'root-cause-analysis-factor',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-dialog.html',
                    controller: 'RootCauseAnalysisFactorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                deleted: false,
                                id: null,
                                company:{}
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('root-cause-analysis-factor', null, { reload: 'root-cause-analysis-factor' });
                }, function() {
                    $state.go('root-cause-analysis-factor');
                });
            }]
        })
        .state('root-cause-analysis-factor.edit', {
            parent: 'root-cause-analysis-factor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-dialog.html',
                    controller: 'RootCauseAnalysisFactorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RootCauseAnalysisFactor', function(RootCauseAnalysisFactor) {
                            return RootCauseAnalysisFactor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('root-cause-analysis-factor', null, { reload: 'root-cause-analysis-factor' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('root-cause-analysis-factor.delete', {
            parent: 'root-cause-analysis-factor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-delete-dialog.html',
                    controller: 'RootCauseAnalysisFactorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RootCauseAnalysisFactor', function(RootCauseAnalysisFactor) {
                            return RootCauseAnalysisFactor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('root-cause-analysis-factor', null, { reload: 'root-cause-analysis-factor' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('RootCauseAnalysisFactor', RootCauseAnalysisFactor);

    RootCauseAnalysisFactor.$inject = ['$resource'];

    function RootCauseAnalysisFactor ($resource) {
        var resourceUrl =  'api/root-cause-analysis-factors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RootCauseAnalysisFactorController', RootCauseAnalysisFactorController);

    RootCauseAnalysisFactorController.$inject = ['$scope', '$state', 'RootCauseAnalysisFactor', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function RootCauseAnalysisFactorController ($scope, $state, RootCauseAnalysisFactor, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            RootCauseAnalysisFactor.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.rootCauseAnalysisFactors = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ReasonCodeDialogController', ReasonCodeDialogController);

    ReasonCodeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ReasonCode'];

    function ReasonCodeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ReasonCode) {
        var vm = this;

        vm.reasonCode = entity;

        vm.notificationQuestioinnaireTypes = ["ANOMALY",
            "CLOSE_CALL","DANGER","PROPOSITION",
            "CHANGE_NOTIFICATION", "BULLETIN_NOTIFICATION", "INJURY_NOTIFICATION", "RECLAMATION_NOTIFICATION"];
        vm.newQuestionnaireType = null;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reasonCode.id !== null) {
                ReasonCode.update(vm.reasonCode, onSaveSuccess, onSaveError);
            } else {
                ReasonCode.save(vm.reasonCode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:reasonCodeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.addQuestionnaireType = function(){
            if (vm.reasonCode.questionnaireTypes.indexOf(vm.newQuestionnaireType) >= 0){
                vm.newQuestionnaireType = null;
                return;
            }
            vm.reasonCode.questionnaireTypes.push(vm.newQuestionnaireType);
            vm.newQuestionnaireType = null;
        };

        vm.removeQuestionnaireType = function(type){
            var index = vm.reasonCode.questionnaireTypes.indexOf(type);
            if (index >= 0){
                vm.reasonCode.questionnaireTypes.splice(index, 1)
            }
        };


    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ReasonCodeDetailController', ReasonCodeDetailController);

    ReasonCodeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ReasonCode', 'Company'];

    function ReasonCodeDetailController($scope, $rootScope, $stateParams, previousState, entity, ReasonCode, Company) {
        var vm = this;

        vm.reasonCode = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:reasonCodeUpdate', function(event, result) {
            vm.reasonCode = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ReasonCodeDeleteController',ReasonCodeDeleteController);

    ReasonCodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReasonCode'];

    function ReasonCodeDeleteController($uibModalInstance, entity, ReasonCode) {
        var vm = this;

        vm.reasonCode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ReasonCode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reason-code', {
            parent: 'company_admin',
            url: '/reason-code?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.reasonCode.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/reason-code/reason-codes.html',
                    controller: 'ReasonCodeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reasonCode');
                    $translatePartialLoader.addPart('questionnaireType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('reason-code-detail', {
            parent: 'company_admin',
            url: '/reason-code/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.reasonCode.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/reason-code/reason-code-detail.html',
                    controller: 'ReasonCodeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reasonCode');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ReasonCode', function($stateParams, ReasonCode) {
                    return ReasonCode.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'reason-code',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('reason-code-detail.edit', {
            parent: 'reason-code-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/reason-code/reason-code-dialog.html',
                    controller: 'ReasonCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReasonCode', function(ReasonCode) {
                            return ReasonCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('reason-code.new', {
            parent: 'reason-code',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/reason-code/reason-code-dialog.html',
                    controller: 'ReasonCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                code: null,
                                id: null,
                                questionnaireTypes: [],
                                deleted: false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('reason-code', null, { reload: 'reason-code' });
                }, function() {
                    $state.go('reason-code');
                });
            }]
        })
        .state('reason-code.edit', {
            parent: 'reason-code',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/reason-code/reason-code-dialog.html',
                    controller: 'ReasonCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReasonCode', function(ReasonCode) {
                            return ReasonCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reason-code', null, { reload: 'reason-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('reason-code.delete', {
            parent: 'reason-code',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/reason-code/reason-code-delete-dialog.html',
                    controller: 'ReasonCodeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ReasonCode', function(ReasonCode) {
                            return ReasonCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reason-code', null, { reload: 'reason-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('ReasonCode', ReasonCode);

    ReasonCode.$inject = ['$resource'];

    function ReasonCode ($resource) {
        var resourceUrl =  'api/reason-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'forInformationType': {
                url: 'api/reason-codes/information-type/:questionnaireType',
                method: 'GET',
                isArray: true},

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ReasonCodeController', ReasonCodeController);

    ReasonCodeController.$inject = ['$scope', '$state', 'ReasonCode', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ReasonCodeController ($scope, $state, ReasonCode, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            ReasonCode.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.reasonCodes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductionUnitDialogController', ProductionUnitDialogController);

    ProductionUnitDialogController.$inject = [
        '$timeout', '$scope', '$stateParams',
        '$uibModalInstance', 'entity', 'ProductionUnit',
        'Factory'];

    function ProductionUnitDialogController (
        $timeout, $scope, $stateParams,
        $uibModalInstance, entity, ProductionUnit,
        Factory) {

        var vm = this;

        vm.productionUnit = entity;
        vm.clear = clear;
        vm.save = save;
        vm.factories = Factory.query({"size": 1000, "sort":"name,asc"});

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.productionUnit.id !== null) {
                ProductionUnit.update(vm.productionUnit, onSaveSuccess, onSaveError);
            } else {
                ProductionUnit.save(vm.productionUnit, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:productionUnitUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductionUnitDetailController', ProductionUnitDetailController);

    ProductionUnitDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProductionUnit', 'Company'];

    function ProductionUnitDetailController($scope, $rootScope, $stateParams, previousState, entity, ProductionUnit, Company) {
        var vm = this;

        vm.productionUnit = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:productionUnitUpdate', function(event, result) {
            vm.productionUnit = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductionUnitDeleteController',ProductionUnitDeleteController);

    ProductionUnitDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductionUnit'];

    function ProductionUnitDeleteController($uibModalInstance, entity, ProductionUnit) {
        var vm = this;

        vm.productionUnit = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProductionUnit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('production-unit', {
            parent: 'company_admin',
            url: '/production-unit?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.productionUnit.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/production-unit/production-units.html',
                    controller: 'ProductionUnitController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: '(name),asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productionUnit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('production-unit-detail', {
            parent: 'company_admin',
            url: '/production-unit/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.productionUnit.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/production-unit/production-unit-detail.html',
                    controller: 'ProductionUnitDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productionUnit');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductionUnit', function($stateParams, ProductionUnit) {
                    return ProductionUnit.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'production-unit',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('production-unit-detail.edit', {
            parent: 'production-unit-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/production-unit/production-unit-dialog.html',
                    controller: 'ProductionUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductionUnit', function(ProductionUnit) {
                            return ProductionUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('production-unit.new', {
            parent: 'production-unit',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/production-unit/production-unit-dialog.html',
                    controller: 'ProductionUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('production-unit', null, { reload: 'production-unit' });
                }, function() {
                    $state.go('production-unit');
                });
            }]
        })
        .state('production-unit.edit', {
            parent: 'production-unit',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/production-unit/production-unit-dialog.html',
                    controller: 'ProductionUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductionUnit', function(ProductionUnit) {
                            return ProductionUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('production-unit', null, { reload: 'production-unit' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('production-unit.delete', {
            parent: 'production-unit',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/production-unit/production-unit-delete-dialog.html',
                    controller: 'ProductionUnitDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductionUnit', function(ProductionUnit) {
                            return ProductionUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('production-unit', null, { reload: 'production-unit' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('ProductionUnit', ProductionUnit);

    ProductionUnit.$inject = ['$resource'];

    function ProductionUnit ($resource) {
        var resourceUrl =  'api/production-units/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductionUnitController', ProductionUnitController);

    ProductionUnitController.$inject = ['$scope', '$state', 'ProductionUnit', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProductionUnitController ($scope, $state, ProductionUnit, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            ProductionUnit.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== '(id)') {
                    result.push('(id)');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.productionUnits = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductLineDialogController', ProductLineDialogController);

    ProductLineDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProductLine', 'ProductionUnit', 'User', 'Training'];

    function ProductLineDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProductLine, ProductionUnit, User, Training) {
        var vm = this;

        vm.productLine = entity;
        vm.clear = clear;
        vm.save = save;
        vm.productionunits = ProductionUnit.query({"size": 1000, "sort":"(name),asc"});
        vm.trainingSelectList = Training.query();
        vm.newTraining = null;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.productLine.id !== null) {
                ProductLine.update(vm.productLine, onSaveSuccess, onSaveError);
            } else {
                ProductLine.save(vm.productLine, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:productLineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.addUser = function () {
            if (vm.newUser != null) {
                var alreadyAdded = false;
                vm.productLine.users.forEach(function (productLineUser) {
                    if (productLineUser.id == vm.newUser.id) {
                        alreadyAdded = true;
                    }
                });
                if (!alreadyAdded) {
                    vm.productLine.users.push(vm.newUser);
                    vm.newUser = null;
                }
            }
        }

        vm.deleteUser = function (index) {
            vm.productLine.users.splice(index,1);
            return false;
        }

        vm.deleteExpectedTraining = function(index) {
            vm.productLine.expectedTrainings.splice(index, 1);
        };

        vm.addExpectedTraining = function() {
            if (vm.newTraining != null) {
                var alreadyAdded = false;

                vm.productLine.expectedTrainings.forEach(function(expt) {
                    if (expt.training.id == vm.newTraining.id)
                        alreadyAdded = true;
                })

                if (!alreadyAdded) {
                    var newExpectedTraining = {id:null, training: vm.newTraining, required: false };
                    vm.productLine.expectedTrainings.push(newExpectedTraining);
                }

                vm.newTraining = null;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductLineDetailController', ProductLineDetailController);

    ProductLineDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProductLine', 'Company'];

    function ProductLineDetailController($scope, $rootScope, $stateParams, previousState, entity, ProductLine, Company) {
        var vm = this;

        vm.productLine = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:productLineUpdate', function(event, result) {
            vm.productLine = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductLineDeleteController',ProductLineDeleteController);

    ProductLineDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProductLine'];

    function ProductLineDeleteController($uibModalInstance, entity, ProductLine) {
        var vm = this;

        vm.productLine = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProductLine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product-line', {
            parent: 'company_admin',
            url: '/product-line?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.productLine.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/product-line/product-lines.html',
                    controller: 'ProductLineController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productLine');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-line-detail', {
            parent: 'company_admin',
            url: '/product-line/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.productLine.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/product-line/product-line-detail.html',
                    controller: 'ProductLineDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productLine');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductLine', function($stateParams, ProductLine) {
                    return ProductLine.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'product-line',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('product-line-detail.edit', {
            parent: 'product-line-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/product-line/product-line-dialog.html',
                    controller: 'ProductLineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductLine', function(ProductLine) {
                            return ProductLine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-line.new', {
            parent: 'product-line',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/product-line/product-line-dialog.html',
                    controller: 'ProductLineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null,
                                users: [],
                                expectedTrainings: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product-line', null, { reload: 'product-line' });
                }, function() {
                    $state.go('product-line');
                });
            }]
        })
        .state('product-line.edit', {
            parent: 'product-line',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/product-line/product-line-dialog.html',
                    controller: 'ProductLineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductLine', function(ProductLine) {
                            return ProductLine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-line', null, { reload: 'product-line' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product-line.delete', {
            parent: 'product-line',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/product-line/product-line-delete-dialog.html',
                    controller: 'ProductLineDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductLine', function(ProductLine) {
                            return ProductLine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('product-line', null, { reload: 'product-line' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('ProductLine', ProductLine);

    ProductLine.$inject = ['$resource'];

    function ProductLine ($resource) {
        var resourceUrl =  'api/product-lines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            "selectList": {url: 'api/product-lines/select-list', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductLineController', ProductLineController);

    ProductLineController.$inject = ['$scope', '$state', 'ProductLine', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProductLineController ($scope, $state, ProductLine, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            ProductLine.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.productLines = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductDialogController', ProductDialogController);

    ProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Product'];

    function ProductDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Product) {
        var vm = this;

        vm.product = entity;
        vm.clear = clear;
        vm.save = save;


        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.product.id !== null) {

                Product.update(vm.product, onSaveSuccess, onSaveError);
            } else {
                Product.save(vm.product, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('abcQualityMatchApp:productUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductDetailController', ProductDetailController);

    ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Product', 'Company'];

    function ProductDetailController($scope, $rootScope, $stateParams, previousState, entity, Product, Company) {
        var vm = this;

        vm.product = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:productUpdate', function(event, result) {
            vm.product = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductDeleteController',ProductDeleteController);

    ProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'Product'];

    function ProductDeleteController($uibModalInstance, entity, Product) {
        var vm = this;

        vm.product = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Product.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product', {
            parent: 'company_admin',
            url: '/product?page&sort&search&includeArchived',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.product.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/product/products.html',
                    controller: 'ProductController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-detail', {
            parent: 'company_admin',
            url: '/product/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.product.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/product/product-detail.html',
                    controller: 'ProductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Product', function($stateParams, Product) {
                    return Product.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'product',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('product-detail.edit', {
            parent: 'product-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product.new', {
            parent: 'product',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                number: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: 'product' });
                }, function() {
                    $state.go('product');
                });
            }]
        })

        .state('product.edit', {
            parent: 'product',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: 'product' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product.delete', {
            parent: 'product',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/product/product-delete-dialog.html',
                    controller: 'ProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: 'product' });
                }, function() {
                    $state.go('^');
                });
            }]
        });

    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('Product', Product);

    Product.$inject = ['$resource'];

    function Product ($resource) {
        var resourceUrl =  'api/products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryWithArchived': { method: 'GET', isArray: true, url:'/api/products?includeArchived=true'},
            'uploadImportSpreadsheet': {method: 'POST', url: 'api/products/upload-export-sheet'},


        });
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['$uibModal', '$scope', '$state', 'Product', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$stateParams'];

    function ProductController($uibModal, $scope, $state, Product, ParseLinks, AlertService, paginationConstants, pagingParams, $stateParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.includeArchived = $stateParams.includeArchived == "true";

        loadAll();

        function loadAll() {
            if (vm.includeArchived) {
                Product.queryWithArchived({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Product.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.products = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.reload = function () {
            loadAll();
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {

            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                includeArchived: vm.includeArchived

            });
        }

        vm.openProductImportDialog = function () {

            $uibModal.open({
                templateUrl: 'app/company_admin/product/import-dialog/product-import-dialog.html',
                controller: 'ProductImportdialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'

            }).result.then(function (result) {
                $state.reload();
            });

        };


    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ProductImportdialogController', ProductImportdialogController);

    ProductImportdialogController.$inject = ['$uibModal','$timeout', '$scope',  'DataUtils','$stateParams', '$uibModalInstance','Product'];

    function ProductImportdialogController ($uibModal,$timeout, $scope,  DataUtils,$stateParams, $uibModalInstance, Product) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.archived = false;
        vm.importFail=false;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            Product.uploadImportSpreadsheet({archived:vm.archived},{fileContent:vm.fileContent}, onSaveSuccess, onSaveFail);
        }

        function onSaveSuccess () {

            $uibModalInstance.close();
        }
        function onSaveFail(errors)
        {

            vm.errorData= errors.data;
            vm.errorType = vm.errorData.errorType;
            if (!vm.errorType) {
                vm.errorType="UNEXPECTED_ERROR"
            }

            vm.importFail=true;
        }

        vm.setFileContent = function ($file, $invalidFiles) {
            vm.selectedFileTooLarge = false;
            vm.isSaving=false;
            vm.badFile=false;

            if ($file) {
                vm.fileContent=null;
                var imgTypes = ["application/vnd.ms-excel","application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
                var typeIndex = imgTypes.indexOf($file.type);
                if (typeIndex < 0) {
                    console.log("wrong filetype " + $file.type+" ");
                    vm.isSaving=true;
                    vm.badFile=true;
                    vm.badFileLabel = "Väärä tiedostomuoto. Tuettu tiedostomuoto on .xls, .xlsx";
                    $file=null;
                    return;

                }

                console.log($file.type);
                vm.filename = $file.name;

                if ($invalidFiles && $invalidFiles.length > 0) {
                    vm.selectedFileTooLarge = true;
                    $timeout(function () {
                        vm.selectedFileTooLarge = false;
                    }, 3000);
                    return;
                }

                vm.preparingSelectedFile = true;
                DataUtils.toBase64($file, function (base64Data) {
                    vm.fileContent = base64Data;
                    vm.importFail=false;
                    $timeout(function () {
                        vm.preparingSelectedFile = false;
                        console.log("done setting file data");
                    }, 1);

                });

            }

        };
        vm.openImportConfirmDialog = function(){
            $uibModal.open({
                templateUrl: 'app/company_admin/product/import-dialog/import-dialog-confirm.html',
                controller: 'ProductImportdialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            });

        };

    }
})();


(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('IssueSignificanceDialogController', IssueSignificanceDialogController);

    IssueSignificanceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'IssueSignificance'];

    function IssueSignificanceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, IssueSignificance) {
        var vm = this;

        vm.issueSignificance = entity;
        vm.clear = clear;
        vm.save = save;
        
        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.issueSignificance.id !== null) {
                IssueSignificance.update(vm.issueSignificance, onSaveSuccess, onSaveError);
            } else {
                IssueSignificance.save(vm.issueSignificance, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:issueSignificanceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('IssueSignificanceDetailController', IssueSignificanceDetailController);

    IssueSignificanceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'IssueSignificance', 'Company'];

    function IssueSignificanceDetailController($scope, $rootScope, $stateParams, previousState, entity, IssueSignificance, Company) {
        var vm = this;

        vm.issueSignificance = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:issueSignificanceUpdate', function(event, result) {
            vm.issueSignificance = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('IssueSignificanceDeleteController',IssueSignificanceDeleteController);

    IssueSignificanceDeleteController.$inject = ['$uibModalInstance', 'entity', 'IssueSignificance'];

    function IssueSignificanceDeleteController($uibModalInstance, entity, IssueSignificance) {
        var vm = this;

        vm.issueSignificance = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            IssueSignificance.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('issue-significance', {
            parent: 'company_admin',
            url: '/issue-significance',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.issueSignificance.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/issue-significance/issue-significances.html',
                    controller: 'IssueSignificanceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('issueSignificance');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('issue-significance-detail', {
            parent: 'company_admin',
            url: '/issue-significance/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.issueSignificance.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/issue-significance/issue-significance-detail.html',
                    controller: 'IssueSignificanceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('issueSignificance');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'IssueSignificance', function($stateParams, IssueSignificance) {
                    return IssueSignificance.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'issue-significance',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('issue-significance-detail.edit', {
            parent: 'issue-significance-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/issue-significance/issue-significance-dialog.html',
                    controller: 'IssueSignificanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IssueSignificance', function(IssueSignificance) {
                            return IssueSignificance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('issue-significance.new', {
            parent: 'issue-significance',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/issue-significance/issue-significance-dialog.html',
                    controller: 'IssueSignificanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                deleted: false,
                                id: null,
                                company:{}
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('issue-significance', null, { reload: 'issue-significance' });
                }, function() {
                    $state.go('issue-significance');
                });
            }]
        })
        .state('issue-significance.edit', {
            parent: 'issue-significance',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/issue-significance/issue-significance-dialog.html',
                    controller: 'IssueSignificanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IssueSignificance', function(IssueSignificance) {
                            return IssueSignificance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('issue-significance', null, { reload: 'issue-significance' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('issue-significance.delete', {
            parent: 'issue-significance',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/issue-significance/issue-significance-delete-dialog.html',
                    controller: 'IssueSignificanceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['IssueSignificance', function(IssueSignificance) {
                            return IssueSignificance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('issue-significance', null, { reload: 'issue-significance' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('IssueSignificance', IssueSignificance);

    IssueSignificance.$inject = ['$resource'];

    function IssueSignificance ($resource) {
        var resourceUrl =  'api/issue-significances/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('IssueSignificanceController', IssueSignificanceController);

    IssueSignificanceController.$inject = ['$scope', '$state', 'IssueSignificance', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function IssueSignificanceController ($scope, $state, IssueSignificance, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        
        loadAll();

        function loadAll () {
            IssueSignificance.query({}, onSuccess, onError);
            
            function onSuccess(data) {
                vm.issueSignificances = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('FactoryDialogController', FactoryDialogController);

    FactoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Factory'];

    function FactoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Factory) {
        var vm = this;

        vm.factory = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('#field_name').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.factory.id !== null) {
                Factory.update(vm.factory, onSaveSuccess, onSaveError);
            } else {
                Factory.save(vm.factory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:factoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('FactoryDetailController', FactoryDetailController);

    FactoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity'];

    function FactoryDetailController($scope, $rootScope, $stateParams, previousState, entity) {
        var vm = this;

        vm.factory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:factoryUpdate', function(event, result) {
            vm.factory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('FactoryDeleteController',FactoryDeleteController);

    FactoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Factory'];

    function FactoryDeleteController($uibModalInstance, entity, Factory) {
        var vm = this;

        vm.factory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Factory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('factory', {
            parent: 'company_admin',
            url: '/factory?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.factory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/factory/factories.html',
                    controller: 'FactoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('factory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('factory-detail', {
            parent: 'company_admin',
            url: '/factory/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.factory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/factory/factory-detail.html',
                    controller: 'FactoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('factory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Factory', function($stateParams, Factory) {
                    return Factory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'factory',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('factory-detail.edit', {
            parent: 'factory-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/factory/factory-dialog.html',
                    controller: 'FactoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Factory', function(Factory) {
                            return Factory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('factory.new', {
            parent: 'factory',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/factory/factory-dialog.html',
                    controller: 'FactoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('factory', null, { reload: 'factory' });
                }, function() {
                    $state.go('factory');
                });
            }]
        })
        .state('factory.edit', {
            parent: 'factory',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/factory/factory-dialog.html',
                    controller: 'FactoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Factory', function(Factory) {
                            return Factory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('factory', null, { reload: 'factory' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('factory.delete', {
            parent: 'factory',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/factory/factory-delete-dialog.html',
                    controller: 'FactoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Factory', function(Factory) {
                            return Factory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('factory', null, { reload: 'factory' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('Factory', Factory);

    Factory.$inject = ['$resource'];

    function Factory ($resource) {
        var resourceUrl =  'api/factories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('FactoryController', FactoryController);

    FactoryController.$inject = ['$scope', '$state', 'Factory', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FactoryController ($scope, $state, Factory, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Factory.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.factories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('company_admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('AnomalyCategoryDialogController', AnomalyCategoryDialogController);

    AnomalyCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AnomalyCategory'];

    function AnomalyCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AnomalyCategory) {
        var vm = this;

        vm.anomalyCategory = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.anomalyCategory.id !== null) {
                AnomalyCategory.update(vm.anomalyCategory, onSaveSuccess, onSaveError);
            } else {
                AnomalyCategory.save(vm.anomalyCategory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:anomalyCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('AnomalyCategoryDetailController', AnomalyCategoryDetailController);

    AnomalyCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AnomalyCategory'];

    function AnomalyCategoryDetailController($scope, $rootScope, $stateParams, previousState, entity, AnomalyCategory) {
        var vm = this;

        vm.anomalyCategory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:anomalyCategoryUpdate', function(event, result) {
            vm.anomalyCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('AnomalyCategoryDeleteController',AnomalyCategoryDeleteController);

    AnomalyCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'AnomalyCategory'];

    function AnomalyCategoryDeleteController($uibModalInstance, entity, AnomalyCategory) {
        var vm = this;

        vm.anomalyCategory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AnomalyCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('anomaly-category', {
            parent: 'company_admin',
            url: '/anomaly-category?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.anomalyCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-categories.html',
                    controller: 'AnomalyCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('anomalyCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('anomaly-category-detail', {
            parent: 'anomaly-category',
            url: '/anomaly-category/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.anomalyCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-category-detail.html',
                    controller: 'AnomalyCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('anomalyCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AnomalyCategory', function($stateParams, AnomalyCategory) {
                    return AnomalyCategory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'anomaly-category',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('anomaly-category-detail.edit', {
            parent: 'anomaly-category-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-category-dialog.html',
                    controller: 'AnomalyCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AnomalyCategory', function(AnomalyCategory) {
                            return AnomalyCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('anomaly-category.new', {
            parent: 'anomaly-category',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-category-dialog.html',
                    controller: 'AnomalyCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('anomaly-category', null, { reload: 'anomaly-category' });
                }, function() {
                    $state.go('anomaly-category');
                });
            }]
        })
        .state('anomaly-category.edit', {
            parent: 'anomaly-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-category-dialog.html',
                    controller: 'AnomalyCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AnomalyCategory', function(AnomalyCategory) {
                            return AnomalyCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('anomaly-category', null, { reload: 'anomaly-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('anomaly-category.delete', {
            parent: 'anomaly-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-category-delete-dialog.html',
                    controller: 'AnomalyCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AnomalyCategory', function(AnomalyCategory) {
                            return AnomalyCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('anomaly-category', null, { reload: 'anomaly-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('AnomalyCategory', AnomalyCategory);

    AnomalyCategory.$inject = ['$resource'];

    function AnomalyCategory ($resource) {
        var resourceUrl =  'api/anomaly-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('AnomalyCategoryController', AnomalyCategoryController);

    AnomalyCategoryController.$inject = ['$scope', '$state', 'AnomalyCategory', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AnomalyCategoryController ($scope, $state, AnomalyCategory, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            AnomalyCategory.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.anomalyCategories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('abcQualityMatchApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1 && response.data.path.indexOf('/api/companies/user') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                
                if (to.name !== 'home'){ //this is so that home page login error does not show login dialog
                    if (to.name !== 'accessdenied') {
                        Auth.storePreviousState(to.name, params);
                    }
                    var LoginService = $injector.get('LoginService');
                    LoginService.open();
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "fi"');
                $cookies.putObject(name, 'fi');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('fi');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';

    angular
            .module('abcQualityMatchApp')
            .config(stateConfig)
            .run(['$rootScope', '$http', '$q', 'ENV', function ($rootScope, $http, $q, ENV) {

                    $rootScope.ENV = ENV;
                    $rootScope.selectedCompany;
                    $rootScope.userCompanies;

                    $rootScope.resetCompany = function () {
//                        console.log("start reset");
                        $rootScope.selectedCompany = null;
                        $rootScope.userCompanies = null;
                        $rootScope.getDefaultCompany();
//                        console.log("end reset");
                    };

                    $rootScope.getSelectedCompanyId = function () {
                        if ($rootScope.selectedCompany &&
                                $rootScope.selectedCompany.id &&
                                $rootScope.selectedCompany != null &&
                                $rootScope.selectedCompany.id > 0) {
                            return $rootScope.selectedCompany.id;
                        } else {
                            return $q.when($rootScope.getSelectedCompany()).then(function (company) {
                                if (company) {
                                    return company.id;
                                } else {
                                    return 0;
                                }
                            });
                        }
                    };

                    $rootScope.getSelectedCompany = function () {
                        if ($rootScope.selectedCompany &&
                                $rootScope.selectedCompany != null &&
                                $rootScope.selectedCompany.id &&
                                $rootScope.selectedCompany.id > 0) {
                            return $rootScope.selectedCompany;
                        } else {
                            return null;
                        }
                    };

                    $rootScope.getDefaultCompany = function () {
                        return $q.when($rootScope.getUserCompanies()).then(function () {
                            return $rootScope.getSelectedCompanyFromServer().then(function (company) {
                                if (company) {
//                                    console.log("default server company");
                                    $rootScope.userCompanies.forEach(function (userCompany) {
                                        if (userCompany.id == company.id) {
                                            $rootScope.selectedCompany = userCompany;
                                        }
                                    });
                                    return $rootScope.selectedCompany;
                                } else if ($rootScope.userCompanies.length > 0) {
//                                    console.log("default company");
                                    $rootScope.selectedCompany = $rootScope.userCompanies[0];
                                    $rootScope.setSelectedCompanyToServer($rootScope.selectedCompany);
                                    return $rootScope.selectedCompany;
                                } else {
                                    return null;
                                }
                            })
                        });
                    }

                    $rootScope.getUserCompanies = function (refresh) {
                        if (refresh == undefined || refresh != undefined && refresh == false) {
                            if ($rootScope.userCompanies != undefined) {
                                return $q.when($rootScope.userCompanies).then(function () {
                                    return $rootScope.userCompanies;
                                });
                            }
                        }
                        return $http.get("/api/companies/user").then(function (response) {
//                            console.log("fetch companies");
                            $rootScope.userCompanies = response.data;
                            return $rootScope.userCompanies;
                        });
                    };

                    $rootScope.setSelectedCompany = function (company) {
                        $rootScope.selectedCompany = company;
                    };

                    $rootScope.setSelectedCompanyToServer = function (company) {
                        console.log("Company changed to :");
                        console.log(company);

                        $http.post('api/companies/selected', company)
                                .success(function (response) {
                                    console.log(response);
                                });
                    };

                    $rootScope.getSelectedCompanyFromServer = function () {
                        return $http.get("/api/companies/selected").then(function (response) {
                            console.log("selected from server");
                            console.log(response.data);
                            return response.data;
                        });
                    };

                    $rootScope.getDefaultCompany();
                }]);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                    }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('abcQualityMatchApp')
        .constant('VERSION', "2022-11-14")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('ENV', "prod")
;
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RootCauseAnalysisDialogController', RootCauseAnalysisDialogController);

    RootCauseAnalysisDialogController.$inject = ['$timeout',
        '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'RootCauseAnalysis', 'RootCauseAnalysisFactor', 'User', 'Principal',
        'AlertService','Information', 'Anomaly', 'AbcListUtils'];

    function RootCauseAnalysisDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                                    RootCauseAnalysis, RootCauseAnalysisFactor, User, Principal,
                                                    AlertService, Information, Anomaly, AbcListUtils) {
        var vm = this;

        vm.rootCauseAnalysis = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.addCause = addCause;
        vm.moveCause = moveCause;
        vm.deleteCause = deleteCause;
        vm.deleteFactor = deleteFactor;

        vm.deleteInformationEvent = deleteInformationEvent;
        vm.addInformationEvent = addInformationEvent;

        vm.addAnomalyEvent = addAnomalyEvent;
        vm.deleteAnomalyEvent = deleteAnomalyEvent;

        vm.datePickerOpenStatus.created = false;

        loadFactors();






        vm.factorToAdd = null;
        vm.addFactor = addFactor;

        $timeout(function (){
            angular.element('#field_issue').focus();
        });

        if (vm.rootCauseAnalysis.id == null){

            if (entity.linkToInformationIds){
                loadInformationEventsForLinking(entity.linkToInformationIds);
            }
            if (entity.linkToAnomalyEventIds){
                loadAnomalyEventsForLinking(entity.linkToAnomalyEventIds);
            }

            Principal.identity().then(function (account) {
                vm.rootCauseAnalysis.author = account;
            });

            if (vm.rootCauseAnalysis.causes.length == 0){
                for (var i=0; i < 5; ++i){
                    var cause = { description: '',
                                   listIndex: vm.rootCauseAnalysis.causes.length,
                                 };
                    vm.rootCauseAnalysis.causes.push(cause);
                }
            }
        }

        function loadFactors() {
            RootCauseAnalysisFactor.query({
                page: 0,
                size: 1000,
                sort: ['name,asc','id']
            }, onSuccess, onError);
            function onSuccess(data) {
                vm.factors = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }


        function loadInformationEventsForLinking(ids) {
            Information.informationEventsByIds({ids: ids }, onSuccess, onError);
            function onSuccess(data) {
                vm.rootCauseAnalysis.informationEvents = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadAnomalyEventsForLinking(ids){
            Anomaly.EventsByIds.query({ids: ids }, onSuccess, onError);
            function onSuccess(data) {
                vm.rootCauseAnalysis.anomalyEvents = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }



        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rootCauseAnalysis.id !== null) {
                RootCauseAnalysis.update(vm.rootCauseAnalysis, onSaveSuccess, onSaveError);
            } else {
                RootCauseAnalysis.save(vm.rootCauseAnalysis, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:rootCauseAnalysisUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }



        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function addCause(){
            var cause = { description: '',
                             listIndex: vm.rootCauseAnalysis.causes.length,
                         };
            vm.rootCauseAnalysis.causes.push(cause);
            return false;
        }

        function deleteCause(index) {
            vm.rootCauseAnalysis.causes.splice(index,1);
            updateListIndexes(vm.rootCauseAnalysis.causes);
            return false;
        }

        function moveCause(index, direction) {
            if(direction === "up") {
                vm.rootCauseAnalysis.causes[index-1].listIndex++;
                vm.rootCauseAnalysis.causes[index].listIndex--;
            }
            else {
                vm.rootCauseAnalysis.causes[index+1].listIndex--;
                vm.rootCauseAnalysis.causes[index].listIndex++;
            }
            vm.rootCauseAnalysis.causes.sort(function(a,b){
                return a.listIndex - b.listIndex;
            });
            updateListIndexes(vm.rootCauseAnalysis.causes);
        }

        function updateListIndexes(list){
            list.forEach(function(currentValue, index, array) {
                currentValue.listIndex = index;
            });
        }

        function deleteFactor(index){
            vm.rootCauseAnalysis.factors.splice(index,1);
        }

        function addFactor(){

            if (!vm.factorToAdd){
                return;
            }
            if (AbcListUtils.findById(vm.factorToAdd.id, vm.rootCauseAnalysis.factors) == null){
                vm.rootCauseAnalysis.factors.push(vm.factorToAdd);
            }
            vm.factorToAdd = null;
        }

        function deleteInformationEvent(index){
            vm.rootCauseAnalysis.informationEvents.splice(index,1);
        }

        function addInformationEvent(selected){
            console.log('addInformationEvent');
            if (selected){



                if (AbcListUtils.findById(selected.id, vm.rootCauseAnalysis.informationEvents) == null){
                    vm.rootCauseAnalysis.informationEvents.push(selected);
                }
            }
        }

        function deleteAnomalyEvent(index){
            vm.rootCauseAnalysis.anomalyEvents.splice(index,1);
        }

        function addAnomalyEvent(selected){
            if (selected){
                var alreadySelected = false;
                vm.rootCauseAnalysis.anomalyEvents.forEach(function(event){
                    if (event.row === selected.row){
                        alreadySelected = true;
                    }
                });


                if (!alreadySelected){
                    vm.rootCauseAnalysis.anomalyEvents.push(selected);
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RootCauseAnalysisDetailController', RootCauseAnalysisDetailController);

    RootCauseAnalysisDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity'];

    function RootCauseAnalysisDetailController($scope, $rootScope, $stateParams, previousState, entity) {
        var vm = this;

        vm.rootCauseAnalysis = entity;
        vm.previousState = 'root-cause-analysis';  //previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:rootCauseAnalysisUpdate', function(event, result) {
            vm.rootCauseAnalysis = result;
        });
        $scope.$on('$destroy', unsubscribe);
        
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RootCauseAnalysisDeleteController',RootCauseAnalysisDeleteController);

    RootCauseAnalysisDeleteController.$inject = ['$uibModalInstance', 'entity', 'RootCauseAnalysis'];

    function RootCauseAnalysisDeleteController($uibModalInstance, entity, RootCauseAnalysis) {
        var vm = this;

        vm.rootCauseAnalysis = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RootCauseAnalysis.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('root-cause-analysis', {
            parent: 'functions_menu',
            url: '/root-cause-analysis?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS'],
                pageTitle: 'abcQualityMatchApp.rootCauseAnalysis.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analyses.html',
                    controller: 'RootCauseAnalysisController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'created,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rootCauseAnalysis');
                    $translatePartialLoader.addPart('information');
                    $translatePartialLoader.addPart('informationEvent');
                    $translatePartialLoader.addPart('questionnaireType');
                    $translatePartialLoader.addPart('anomalyEvent');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('root-cause-analysis-detail', {
            parent: 'functions_menu',
            url: '/root-cause-analysis/detail/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS'],
                pageTitle: 'abcQualityMatchApp.rootCauseAnalysis.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analysis-detail.html',
                    controller: 'RootCauseAnalysisDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rootCauseAnalysis');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('ticketMaterial');
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('information');
                    $translatePartialLoader.addPart('informationEvent');
                    $translatePartialLoader.addPart('questionnaireType');
                    $translatePartialLoader.addPart('anomalyEvent');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RootCauseAnalysis', function($stateParams, RootCauseAnalysis) {
                    return RootCauseAnalysis.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'root-cause-analysis',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('root-cause-analysis-detail.edit', {
            parent: 'root-cause-analysis-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analysis-dialog.html',
                    controller: 'RootCauseAnalysisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RootCauseAnalysis', function(RootCauseAnalysis) {
                            return RootCauseAnalysis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('root-cause-analysis.new', {
            parent: 'root-cause-analysis',
            url: '/new?inf&aes',
            param:{
                inf:{
                    array : true,
                }
            },
            
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analysis-dialog.html',
                    controller: 'RootCauseAnalysisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        
                        
                        entity: 
                            function () {
                                return {
                                    created: new Date(),
                                    factorsDescription: null,
                                    factors: [],
                                    id: null,
                                    issue: null,
                                    causes:[],
                                    rootCauseDescription: null,
                                    company: {},
                                    correctiveActionPlan: null,
                                    correctiveProjectId: null,
                                    correctiveTasktId:null,
                                    author:null,
                                    informationEvents: [],
                                    anomalyEvents:[],
                                    
                                    linkToInformationIds : $stateParams.inf,
                                    linkToAnomalyEventIds : $stateParams.aes
                                };
                            }
                        
                       }
                }).result.then(function() {
                    $state.go('root-cause-analysis', null, { reload: 'root-cause-analysis' });
                }, function() {
                    $state.go('root-cause-analysis');
                });
            }]
        })
        
       
        
        
        .state('root-cause-analysis.edit', {
            parent: 'root-cause-analysis',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analysis-dialog.html',
                    controller: 'RootCauseAnalysisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RootCauseAnalysis', function(RootCauseAnalysis) {
                            return RootCauseAnalysis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('root-cause-analysis', null, { reload: 'root-cause-analysis' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('root-cause-analysis.delete', {
            parent: 'root-cause-analysis',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analysis-delete-dialog.html',
                    controller: 'RootCauseAnalysisDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RootCauseAnalysis', function(RootCauseAnalysis) {
                            return RootCauseAnalysis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('root-cause-analysis', null, { reload: 'root-cause-analysis' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
    

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('RootCauseAnalysis', RootCauseAnalysis);

    RootCauseAnalysis.$inject = ['$resource', 'DateUtils'];

    function RootCauseAnalysis ($resource, DateUtils) {
        var resourceUrl =  'api/root-cause-analyses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RootCauseAnalysisController', RootCauseAnalysisController);

    RootCauseAnalysisController.$inject = ['$scope', '$state', 'RootCauseAnalysis', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function RootCauseAnalysisController ($scope, $state, RootCauseAnalysis, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            RootCauseAnalysis.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.rootCauseAnalyses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('QuestionnaireGroupDialogController', QuestionnaireGroupDialogController);

    QuestionnaireGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'QuestionnaireGroup', 'Company', 'Questionnaire'];

    function QuestionnaireGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, QuestionnaireGroup, Company, Questionnaire) {
        var vm = this;

        vm.questionnaireGroup = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query({"size": 1000, "sort":"name,asc"});

        vm.newQuestionnaire = null;
        vm.newCompany = null;
        vm.templateQuestionnaires = Questionnaire.query({"size": 1000, "sort":"title,asc"});

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.questionnaireGroup.id !== null) {
                QuestionnaireGroup.update(vm.questionnaireGroup, onSaveSuccess, onSaveError);
            } else {
                QuestionnaireGroup.save(vm.questionnaireGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('abcQualityMatchApp:questionnaireGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.removeQuestionnaire = function(questionnaire){

            var index = null;
            for (var i = 0; i<vm.questionnaireGroup.questionnaires.length; ++i){
                if (vm.questionnaireGroup.questionnaires[i].id == questionnaire.id){
                    index = i;
                }
            }
            if (index != null) {
                vm.questionnaireGroup.questionnaires.splice(index, 1);
            }
        };

        vm.addQuestionnaire = function(){

            if (!vm.newQuestionnaire){
                return;
            }

            var found = false;

            vm.questionnaireGroup.questionnaires.forEach(function(qn){
                if (qn.id == vm.newQuestionnaire.id){
                    found = true;
                } });

            if (!found){
                vm.questionnaireGroup.questionnaires.push(vm.newQuestionnaire);
            }
            vm.newQuestionnaire = null;
        };


        vm.removeCompany = function(company){

            var index = null;
            for (var i = 0; i< vm.questionnaireGroup.companies.length; ++i){
                if (vm.questionnaireGroup.companies[i].id == company.id){
                    index = i;
                }
            }
            if (index != null) {
                vm.questionnaireGroup.companies.splice(index, 1);
            }
        };

        vm.addCompany = function(){

            if (!vm.newCompany){
                return;
            }

            var found = false;

            vm.questionnaireGroup.companies.forEach(function(company){
                if (company.id == vm.newCompany.id){
                    found = true;
                } });

            if (!found){
                vm.questionnaireGroup.companies.push(vm.newCompany);
            }
            vm.newCompany = null;
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('QuestionnaireGroupDetailController', QuestionnaireGroupDetailController);

    QuestionnaireGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'QuestionnaireGroup', 'Company'];

    function QuestionnaireGroupDetailController($scope, $rootScope, $stateParams, previousState, entity, QuestionnaireGroup, Company) {
        var vm = this;

        vm.questionnaireGroup = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:questionnaireGroupUpdate', function(event, result) {
            vm.questionnaireGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('QuestionnaireGroupDeleteController',QuestionnaireGroupDeleteController);

    QuestionnaireGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'QuestionnaireGroup'];

    function QuestionnaireGroupDeleteController($uibModalInstance, entity, QuestionnaireGroup) {
        var vm = this;

        vm.questionnaireGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            QuestionnaireGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];




    function stateConfig($stateProvider) {

        $stateProvider
        .state('questionnaire-group', {
            parent: 'admin',
            url: '/questionnaire-group?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'abcQualityMatchApp.questionnaireGroup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-groups.html',
                    controller: 'QuestionnaireGroupController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('questionnaireGroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('questionnaire-group-detail', {
            parent: 'questionnaire-group',
            url: '/questionnaire-group/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'abcQualityMatchApp.questionnaireGroup.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-group-detail.html',
                    controller: 'QuestionnaireGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('questionnaireGroup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'QuestionnaireGroup', function($stateParams, QuestionnaireGroup) {
                    return QuestionnaireGroup.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'questionnaire-group',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('questionnaire-group-detail.edit', {
            parent: 'questionnaire-group-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-group-dialog.html',
                    controller: 'QuestionnaireGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QuestionnaireGroup', function(QuestionnaireGroup) {
                            return QuestionnaireGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('questionnaire-group.new', {
            parent: 'questionnaire-group',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-group-dialog.html',
                    controller: 'QuestionnaireGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null,
                                questionnaires: [],
                                companies:[]
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('questionnaire-group', null, { reload: 'questionnaire-group' });
                }, function() {
                    $state.go('questionnaire-group');
                });
            }]
        })
        .state('questionnaire-group.edit', {
            parent: 'questionnaire-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-group-dialog.html',
                    controller: 'QuestionnaireGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['QuestionnaireGroup', function(QuestionnaireGroup) {
                            return QuestionnaireGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('questionnaire-group', null, { reload: 'questionnaire-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('questionnaire-group.delete', {
            parent: 'questionnaire-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/questionnaire-group/questionnaire-group-delete-dialog.html',
                    controller: 'QuestionnaireGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['QuestionnaireGroup', function(QuestionnaireGroup) {
                            return QuestionnaireGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('questionnaire-group', null, { reload: 'questionnaire-group' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('QuestionnaireGroup', QuestionnaireGroup);

    QuestionnaireGroup.$inject = ['$resource'];

    function QuestionnaireGroup ($resource) {
        var resourceUrl =  'api/questionnaire-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('QuestionnaireGroupController', QuestionnaireGroupController);

    QuestionnaireGroupController.$inject = ['$state', 'QuestionnaireGroup', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function QuestionnaireGroupController($state, QuestionnaireGroup, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            QuestionnaireGroup.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.questionnaireGroups = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('abcQualityMatchApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('CompanyDialogController', CompanyDialogController);

    CompanyDialogController.$inject = ['$rootScope', '$timeout', '$scope', 'DataUtils', '$stateParams', '$uibModalInstance', 'entity', 'Company'];

    function CompanyDialogController($rootScope, $timeout, $scope, DataUtils, $stateParams, $uibModalInstance, entity, Company) {
        var vm = this;

        vm.company = entity.company;
        vm.clear = clear;
        vm.save = save;
        loadLogo();
        vm.deleteLogo = false;

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadLogo() {
            if (!entity.companyLogo) {
                vm.hasLogo = false;
                return;
            }
            vm.logoUrl = "/api/companies/get-logo/" + entity.companyLogo.id;
            vm.hasLogo = true;
        }

        function save() {
            vm.isSaving = true;

            if (vm.fileContent) {
                vm.companyLogo = {
                    fileContent: vm.fileContent,
                    fileContentContentType: vm.fileType
                };
            }
            vm.companyDTO = {company: vm.company, companyLogo: vm.companyLogo}
            if (vm.company.id) {
                if (vm.deleteLogo) {
                    vm.companyDTO = {company: vm.company, companyLogo: null}
                    vm.hasLogo = false;
                }
                if(!vm.fileContent && !vm.deleteLogo){
                    vm.companyDTO = {company: vm.company, companyLogo: entity.companyLogo};

                }
                Company.update(vm.companyDTO, onSaveSuccess, onSaveError);

            } else {
                Company.save(vm.companyDTO, onSaveSuccess, onSaveError);
            }

        }


        vm.setFileContent = function ($file, $invalidFiles) {
            vm.selectedFileTooLarge = false;
            vm.isSaving = false;
            vm.badFile = false;

            if ($file) {
                var imgTypes = ["image/jpeg", "image/jpg", "image/png"];
                var typeIndex = imgTypes.indexOf($file.type);
                if (typeIndex < 0) {
                    console.log("wrong filetype " + $file.type + " ");
                    vm.isSaving = true;
                    vm.badFile = true;
                    vm.badFileLabel = "-  Väärä tiedostomuoto. Tuetut tiedostomuodot ovat: .jpeg .jpg .png";
                    vm.fileLabel = $file.name;

                    return;
                }
                vm.fileType = $file.type;
                console.log($file.type);
                vm.fileLabel = $file.name;

                if ($invalidFiles && $invalidFiles.length > 0) {
                    vm.selectedFileTooLarge = true;
                    $timeout(function () {
                        vm.selectedFileTooLarge = false;
                    }, 3000);
                    return;
                }

                vm.preparingSelectedFile = true;
                DataUtils.toBase64($file, function (base64Data) {
                    vm.fileContent = base64Data;
                    $timeout(function () {
                        vm.preparingSelectedFile = false;
                        console.log("done setting file data");
                    }, 1);

                });
            }

        };



        function onSaveSuccess(result) {
            $scope.$emit('abcQualityMatchApp:companyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            $rootScope.resetCompany();
            console.log(result);

        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('CompanyDetailController', CompanyDetailController);

    CompanyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Company', 'Questionnaire'];

    function CompanyDetailController($scope, $rootScope, $stateParams, previousState, entity, Company, Questionnaire) {
        var vm = this;

        vm.company = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('abcQualityMatchApp:companyUpdate', function(event, result) {
            vm.company = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('CompanyDeleteController',CompanyDeleteController);

    CompanyDeleteController.$inject = ['$rootScope','$uibModalInstance', 'entity', 'Company'];

    function CompanyDeleteController($rootScope,$uibModalInstance, entity, Company) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Company.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    $rootScope.resetCompany();
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('company', {
                parent: 'admin',
                url: '/company',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'abcQualityMatchApp.company.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/company/companies.html',
                        controller: 'CompanyController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('company-detail', {
                parent: 'admin',
                url: '/company/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'abcQualityMatchApp.company.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/company/company-detail.html',
                        controller: 'CompanyDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Company', function ($stateParams, Company) {
                        return Company.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'company',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('company-detail.edit', {
                parent: 'company-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/company/company-dialog.html',
                        controller: 'CompanyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Company', function (Company) {
                                return Company.getDto({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company.new', {
                parent: 'company',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/company/company-dialog.html',
                        controller: 'CompanyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    streetAddress: null,
                                    postCode: null,
                                    city: null,
                                    tel: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('company', null, {reload: 'company'});
                    }, function () {
                        $state.go('company');
                    });
                }]
            })
            .state('company.edit', {
                parent: 'company',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/company/company-dialog.html',
                        controller: 'CompanyDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Company', function (Company) {
                                return Company.getDto({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company', null, {reload: 'company'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('company.delete', {
                parent: 'company',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/company/company-delete-dialog.html',
                        controller: 'CompanyDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Company', function (Company) {
                                return Company.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('company', null, {reload: 'company'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function () {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('Company', Company);

    Company.$inject = ['$resource'];

    function Company($resource) {
        var resourceUrl = 'api/companies/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'getLogo': {
                method: 'GET',
                url: 'api/companies/get-logo/:id'
            },
            'getLogoId': {
                method: 'GET',
                url: 'api/companies/get-logo-id'
            },

            'getDto': {
                method: 'GET',
                url: 'api/companies/dto/:id'
            },


        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('CompanyController', CompanyController);

    CompanyController.$inject = ['$scope', '$state', 'Company', 'ParseLinks', 'AlertService', 'paginationConstants'];

    function CompanyController ($scope, $state, Company, ParseLinks, AlertService, paginationConstants) {
        var vm = this;

        vm.companies = [];
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;

        loadAll();

        function loadAll () {
            Company.query({
                page: vm.page,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.companies.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.companies = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_COMPANY_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('forced-password-change', {
            parent: 'app',
            url: '/forced-password-change',
            data: {
                pageTitle: 'abcQualityMatchApp.forcedPasswordChange.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/forced-password-change/forced-password-change.html',
                    controller: 'ForcedPasswordChangeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('forcedPasswordChange');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .factory('ForcedPasswordChange', ForcedPasswordChange);

    ForcedPasswordChange.$inject = ['$resource'];

    function ForcedPasswordChange($resource) {
        var resourceUrl =  'api/account/forced-password-change';

        return $resource(resourceUrl, {}, {
            'changePassword': { method:'POST' }
        });
    }


})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ForcedPasswordChangeController', ForcedPasswordChangeController);

    ForcedPasswordChangeController.$inject = ['ForcedPasswordChange', 'Principal', '$state', '$injector','$rootScope', '$uibModal'];

    function ForcedPasswordChangeController (ForcedPasswordChange, Principal, $state, $injector, $rootScope, $uibModal) {
        var vm = this;

        vm.error = null;

        vm.passwordChange = {
            oldPassword:"",
            newPassword:""
        };


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        $rootScope.$on('$stateChangeStart',
            function(event){
                if (event.currentScope.fromState.name ==='forced-password-change'){
                    var authenticated = Principal.isAuthenticated();
                    if (authenticated){
                        if (vm.account.forcedPasswordChangeOnNextLogin){
                            event.preventDefault();
                        }
                    }
                }
            });

        vm.changePassword = function() {

            vm.confirmationMatch = vm.password !== vm.confirmPassword;
            vm.error = null;

            if (!vm.confirmationMatch){
                return;
            }

            ForcedPasswordChange.changePassword(vm.passwordChange, onSuccess, onError);

            function onSuccess() {
                showDoneDialog();
            }

            function onError(result) {
                vm.error = result.data.error;
            }

        }

        function showDoneDialog(){
            $uibModal.open({
                templateUrl: 'app/account/forced-password-change/password-change-done-dialog.html',
                controller: 'PasswordChangeDoneController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md'
            }).result.then(function () {
                var Auth = $injector.get('Auth');
                Auth.logout();
                vm.account.forcedPasswordChangeOnNextLogin = false;
                $state.go('home', {reload: false})
            });
        }
    }

    angular.module('abcQualityMatchApp')
        .controller('PasswordChangeDoneController', PasswordChangeDoneController);

    PasswordChangeDoneController.$inject = ['$uibModalInstance'];

    function PasswordChangeDoneController($uibModalInstance) {
        var vm = this;
        vm.close = function() {
            $uibModalInstance.close(true);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('abcQualityMatchApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/admin-home.html','<div ng-cl><div class="row"><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"><div><verification-events></div></div><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"><div><informations></div><div><notable-documents-list-view></div></div></div></div>');
$templateCache.put('app/home/company-admin-home.html','<div ng-cl><div class="row"><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"><div><open-projects></div><div><tasks></div><div><verification-events></div></div><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"><div><anomalies></div><div><informations></div><div><notable-documents-list-view></div></div></div></div>');
$templateCache.put('app/home/company-supervisor-home.html','<div ng-cl><div class="row"><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"><div has-any-authority="PROJECT"><open-projects></div><div><tasks></div><div has-any-authority="VERIFICATION,VERIFICATION_BY_PRODUCT_LINE"><verification-events></div></div><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"><div><anomalies></div><div><informations></div><div><notable-documents-list-view></div></div></div></div>');
$templateCache.put('app/home/home.html','<div ng-cloak class="welcome"><div class="welcome-content"><div><span class="abc-logo abc img-responsive img-rounded"></span><div class="login-form"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></form></div></div><div class="message"><span data-translate="login.welcomeMessage">Welcome</span></div></div></div>');
$templateCache.put('app/home/user-home.html','<div ng-cl><div class="row"><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"><div has-any-authority="PROJECT"><open-projects></div><div><tasks></div><div has-any-authority="VERIFICATION,VERIFICATION_BY_PRODUCT_LINE"><verification-events></div></div><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"><div><anomalies></div><div><informations></div><div><notable-documents-list-view></div></div></div></div>');
$templateCache.put('app/information/information-dialog.html','<div class="questionnaire-answer questionnaire-form"><form name="editForm" novalidate><div><h2>{{vm.questionnaire.title}}</h2><div class="description-view">{{vm.questionnaire.description}}</div></div><div class="row information"><div class="form-group question-row" ng-if="vm.information.id != null && vm.information.anomalyQuestionnaireAnswer != null"><label class="control-label" data-translate="abcQualityMatchApp.information.sourceQuestionnaire">Title</label><p class="form-control">{{vm.information.anomalyQuestionnaireAnswer.questionnaire.title}}</p></div><div class="form-group question-row" ng-if="vm.information.id != null && vm.information.anomalyAnswer != null"><label class="control-label" data-translate="abcQualityMatchApp.information.sourceQuestion">Title</label><p class="form-control">{{vm.information.anomalyAnswer.question.title}}</p></div><div class="form-group question-row" ng-if="vm.information.id == null && vm.tempAnomalyQuestionnaireAnswer != null"><label class="control-label" data-translate="abcQualityMatchApp.information.sourceQuestionnaire">Title</label><p class="form-control">{{vm.tempAnomalyQuestionnaireAnswer.questionnaire.title}}</p></div><div class="form-group question-row" ng-if="vm.information.id == null && vm.tempAnomalyAnswer != null"><label class="control-label" data-translate="abcQualityMatchApp.information.sourceQuestion">Title</label><p class="form-control">{{vm.tempAnomalyAnswer.question.title}}</p></div><div class="form-group question-row"><label class="control-label required" data-translate="abcQualityMatchApp.information.title" for="field_title">Title</label><textarea class="form-control" name="title" id="field_title" ng-model="vm.information.ticket.title" rows="3" columns="40" required maxlength="255" ng-readonly="vm.disabled"></textarea><div><p class="help-block" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group question-row"><label class="control-label required" data-translate="abcQualityMatchApp.ticket.description" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" ng-model="vm.information.ticket.description" rows="6" columns="40" maxlength="6000" required ng-readonly="vm.disabled"></textarea><div><p class="help-block" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group question-row"><label data-translate="abcQualityMatchApp.information.submitUser" for="field_submitUser">Submit User</label><user-select id="field_submitUser" user="vm.information.submitUser" viewonly="vm.disabled"></user-select></div><div class="form-group question-row"><label class="control-label"><span data-translate="abcQualityMatchApp.ticket.materials"></span> <span data-translate="abcQualityMatchApp.ticket.materialsInputHint"></span></label><div><table class="table table-ticketmaterial"><tbody><tr ng-repeat="material in vm.ticketMaterials| orderBy: \'listIndex\'"><td><a ng-if="material.linkUrl" ng-href="{{material.linkUrl| ticketMaterialLinkUrlAddProtocoll}}" target="_blank" title="{{material.linkUrl}}" class="materialLink"><span class="glyphicon glyphicon-new-window"></span> {{material.linkUrl}} </a><a ng-if="!material.linkUrl" ng-href="/api/ticket-materials/download/{{material.id}}/{{material.name| ticketMaterialEncodeFilename}}?inline=true" target="_blank"><span class="glyphicon glyphicon-file"></span> {{material.name}}</a></td><td><a ng-if="!material.linkUrl" ng-href="/api/ticket-materials/download/{{material.id}}/{{material.name| ticketMaterialEncodeFilename}}?inline=false"><span class="glyphicon glyphicon-save"></span> <span data-translate="abcQualityMatchApp.ticket.materialDownLoadLink">download</span></a></td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteTicketMaterial(material)" ng-disabled="vm.disabled" data-translate="entity.action.delete">Delete</button></td></tr></tbody><tfoot><tr><td colspan="2"><div class="alert alert-info material-upload-alert" ng-show="vm.uploadingTicketMaterial"><div class="upload-spinner"></div><div><strong data-translate="abcQualityMatchApp.ticket.materialDownInProgressTitle">Uploading</strong><br><span data-translate="abcQualityMatchApp.ticket.materialDownInProgressMessage">Please wait</span></div></div><div class="alert alert-danger" ng-show="vm.selectedFileTooLarge"><span data-translate="abcQualityMatchApp.ticket.materialFileIsTooLargeMessage">File too large</span></div></td><td><div class="btn-group" uib-dropdown is-open="status.isopen"><button id="single-button" type="button" class="btn btn-primary" ng-disabled="vm.disabled" uib-dropdown-toggle><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="single-button"><li role="menuitem" ngf-select ngf-change="vm.setFileContent($file, $invalidFiles)" ngf-max-size="20MB"><span class="btn" data-translate="abcQualityMatchApp.ticket.addTicketMaterialFileButton">add file</span></li></ul></div></td></tr></tfoot></table></div></div><div class="form-group question-row"><label class="control-label" data-translate="abcQualityMatchApp.information.createTime">Create time</label><div class="input-group"><span ng-if="vm.information.createTime">{{vm.information.createTime | date:\'short\'}}</span> <span ng-if="!vm.information.createTime" data-translate="abcQualityMatchApp.information.createTimeNow"></span></div></div><div class="form-group question-row"><label class="control-label required" data-translate="abcQualityMatchApp.information.submitDate" for="field_submitDate">Submit Date</label><div class="input-group"><input id="field_submitDate" type="text" class="form-control" name="submitDate" datetime-picker="{{dateformat}}" ng-model="vm.information.submitDate" is-open="vm.datePickerOpenStatus.submitDate" timepicker-options="vm.picker.timepickerOptions" ng-disabled="vm.disabled" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-disabled="vm.disabled" ng-click="vm.openCalendar(\'submitDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.submitDate.$invalid"><p class="help-block" ng-show="editForm.submitDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.submitDate.$error.datetime" data-translate="entity.validation.datetimelocal">This field should be a date and time.</p></div></div><div class="form-group question-row"><label class="control-label required" data-translate="abcQualityMatchApp.ticket.state" for="field_state">State</label><select class="form-control" id="field_state" name="state" ng-model="vm.information.ticket.state" ng-options="ticketState as ticketState.name for ticketState in vm.ticketstates track by ticketState.id" ng-disabled="vm.disabled"></select><div><p class="help-block" data-translate="entity.validation.required">This field is required.</p></div></div><div class="secondary-section panel panel-default"><div class="panel-heading" ng-click="vm.toggleSecondaryVisible()"><span class="secondary-section-title" data-translate="abcQualityMatchApp.information.secondaryInformationSectionTitle"></span> <span class="glyphicon" ng-class="{\'glyphicon-chevron-right\':!vm.secondaryInformationVisible , \'glyphicon-chevron-down\':vm.secondaryInformationVisible}"></span></div><div class="panel-body" ng-show="vm.secondaryInformationVisible "><div class="form-group question-row"><label data-translate="abcQualityMatchApp.ticket.productLine" for="field_productLine">Product Line</label><select class="form-control" id="field_productLine" name="productLine" ng-disabled="vm.disabled" ng-model="vm.information.ticket.productLine" ng-options="productLine as productLine.name for productLine in vm.productlines track by productLine.id"><option value=""></option></select></div><div class="form-group question-row"><label class="control-label" for="field_place"><span data-translate="abcQualityMatchApp.ticket.place"></span> <span data-translate="abcQualityMatchApp.ticket.placeInputHint"></span></label><input type="text" class="form-control" name="place" id="field_place" ng-model="vm.information.ticket.place" maxlength="255" ng-disabled="vm.disabled"></div><hr><div class="form-group question-row"><label class="control-label" for="field_immediateActions"><span data-translate="abcQualityMatchApp.information.immediateActions"></span> <span data-translate="abcQualityMatchApp.information.immediateActionsInputHint"></span></label><input type="text" class="form-control" name="immediateActions" id="field_immediateActions" ng-model="vm.information.immediateActions" maxlength="600" ng-disabled="vm.disabled"></div><div class="form-group question-row"><label data-translate="abcQualityMatchApp.ticket.product" for="field_product">Product</label><product-select id="field_product" product="vm.information.ticket.product" viewonly="vm.disabled"></product-select></div><div class="form-group question-row"><label class="control-label" data-translate="abcQualityMatchApp.ticket.productBatch" for="field_productBatch">Product Batch</label><input type="text" class="form-control" name="productBatch" id="field_productBatch" ng-model="vm.information.ticket.productBatch" maxlength="255" ng-disabled="vm.disabled"></div><div class="form-group question-row"><label class="control-label" for="field_productActions"><span data-translate="abcQualityMatchApp.information.productActions"></span> <span data-translate="abcQualityMatchApp.information.productActionsInputHint"></span></label><input type="text" class="form-control" name="productActions" id="field_productActions" ng-model="vm.information.productActions" maxlength="600" ng-disabled="vm.disabled"></div><div class="form-group question-row"><label class="control-label" for="correctiveActions"><span data-translate="abcQualityMatchApp.information.correctiveActions"></span> <span data-translate="abcQualityMatchApp.information.correctiveActionsInputHint"></span></label><textarea class="form-control" name="correctiveActions" id="correctiveActions" ng-model="vm.information.correctiveActions" rows="3" columns="40" maxlength="600" ng-disabled="vm.disabled"></textarea></div><div class="form-group question-row"><label class="control-label" data-translate="abcQualityMatchApp.ticket.priority" for="field_priority">Priority</label><select name="priority" id="field_priority" class="form-control" ng-model="vm.information.ticket.priority" ng-options="option for option in [1, 2, 3, 4, 5] track by option" ng-disabled="vm.disabled"><option></option></select></div><div class="form-group question-row"><label data-translate="abcQualityMatchApp.ticket.assignedTo" for="field_assignedTo">Assigned To</label><user-select id="field_assignedTo" user="vm.information.ticket.assignedTo" viewonly="vm.disabled"></user-select></div><div class="form-group question-row"><label data-translate="abcQualityMatchApp.ticket.assignedToUserGroup" for="field_assignedToUserGroup">Assigned To User Group</label><select class="form-control" id="field_assignedToUserGroup" name="assignedToUserGroup" ng-model="vm.information.ticket.assignedToUserGroup" ng-options="userGroup as userGroup.name for userGroup in vm.usergroups track by userGroup.id" ng-disabled="vm.disabled"><option value=""></option></select></div><div class="form-group question-row"><label data-translate="abcQualityMatchApp.information.reasonCode" for="field_reasonCode">Reason Code</label><select class="form-control" id="field_reasonCode" name="reasonCode" ng-model="vm.information.reasonCode" ng-options="reasonCode as reasonCode | codeAndName for reasonCode in vm.reasoncodes track by reasonCode.id" ng-disabled="vm.disabled"><option value=""></option></select></div><div class="form-group question-row"><label class="control-label" data-translate="abcQualityMatchApp.information.standardSection" for="field_standardSection">Standard Section</label><input type="text" class="form-control" name="standardSection" id="field_standardSection" ng-model="vm.information.standardSection" maxlength="255" ng-disabled="vm.disabled"></div><div class="form-group question-row"><label data-translate="abcQualityMatchApp.information.issueSignificances">Assesment</label><div><ul class="issue-significance-list"><li ng-repeat="significance in vm.issueSignificances| orderBy: \'listIndex\'"><label><input type="checkbox" value="{{significance.name}}" ng-model="significance.selected" ng-disabled="vm.disabled"> {{significance.name}}</label></li><li class="assesment-done"><label><input type="checkbox" name="significanceAssesmentDone" ng-model="vm.information.significanceAssesmentDone" ng-disabled="vm.disabled"> {{\'abcQualityMatchApp.information.issueSignificancesAssesmentDone\'| translate }}</label></li></ul></div></div></div></div></div><div class="row" ng-if="vm.comparisonAnswer != null && vm.comparisonAnswer != undefined && vm.comparisonAnswer.answers != null && vm.comparisonAnswer.answers != undefined"><div class="half-column">&nbsp;</div><div class="half-column"><p><span data-translate="abcQualityMatchApp.ticket.comparison"></span>: {{vm.comparisonAnswer.answerTime| date: \'short\'}}</p></div><div class="clear-column"></div></div><div class="row"><questionnaire-answer questionnaire="vm.questionnaire" on-answer-change="vm.onAnswerChange()" edit-form="editForm" contains-unanswered-questions="vm.containsUnansweredQuestions" viewonly="vm.disabled"></div><br ng-if="vm.containsUnansweredQuestions"><div ng-if="vm.containsUnansweredQuestions" class="alert alert-warning"><span data-translate="abcQualityMatchApp.information.containsUnansweredQuestions"></span></div><br><br><div class="row"><div class="pull-right"><button ng-click="vm.saveAnswers()" class="btn btn-primary" ng-disabled="vm.uploadingTicketMaterial || editForm.$invalid || vm.containsUnansweredQuestions || vm.disabled"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">save</span></button> <button type="button" class="btn btn-default" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">cancel</span></button></div></div></form></div>');
$templateCache.put('app/information/information.html','<div class="information" xmlns="http://www.w3.org/1999/html"><h2 data-translate="abcQualityMatchApp.information.home.title">Information</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><div class="alert alert-info information-importsheet-upload-alert" ng-show="vm.uploadingImportSheet"><div class="upload-spinner"></div><div><strong data-translate="abcQualityMatchApp.information.sheetDownloadInProgressTitle">Donwloading</strong><br><span data-translate="abcQualityMatchApp.information.sheetDownloadInProgressMessage">Please wait</span></div></div><div class="alert alert-danger" ng-show="vm.importError"><strong data-translate="abcQualityMatchApp.information.importSheetError.title"></strong><br><span ng-show="vm.importError.invalidFile" data-translate="abcQualityMatchApp.information.importSheetError.invalidFile">err.invalidFile</span> <span ng-show="vm.importError.missingRequiredFields" data-translate="abcQualityMatchApp.information.importSheetError.missingRequiredFields" translate-values="{missingRequiredFields: \'{{vm.importError.missingRequiredFields}}\'}">err.missingRequiredFields</span> <span ng-show="vm.importError.invalidField" data-translate="abcQualityMatchApp.information.importSheetError.invalidField" translate-values="{invalidField: \'{{vm.importError.invalidField}}\'}">err.invalidField</span> <span ng-show="vm.importError.invalidStringFieldLength" data-translate="abcQualityMatchApp.information.importSheetError.invalidStringFieldLength" translate-values="{invalidField: \'{{vm.importError.invalidField}}\', valueLength: \'{{vm.importError.valueLength}}\', maxLength: \'{{vm.importError.maxLength}}\' }">err.invalidStringFieldLength</span></div><div><div class="btn-group" uib-dropdown style="display: inline-block; margin-right:1em"><button id="downloadImportSheetButton" class="btn btn-default" uib-dropdown-toggle><span class="glyphicon glyphicon-save"></span> <span data-translate="abcQualityMatchApp.information.downloadImportSheet">import from sheet</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="downloadImportSheetButton"><li role="menuitem" ng-repeat="questionnaire in vm.informationQuestionnaires track by questionnaire.id"><a ng-href="/api/information/information-import-sheet/download/{{questionnaire.id}}?cacheBuster={{vm.cacheBuster}}"><span class="glyphicon glyphicon-save-file"></span> {{questionnaire.title}}</a></li></ul></div><button type="button" class="btn btn-default" ngf-select ngf-change="vm.uploadImportSheet($file)"><span class="glyphicon glyphicon-cloud-upload"></span> <span data-translate="abcQualityMatchApp.information.uploadImportSheet">add</span></button></div></div></div></div><br><form ng-submit="vm.refreshSearch()" class="listing-filters"><legend data-translate="abcQualityMatchApp.information.findByRestrictionsLegend"></legend><fieldset class="informationTypesFilter"><legend data-translate="abcQualityMatchApp.informationEvent.findByTypes"></legend><div><table><tbody><tr ng-repeat="type in vm.filterByQuestionnaireTypes"><td data-translate="{{\'abcQualityMatchApp.QuestionnaireType.\' + type}}">{{type}}</td><td><span class="glyphicon glyphicon-remove" ng-click="vm.removeFilterQuestionnaireType(type)" title="{{\'entity.action.delete\' | translate}}"></span></td></tr><tr ng-if="!(vm.filterByQuestionnaireTypes.length > 0)"><td colspan="2" data-translate="abcQualityMatchApp.informationEvent.findByTypesAll"></td></tr></tbody><tfoot><tr><td colspan="2"><select class="form-control" id="field_findByTypes" name="filteringByType" ng-model="vm.addToFilterByQuestionnaireTypes" ng-change="vm.refreshSearch()"><option disabled="disabled" value="" data-translate="abcQualityMatchApp.informationEvent.findByTypesAdd">add</option><option value="ALL" data-translate="abcQualityMatchApp.informationEvent.findByTypesAll">all</option><option ng-repeat="type in vm.informationQuestionnairesTypes" value="{{type}}" data-translate="{{\'abcQualityMatchApp.QuestionnaireType.\' + type}}">{{type}}</option></select></td></tr></tfoot></table></div></fieldset><fieldset><legend data-translate="abcQualityMatchApp.information.findByDateLimits"></legend><div class="timespan-limit"><div class="input-group date-select-container"><input id="field_fromDate" type="text" class="form-control" name="fromDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.filteringFromDate" is-open="vm.datePickerOpenStatus.fromDate" ng-change="vm.refreshSearch()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div>-<div class="input-group date-select-container"><input id="field_toDate" type="text" class="form-control" name="toDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.filteringToDate" is-open="vm.datePickerOpenStatus.toDate" ng-change="vm.refreshSearch()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></fieldset><fieldset><legend data-translate="abcQualityMatchApp.information.findByTextLegend"></legend><div class="searchField"><input class="form-control" type="text" ng-model="vm.filteringSearchTerm" id="seachTerm" placeholder="{{\'abcQualityMatchApp.information.findByText\'|translate }}"> <button type="submit" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-search"></span></button></div></fieldset><fieldset><legend data-translate="abcQualityMatchApp.information.findByProduct"></legend><div class="form-container"><product-select id="productFilter" productid="vm.filteringProductId" product="vm.filteringProduct" on-select="vm.productSelected()"></product-select></div></fieldset><fieldset><legend data-translate="abcQualityMatchApp.informationEvent.state"></legend><div class="select-container"><select class="form-control" id="ticketStateFilter" name="filteringTicketStateTypeId" ng-model="vm.filteringTicketStateTypeId" ng-change="vm.refreshSearch()"><option value="" class="placeholder" data-translate="abcQualityMatchApp.informationEvent.state">status</option><option ng-repeat="status in vm.statusCodes" value="{{status.id}}">{{status.name}}</option></select></div></fieldset><fieldset><legend data-translate="abcQualityMatchApp.information.findByProductLine"></legend><div class="select-container"><select class="form-control" id="productLineFilter" name="filteringProductLine" ng-model="vm.filteringProductLineId" ng-change="vm.refreshSearch()"><option value="" class="placeholder" data-translate="abcQualityMatchApp.information.findByProductLine">productline</option><option ng-repeat="productLine in vm.productLines" value="{{productLine.id}}">{{productLine.name}}</option></select></div></fieldset><fieldset><legend data-translate="abcQualityMatchApp.information.findByProductionUnit"></legend><div class="select-container"><select class="form-control" id="filteringProductionUnit" name="filteringProductionUnit" ng-model="vm.filteringProductionUnitId" ng-change="vm.refreshSearch()"><option value="" class="placeholder" data-translate="abcQualityMatchApp.information.findByProductionUnit">ProductionUnit</option><option ng-repeat="productLine in vm.productLines" value="{{productLine.productionUnit.id}}">{{productLine.productionUnit.name}}</option></select></div></fieldset><fieldset><legend data-translate="abcQualityMatchApp.information.findByReasonCode"></legend><div class="select-container"><select class="form-control" id="reasonCodeFilter" name="filteringReasonCode" ng-model="vm.filteringReasonCodeId" ng-change="vm.refreshSearch()"><option value="" class="placeholder" data-translate="abcQualityMatchApp.information.findByReasonCode">reasoncode</option><option ng-repeat="reasoncode in vm.reasonCodes" value="{{reasoncode.id}}">{{reasoncode.code}}</option></select></div></fieldset></form><div><div uib-dropdown><button ng-disabled="vm.savingPreferences" id="showHideColumnMenuButton" class="btn btn-default btn-sm" uib-dropdown-toggle><span class="glyphicon glyphicon-option-vertical"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="showHideColumnMenuButton"><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'submitDate\')" ng-click="vm.toggleVisibleColumn(\'submitDate\')"> <span data-translate="abcQualityMatchApp.information.submitDate">submitDate</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'ticketTitle\')" ng-click="vm.toggleVisibleColumn(\'ticketTitle\')"> <span data-translate="abcQualityMatchApp.informationEvent.name">tickettitle</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'productName\')" ng-click="vm.toggleVisibleColumn(\'productName\')"> <span data-translate="abcQualityMatchApp.informationEvent.productName">productName</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'questionnaireTitle\')" ng-click="vm.toggleVisibleColumn(\'questionnaireTitle\')"> <span data-translate="abcQualityMatchApp.informationEvent.questionnaireTitle">questionnaireTitle</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'productLineName\')" ng-click="vm.toggleVisibleColumn(\'productLineName\')"> <span data-translate="abcQualityMatchApp.informationEvent.productLineName">productLineName</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'productionUnitName\')" ng-click="vm.toggleVisibleColumn(\'productionUnitName\')"> <span data-translate="abcQualityMatchApp.informationEvent.productionUnitName">productLineName</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'questionnaireType\')" ng-click="vm.toggleVisibleColumn(\'questionnaireType\')"> <span data-translate="abcQualityMatchApp.informationEvent.type">questionnaireType</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'anomalySourceQuestionnaireTitle\')" ng-click="vm.toggleVisibleColumn(\'anomalySourceQuestionnaireTitle\')"> <span data-translate="abcQualityMatchApp.informationEvent.anomalySourceQuestionnaireTitle">anomaly_source_questionnaire_title</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'reasonCodeCode\')" ng-click="vm.toggleVisibleColumn(\'reasonCodeCode\')"> <span data-translate="abcQualityMatchApp.informationEvent.reasonCodeCode">reasonCodeCode</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'reasonCodeName\')" ng-click="vm.toggleVisibleColumn(\'reasonCodeName\')"> <span data-translate="abcQualityMatchApp.informationEvent.reasonCodeName">reasonCodeName</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'ticketPriority\')" ng-click="vm.toggleVisibleColumn(\'ticketPriority\')"> <span data-translate="abcQualityMatchApp.informationEvent.ticketPriority">ticketPriority</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'state\')" ng-click="vm.toggleVisibleColumn(\'state\')"> <span data-translate="abcQualityMatchApp.informationEvent.state">state</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'creator\')" ng-click="vm.toggleVisibleColumn(\'creator\')"> <span data-translate="abcQualityMatchApp.informationEvent.creator">creator</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'assignedTo\')" ng-click="vm.toggleVisibleColumn(\'assignedTo\')"> <span data-translate="abcQualityMatchApp.informationEvent.assignedTo">assignedTo</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'assignedToUserGroup\')" ng-click="vm.toggleVisibleColumn(\'assignedToUserGroup\')"> <span data-translate="abcQualityMatchApp.informationEvent.assignedToUserGroup">assignedToUserGroup</span></label></a></li><li role="menuitem"><a href="javascript:void(0)"><label><input type="checkbox" ng-checked="!vm.isHiddenColumn(\'analysisStatus\')" ng-click="vm.toggleVisibleColumn(\'analysisStatus\')"> <span data-translate="abcQualityMatchApp.information.analysisStatus">analysisStatus</span></label></a></li></ul></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th></th><th jh-sort-by="(submit_date)" ng-hide="vm.isHiddenColumn(\'submitDate\')"><span data-translate="abcQualityMatchApp.information.submitDate">time</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tic.title" ng-hide="vm.isHiddenColumn(\'ticketTitle\')"><span data-translate="abcQualityMatchApp.informationEvent.name">Ticket</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(product_name)" ng-hide="vm.isHiddenColumn(\'productName\')"><span data-translate="abcQualityMatchApp.informationEvent.productName">product_name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(questionnaire_title)" ng-hide="vm.isHiddenColumn(\'questionnaireTitle\')"><span data-translate="abcQualityMatchApp.informationEvent.questionnaireTitle">questionnaire_title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(product_line_name)" ng-hide="vm.isHiddenColumn(\'productLineName\')"><span data-translate="abcQualityMatchApp.informationEvent.productLineName">product_line_name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(production_unit_name)" ng-hide="vm.isHiddenColumn(\'productionUnitName\')"><span data-translate="abcQualityMatchApp.informationEvent.productionUnitName">productionUnitName</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="que.questionnaire_type" ng-hide="vm.isHiddenColumn(\'questionnaireType\')"><span data-translate="abcQualityMatchApp.informationEvent.type">questionnaire_type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(anomaly_source_questionnaire_title)" ng-hide="vm.isHiddenColumn(\'anomalySourceQuestionnaireTitle\')"><span data-translate="abcQualityMatchApp.informationEvent.anomalySourceQuestionnaireTitle">anomaly_source_questionnaire_title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(reason_code_code)" ng-hide="vm.isHiddenColumn(\'reasonCodeCode\')"><span data-translate="abcQualityMatchApp.informationEvent.reasonCodeCode">reason_code_code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(reason_code_name)" ng-hide="vm.isHiddenColumn(\'reasonCodeName\')"><span data-translate="abcQualityMatchApp.informationEvent.reasonCodeName">reason_code_name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(ticket_priority)" ng-hide="vm.isHiddenColumn(\'ticketPriority\')"><span data-translate="abcQualityMatchApp.informationEvent.ticketPriority">ticket_priority</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tics.name" ng-hide="vm.isHiddenColumn(\'state\')"><span data-translate="abcQualityMatchApp.informationEvent.state">state</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(modifier)" ng-hide="vm.isHiddenColumn(\'creator\')"><span data-translate="abcQualityMatchApp.informationEvent.creator">creator</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(assigned_to)" ng-hide="vm.isHiddenColumn(\'assignedTo\')"><span data-translate="abcQualityMatchApp.informationEvent.assignedTo">assignedTo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(assigned_to_user_group)" ng-hide="vm.isHiddenColumn(\'assignedToUserGroup\')"><span data-translate="abcQualityMatchApp.informationEvent.assignedToUserGroup">assigned_to_user_group</span> <span class="glyphicon glyphicon-sort"></span></th><th ng-hide="vm.isHiddenColumn(\'analysisStatus\')"><span data-translate="abcQualityMatchApp.information.analysisStatus">analysis</span></th><th></th></tr></thead><tbody><tr ng-repeat="information in vm.information track by information.id"><td><input type="checkbox" ng-model="information.selectionChecked"></td><td ng-hide="vm.isHiddenColumn(\'submitDate\')">{{information.submitDate | date:\'short\'}}</td><td ng-hide="vm.isHiddenColumn(\'ticketTitle\')">{{information.title}}</td><td ng-hide="vm.isHiddenColumn(\'productName\')">{{information.productName}}</td><td ng-hide="vm.isHiddenColumn(\'questionnaireTitle\')">{{information.questionnaireTitle}}</td><td ng-hide="vm.isHiddenColumn(\'productLineName\')">{{information.productLineName}}</td><td ng-hide="vm.isHiddenColumn(\'productionUnitName\')">{{information.productionUnitName}}</td><td ng-hide="vm.isHiddenColumn(\'questionnaireType\')" data-translate="{{\'abcQualityMatchApp.QuestionnaireType.\' + information.questionnaireType}}">{{information.questionnaireType}}</td><td ng-hide="vm.isHiddenColumn(\'anomalySourceQuestionnaireTitle\')">{{information.anomalySourceQuestionnaireTitle}}</td><td ng-hide="vm.isHiddenColumn(\'reasonCodeCode\')">{{information.reasonCodeCode}}</td><td ng-hide="vm.isHiddenColumn(\'reasonCodeName\')">{{information.reasonCodeName}}</td><td ng-hide="vm.isHiddenColumn(\'ticketPriority\')">{{information.ticketPriority}}</td><td ng-hide="vm.isHiddenColumn(\'state\')">{{information.state}}</td><td ng-hide="vm.isHiddenColumn(\'creator\')">{{information.modifier}}</td><td ng-hide="vm.isHiddenColumn(\'assignedTo\')">{{information.assignedTo}}</td><td ng-hide="vm.isHiddenColumn(\'assignedToUserGroup\')">{{information.assignedToUserGroup}}</td><td ng-hide="vm.isHiddenColumn(\'analysisStatus\')"><ul class="analysis-list"><li ng-show="information.significanceAssesmentDone"><span data-translate="abcQualityMatchApp.information.issueSignificancesAssesmentResult" translate-values="{count: \'{{information.issueSignificances.length}}\'}"></span></li><li ng-repeat="rca in information.rootCauseAnalyses | orderBy: \'created\' track by rca.id"><a ui-sref="root-cause-analysis-detail({id:rca.id})" target="_blank">{{\'abcQualityMatchApp.information.rootCauseAnalysisLink\'| translate}} {{rca.created|date:shortDate}}</a></li></ul></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-if="information.currentUserEditAllowed" class="btn btn-sm btn-primary" ui-sref="editInformation({id: information.id, returnToView: \'information\'})"><span class="glyphicon glyphicon-pencil"></span> <span data-translate="entity.action.edit">Edit</span></button> <button ng-if="!information.currentUserEditAllowed" class="btn btn-sm btn-info" ui-sref="editInformation({id: information.id, returnToView: \'information\'})"><span class="glyphicon glyphicon-eye-open"></span> <span data-translate="entity.action.view">View</span></button> <button class="btn btn-sm btn-primary" ui-sref="information.project-new({id: information.id})" has-any-authority="ROLE_COMPANY_ADMIN,PROJECT"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.information.createProject">Create project</span></button></div></td></tr></tbody><tfoot><tr><td colspan="15"><button class="btn btn-sm btn-default" ng-click="vm.createRootCauseAnalysisForSelected()" has-any-authority="ROLE_COMPANY_ADMIN,ROOT_CAUSE_ANALYSIS"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.information.createRootCauseAnalysisForSelected">do root cause analysis</span></button></td></tr><tr><td colspan="3"><a download ng-href="api/information/export-spreadsheet{{vm.informationExportParameters | toQueryString }}"><span class="glyphicon glyphicon-download-alt"></span> <span data-translate="abcQualityMatchApp.information.downloadLink"></span></a></td></tr></tfoot></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/questionnaire-edit/questionnaire-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.questionnaire.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.questionnaire.delete.question" translate-values="{id: \'{{vm.questionnaire.title}}\'}">Are you sure you want to delete this Questionnaire?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/questionnaire-edit/questionnaire-edit-dialog.html','<div ng-cloak class="questionnaire"><form name="editForm" role="form" novalidate show-validation><div class="row"><h2 data-translate="questionnaireEdit.general">General information</h2><div ng-if="vm.copyMode" class="alert alert-warning"><span data-translate="abcQualityMatchApp.questionnaire.copyAlert" data-translate-values="{questionnaireTitle: \'{{vm.copyingFromQUestionnaireTitle}}\'}"></span></div><div class="col-md-12 questionnaire"><div class="form-group"><label class="control-label required" data-translate="questionnaireEdit.questionnaire_title" for="field_title">Questionnaire title</label><input type="text" class="form-control" name="name" id="field_title" ng-model="vm.questionnaire.title"></div><div class="form-group"><label class="control-label" data-translate="questionnaireEdit.questionnaire_desc" for="field_desc">Description</label><textarea class="form-control" id="field_desc" rows="5" cols="50" ng-model="vm.questionnaire.description" name="description"></textarea></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.questionnaire.questionnaireType" for="field_questionnaireType">Questionnaire Type</label><select class="form-control" name="questionnaireType" ng-model="vm.questionnaire.questionnaireType" id="field_questionnaireType" ng-change="vm.selectQuestionnaireType()" required><option value="NORMAL" data-translate="abcQualityMatchApp.QuestionnaireType.selectDescriptions.NORMAL">NORMAL</option><option value="ANOMALY" data-translate="abcQualityMatchApp.QuestionnaireType.selectDescriptions.ANOMALY">ANOMALY</option><option value="CLOSE_CALL" data-translate="abcQualityMatchApp.QuestionnaireType.selectDescriptions.CLOSE_CALL">CLOSE_CALL</option><option value="DANGER" data-translate="abcQualityMatchApp.QuestionnaireType.selectDescriptions.DANGER">DANGER</option><option value="INJURY_NOTIFICATION" data-translate="abcQualityMatchApp.QuestionnaireType.selectDescriptions.INJURY_NOTIFICATION">INJURY_NOTIFICATION</option><option value="PROPOSITION" data-translate="abcQualityMatchApp.QuestionnaireType.selectDescriptions.PROPOSITION">PROPOSITION</option><option value="CHANGE_NOTIFICATION" data-translate="abcQualityMatchApp.QuestionnaireType.selectDescriptions.CHANGE_NOTIFICATION">CHANGE_NOTIFICATION</option><option value="BULLETIN_NOTIFICATION" data-translate="abcQualityMatchApp.QuestionnaireType.selectDescriptions.BULLETIN_NOTIFICATION">BULLETIN_NOTIFICATION</option><option value="RECLAMATION_NOTIFICATION" data-translate="abcQualityMatchApp.QuestionnaireType.selectDescriptions.RECLAMATION_NOTIFICATION">RECLAMATION_NOTIFICATION</option><option value="INITIATIVE_NOTIFICATION" data-translate="abcQualityMatchApp.QuestionnaireType.selectDescriptions.INITIATIVE_NOTIFICATION">INITIATIVE_NOTIFICATION</option></select><div ng-show="editForm.questionnaireType.$invalid"><p class="help-block" ng-show="editForm.questionnaireType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group anomaly-type-select" ng-show="vm.questionnaire.questionnaireType == \'ANOMALY\'"><label class="control-label required" data-translate="abcQualityMatchApp.questionnaire.anomalyType" for="field_anomalyType">Anomaly Type</label><select class="form-control" name="anomalyType" ng-model="vm.questionnaire.anomalyType" id="field_anomalyType" ng-required="vm.questionnaire.questionnaireType == \'ANOMALY\' "><option value="QUALITY" data-translate="abcQualityMatchApp.AnomalyType.QUALITY">QUALITY</option><option value="ENVIRONMENT" data-translate="abcQualityMatchApp.AnomalyType.ENVIRONMENT">ENVIRONMENT</option><option value="FOOD_SAFETY" data-translate="abcQualityMatchApp.AnomalyType.FOOD_SAFETY">FOOD_SAFETY</option><option value="WORK_SAFETY" data-translate="abcQualityMatchApp.AnomalyType.WORK_SAFETY">WORK_SAFETY</option></select><div ng-show="editForm.anomalyType.$invalid"><p class="help-block" ng-show="editForm.anomalyType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></div></form></div><hr><div class="row"><h2 data-translate="questionnaireEdit.sections">Sections</h2><div class="section-wrapper col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-repeat="section in vm.questionnaire.sections | orderBy: \'listIndex\'"><div class="section-header"><span>{{$index + 1}}.</span> <input type="text" class="form-control" name="section{{$index}}" ng-model="section.title" placeholder="{{\'abcQualityMatchApp.questionnaire.sectionTitlePlaceholder\' | translate}}"> <span class="move-up-down-buttons"><button ng-disabled="$first" type="button" class="btn btn-primary btn-sm" ng-click="vm.moveSection($index, \'up\')" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></button> <button ng-disabled="$last" type="button" class="btn btn-primary btn-sm" ng-click="vm.moveSection($index, \'down\')" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></button> </span><button confirmed-delete="vm.deleteSection($index)" confirmed-delete-message="abcQualityMatchApp.questionnaire.deleteSectionConfirmation" class="btn btn-danger btn-sm" type="button"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div><div class="col-xs-11 col-xs-offset-1 col-sm-11 col-sm-offset-1 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1"><div class="pull-right" style="padding-bottom: 10px"><div class="btn-group" uib-dropdown><button id="newQuestionButton" class="btn btn-primary btn-sm" uib-dropdown-toggle type="button"><span class="glyphicon glyphicon-plus"></span> <span data-translate="questionnaireEdit.newQuestion"></span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="newQuestionButton"><li role="menuitem" ng-repeat="type in vm.questionTypes"><a ng-click="vm.addQuestion(section, type)" data-translate="{{ \'question.questionTypes.\'+type }}"></a></li></ul></div></div><table class="table table-striped"><thead><tr><th data-translate="question.title">Title</th><th data-translate="question.questionType">Question type</th><th colspan="2">&nbsp;</th></tr></thead><tbody><tr ng-repeat="question in section.questions | orderBy: \'listIndex\' "><td>{{question.title}}</td><td>{{ \'question.questionTypes.\' + question.questionType | translate }}</td><td><button ng-disabled="$first" type="button" class="btn btn-primary btn-sm" ng-click="vm.moveQuestion(section, $index, \'up\')" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></button> <button ng-disabled="$last" type="button" class="btn btn-primary btn-sm" ng-click="vm.moveQuestion(section, $index, \'down\')" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></button></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.editQuestion(section, $index)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button class="btn btn-danger btn-sm" type="button" confirmed-delete="vm.deleteQuestion(section, $index)" confirmed-delete-message="abcQualityMatchApp.questionnaire.deleteQuestionConfirmation"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table><div class="pull-right" style="padding-bottom: 10px"><div class="btn-group" uib-dropdown><button id="newQuestionButtonBottom" class="btn btn-primary btn-sm" uib-dropdown-toggle type="button"><span class="glyphicon glyphicon-plus"></span> <span data-translate="questionnaireEdit.newQuestion"></span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="newQuestionButtonBottom"><li role="menuitem" ng-repeat="type in vm.questionTypes"><a ng-click="vm.addQuestion(section, type)" data-translate="{{ \'question.questionTypes.\'+type }}"></a></li></ul></div></div></div></div></div><div class="row"><div class="col-12"><button ng-click="vm.addSection()" class="btn btn-primary btn-sm" type="button"><span class="glyphicon glyphicon-plus"></span> <span class="" data-translate="questionnaireEdit.newSection"></span></button></div></div><div class="row"><div class="col-12"><div class="pull-right"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" ng-click="vm.save()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></div><div class="row"><div class="col-12"><div ng-if="vm.copyMode" class="alert alert-warning"><span data-translate="abcQualityMatchApp.questionnaire.copyAlert" data-translate-values="{questionnaireTitle: \'{{vm.copyingFromQUestionnaireTitle}}\'}"></span></div></div></div>');
$templateCache.put('app/questionnaire-edit/questionnaires-admin-list.html','<div><h2 data-translate="abcQualityMatchApp.questionnaire.home.templateQuestionnaires">admin Questionnaires</h2><jhi-alert></jhi-alert><br><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="questionnaire-admin.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.questionnaire.home.createLabel">Create new Questionnaire</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="title"><span data-translate="abcQualityMatchApp.questionnaire.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="questionnaireType"><span data-translate="abcQualityMatchApp.questionnaire.questionnaireType">Questionnaire Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="anomalyType"><span data-translate="abcQualityMatchApp.questionnaire.anomalyType">Anomaly Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="questionnaire in vm.questionnaires track by questionnaire.id"><td>{{questionnaire.title}}</td><td data-translate="{{\'abcQualityMatchApp.QuestionnaireType.\' + questionnaire.questionnaireType}}">{{questionnaire.questionnaireType}}</td><td data-translate="{{\'abcQualityMatchApp.AnomalyType.\' + questionnaire.anomalyType}}">{{questionnaire.anomalyType}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="questionnaire-admin.edit({id:questionnaire.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="questionnaire-admin.delete({id:questionnaire.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button> <button type="submit" ui-sref="questionnaire-admin.copy({id:questionnaire.id})" class="btn btn-warning btn-sm"><span class="glyphicon glyphicon-duplicate"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.copy"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/questionnaire-edit/questionnaires-company-list.html','<div class="questionnaire"><h2 data-translate="abcQualityMatchApp.questionnaire.home.title">Questionnaires</h2><jhi-alert></jhi-alert><br><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary new-from-tempate-button" ui-sref="questionnaire-company.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.questionnaire.home.createLabel">Create new Questionnaire</span></button><div class="btn-group" uib-dropdown><button id="copyButton" class="btn btn-primary" uib-dropdown-toggle><span class="glyphicon glyphicon-copy"></span> <span data-translate="abcQualityMatchApp.questionnaire.importTemplateQuestionnaire">Create new Questionnaire from template </span><span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="{{\'copyButton\' + anomaly.row}}"><li role="menuitem" ng-repeat="copyQuestionnaire in vm.templateQuestionnaires"><a ng-click="copy(copyQuestionnaire.id)">{{copyQuestionnaire.title}}</a></li></ul></div></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="title"><span data-translate="abcQualityMatchApp.questionnaire.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="questionnaireType"><span data-translate="abcQualityMatchApp.questionnaire.questionnaireType">Questionnaire Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="anomalyType"><span data-translate="abcQualityMatchApp.questionnaire.anomalyType">Anomaly Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="questionnaire in vm.questionnaires track by questionnaire.id"><td>{{questionnaire.title}}</td><td data-translate="{{\'abcQualityMatchApp.QuestionnaireType.\' + questionnaire.questionnaireType}}">{{questionnaire.questionnaireType}}</td><td data-translate="{{\'abcQualityMatchApp.AnomalyType.\' + questionnaire.anomalyType}}">{{questionnaire.anomalyType}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="questionnaire-company.edit({id:questionnaire.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="questionnaire-company.delete({id:questionnaire.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button> <button type="submit" ui-sref="questionnaire-company.copy({id:questionnaire.id})" class="btn btn-warning btn-sm"><span class="glyphicon glyphicon-duplicate"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.copy"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/report/report.html','<div ng-cl><div class="row"><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"><div><stats></div></div></div></div>');
$templateCache.put('app/task/task-activate.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="activateTaskLabel" data-translate="abcQualityMatchApp.task.activateTaskTitle">Activate task</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.ticket.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.task.title" maxlength="255" ng-readonly="true"></div><div class="form-group"><label data-translate="abcQualityMatchApp.task.questionnaire" for="field_questionnaire">Questionnaire</label><input type="text" class="form-control" name="title" id="field_questionnaire" ng-model="vm.task.questionnaire.title" maxlength="255" ng-readonly="true"></div><div ng-show="editForm.state.$invalid"><p class="help-block" ng-show="editForm.state.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.task.start" for="field_start">Start</label><div class="input-group"><input id="field_start" type="text" class="form-control" name="start" datetime-picker="{{dateformat}}" ng-model="vm.task.start" is-open="vm.datePickerOpenStatus.start" timepicker-options="vm.picker.timepickerOptions" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'start\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.start.$invalid"><p class="help-block" ng-show="editForm.start.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.start.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.task.end" for="field_end">End</label><div class="input-group"><input id="field_end" type="text" class="form-control" name="end" datetime-picker="{{dateformat}}" ng-model="vm.task.end" is-open="vm.datePickerOpenStatus.end" timepicker-options="vm.picker.timepickerOptions" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'end\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.end.$invalid"><p class="help-block" ng-show="editForm.end.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.end.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.activate">Save</span></button></div></form>');
$templateCache.put('app/task/task-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.task.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.task.delete.question" translate-values="{id: \'{{vm.task.id}}\'}">Are you sure you want to delete this Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/task/task-detail.html','<div><h2><span data-translate="abcQualityMatchApp.task.detail.title">Task</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details" ng-switch="vm.task.freq != undefined"><dt><span data-translate="abcQualityMatchApp.ticket.title">Title</span></dt><dd><span class="long-text">{{vm.task.title}}</span></dd><dt><span data-translate="abcQualityMatchApp.ticket.description">Description</span></dt><dd><span class="long-text">{{vm.task.description}}</span></dd><dt><span data-translate="abcQualityMatchApp.ticket.materials">Material</span></dt><dd><div><ticket-material task="vm.task"></ticket-material></div></dd><dt><span data-translate="abcQualityMatchApp.task.start">Start</span></dt><dd><span ng-if="vm.task.allDay">{{vm.task.start | date:\'shortDate\'}}</span> <span ng-if="!vm.task.allDay">{{vm.task.start | date:\'short\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.task.end">End</span></dt><dd><span ng-if="vm.task.allDay">{{vm.task.end | date:\'shortDate\'}}</span> <span ng-if="!vm.task.allDay">{{vm.task.end | date:\'short\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.ticket.doneTime">doneTime</span></dt><dd><span>{{vm.task.doneTime | date:\'short\'}}</span></dd><dt ng-switch-when="true"><span data-translate="abcQualityMatchApp.recurrence.freq">Frequence</span></dt><dd ng-switch-when="true"><span data-translate="{{\'abcQualityMatchApp.Frequence.\' + vm.task.freq}}">{{vm.task.freq}}</span></dd><dt ng-switch-when="true"><span data-translate="abcQualityMatchApp.recurrence.recurInterval">Interval</span></dt><dd ng-switch-when="true"><span>{{vm.task.interval}}</span></dd><dt ng-switch-when="true"><span data-translate="abcQualityMatchApp.recurrence.recurCount">Count</span></dt><dd ng-switch-when="true"><span>{{vm.task.count}}</span></dd><dt ng-switch-when="true"><span data-translate="abcQualityMatchApp.recurrence.until">Until</span></dt><dd ng-switch-when="true"><span>{{vm.task.until | date:\'short\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="task-detail.edit({id:vm.task.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/task/task-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTaskLabel" data-translate="abcQualityMatchApp.task.home.createOrEditLabel">Create or edit a Task</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.ticket.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.task.title" maxlength="255" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.ticket.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.task.description" maxlength="600"></div><div class="form-group" has-any-authority="ROLE_COMPANY_ADMIN,TASKS_ALL,TASKS_BY_PRODUCT_LINE,PROJECT"><label data-translate="abcQualityMatchApp.ticket.assignedTo" for="field_assignedTo">Assigned To</label><user-select id="field_assignedTo" user="vm.task.assignedTo"></user-select></div><div class="form-group" has-any-authority="ROLE_COMPANY_ADMIN,TASKS_ALL,TASKS_BY_PRODUCT_LINE,PROJECT"><label data-translate="abcQualityMatchApp.ticket.assignedToUserGroup" for="field_assignedToUserGroup">Assigned To User Group</label><select class="form-control" id="field_assignedToUserGroup" name="assignedToUserGroup" ng-model="vm.task.assignedToUserGroup" ng-options="userGroup as userGroup.name for userGroup in vm.usergroups track by userGroup.id"><option value=""></option></select></div><div class="form-group" has-any-authority="ROLE_COMPANY_ADMIN,TASKS_ALL,TASKS_BY_PRODUCT_LINE,PROJECT"><label data-translate="abcQualityMatchApp.ticket.productLine" for="field_productLine">Product Line</label><select class="form-control" id="field_productLine" name="productLine" ng-model="vm.task.productLine" ng-options="productLine as productLine.name for productLine in vm.productLines track by productLine.id"><option value=""></option></select></div><div class="form-group"><label data-translate="abcQualityMatchApp.task.questionnaire" for="field_questionnaire">Questionnaire</label><select class="form-control" id="field_questionnaire" name="questionnaire" ng-model="vm.task.questionnaire" ng-options="questionnaire as questionnaire.title for questionnaire in vm.questionnaires track by questionnaire.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.ticket.materials">Materials</label><div><table class="table table-ticketmaterial"><tbody><tr ng-repeat="material in vm.ticketMaterials| orderBy: \'listIndex\'"><td><a ng-if="material.linkUrl" ng-href="{{material.linkUrl| ticketMaterialLinkUrlAddProtocoll}}" target="_blank" title="{{material.linkUrl}}" class="materialLink"><span class="glyphicon glyphicon-new-window"></span> {{material.linkUrl}} </a><a ng-if="!material.linkUrl" ng-href="/api/ticket-materials/download/{{material.id}}/{{material.name| ticketMaterialEncodeFilename}}?inline=true" target="_blank"><span class="glyphicon glyphicon-file"></span> {{material.name}}</a></td><td><a ng-if="!material.linkUrl" ng-href="/api/ticket-materials/download/{{material.id}}/{{material.name| ticketMaterialEncodeFilename}}?inline=false"><span class="glyphicon glyphicon-save"></span> <span data-translate="abcQualityMatchApp.ticket.materialDownLoadLink">download</span></a></td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteTicketMaterial(material)" data-translate="entity.action.delete">Delete</button></td></tr></tbody><tfoot><tr><td colspan="2"><div class="alert alert-info material-upload-alert" ng-show="vm.uploadingTicketMaterial"><div class="upload-spinner"></div><div><strong data-translate="abcQualityMatchApp.ticket.materialDownInProgressTitle">Uploading</strong><br><span data-translate="abcQualityMatchApp.ticket.materialDownInProgressMessage">Please wait</span></div></div><div class="alert alert-danger" ng-show="vm.selectedFileTooLarge"><span data-translate="abcQualityMatchApp.ticket.materialFileIsTooLargeMessage">File too large</span></div></td><td><div class="btn-group" uib-dropdown is-open="status.isopen"><button id="single-button" type="button" class="btn btn-primary btn-sm" uib-dropdown-toggle><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="single-button"><li role="menuitem" ngf-select ngf-change="vm.setFileContent($file, $invalidFiles)" ngf-max-size="20MB"><span class="btn" data-translate="abcQualityMatchApp.ticket.addTicketMaterialFileButton">add file</span></li><!--                                      <li role="menuitem" ng-click="vm.showAddMaterialLinkDialog()">\n                                                                                  <span class="btn" data-translate="abcQualityMatchApp.ticket.addTicketMaterialLinkButton">add link</span>\n                                                                              </li>--></ul></div></td></tr></tfoot></table></div></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.ticket.state" for="field_state">State</label><select class="form-control" id="field_state" name="state" ng-model="vm.task.state" ng-options="ticketState as ticketState.name for ticketState in vm.ticketstates track by ticketState.id" required><option value=""></option></select></div><div ng-show="editForm.state.$invalid"><p class="help-block" ng-show="editForm.state.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.ticket.doneTime" for="field_doneTime">doneTime</label><div class="input-group"><input id="field_doneTime" type="text" class="form-control" name="doneTime" datetime-picker="{{dateformat}}" ng-model="vm.task.doneTime" is-open="vm.datePickerOpenStatus.doneTime" timepicker-options="vm.picker.timepickerOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'doneTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.task.start" for="field_start">Start</label><div class="input-group"><input id="field_start" type="text" class="form-control" name="start" datetime-picker="{{dateformat}}" ng-model="vm.task.start" is-open="vm.datePickerOpenStatus.start" timepicker-options="vm.picker.timepickerOptions" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'start\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.start.$invalid"><p class="help-block" ng-show="editForm.start.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.start.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.task.end" for="field_end">End</label><div class="input-group"><input id="field_end" type="text" class="form-control" name="end" datetime-picker="{{dateformat}}" ng-model="vm.task.end" is-open="vm.datePickerOpenStatus.end" timepicker-options="vm.picker.timepickerOptions" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'end\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.end.$invalid"><p class="help-block" ng-show="editForm.end.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.end.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label for="field_allDay"><input type="checkbox" id="field_allDay" ng-model="vm.task.allDay" name="allDay" ng-click="vm.clickAllDay()"> <span translate="abcQualityMatchApp.task.allDay">All Day</span></label><div ng-show="editForm.allDay.$invalid"><p class="help-block" ng-show="editForm.allDay.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label for="field_useRecurrence"><input type="checkbox" id="field_useRecurrence" name="useRecurrence" ng-model="vm.task.useRecurrence"> <span translate="abcQualityMatchApp.task.useRecurrence">Use recurrence</span></label></div><div ng-show="vm.task.useRecurrence" class="form-group"><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.recurrence.freq" for="field_freq">Freq</label><select class="form-control" name="freq" ng-model="vm.task.freq" id="field_freq" ng-required="vm.task.useRecurrence"><option value="HOURLY" data-translate="abcQualityMatchApp.Frequence.HOURLY" ng-if="!vm.task.allDay">HOURLY</option><option value="DAILY" data-translate="abcQualityMatchApp.Frequence.DAILY">DAILY</option><option value="WEEKLY" data-translate="abcQualityMatchApp.Frequence.WEEKLY">WEEKLY</option><option value="MONTHLY" data-translate="abcQualityMatchApp.Frequence.MONTHLY">MONTHLY</option><option value="YEARLY" data-translate="abcQualityMatchApp.Frequence.YEARLY">YEARLY</option></select><div ng-show="editForm.freq.$invalid"><p class="help-block" ng-show="editForm.freq.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.recurrence.recurInterval" for="field_interval">Interval</label><input type="number" class="form-control" name="interval" id="field_interval" ng-model="vm.task.interval"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.recurrence.recurCount" for="field_count">Count</label><input type="number" class="form-control" name="count" id="field_count" ng-model="vm.task.count"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.recurrence.until" for="field_until">Until</label><div class="input-group"><input id="field_until" type="text" class="form-control" name="until" datetime-picker="{{dateformat}}" ng-model="vm.task.until" is-open="vm.datePickerOpenStatus.until" timepicker-options="vm.picker.timepickerOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'until\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/task/tasks.html','<div><h2 data-translate="abcQualityMatchApp.task.home.title">Tasks</h2><jhi-alert></jhi-alert><div class="container-fluid" has-any-authority="ROLE_COMPANY_ADMIN,TASKS_ALL,TASKS_BY_PRODUCT_LINE"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="task.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.task.home.createLabel">Create new Task</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="(title)"><span data-translate="abcQualityMatchApp.ticket.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs" jh-sort-by="(assigned_to)" has-any-authority="ROLE_COMPANY_ADMIN,TASKS_ALL,TASKS_BY_PRODUCT_LINE"><span data-translate="abcQualityMatchApp.ticket.assignedTo">Assigned To</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs" jh-sort-by="(assigned_to_user_group)" has-any-authority="ROLE_COMPANY_ADMIN,TASKS_ALL,TASKS_BY_PRODUCT_LINE"><span data-translate="abcQualityMatchApp.ticket.assignedToUserGroup">Assigned To User Group</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="start"><span data-translate="abcQualityMatchApp.task.start">Start</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="end"><span data-translate="abcQualityMatchApp.task.end">End</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tic.done_time"><span data-translate="abcQualityMatchApp.ticket.doneTime">doneTime</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(ticket_state)"><span data-translate="abcQualityMatchApp.ticket.state">State</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs" jh-sort-by="(recurrence_id)"><span data-translate="abcQualityMatchApp.task.type">Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="task in vm.tasks"><td><span class="long-text">{{task.title}}</span></td><td class="hidden-xs" has-any-authority="ROLE_COMPANY_ADMIN,TASKS_ALL,TASKS_BY_PRODUCT_LINE">{{task.assignedTo}}</td><td class="hidden-xs" has-any-authority="ROLE_COMPANY_ADMIN,TASKS_ALL,TASKS_BY_PRODUCT_LINE">{{task.assignedToUserGroup}}</td><td ng-if="task.allDay">{{task.start | date:\'shortDate\'}}</td><td ng-if="!task.allDay">{{task.start | date:\'short\'}}</td><td ng-if="task.allDay">{{task.end | date:\'shortDate\'}}</td><td ng-if="!task.allDay">{{task.end | date:\'short\'}}</td><td>{{task.doneTime | date:\'short\'}}</td><td>{{task.state}}</td><td class="hidden-xs" ng-if="task.recurrenceId != null" data-translate="abcQualityMatchApp.task.recurringTask">Recurring</td><td class="hidden-xs" ng-if="task.recurrenceId == null" data-translate="abcQualityMatchApp.task.singleTask">Normal</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="task.activate({id:task.id})" class="btn btn-secondary btn-sm"><span class="glyphicon glyphicon-flash"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.activate"></span></button><div has-any-authority="ROLE_COMPANY_ADMIN,TASKS_ALL,TASKS_BY_PRODUCT_LINE"><button type="submit" ui-sref="task-detail({id:task.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button></div><div has-any-authority="ROLE_COMPANY_ADMIN,TASKS_ALL,TASKS_BY_PRODUCT_LINE"><button type="submit" ui-sref="task.edit({id:task.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button></div><div has-any-authority="ROLE_COMPANY_ADMIN,TASKS_ALL,TASKS_BY_PRODUCT_LINE"><button type="submit" ui-sref="task.delete({id:task.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/ticket/ticket-dialog.html','<div class="modal-wrapper" ng-cloak><div class="form-group"><label class="control-label">Ilmoituksen tyyppi</label><select class="form-control" ng-options="type as type.name for type in vm.ticketTypes" ng-model="vm.selectedType"></select></div><div ng-if="vm.selectedType.qId === vm.ticketTypes[0].qId"><div class="form-group"><label class="control-label">Poikkeamalaji</label><select class="form-control" ng-model="vm.pl" ng-options="pl for pl in [\'Laatu\', \'Elintarviketurvallisuus\', \'Ty\xF6turvallisuus\', \'Ymp\xE4rist\xF6\']"></select></div><div class="form-group"><label class="control-label">Toiminto</label><select class="form-control" ng-model="vm.func" ng-options="f for f in [\'Valmistus\', \'Pakkaamo\']"></select></div><div class="form-group"><label class="control-label">Tuote</label><input class="form-control" type="text"></div><div class="form-group"><label class="control-label">Tuote-er\xE4</label><input class="form-control" type="text"></div><div class="form-group"><label class="control-label">Otsikko</label><input class="form-control" type="text"></div><div class="form-group"><label class="control-label">Kuvaus</label><textarea class="form-control" rows="6" cols="50"></textarea></div><div class="form-group"><label class="control-label">V\xE4litt\xF6m\xE4t toimenpiteet</label><select class="form-control" ng-model="vm.vt" ng-options="vt for vt in [\'Hyl\xE4tty j\xE4tteeksi\', \'Ty\xF6stet\xE4\xE4n uudelleen\', \'Hyl\xE4tty rehuksi\', \'Karanteeni\']"></select></div><div class="form-group"><label class="control-label">Liit\xE4 dokumentti</label><input class="form-control" type="file"></div></div><div ng-if="vm.selectedType.qId === vm.ticketTypes[1].qId"><p>fooo</p></div><div class="form-group"><div class="pull-right"><button class="btn btn-primary" ng-click="vm.save()"><span data-translate="entity.action.save">Tallenna</span></button> <button class="btn btn-primary" ng-click="vm.clear()"><span data-translate="entity.action.cancel">Peruuta</span></button></div></div></div>');
$templateCache.put('app/ticket/ticket.html','<h4>Tickets</h4>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/forced-password-change/forced-password-change.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="abcQualityMatchApp.forcedPasswordChange.title">Forced password change</h2><div class="alert alert-warning" ng-show="vm.error">{{\'abcQualityMatchApp.forcedPasswordChange.errorMessages.\' + vm.error | translate}}</div><div class="alert alert-warning" ng-show="vm.confirmationMatch === false" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label required" for="currentPassword" data-translate="abcQualityMatchApp.forcedPasswordChange.currentPassword">Current password</label><input type="password" class="form-control" id="currentPassword" name="currentPassword" ng-model="vm.passwordChange.currentPassword" ng-maxlength="50" required><div ng-show="form.currentPassword.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.currentPassword.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.currentPassword.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div><hr><div class="form-group"><label class="control-label required" for="newPassword" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="newPassword" name="newPassword" ng-model="vm.passwordChange.newPassword" ng-minlength="5" ng-maxlength="50" required><div ng-show="form.newPassword.$dirty && form.newPassword.$invalid"><p class="help-block" ng-show="form.newPassword.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.newPassword.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.newPassword.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label required" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="entity.action.save">Save</button></form></div></div></div>');
$templateCache.put('app/account/forced-password-change/password-change-done-dialog.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="abcQualityMatchApp.forcedPasswordChange.passwordChangedTitle">Password changed</h4></div><div class="modal-body"><div class="alert alert-success" data-translate="abcQualityMatchApp.forcedPasswordChange.passwordChangedMessage"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.close()"><span class="glyphicon glyphicon-check"></span>&nbsp;<span data-translate="abcQualityMatchApp.forcedPasswordChange.relogin">OK</span></button></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-maxlength="100" maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/company/companies.html','<div><h2 data-translate="abcQualityMatchApp.company.home.title">Companies</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="company.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.company.home.createLabel">Create new Company</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="name"><span data-translate="abcQualityMatchApp.company.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="streetAddress"><span data-translate="abcQualityMatchApp.company.streetAddress">Street Address</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="postCode"><span data-translate="abcQualityMatchApp.company.postCode">Post Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="city"><span data-translate="abcQualityMatchApp.company.city">City</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tel"><span data-translate="abcQualityMatchApp.company.tel">Tel</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="company in vm.companies track by company.id"><td>{{company.name}}</td><td>{{company.streetAddress}}</td><td>{{company.postCode}}</td><td>{{company.city}}</td><td>{{company.tel}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="company-detail({id:company.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="company.edit({id:company.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="company.delete({id:company.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/company/company-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.company.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.company.delete.question" translate-values="{id: \'{{vm.company.name}}\'}">Are you sure you want to delete this Company?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/company/company-detail.html','<div><h2><span data-translate="abcQualityMatchApp.company.detail.title">Company</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.company.name">Name</span></dt><dd><span>{{vm.company.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.company.streetAddress">Street Address</span></dt><dd><span>{{vm.company.streetAddress}}</span></dd><dt><span data-translate="abcQualityMatchApp.company.postCode">Post Code</span></dt><dd><span>{{vm.company.postCode}}</span></dd><dt><span data-translate="abcQualityMatchApp.company.city">City</span></dt><dd><span>{{vm.company.city}}</span></dd><dt><span data-translate="abcQualityMatchApp.company.tel">Tel</span></dt><dd><span>{{vm.company.tel}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="company-detail.edit({id:vm.company.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/admin/company/company-dialog.html','<form class="company" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCompanyLabel" data-translate="abcQualityMatchApp.company.home.createOrEditLabel">Create or edit a Company</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.company.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.company.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.company.streetAddress" for="field_streetAddress">Street Address</label><input type="text" class="form-control" name="streetAddress" id="field_streetAddress" ng-model="vm.company.streetAddress"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.company.postCode" for="field_postCode">Post Code</label><input type="text" class="form-control" name="postCode" id="field_postCode" ng-model="vm.company.postCode"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.company.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.company.city"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.company.tel" for="field_tel">Tel</label><input type="text" class="form-control" name="tel" id="field_tel" ng-model="vm.company.tel"></div><div class="logoDiv" ng-if="vm.hasLogo"><img class="logo" ng-src="{{vm.logoUrl}}" alt=""><div><label for="deleteCheckBox"><span class="glyphicon glyphicon-trash"></span> <span id="deleteLogoLabel" data-translate="abcQualityMatchApp.company.deleteLogoBtn">Save</span></label><input id="deleteCheckBox" type="checkbox" ng-model="vm.deleteLogo"></div></div><div ng-if="!vm.hasLogo"><button ngf-select ngf-change="vm.setFileContent($file, $invalidFiles)" ngf-max-size="20MB" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-file"></span> <span data-translate="abcQualityMatchApp.company.addLogo">File</span></button><label ng-if="vm.fileContent">{{ vm.fileLabel }}</label><label ng-if="!vm.fileContent"><span data-translate="abcQualityMatchApp.company.fileText"></span></label><span class="alert alert-danger" ng-if="vm.badFile" data-translate="abcQualityMatchApp.company.badFileError"></span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/questionnaire-group/questionnaire-group-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.questionnaireGroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.questionnaireGroup.delete.question" translate-values="{name: \'{{vm.questionnaireGroup.name}}\'}">Are you sure you want to delete this Questionnaire Group?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/questionnaire-group/questionnaire-group-detail.html','<div><h2><span data-translate="abcQualityMatchApp.questionnaireGroup.detail.title">Questionnaire Group</span> {{vm.questionnaireGroup.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.questionnaireGroup.name">Name</span></dt><dd><span>{{vm.questionnaireGroup.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.questionnaireGroup.company">Company</span></dt><dd><a ui-sref="company-detail({id:vm.questionnaireGroup.company.id})">{{vm.questionnaireGroup.company.name}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="questionnaire-group-detail.edit({id:vm.questionnaireGroup.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/admin/questionnaire-group/questionnaire-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myQuestionnaireGroupLabel" data-translate="abcQualityMatchApp.questionnaireGroup.home.createOrEditLabel">Create or edit a Questionnaire Group</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.questionnaireGroup.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.questionnaireGroup.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><h3 data-translate="abcQualityMatchApp.questionnaireGroup.questionnaires">Options</h3><table class="table table-striped"><tbody><tr ng-repeat="questionnaire in vm.questionnaireGroup.questionnaires | orderBy: \'title\' track by questionnaire.id"><td>{{questionnaire.title}}</td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.removeQuestionnaire(questionnaire)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete">Delete</span></button></td></tr></tbody><tfoot><tr><td colspan="2"><select name="newQuestionnaire" class="form-control" ng-model="vm.newQuestionnaire" ng-options="questionnaire as questionnaire.title for questionnaire in vm.templateQuestionnaires track by questionnaire.id" ng-change="vm.addQuestionnaire()"><option value="" disabled="disabled" selected="selected">{{\'abcQualityMatchApp.questionnaireGroup.addQuestionnaireSelectPlaceholder\'| translate}}</option></select></td></tr></tfoot></table></div><div class="form-group"><h3 data-translate="abcQualityMatchApp.questionnaireGroup.companies">Options</h3><table class="table table-striped"><tbody><tr ng-repeat="company in vm.questionnaireGroup.companies | orderBy: \'name\' track by company.id"><td>{{company.name}}</td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.removeCompany(company)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete">Delete</span></button></td></tr></tbody><tfoot><tr><td colspan="2"><select name="newCompany" class="form-control" ng-model="vm.newCompany" ng-options="company as company.name for company in vm.companies track by company.id" ng-change="vm.addCompany()"><option value="" disabled="disabled" selected="selected">{{\'abcQualityMatchApp.questionnaireGroup.addCompanySelectPlaceholder\'| translate}}</option></select></td></tr></tfoot></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/questionnaire-group/questionnaire-groups.html','<div><h2 data-translate="abcQualityMatchApp.questionnaireGroup.home.title">Questionnaire Groups</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="questionnaire-group.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.questionnaireGroup.home.createLabel">Create new Questionnaire Group</span></button></div></div></div><br><div class="alert alert-info"><span data-translate="abcQualityMatchApp.questionnaireGroup.grouplessCompanySeesAllQuestionnaireTemplates"></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="abcQualityMatchApp.questionnaireGroup.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="abcQualityMatchApp.questionnaireGroup.companies">Companies</span></th><th><span data-translate="abcQualityMatchApp.questionnaireGroup.questionnaires">Questionnaires</span></th><th></th></tr></thead><tbody><tr ng-repeat="questionnaireGroup in vm.questionnaireGroups track by questionnaireGroup.id"><td>{{questionnaireGroup.name}}</td><td><ul class="list-unstyled"><li ng-repeat="company in questionnaireGroup.companies | orderBy: \'name\' track by company.id">{{company.name}}</li></ul></td><td><ul class="list-unstyled"><li ng-repeat="questionnaire in questionnaireGroup.questionnaires | orderBy: \'title\' track by questionnaire.id">{{questionnaire.title}}</li></ul></td><td class="text-right"><div class="btn-group flex-btn-group-container"><!--\n                            <button type="submit"\n                                    ui-sref="questionnaire-group-detail({id:questionnaireGroup.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-sm-down" data-translate="entity.action.view"></span>\n                            </button>\n                            --> <button type="submit" ui-sref="questionnaire-group.edit({id:questionnaireGroup.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="questionnaire-group.delete({id:questionnaireGroup.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/analysis/root-cause-analysis/root-cause-analyses.html','<div class="root-cause-analysis"><h2 data-translate="abcQualityMatchApp.rootCauseAnalysis.home.title">Root Cause Analyses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="root-cause-analysis.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.rootCauseAnalysis.home.createLabel">Create new Root Cause Analysis</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped indexTable indexTableDropdownCutoffFix"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="created"><span data-translate="abcQualityMatchApp.rootCauseAnalysis.created">Created</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="issue"><span data-translate="abcQualityMatchApp.rootCauseAnalysis.issue">Issue</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="abcQualityMatchApp.rootCauseAnalysis.factors">Factors</span></th><th jh-sort-by="factorsDescription"><span data-translate="abcQualityMatchApp.rootCauseAnalysis.factorsDescription">Factors Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="correctiveActionPlan"><span data-translate="abcQualityMatchApp.rootCauseAnalysis.correctiveActionPlan">correctiveActionPlan</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rootCauseDescription"><span data-translate="abcQualityMatchApp.rootCauseAnalysis.rootCauseDescription">rootCauseDescription</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="author.login"><span data-translate="abcQualityMatchApp.rootCauseAnalysis.author">Author</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="rootCauseAnalysis in vm.rootCauseAnalyses track by rootCauseAnalysis.id"><td>{{rootCauseAnalysis.created | date:\'shortDate\'}}</td><td>{{rootCauseAnalysis.issue}}</td><td><span ng-repeat="factor in rootCauseAnalysis.factors">{{factor.name}}{{$last ? \'\' : \', \'}}</span></td><td class="long-text">{{rootCauseAnalysis.factorsDescription}}</td><td><div class="long-text">{{rootCauseAnalysis.correctiveActionPlan}}</div><span has-any-authority="ROLE_COMPANY_ADMIN,PROJECT"><a ui-sref="project-detail({id: rootCauseAnalysis.correctiveProjectId})" ng-show="rootCauseAnalysis.correctiveProjectId != null"><span data-translate="abcQualityMatchApp.rootCauseAnalysis.correctiveProject">correction project</span></a><br ng-show="rootCauseAnalysis.correctiveProjectId != null && rootCauseAnalysis.correctiveTaskId != null"></span><a ui-sref="task-detail({id: rootCauseAnalysis.correctiveTaskId})" ng-show="rootCauseAnalysis.correctiveTaskId != null"><span data-translate="abcQualityMatchApp.rootCauseAnalysis.correctiveTask">correction task</span></a><div class="btn-group" uib-dropdown is-open="status.isopen" ng-show="rootCauseAnalysis.correctiveTaskId == null || rootCauseAnalysis.correctiveProjectId == null"><button id="single-button" type="button" class="btn btn-xs" uib-dropdown-toggle><span class="glyphicon glyphicon-plus"></span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="single-button"><li role="menuitem" ng-show="rootCauseAnalysis.correctiveProjectId == null"><a ui-sref="root-cause-analysis-detail.newCorrectiveProject({id:rootCauseAnalysis.id})" data-translate="abcQualityMatchApp.rootCauseAnalysis.createCorrectiveProject" has-any-authority="ROLE_COMPANY_ADMIN,PROJECT">create project</a></li><li role="menuitem" ng-show="rootCauseAnalysis.correctiveTaskId == null"><a ui-sref="root-cause-analysis-detail.newCorrectiveTask({id:rootCauseAnalysis.id})" data-translate="abcQualityMatchApp.rootCauseAnalysis.createCorrectiveTask">create task</a></li></ul></div></td><td class="long-text">{{rootCauseAnalysis.rootCauseDescription}}</td><td>{{rootCauseAnalysis.author | fullUserName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="root-cause-analysis-detail({id:rootCauseAnalysis.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="root-cause-analysis.edit({id:rootCauseAnalysis.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="root-cause-analysis.delete({id:rootCauseAnalysis.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/analysis/root-cause-analysis/root-cause-analysis-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rootCauseAnalysis.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.rootCauseAnalysis.delete.question" translate-values="{id: \'{{vm.rootCauseAnalysis.issue}}\'}">Are you sure you want to delete this Root Cause Analysis?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/analysis/root-cause-analysis/root-cause-analysis-detail.html','<div class="root-cause-analysis"><h2><span data-translate="abcQualityMatchApp.rootCauseAnalysis.detail.title">Root Cause Analysis</span>: <span>{{vm.rootCauseAnalysis.issue}}</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.rootCauseAnalysis.created">Created</span></dt><dd><span>{{vm.rootCauseAnalysis.created | date:\'medium\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.rootCauseAnalysis.author">Author</span></dt><dd>{{vm.rootCauseAnalysis.author | fullUserName}}</dd><dt><span data-translate="abcQualityMatchApp.rootCauseAnalysis.informationEvents">Information events</span></dt><dd><table class="jh-table table" ng-show="vm.rootCauseAnalysis.informationEvents.length > 0"><thead><tr><th><span data-translate="abcQualityMatchApp.information.submitDate">submitDate</span></th><th><span data-translate="abcQualityMatchApp.informationEvent.type">Type</span></th><th><span data-translate="abcQualityMatchApp.informationEvent.state">state</span></th><th><span data-translate="abcQualityMatchApp.informationEvent.name">Name</span></th></tr></thead><tbody><tr ng-repeat="information in vm.rootCauseAnalysis.informationEvents | orderBy: \'created\'"><td>{{information.submitDate | date:\'short\'}}</td><td data-translate="{{\'abcQualityMatchApp.QuestionnaireType.\' + information.questionnaireType}}">>{{information.questionnaireType}}</td><td>{{information.state}}</td><td>{{information.title}}</td></tr></tbody></table></dd><dt><span data-translate="abcQualityMatchApp.rootCauseAnalysis.anomalyEvents">Anomaly events</span></dt><dd><div class="table-responsive-TODO" ng-show="vm.rootCauseAnalysis.anomalyEvents.length > 0"><table class="jh-table table"><thead><tr><th><span data-translate="abcQualityMatchApp.anomalyEvent.answerTime">time</span></th><th><span data-translate="abcQualityMatchApp.anomalyEvent.questionnaireTitle">Questionnaire</span></th><th><span data-translate="abcQualityMatchApp.anomalyEvent.questionTitle">Question</span></th><th><span data-translate="abcQualityMatchApp.anomalyEvent.value">value</span></th></tr></thead><tbody><tr ng-repeat="anomaly in vm.rootCauseAnalysis.anomalyEvents | orderBy: \'answerTime\'"><td>{{anomaly.answerTime| date:\'shortDate\'}}</td><td>{{anomaly.questionnaireTitle}}</td><td>{{anomaly.questionTitle}}</td><td>{{anomaly.value}}</td></tr></tbody></table></div></dd><dt><span data-translate="abcQualityMatchApp.rootCauseAnalysis.issue">Issue</span></dt><dd><span>{{vm.rootCauseAnalysis.issue}}</span></dd><dt><span data-translate="abcQualityMatchApp.rootCauseAnalysis.causes">Causes</span></dt><dd><ul class="cause-list"><li ng-repeat="cause in vm.rootCauseAnalysis.causes | orderBy: \'listIndex\'"><span class="item-label">{{$index + 1}}.</span> <span class="item-text">{{cause.description}}</span></li><li class="root-cause"><span class="item-label" data-translate="abcQualityMatchApp.rootCauseAnalysis.rootCauseDescription">rootcause</span>: <span class="item-text">{{vm.rootCauseAnalysis.rootCauseDescription}}</span></li></ul></dd><dt><span data-translate="abcQualityMatchApp.rootCauseAnalysis.factorsLongLabel">Factors</span></dt><dd><ul class="factor-list"><li ng-repeat="factor in vm.rootCauseAnalysis.factors">{{factor.name}}</li></ul></dd><dt><span data-translate="abcQualityMatchApp.rootCauseAnalysis.factorsDescription">Factors Description</span></dt><dd><span class="long-text-detail">{{vm.rootCauseAnalysis.factorsDescription}}</span></dd><dt><span data-translate="abcQualityMatchApp.rootCauseAnalysis.correctiveActionPlan">correctiveActionPlan</span></dt><dd><ul class="correctiveActionList"><li ng-show="vm.rootCauseAnalysis.correctiveActionPlan.length > 0"><span class="long-text-detail">{{vm.rootCauseAnalysis.correctiveActionPlan}}</span></li><li><div ng-show="vm.rootCauseAnalysis.correctiveProjectId == null"><button class="btn btn-default btn-sm" ui-sref="root-cause-analysis-detail.newCorrectiveProject" has-any-authority="ROLE_COMPANY_ADMIN,PROJECT"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.project.home.createLabel">Create new Project</span></button></div><div ng-show="vm.rootCauseAnalysis.correctiveProjectId != null" has-any-authority="ROLE_COMPANY_ADMIN,PROJECT"><a ui-sref="project-detail({id: vm.rootCauseAnalysis.correctiveProjectId})"><span data-translate="abcQualityMatchApp.rootCauseAnalysis.correctiveProject">correction project</span></a></div></li><li><div ng-show="vm.rootCauseAnalysis.correctiveTaskId == null"><button class="btn btn-default btn-sm" ui-sref="root-cause-analysis-detail.newCorrectiveTask"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.task.home.createLabel">Create new Task</span></button></div><div ng-show="vm.rootCauseAnalysis.correctiveTaskId != null"><a ui-sref="task-detail({id: vm.rootCauseAnalysis.correctiveTaskId})"><span data-translate="abcQualityMatchApp.rootCauseAnalysis.correctiveTask">correction task</span></a></div></li></ul></dd></dl><br><br><br><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="root-cause-analysis-detail.edit({id:vm.rootCauseAnalysis.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/analysis/root-cause-analysis/root-cause-analysis-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="root-cause-analysis"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRootCauseAnalysisLabel" data-translate="abcQualityMatchApp.rootCauseAnalysis.home.createOrEditLabel">Create or edit a Root Cause Analysis</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.rootCauseAnalysis.created" for="field_created">Created</label><div class="input-group"><input id="field_created" type="text" class="form-control" name="created" datetime-picker="{{dateformat}}" ng-model="vm.rootCauseAnalysis.created" is-open="vm.datePickerOpenStatus.created" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'created\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.created.$invalid"><p class="help-block" ng-show="editForm.created.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.created.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label data-translate="abcQualityMatchApp.rootCauseAnalysis.author" for="field_author">Author</label><user-select id="field_author" user="vm.rootCauseAnalysis.author"></user-select></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.rootCauseAnalysis.informationEvents">Information events</label><div class="table-responsive-TODO"><table class="jh-table table"><thead><tr><th><span data-translate="abcQualityMatchApp.information.submitDate">submitDate</span></th><th><span data-translate="abcQualityMatchApp.informationEvent.type">Type</span></th><th><span data-translate="abcQualityMatchApp.informationEvent.state">state</span></th><th><span data-translate="abcQualityMatchApp.informationEvent.name">Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="information in vm.rootCauseAnalysis.informationEvents | orderBy: \'created\'"><td>{{information.submitDate | date:\'short\'}}</td><td data-translate="{{\'abcQualityMatchApp.QuestionnaireType.\' + information.questionnaireType}}">>{{information.questionnaireType}}</td><td>{{information.state}}</td><td>{{information.title}}</td><td><button type="button" class="btn btn-danger btn-sm" confirmed-delete="vm.deleteInformationEvent($index)" confirmed-delete-message="abcQualityMatchApp.rootCauseAnalysis.confirmRemoveInformationEvent" data-translate="entity.action.delete" tabindex="-1"><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span></button></td></tr></tbody><tfoot><tr><td colspan="2"><information-event-select on-select="vm.addInformationEvent(selected)"></td><td colspan="3"></td></tr></tfoot></table></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.rootCauseAnalysis.anomalyEvents">Anomaly events</label><div class="table-responsive-TODO"><table class="jh-table table"><thead><tr><th><span data-translate="abcQualityMatchApp.anomalyEvent.answerTime">time</span></th><th><span data-translate="abcQualityMatchApp.anomalyEvent.questionnaireTitle">Questionnaire</span></th><th><span data-translate="abcQualityMatchApp.anomalyEvent.questionTitle">Question</span></th><th><span data-translate="abcQualityMatchApp.anomalyEvent.value">value</span></th><th></th></tr></thead><tbody><tr ng-repeat="anomaly in vm.rootCauseAnalysis.anomalyEvents | orderBy: \'answerTime\'"><td>{{anomaly.answerTime| date:\'shortDate\'}}</td><td>{{anomaly.questionnaireTitle}}</td><td>{{anomaly.questionTitle}}</td><td>{{anomaly.value}}</td><td><button type="button" class="btn btn-danger btn-sm" confirmed-delete="vm.deleteAnomalyEvent($index)" confirmed-delete-message="abcQualityMatchApp.rootCauseAnalysis.confirmRemoveAnomalyEvent" data-translate="entity.action.delete" tabindex="-1"><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span></button></td></tr></tbody><tfoot><tr><td colspan="2"><anomaly-event-add-select on-select="vm.addAnomalyEvent(selected)"></td><td colspan="3"></td></tr></tfoot></table></div></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.rootCauseAnalysis.issue" for="field_issue">Issue</label><input type="text" class="form-control" name="unusedissuename" id="field_issue" ng-model="vm.rootCauseAnalysis.issue" required><div ng-show="editForm.issue.$invalid"><p class="help-block" ng-show="editForm.issue.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="abcQualityMatchApp.rootCauseAnalysis.causes">Causes</label><div class="table-responsive-TODO"><table class="table table-cause-edit" id="rootCauseTable"><tbody><tr ng-repeat="cause in vm.rootCauseAnalysis.causes | orderBy: \'listIndex\'"><td>{{$index + 1}}. <span data-translate="abcQualityMatchApp.rootCauseAnalysis.why">why?</span></td><td><textarea ng-model="cause.description" placeholder="{{ \'abcQualityMatchApp.rootCauseAnalysis.cause_input_placeholder\' | translate }}" rows="2" maxlength="255" class="form-control"></textarea></td><td><button ng-disabled="$first" type="button" class="btn btn-primary btn-sm" ng-click="vm.moveCause($index, \'up\')" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></button> <button ng-disabled="$last" type="button" class="btn btn-primary btn-sm" ng-click="vm.moveCause($index, \'down\')" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></button> <button type="button" class="btn btn-danger btn-sm" confirmed-delete="vm.deleteCause($index)" confirmed-delete-message="abcQualityMatchApp.rootCauseAnalysis.causeDeleteConfirm" data-translate="entity.action.delete" tabindex="-1">Delete</button></td></tr></tbody><tfoot><tr><td colspan="2"></td><td><button type="button" class="btn-sm btn-primary" ng-click="event.preventDefault();vm.addCause()"><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span></button></td></tr><tr><td><span data-translate="abcQualityMatchApp.rootCauseAnalysis.rootCauseDescription">root cause</span></td><td><textarea ng-model="vm.rootCauseAnalysis.rootCauseDescription" name="rootCauseDescription" rows="2" maxlength="255" class="form-control"></textarea></td><td></td></tr></tfoot></table></div></div><div class="form-group"><label data-translate="abcQualityMatchApp.rootCauseAnalysis.factorsLongLabel" for="field_factors">Factors</label><div class="table-responsive-TODO"><table class="table table-factors-select"><tbody><tr ng-repeat="factor in vm.rootCauseAnalysis.factors track by factor.id"><td>{{factor.name}}</td><td><button type="button" class="btn btn-danger btn-sm" confirmed-delete="vm.deleteFactor($index)" confirmed-delete-message="abcQualityMatchApp.rootCauseAnalysis.factorDeleteConfirm" data-translate="entity.action.delete" tabindex="-1">Delete</button></td></tr></tbody><tfoot><tr><td colspan="2"><select class="form-control" id="field_factors" name="factors" ng-options="factor as factor.name for factor in vm.factors track by factor.id" ng-model="vm.factorToAdd" ng-change="vm.addFactor()"><option value="" disabled="disabled" selected="selected">{{\'abcQualityMatchApp.rootCauseAnalysis.factorAddSelectPlaceholder\'| translate}}</option></select></td></tr></tfoot></table></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.rootCauseAnalysis.factorsDescription" for="field_factorsDescription">Factors Description</label><textarea ng-model="vm.rootCauseAnalysis.factorsDescription" name="factorsDescription" id="field_factorsDescription" rows="2" maxlength="255" class="form-control"></textarea></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.rootCauseAnalysis.correctiveActionPlan" for="field_correctiveActionPlan">Corrective Action Plan</label><textarea ng-model="vm.rootCauseAnalysis.correctiveActionPlan" id="field_correctiveActionPlan" name="correctiveActionPlan" rows="2" maxlength="255" class="form-control"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/company_admin/anomaly-category/anomaly-categories.html','<div><h2 data-translate="abcQualityMatchApp.anomalyCategory.home.title">Anomaly Categories</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="anomaly-category.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.anomalyCategory.home.createLabel">Create new Anomaly Category</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="abcQualityMatchApp.anomalyCategory.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="anomalyCategory in vm.anomalyCategories track by anomalyCategory.id"><td>{{anomalyCategory.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="anomaly-category-detail({id:anomalyCategory.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="anomaly-category.edit({id:anomalyCategory.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="anomaly-category.delete({id:anomalyCategory.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/company_admin/anomaly-category/anomaly-category-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.anomalyCategory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.anomalyCategory.delete.question" translate-values="{name: \'{{vm.anomalyCategory.name}}\'}">Are you sure you want to delete this Anomaly Category?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/company_admin/anomaly-category/anomaly-category-detail.html','<div><h2><span data-translate="abcQualityMatchApp.anomalyCategory.detail.title">Anomaly Category</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.anomalyCategory.name">Name</span></dt><dd><span>{{vm.anomalyCategory.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="anomaly-category-detail.edit({id:vm.anomalyCategory.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/company_admin/anomaly-category/anomaly-category-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAnomalyCategoryLabel" data-translate="abcQualityMatchApp.anomalyCategory.home.createOrEditLabel">Create or edit a Anomaly Category</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.anomalyCategory.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.anomalyCategory.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/company_admin/factory/factories.html','<div><h2 data-translate="abcQualityMatchApp.factory.home.title">Factories</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="factory.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.factory.home.createLabel">Create new Factory</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="abcQualityMatchApp.factory.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="factory in vm.factories track by factory.id"><td>{{factory.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="factory-detail({id:factory.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="factory.edit({id:factory.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="factory.delete({id:factory.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/company_admin/factory/factory-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.factory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.factory.delete.question" translate-values="{name: \'{{vm.factory.name}}\'}">Are you sure you want to delete this Factory?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/company_admin/factory/factory-detail.html','<div><h2><span data-translate="abcQualityMatchApp.factory.detail.title">Factory</span> {{vm.factory.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.factory.name">Name</span></dt><dd><span>{{vm.factory.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="factory-detail.edit({id:vm.factory.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/company_admin/factory/factory-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFactoryLabel" data-translate="abcQualityMatchApp.factory.home.createOrEditLabel">Create or edit a Factory</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.factory.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.factory.name" maxlength="254" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/company_admin/issue-significance/issue-significance-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.issueSignificance.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.issueSignificance.delete.question" translate-values="{id: \'{{vm.issueSignificance.name}}\'}">Are you sure you want to delete this Issue Significance?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/company_admin/issue-significance/issue-significance-detail.html','<div><h2><span data-translate="abcQualityMatchApp.issueSignificance.detail.title">Issue Significance</span> {{vm.issueSignificance.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.issueSignificance.name">Name</span></dt><dd><span>{{vm.issueSignificance.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.issueSignificance.listIndex">List Index</span></dt><dd><span>{{vm.issueSignificance.listIndex}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="issue-significance-detail.edit({id:vm.issueSignificance.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/company_admin/issue-significance/issue-significance-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myIssueSignificanceLabel" data-translate="abcQualityMatchApp.issueSignificance.home.createOrEditLabel">Create or edit a Issue Significance</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.issueSignificance.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.issueSignificance.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.issueSignificance.listIndex" for="field_listIndex">List Index</label><input type="number" class="form-control" name="listIndex" id="field_listIndex" ng-model="vm.issueSignificance.listIndex"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/company_admin/issue-significance/issue-significances.html','<div><h2 data-translate="abcQualityMatchApp.issueSignificance.home.title">Issue Significances</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="issue-significance.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.issueSignificance.home.createLabel">Create new Issue Significance</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="abcQualityMatchApp.issueSignificance.name">Name</span></th><th><span data-translate="abcQualityMatchApp.issueSignificance.listIndex">List Index</span></th><th></th></tr></thead><tbody><tr ng-repeat="issueSignificance in vm.issueSignificances track by issueSignificance.id"><td>{{issueSignificance.name}}</td><td>{{issueSignificance.listIndex}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="issue-significance-detail({id:issueSignificance.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="issue-significance.edit({id:issueSignificance.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="issue-significance.delete({id:issueSignificance.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/company_admin/product/product-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.product.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.product.delete.question" translate-values="{id: \'{{vm.product.id}}\'}">Are you sure you want to delete this Product?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/company_admin/product/product-detail.html','<div><h2><span data-translate="abcQualityMatchApp.product.detail.title">Product</span> {{vm.product.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.product.name">Name</span></dt><dd><span>{{vm.product.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.product.number">Number</span></dt><dd><span>{{vm.product.number}}</span></dd><dt><span data-translate="abcQualityMatchApp.product.archived">Archived</span></dt><dd><span>{{vm.product.archived | checkMark}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="product-detail.edit({id:vm.product.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/company_admin/product/product-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProductLabel" data-translate="abcQualityMatchApp.product.home.createOrEditLabel">Create or edit a Product</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.product.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.product.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.product.number" for="field_number">Number</label><input type="text" class="form-control" name="number" id="field_number" ng-model="vm.product.number" ng-maxlength="254"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.product.archived" for="field_archived">Archived</label><span><input type="checkbox" name="archived" id="field_archived" ng-model="vm.product.archived"></span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/company_admin/product/products.html','<div class="products"><h2 data-translate="abcQualityMatchApp.product.home.title">Products</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="product.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.product.home.createLabel">Create new Product</span></button></div></div></div><div id="includeArchivedDiv"><input type="checkbox" id="includeArchived" ng-model="vm.includeArchived" ng-change="vm.reload()"><label for="includeArchived"><span data-translate="abcQualityMatchApp.product.home.includeArchived"></span></label></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!--                    <th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th>--><th jh-sort-by="name"><span data-translate="abcQualityMatchApp.product.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="number"><span data-translate="abcQualityMatchApp.product.number">Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="archived"><span data-translate="abcQualityMatchApp.product.archived">Archived</span> <span class="glyphicon glyphicon-sort"></span></th><!--                    <th jh-sort-by="company.id"><span data-translate="abcQualityMatchApp.product.company">Company</span> <span class="glyphicon glyphicon-sort"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat="product in vm.products track by product.id"><!--                    <td><a ui-sref="product-detail({id:product.id})">{{product.id}}</a></td>--><td>{{product.name}}</td><td>{{product.number}}</td><td>{{product.archived | checkMark}}</td><td><!--                        <a ui-sref="company-detail({id:product.company.id})">{{product.company.id}}</a>--></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="product-detail({id:product.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="product.edit({id:product.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="product.delete({id:product.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody><tfoot><tr><td colspan="4"><a upload ng-click="vm.openProductImportDialog()"><span class="glyphicon glyphicon-upload"></span> <span data-translate="abcQualityMatchApp.product.uploadLink"></span></a></td></tr></tfoot><tfoot><tr><td colspan="3"><a download ng-href="/api/products/download-export-sheet"><span class="glyphicon glyphicon-download-alt"></span> <span data-translate="abcQualityMatchApp.product.downloadLink"></span></a></td></tr></tfoot></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/company_admin/product-line/product-line-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.productLine.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.productLine.delete.question" translate-values="{id: \'{{vm.productLine.id}}\'}">Are you sure you want to delete this Product Line?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/company_admin/product-line/product-line-detail.html','<div class="training"><h2><span data-translate="abcQualityMatchApp.productLine.detail.title">Product Line</span> {{vm.productLine.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.productLine.name">Name</span></dt><dd><span>{{vm.productLine.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.productLine.productionUnit">Production Unit</span></dt><dd><a ui-sref="production-unit-detail({id:vm.productLine.productionUnit.id})">{{vm.productLine.productionUnit.name}}</a></dd><dt><span data-translate="abcQualityMatchApp.productLine.expectedTrainings.label">Trainings</span></dt><dd><table class="expected-trainings-view table table-condensed"><tr ng-repeat="expectedTraining in vm.productLine.expectedTrainings"><td>{{expectedTraining.training.name}}</td><td><span ng-show="expectedTraining.required" data-translate="abcQualityMatchApp.productLine.expectedTrainings.required">Required</span></td></tr></table></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="product-line-detail.edit({id:vm.productLine.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/company_admin/product-line/product-line-dialog.html','<form class="training" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProductLineLabel" data-translate="abcQualityMatchApp.productLine.home.createOrEditLabel">Create or edit a Product Line</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.productLine.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.productLine.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="abcQualityMatchApp.productLine.productionUnit" for="field_productionUnit">Production Unit</label><select class="form-control" id="field_productionUnit" name="productionUnit" ng-model="vm.productLine.productionUnit" ng-options="productionUnit as productionUnit.name for productionUnit in vm.productionunits track by productionUnit.id"><option value=""></option></select></div><div class="form-group"><h3 data-translate="abcQualityMatchApp.productLine.users">Options</h3><users-multiple-select users="vm.productLine.users"></users-multiple-select></div><div class="form-group"><h3 data-translate="abcQualityMatchApp.productLine.expectedTrainings.label">Expected trainings</h3><table class="table table-striped expected-trainings-edit"><thead><tr><th data-translate="abcQualityMatchApp.productLine.expectedTrainings.training">Training</th><th colspan="2">&nbsp;</th></tr></thead><tbody><tr ng-repeat="expectedTraining in vm.productLine.expectedTrainings"><td>{{expectedTraining.training.name}}</td><td><label><input type="checkbox" ng-model="expectedTraining.required" name="requriedTraining"> <span class="traininglabel" data-translate="abcQualityMatchApp.productLine.expectedTrainings.required"></span></label></td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteExpectedTraining($index)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete">Delete</span></button></td></tr></tbody><tfoot><tr><td colspan="3"><select name="newExpectedTraining" class="form-control" ng-model="vm.newTraining" ng-options="training.name for training in vm.trainingSelectList" ng-change="vm.addExpectedTraining()"><option value="" disabled="disabled" selected="selected">{{\'abcQualityMatchApp.productLine.expectedTrainings.addTrainingPlaceholder\' | translate}}</option></select></td></tr></tfoot></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/company_admin/product-line/product-lines.html','<div><h2 data-translate="abcQualityMatchApp.productLine.home.title">Product Lines</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="product-line.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.productLine.home.createLabel">Create new Product Line</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="abcQualityMatchApp.productLine.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="productionUnit.id"><span data-translate="abcQualityMatchApp.productLine.productionUnit">Production Unit</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="productLine in vm.productLines track by productLine.id"><td>{{productLine.name}}</td><td><a ui-sref="production-unit-detail({id:productLine.productionUnit.id})">{{productLine.productionUnit.name}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="product-line-detail({id:productLine.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="product-line.edit({id:productLine.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="product-line.delete({id:productLine.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/company_admin/production-unit/production-unit-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.productionUnit.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.productionUnit.delete.question" translate-values="{id: \'{{vm.productionUnit.id}}\'}">Are you sure you want to delete this Production Unit?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/company_admin/production-unit/production-unit-detail.html','<div><h2><span data-translate="abcQualityMatchApp.productionUnit.detail.title">Production Unit</span> {{vm.productionUnit.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.productionUnit.name">Name</span></dt><dd><span>{{vm.productionUnit.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.productionUnit.factory">Factory</span></dt><dd><span>{{vm.productionUnit.factory.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="production-unit-detail.edit({id:vm.productionUnit.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/company_admin/production-unit/production-unit-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProductionUnitLabel" data-translate="abcQualityMatchApp.productionUnit.home.createOrEditLabel">Create or edit a Production Unit</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.productionUnit.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.productionUnit.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="abcQualityMatchApp.productionUnit.factory" for="field_factory">Factory</label><select class="form-control" id="field_factory" name="factory" ng-model="vm.productionUnit.factory" ng-options="factory as factory.name for factory in vm.factories track by factory.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/company_admin/production-unit/production-units.html','<div><h2 data-translate="abcQualityMatchApp.productionUnit.home.title">Production Units</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="production-unit.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.productionUnit.home.createLabel">Create new Production Unit</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="(name)"><span data-translate="abcQualityMatchApp.productionUnit.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(factory.name)"><span data-translate="abcQualityMatchApp.productionUnit.factory">Factory</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="productionUnit in vm.productionUnits track by productionUnit.id"><td>{{productionUnit.name}}</td><td>{{productionUnit.factory.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="production-unit-detail({id:productionUnit.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="production-unit.edit({id:productionUnit.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="production-unit.delete({id:productionUnit.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/company_admin/reason-code/reason-code-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.reasonCode.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.reasonCode.delete.question" translate-values="{id: \'{{vm.reasonCode.id}}\'}">Are you sure you want to delete this Reason Code?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/company_admin/reason-code/reason-code-detail.html','<div><h2><span data-translate="abcQualityMatchApp.reasonCode.detail.title">Reason Code</span> {{vm.reasonCode.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.reasonCode.name">Name</span></dt><dd><span>{{vm.reasonCode.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.reasonCode.code">Code</span></dt><dd><span>{{vm.reasonCode.code}}</span></dd><dd><span>{{abcQualityMatchApp.reasonCode.questionnaireTypes}}</span><table class="table table-condensed"><tbody><tr ng-if="vm.reasonCode.questionnaireTypes.length == 0"><td><span data-translate="abcQualityMatchApp.reasonCode.anyInformationType">any</span></td></tr><tr ng-repeat="type in vm.reasonCode.questionnaireTypes"><td>{{\'abcQualityMatchApp.QuestionnaireType.selectDescriptions.\' + type | translate}}</td></tr></tbody></table></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="reason-code-detail.edit({id:vm.reasonCode.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/company_admin/reason-code/reason-code-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReasonCodeLabel" data-translate="abcQualityMatchApp.reasonCode.home.createOrEditLabel">Create or edit a Reason Code</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.reasonCode.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.reasonCode.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.reasonCode.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.reasonCode.code" required><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.reasonCode.questionnaireTypes" for="field_code">Code</label><table class="table table-condensed"><tbody><tr ng-if="vm.reasonCode.questionnaireTypes.length == 0"><td><span data-translate="abcQualityMatchApp.reasonCode.anyInformationType">any</span></td></tr><tr ng-repeat="type in vm.reasonCode.questionnaireTypes"><td>{{\'abcQualityMatchApp.QuestionnaireType.selectDescriptions.\' + type | translate}}"</td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.removeQuestionnaireType(type)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete">Delete</span></button></td></tr></tbody><tfoot><tr><td colspan="2"><select name="newQuestionnaireType" class="form-control" ng-model="vm.newQuestionnaireType" ng-options="type as (\'abcQualityMatchApp.QuestionnaireType.selectDescriptions.\' + type | translate) for type in vm.notificationQuestioinnaireTypes" ng-change="vm.addQuestionnaireType()"><option value="" disabled="disabled" selected="selected">{{\'abcQualityMatchApp.reasonCode.addQuestionnaireTypeSelectPlaceholder\'| translate}}</option></select></td></tr></tfoot></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/company_admin/reason-code/reason-codes.html','<div><h2 data-translate="abcQualityMatchApp.reasonCode.home.title">Reason Codes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="reason-code.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.reasonCode.home.createLabel">Create new Reason Code</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="abcQualityMatchApp.reasonCode.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span data-translate="abcQualityMatchApp.reasonCode.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="abcQualityMatchApp.reasonCode.questionnaireTypes">questionnaireTypes</span></th><th></th></tr></thead><tbody><tr ng-repeat="reasonCode in vm.reasonCodes track by reasonCode.id"><td>{{reasonCode.name}}</td><td>{{reasonCode.code}}</td><td><ul class="list-unstyled"><li ng-repeat="type in reasonCode.questionnaireTypes"><span>{{\'abcQualityMatchApp.QuestionnaireType.selectDescriptions.\' + type | translate}}</span></li><li ng-if="reasonCode.questionnaireTypes.length == 0"><span data-translate="abcQualityMatchApp.reasonCode.anyInformationType">any</span></li></ul></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="reason-code-detail({id:reasonCode.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="reason-code.edit({id:reasonCode.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="reason-code.delete({id:reasonCode.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rootCauseAnalysisFactor.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.rootCauseAnalysisFactor.delete.question" translate-values="{id: \'{{vm.rootCauseAnalysisFactor.name}}\'}">Are you sure you want to delete this Root Cause Analysis Factor?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-detail.html','<div><h2><span data-translate="abcQualityMatchApp.rootCauseAnalysisFactor.detail.title">Root Cause Analysis Factor</span> {{vm.rootCauseAnalysisFactor.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.rootCauseAnalysisFactor.name">Name</span></dt><dd><span>{{vm.rootCauseAnalysisFactor.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="root-cause-analysis-factor-detail.edit({id:vm.rootCauseAnalysisFactor.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/company_admin/root-cause-analysis-factor/root-cause-analysis-factor-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRootCauseAnalysisFactorLabel" data-translate="abcQualityMatchApp.rootCauseAnalysisFactor.home.createOrEditLabel">Create or edit a Root Cause Analysis Factor</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.rootCauseAnalysisFactor.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.rootCauseAnalysisFactor.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/company_admin/root-cause-analysis-factor/root-cause-analysis-factors.html','<div><h2 data-translate="abcQualityMatchApp.rootCauseAnalysisFactor.home.title">Root Cause Analysis Factors</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="root-cause-analysis-factor.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.rootCauseAnalysisFactor.home.createLabel">Create new Root Cause Analysis Factor</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="abcQualityMatchApp.rootCauseAnalysisFactor.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="rootCauseAnalysisFactor in vm.rootCauseAnalysisFactors track by rootCauseAnalysisFactor.id"><td>{{rootCauseAnalysisFactor.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="root-cause-analysis-factor-detail({id:rootCauseAnalysisFactor.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="root-cause-analysis-factor.edit({id:rootCauseAnalysisFactor.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="root-cause-analysis-factor.delete({id:rootCauseAnalysisFactor.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/company_admin/ticket-state/ticket-state-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticketState.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="{{\'abcQualityMatchApp.ticketState.type.\' + vm.type + \'.delete.question\'}}" translate-values="{id: \'{{vm.ticketState.name}}\'}">Are you sure you want to delete this Ticket State?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/company_admin/ticket-state/ticket-state-detail.html','<div><h2><span data-translate="{{\'abcQualityMatchApp.ticketState.type.\' + vm.type + \'.detail.title\'}}">Ticket State</span> {{vm.ticketState.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.ticketState.name">Name</span></dt><dd><span>{{vm.ticketState.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.ticketState.listIndex">List Index</span></dt><dd><span>{{vm.ticketState.listIndex}}</span></dd><dt><span data-translate="abcQualityMatchApp.ticketState.ticketStateType">Ticket State Type</span></dt><dd><span data-translate="{{\'abcQualityMatchApp.TicketStateType.\' + vm.ticketState.ticketStateType}}">{{vm.ticketState.ticketStateType}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}({ticketType:vm.type})" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ticket-state-detail.edit({id:vm.ticketState.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/company_admin/ticket-state/ticket-state-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicketStateLabel" data-translate="{{\'abcQualityMatchApp.ticketState.type.\' + vm.type + \'.home.createOrEditLabel\'}}">Create or edit a Ticket State</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.ticketState.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.ticketState.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.ticketState.listIndex" for="field_listIndex">List Index</label><input type="number" class="form-control" name="listIndex" id="field_listIndex" ng-model="vm.ticketState.listIndex"></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.ticketState.ticketStateType" for="field_ticketStateType">Ticket State Type</label><select class="form-control" name="ticketStateType" ng-model="vm.ticketState.ticketStateType" id="field_ticketStateType" required><option value="NEW" data-translate="abcQualityMatchApp.TicketStateType.NEW">NEW</option><option value="IN_PROGRESS" data-translate="abcQualityMatchApp.TicketStateType.IN_PROGRESS">IN_PROGRESS</option><option value="DONE" data-translate="abcQualityMatchApp.TicketStateType.DONE">DONE</option><option value="VERIFIED" data-translate="abcQualityMatchApp.TicketStateType.VERIFIED">VERIFIED</option></select><div ng-show="editForm.ticketStateType.$invalid"><p class="help-block" ng-show="editForm.ticketStateType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/company_admin/ticket-state/ticket-states.html','<div><h2 data-translate="{{\'abcQualityMatchApp.ticketState.type.\' + vm.type + \'.home.title\'}}">Ticket States</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ticket-state.new({ticketType:vm.type})"><span class="glyphicon glyphicon-plus"></span> <span data-translate="{{\'abcQualityMatchApp.ticketState.type.\' + vm.type + \'.home.createLabel\'}}">Create new Ticket State</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="abcQualityMatchApp.ticketState.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="listIndex"><span data-translate="abcQualityMatchApp.ticketState.listIndex">List Index</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ticketStateType"><span data-translate="abcQualityMatchApp.ticketState.ticketStateType">Ticket State Type</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="ticketState in vm.ticketStates track by ticketState.id"><td>{{ticketState.name}}</td><td>{{ticketState.listIndex}}</td><td data-translate="{{\'abcQualityMatchApp.TicketStateType.\' + ticketState.ticketStateType}}">{{ticketState.ticketStateType}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ticket-state-detail({ticketType:vm.type, id:ticketState.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="ticket-state.edit({ticketType:vm.type, id:ticketState.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="ticket-state.delete({ticketType:vm.type, id:ticketState.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/company_admin/user-group/user-group-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.userGroup.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.userGroup.delete.question" translate-values="{id: \'{{vm.userGroup.id}}\'}">Are you sure you want to delete this User Group?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/company_admin/user-group/user-group-detail.html','<div class="user-group"><h2><span data-translate="abcQualityMatchApp.userGroup.detail.title">User Group</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.userGroup.name">Name</span></dt><dd><span>{{vm.userGroup.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.userGroup.users">Users !</span></dt><dd><table class="users-view table table-condensed"><tr ng-repeat="user in vm.userGroup.users track by user.id"><td ng-if="user.activated && !user.deleted">{{user|fullUserName}}</td></tr></table></dd><dt><span data-translate="abcQualityMatchApp.userGroup.userGroupAuthorities">Trainings</span></dt><dd><table class="authorities-view table table-condensed"><tr ng-repeat="authority in vm.userGroup.userGroupAuthorities track by authority.name"><td>{{\'abcQualityMatchApp.UserGroupAuthorityType.\' + authority.name| translate}}</td></tr></table></dd><dt><span data-translate="abcQualityMatchApp.userGroup.expectedTrainings.label">Trainings</span></dt><dd><table class="expected-trainings-view table table-condensed"><tr ng-repeat="expectedTraining in vm.userGroup.expectedTrainings"><td>{{expectedTraining.training.name}}</td><td><span ng-show="expectedTraining.required" data-translate="abcQualityMatchApp.userGroup.expectedTrainings.required">Required</span></td></tr></table></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="user-group-detail.edit({id:vm.userGroup.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/company_admin/user-group/user-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="user-group"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserGroupLabel" data-translate="abcQualityMatchApp.userGroup.home.createOrEditLabel">Create or edit a User Group</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.userGroup.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.userGroup.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><h3 data-translate="abcQualityMatchApp.userGroup.users">Options</h3><users-multiple-select users="vm.userGroup.users"></users-multiple-select></div><div class="form-group"><h3 data-translate="abcQualityMatchApp.userGroup.userGroupAuthorities">Options</h3><table class="table table-striped"><thead><tr><th data-translate="abcQualityMatchApp.userGroup.userGroupAuthority">Value</th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat="authority in vm.userGroup.userGroupAuthorities track by authority.name"><td>{{\'abcQualityMatchApp.UserGroupAuthorityType.\' + authority.name| translate}}</td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteAuthority($index)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete">Delete</span></button></td></tr></tbody><tfoot><tr><td colspan="2"><select name="newsiggupauthority" class="form-control" ng-model="vm.newAuthority" ng-options="\'abcQualityMatchApp.UserGroupAuthorityType.\' + authority | translate for authority in vm.authorities" ng-change="vm.addAuthority()" multiple="multiple" size="9"></select></td></tr></tfoot></table></div><div class="form-group"><h3 data-translate="abcQualityMatchApp.userGroup.expectedTrainings.label">Expected trainings</h3><table class="table table-striped expected-trainings-edit"><thead><tr><th data-translate="abcQualityMatchApp.userGroup.expectedTrainings.training">Training</th><th colspan="2">&nbsp;</th></tr></thead><tbody><tr ng-repeat="expectedTraining in vm.userGroup.expectedTrainings"><td>{{expectedTraining.training.name}}</td><td><label><input type="checkbox" ng-model="expectedTraining.required" name="requiredTraining"> <span class="expected-trainings-edit" data-translate="abcQualityMatchApp.userGroup.expectedTrainings.required"></span></label></td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteExpectedTraining($index)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete">Delete</span></button></td></tr></tbody><tfoot><tr><td colspan="3"><select name="newExpectedTraining" class="form-control" ng-model="vm.newTraining" ng-options="training.name for training in vm.trainingSelectList" ng-change="vm.addExpectedTraining()"><option value="" disabled="disabled" selected="selected">{{\'abcQualityMatchApp.userGroup.expectedTrainings.addTrainingPlaceholder\'| translate}}</option></select></td></tr></tfoot></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/company_admin/user-group/user-groups.html','<div><h2 data-translate="abcQualityMatchApp.userGroup.home.title">User Groups</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="user-group.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.userGroup.home.createLabel">Create new User Group</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="abcQualityMatchApp.userGroup.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="userGroup in vm.userGroups track by userGroup.id"><td>{{userGroup.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-group-detail({id:userGroup.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-group.edit({id:userGroup.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-group.delete({id:userGroup.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/company_admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user | fullUserName }}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/company_admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.status">Activated</span></dt><dd><span class="label label-success" ng-click="vm.setActive(vm.user, false)" ng-show="vm.user.activeNow" data-translate="userManagement.activityType.active" style="cursor: pointer">Activated</span> <span ng-show="vm.user.activeNow && (vm.user.activeFromDate != null || user.activeToDate != null)" class="date-limited-activity-timespan-view">{{ vm.user.activeFromDate | date:medium}} - {{ vm.user.activeToDate | date:medium}} </span><span class="label label-danger" ng-click="vm.setActive(vm.user, true)" ng-show="!vm.user.activeNow" data-translate="userManagement.activityType.inactive" style="cursor: pointer">Deactivated</span></dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span data-translate="{{\'userManagement.authority.\' + authority}}">{{authority}}</span></li></ul></dd><dt><span data-translate="userManagement.userGroups">groups</span></dt><dd><ul class="list-unstyled"><li ng-repeat="group in vm.user.userGroupLites | orderBy:\'name\' track by group.id"><span>{{group.name}}</span></li></ul></dd><dt><span data-translate="userManagement.productLines">productLines</span></dt><dd><ul class="list-unstyled"><li ng-repeat="productLine in vm.user.productLineLites | orderBy:\'name\' track by productLine.id"><span>{{productLine.name}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/company_admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="user-management"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="alert alert-danger" ng-show="doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="form-group"><div class="alert alert-warning" ng-show="!vm.newUser && vm.user.login != vm.originalLogin" translate="userManagement.edit_username"></div><label class="control-label required" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" autocomplete="off" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.jobTitle">First Name</label><input type="text" class="form-control" name="jobTitle" ng-model="vm.user.jobTitle" ng-maxlength="255"><div ng-show="editForm.jobTitle.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label for="changePassword"><input type="checkbox" id="changePassword" name="changePassword" ng-model="changePassword" ng-disabled="vm.user.id === null"> <span translate="userManagement.changePassword">Change password</span></label><div ng-show="changePassword" class="form-group"><label class="control-label required" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" autocomplete="new-password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="password" ng-minlength="5" ng-maxlength="50" ng-required="changePassword"><div ng-show="editForm.password.$dirty && editForm.password.$invalid"><p class="help-block" ng-show="editForm.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="editForm.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="password"></password-strength-bar></div><div ng-show="changePassword" class="form-group"><label class="control-label required" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" autocomplete="new-password" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="confirmPassword" ng-minlength="5" ng-maxlength="50" ng-required="changePassword"><div ng-show="editForm.confirmPassword.$dirty && editForm.confirmPassword.$invalid"><p class="help-block" ng-show="editForm.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="editForm.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 5 characters.</p><p class="help-block" ng-show="editForm.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label for="forcedPasswordChangeOnNextLogin"><input type="checkbox" id="forcedPasswordChangeOnNextLogin" name="forcedPasswordChangeOnNextLogin" ng-model="vm.user.forcedPasswordChangeOnNextLogin"> <span translate="userManagement.forcedPasswordChangeOnNextLogin">Forced password change</span></label></div><div class="form-group"><label for="active"><span data-translate="userManagement.status">status</span></label><ul class="activityTypeList"><li><input type="radio" ng-model="vm.activityType" id="active" value="ACTIVE" name="activtyType"><label for="active"><span data-translate="userManagement.activityType.active">active</span></label><div class="dateLimitedActivityDates"><div class="input-group activity-time_limit"><input id="activeFromDate" type="text" class="form-control" name="activeFromDate" datetime-picker="{{dateformat}}" ng-model="vm.user.activeFromDate" is-open="vm.datePickerOpenStatus.activeFromDate" placeholder="{{\'userManagement.activeFromDate\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'activeFromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div>-<div class="input-group activity-time_limit"><input id="active_to_date" type="text" class="form-control" name="activeToDate" datetime-picker="{{dateformat}}" ng-model="vm.user.activeToDate" is-open="vm.datePickerOpenStatus.activeToDate" placeholder="{{\'userManagement.activeToDate\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'activeToDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></li><li><input type="radio" ng-model="vm.activityType" id="inactive" value="INACTIVE" name="activtyType"><label for="inactive"><span data-translate="userManagement.activityType.inactive">inactive</span></label></li></ul><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><ul class="authority-list"><li ng-repeat="authority in vm.authorities"><label><input type="radio" ng-model="vm.user.authorities[0]" value="{{authority}}"> <span data-translate="{{\'userManagement.authority.\' + authority}}">{{authority}}</span><br></label></li></ul></div><div class="form-group"><label data-translate="userManagement.userGroups">groups</label><table class="table table-striped"><tr ng-repeat="group in vm.user.userGroupLites  track by group.id"><td>{{group.name}}</td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteUserGroup($index)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete">Delete</span></button></td></tr><tr><td colspan="2"><select name="newUserGroup" class="form-control" ng-model="vm.newUserGroup" ng-options="group as group.name for group in vm.userGroups | orderBy:\'name\' track by group.id" ng-change="vm.addUserGroup()" ng-disabled="vm.user.authorities[0] == \'ROLE_ADMIN\'"><option value="" disabled="disabled" selected="selected">{{\'userManagement.addUserGroupSelectPlaceholder\'| translate}}</option></select></td></tr></table></div><div class="form-group"><label data-translate="userManagement.productLines">productLines</label><table class="table table-striped"><tr ng-repeat="productLine in vm.user.productLineLites  track by productLine.id"><td>{{productLine.name}}</td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteProductLine($index)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete">Delete</span></button></td></tr><tr><td colspan="2"><select name="newUserGroup" class="form-control" ng-model="vm.newProductLine" ng-options="productLine as productLine.name for productLine in vm.productLines | orderBy:\'name\' track by productLine.id" ng-change="vm.addProductLine()" ng-disabled="vm.user.authorities[0] == \'ROLE_ADMIN\'"><option value="" disabled="disabled" selected="selected">{{\'userManagement.addProductLineSelectPlaceholder\'| translate}}</option></select></td></tr></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/company_admin/user-management/user-management.html','<div class="user-management"><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><br><form ng-submit="vm.refreshSearch()" class="listing-filters"><div class="seachField"><input class="form-control" type="text" ng-model="vm.searchTerm" id="seachTerm" placeholder="{{\'userManagement.filters.findByName\'|translate }}"> <button type="submit" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-search"></span></button></div><select class="form-control user-activity-status" ng-model="vm.status" ng-change="vm.refreshSearch()"><option value="ALL" data-translate="userManagement.filters.statusAll">all</option><option value="ACTIVE" data-translate="userManagement.filters.statusActive">active</option><option value="INACTIVE" data-translate="userManagement.filters.statusInactive">inactive</option></select></form><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="first_name"><span data-translate="userManagement.firstName">First Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="last_name"><span data-translate="userManagement.lastName">Last Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="job_title"><span data-translate="userManagement.jobTitle">status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="activated"><span data-translate="userManagement.status">status</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td>{{user.login}}</td><td>{{user.firstName}}</td><td>{{user.lastName}}</td><td>{{user.jobTitle}}</td><td><span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activeNow" data-translate="userManagement.activityType.active" style="cursor: pointer">Activated</span> <span ng-show="user.activeNow && (user.activeFromDate != null || user.activeToDate != null)" class="date-limited-activity-timespan-view">{{ user.activeFromDate | date:short}} - {{ user.activeToDate | date:short}} </span><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activeNow" data-translate="userManagement.activityType.inactive" style="cursor: pointer">Deactivated</span></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info" data-translate="{{\'userManagement.authority.\' + authority}}">{{ authority }}</span></div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({id:user.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({id:user.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({id:user.id})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody><tfoot><tr><td colspan="9"><a download ng-href="api/users/export-spreadsheet{{vm.spreadsheetDownloadParams | toQueryString}}"><span class="glyphicon glyphicon-download-alt"></span> <span data-translate="userManagement.downloadSpreadsheet"></span></a></td></tr></tfoot></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/anomaly-event-add-select/anomaly-event-add-select-component.html','<div class="anomaly-event-select has-feedback"><input type="text" autocomplete="off" ng-model="$ctrl.selected" placeholder="{{\'abcQualityMatchApp.rootCauseAnalysis.addAnomalyEvent\' | translate }}" uib-typeahead="event as event | anomalyEventFormat for event in $ctrl.getAnomalyEvents($viewValue)" typeahead-on-select="$ctrl.setSelected()" typeahead-loading="loadingLocations" typeahead-no-results="noResults" typeahead-wait-ms="150" typeahead-editable="false" typeahead-focus-first="false" class="form-control" typeahead-template-url="anomalyEventTemplate.html" uib-tooltip="{{\'abcQualityMatchApp.rootCauseAnalysis.anomalyEventselectComboBoxNoResults\' | translate }}" tooltip-placement="bottom-left" tooltip-is-open="noResults" tooltip-enable="noResults"> <i ng-show="loadingLocations" class="glyphicon glyphicon-refresh spinner form-control-feedback"></i> <i ng-show="!loadingLocations" class="glyphicon glyphicon-search search form-control-feedback"></i></div><script type="text/ng-template" id="anomalyEventTemplate.html"><a class="anomaly-item">\n      <span class="meta">\n        <span >{{match.model.answerTime | date:shortDate}}</span>\n      </span>\n      <br>\n      <span ng-bind-html="match.model.questionnaireTitle | uibTypeaheadHighlight:query"></span>\n\n      <br ng-show="match.model.questionTitle != null">\n      <span ng-show="match.model.questionTitle != null"\n            ng-bind-html="match.model.questionTitle | uibTypeaheadHighlight:query"></span>\n\n      <br ng-show="match.model.value != null">\n      <span ng-show="match.model.value != null"\n            ng-bind-html="match.model.value | uibTypeaheadHighlight:query"></span>\n  </a></script>');
$templateCache.put('app/components/information-select/information-select-component.html','<div class="information-event-select has-feedback"><input type="text" autocomplete="off" ng-model="$ctrl.selected" placeholder="{{\'abcQualityMatchApp.rootCauseAnalysis.addInformationEvent\' | translate }}" uib-typeahead="info as info | informationEventFormat for info in $ctrl.getInformation($viewValue)" typeahead-on-select="$ctrl.setSelected()" typeahead-loading="loadingLocations" typeahead-no-results="noResults" typeahead-wait-ms="150" typeahead-editable="false" typeahead-focus-first="false" class="form-control" typeahead-template-url="customTemplate.html" uib-tooltip="{{\'abcQualityMatchApp.informationEvent.selectComboBox\' | translate }}" tooltip-placement="bottom-left" tooltip-is-open="noResults" tooltip-enable="noResults"> <i ng-show="loadingLocations" class="glyphicon glyphicon-refresh spinner form-control-feedback"></i> <i ng-show="!loadingLocations" class="glyphicon glyphicon-search search form-control-feedback"></i></div><script type="text/ng-template" id="customTemplate.html"><a class="information-item">\n      <span class="meta">\n        <span >{{match.model.created | date:shortDate}}</span>\n        <span>{{match.model.state}}</span>\n        <span data-translate="{{\'abcQualityMatchApp.QuestionnaireType.\' + match.model.questionnaireType}}">>{{match.model.questionnaireType}}}}"/></span>\n      </span>\n      <br>\n      <span ng-bind-html="match.model.title | uibTypeaheadHighlight:query"></span> \n  </a></script>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div>');
$templateCache.put('app/components/product-select/product-select-component.html','<div class="anomaly-event-select has-feedback"><input type="text" autocomplete="off" ng-model="$ctrl.product" placeholder="{{$ctrl.placeholder}}" ng-value="$ctrl.product.number + $ctrl.product.name" ng-change="$ctrl.evaluateChange()" uib-typeahead="product as product | productNumberAndName for product in $ctrl.getProducts($viewValue)" typeahead-on-select="$ctrl.setSelected()" typeahead-loading="loadingProducts" typeahead-no-results="noResults" typeahead-wait-ms="300" typeahead-editable="false" typeahead-focus-first="false" class="form-control" id="productSelectInput" ng-disabled="$ctrl.viewonly"> <i ng-show="loadingProducts" class="glyphicon glyphicon-refresh spinner form-control-feedback"></i> <i ng-show="!loadingProducts" class="glyphicon glyphicon-barcode search form-control-feedback"></i></div>');
$templateCache.put('app/components/questionnaire-answer/questionnaire-answer.html','<div class="questionnaireAnswer"><div class="panel-heading" ng-if="vm.information"><label data-translate="abcQualityMatchApp.information.questionnaire"></label></div><div class="panel-body"><div id="questionnaire-dropdown" class="btn-group" uib-dropdown is-open="status.isopen"><button id="single-button" type="button" class="btn btn-info" ng-disabled="vm.editForm.$invalid" uib-dropdown-toggle><span data-translate="abcQualityMatchApp.questionnaire.selectSection">Select section</span> <span class="caret"></span></button><ul class="dropdown-menu questionnaire-menu" uib-dropdown-menu role="menu"><li ng-click="$event.stopPropagation()"><label><input type="checkbox" ng-model="vm.showAnswered">&nbsp; <span data-translate="abcQualityMatchApp.questionnaire.showAnswered">Show answered</span></label></li><li class="divider"></li><li ng-repeat="section in vm.questionnaire.sections | orderBy: \'listIndex\'"><span class="questionnaire-section btn" ng-click="vm.goToSection(section)">{{section.title}} <span ng-if="!section.title" data-translate="abcQualityMatchApp.questionnaire.section">Section</span></span><ul class="list-unstyled"><li class="questions" ng-repeat="question in section.questions | orderBy: \'listIndex\'"><span ng-if="question.answer.isAnswered && vm.showAnswered" class="glyphicon glyphicon-ok"></span> <span ng-if="!question.answer.isAnswered || vm.showAnswered" ng-click="vm.goToQuestion(section, question)" class="btn">{{question.title}}</span></li></ul></li></ul></div><questionnaire-answer-section section="vm.questionnaire.sections[vm.currentSection]" questionnaire="vm.questionnaire" comparisons="vm.comparisons" on-answer-change="vm.onAnswerChange()" edit-form="vm.editForm" viewonly="vm.viewonly"></div><div class="panel-footer text-right" ng-if="vm.questionnaire.sections.length > 1"><button ng-disabled="!vm.hasPrevSection || vm.editForm.$invalid" ng-click="vm.prevSection()" class="btn btn-primary" data-translate="entity.action.previous">previous</button> <button ng-disabled="!vm.hasNextSection || vm.editForm.$invalid" ng-click="vm.nextSection()" class="btn btn-primary" data-translate="entity.action.next">next</button></div></div>');
$templateCache.put('app/components/questionnaire-answer-attachment/answer-attachment-dialog.html','<form name="attachmentForm" ng-submit="vm.addAttachment()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.attachment.title">Add Attachment</h4><div class="alert alert-danger" ng-show="vm.selectedFileTooLarge"><span data-translate="abcQualityMatchApp.ticket.materialFileIsTooLargeMessage">File too large</span></div></div><div class="modal-body"><div><!--//TODO QMYP-103 maksimi tiedostokoon ylityksest\xE4 virheen n\xE4yttl ja uplaodauksesta spinner. Vaikka samaan tapaan kuin document-file-edit-dialog.html:l\xE4ss\xE4. --> <button class="btn" ngf-select="vm.fileSelected($file, $invalidFiles)" ngf-max-size="20MB"><span class="glyphicon glyphicon-paperclip"></span></button> <button class="btn" ng-click="vm.camera()"><span class="glyphicon glyphicon-camera"></span></button></div><div id="camera-canvas" ng-if="vm.isCamera" style="float:right; margin-bottom: 15px; width: 320px; height: 240px; border: solid 1px"><video id="video" width="320" height="240" autoplay></video><button class="btn" ng-click="vm.takePhoto()" style="bottom: 42px; left: 3px; position: relative"><span class="glyphicon glyphicon-camera"></span></button></div><canvas id="snapshot" width="320" height="240" style="float:right"></canvas><div><table class="table table-ticketmaterial"><!--//TODO QMYP-103 Table yhdelle tiedostonimelle css tyylill\xE4 jolla ei ole mit\xE4\xE4n tekmist\xE4 t\xE4m\xE4n featuren kanssa?\n            Mieluummin feature kohtaiset tyylit jos bootstapissa ei ole mit\xE4\xE4n sopivaa tai refactoroi jotain jo m\xE4\xE4ritelty\xE4 tyyli\xE4 yleisemm\xE4ksi --><tbody><tr><td ng-if="vm.file"><span class="glyphicon glyphicon-file"></span> {{vm.file.name}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-primary" ng-click="vm.add()"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span data-translate="entity.action.add">Add Attachment</span></button></div></form>');
$templateCache.put('app/components/questionnaire-answer-decimal-question/questionnaire-answer-decimal-question.html','<input type="number" class="form-control question-decimal-input" step="1" ng-pattern="/-?[0-9]+(\\.[0-9]+)?/" name="{{vm.inputName}}" ng-model="vm.question.answer.value" ng-disabled="vm.viewonly" ng-change="vm.answerInputChange()" ng-class="{\'invalid-answer\': vm.editForm[vm.inputName].$touched && vm.editForm[vm.inputName].$invalid }" ng-keydown="vm.preventInvalidInput($event)"><div ng-show="vm.editForm[vm.inputName].$touched && vm.editForm[vm.inputName].$invalid"><p class="help-block" data-translate="question.answerValidation.decimal"></p></div><hr><div><table class="table table-ticketmaterial"><tbody><tr ng-repeat="attachment in vm.question.answer.attachments track by $index"><td><span><span class="glyphicon glyphicon-file"></span> {{attachment.storageFile.fileName}}</span></td><td></td><td><button ng-if="!vm.viewonly" type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteAttachment(vm.question.answer, attachment)" data-translate="entity.action.delete">Delete</button></td></tr></tbody></table></div><div ng-if="vm.question.allowsAddingAttachments && !vm.viewonly"><button class="btn btn-primary" ng-click="vm.addAttachment(vm.question.answer)"><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span></button></div><ng-include src="\'app/components/questionnaire-answer-question/anomaly-category-select.html\'"></ng-include>');
$templateCache.put('app/components/questionnaire-answer-freetext-question/questionnaire-answer-freetext-question.html','<textarea rows="{{vm.rowCount}}" cols="40" maxlength="20000" class="form-control" name="{{vm.inputName}}" ng-model="vm.question.answer.value" ng-disabled="vm.viewonly" ng-change="vm.answerInputChange()"></textarea><hr><div><table class="table table-ticketmaterial"><tbody><tr ng-repeat="attachment in vm.question.answer.attachments track by $index"><!--//TODO QMYP-103 attachement on setti joten t\xE4m\xE4 olisivat aina satunnaisessa j\xE4rjestyksess\xE4. Lis\xE4\xE4 ng-repeattiin order by storageFile.id:ll\xE4--><td><span><span class="glyphicon glyphicon-file"></span> {{attachment.storageFile.fileName}}</span></td><td></td><td><button ng-if="!vm.viewonly" type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteAttachment(vm.question.answer, attachment)">Delete</button></td></tr></tbody></table></div><div ng-if="vm.question.allowsAddingAttachments && !vm.viewonly"><button class="btn btn-primary" ng-click="vm.addAttachment(vm.question.answer)"><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span></button></div><ng-include src="\'app/components/questionnaire-answer-question/anomaly-category-select.html\'"></ng-include>');
$templateCache.put('app/components/questionnaire-answer-integer-question/questionnaire-answer-integer-question.html','<input type="number" class="form-control question-integer-input" step="1" ng-pattern="/-?[0-9]+/" name="{{vm.inputName}}" ng-model="vm.question.answer.value" ng-disabled="vm.viewonly" ng-change="vm.answerInputChange()" ng-class="{\'invalid-answer\': vm.editForm[vm.inputName].$touched && vm.editForm[vm.inputName].$invalid }" ng-keydown="vm.preventInvalidInput($event)"><div ng-show="vm.editForm[vm.inputName].$touched && vm.editForm[vm.inputName].$invalid"><p class="help-block" data-translate="question.answerValidation.integer"></p></div><hr><div><table class="table table-ticketmaterial"><tbody><tr ng-repeat="attachment in vm.question.answer.attachments track by $index"><td><span><span class="glyphicon glyphicon-file"></span> {{attachment.storageFile.fileName}}</span></td><td></td><td><button ng-if="!vm.viewonly" type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteAttachment(vm.question.answer, attachment)" data-translate="entity.action.delete">Delete</button></td></tr></tbody></table></div><div ng-if="vm.question.allowsAddingAttachments && !vm.viewonly"><button class="btn btn-primary" ng-click="vm.addAttachment(vm.question.answer)"><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span></button></div><ng-include src="\'app/components/questionnaire-answer-question/anomaly-category-select.html\'"></ng-include>');
$templateCache.put('app/components/questionnaire-answer-multi-question/questionnaire-answer-multi-question.html','<div ng-switch="vm.question.renderType"><div ng-switch-when="DROPDOWN"><select ng-model="vm.dropDownSelectedOption" ng-options="opt as opt.name for opt in vm.question.options | orderBy:\'listIndex\' track by opt.id" ng-disabled="vm.viewonly" ng-change="vm.dropdownSelectionChange()" class="form-control"><option value="null"></option></select></div><div ng-switch-when="CHECKBOX"><ul class="list-unstyled"><li ng-repeat="opt in vm.question.options | orderBy: \'listIndex\'"><label class="checkbox-inline"><input type="checkbox" name="multicheck" ng-model="opt.selected" ng-disabled="vm.viewonly" ng-change="vm.checkBoxSelectionChange()"> {{opt.name}}</label></li></ul></div><div ng-switch-when="RADIOBUTTON"><div class="btn-group multi-question-radio-group"><label class="btn btn-primary" ng-click="vm.radioButtonChange()" ng-repeat="opt in vm.question.options | orderBy: \'listIndex\'" ng-model="vm.radioButtonSelectedOptionId" uib-btn-radio="{{opt.id}}" ng-disabled="vm.viewonly">{{opt.name}}</label></div></div><div ng-switch-when="SINGLE_BUTTON"><button type="button" class="btn btn-primary" ng-click="vm.singleButtonClick()" ng-disabled="vm.viewonly">{{vm.question.options[vm.singleButtonSelectedIndex].name}}</button></div><div ng-switch-default=""><p>default</p></div></div><hr><div><table class="table table-ticketmaterial"><tbody><tr ng-repeat="attachment in vm.question.answer.attachments track by $index"><td><span><span class="glyphicon glyphicon-file"></span> {{attachment.storageFile.fileName}}</span></td><td></td><td><button ng-if="!vm.viewonly" type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteAttachment(vm.question.answer, attachment)" data-translate="entity.action.delete">Delete</button></td></tr></tbody></table></div><div ng-if="vm.question.allowsAddingAttachments && !vm.viewonly"><button class="btn btn-primary" ng-click="vm.addAttachment(vm.question.answer)"><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span></button></div><ng-include src="\'app/components/questionnaire-answer-question/anomaly-category-select.html\'"></ng-include>');
$templateCache.put('app/components/questionnaire-answer-question/anomaly-category-select.html','<div ng-if="vm.questionnaire.questionnaireType==\'NORMAL\' && vm.questionnaire.anomalyCategories.length>0" class="form-group anomaly-category-div"><label class="control-label" data-translate="abcQualityMatchApp.questionnaire.anomalyCategory" ng-if="!vm.viewonly">AnomalyCategories</label><select ng-model="vm.question.answer.anomalyCategory" ng-change="vm.answerInputChange()" ng-if="!vm.viewonly" ng-options="anomalyCategory as anomalyCategory.name for anomalyCategory in vm.questionnaire.anomalyCategories | orderBy:\'listIndex\' track by anomalyCategory.id" class="form-control anomaly-category-select"><option value=""></option></select><div ng-if="vm.viewonly && vm.question.answer.anomalyCategory" class="text-muted"><label class="control-label" data-translate="abcQualityMatchApp.questionnaire.anomalyCategory">AnomalyCategory</label>: <span>{{vm.question.answer.anomalyCategory.name}}</span></div></div>');
$templateCache.put('app/components/questionnaire-answer-question/questionnaire-answer-question.html','<div class="row question-row" ng-class="{\'bg-danger\': vm.question.answer.anomaly}"><div class="half-clear-column"><label class="control-label" ng-class="{\'required\': vm.question.required}" id="question{{vm.question.id}}">{{vm.question.title}}</label><div class="question-meta-info"><div ng-if="vm.question.standardReference" class="text-muted"><span data-translate="question.standardReference">Standard reference</span> <span>{{vm.question.standardReference}}</span></div><div ng-if="vm.question.text" class="text-muted"><span>{{vm.question.text}}</span></div></div></div><div class="half-column questionnaire-answer-question"><div ng-switch="vm.question.questionType"><div ng-switch-when="integer"><questionnaire-answer-integer-question question="vm.question" viewonly="vm.viewonly" questionnaire="vm.questionnaire" on-answer-change="vm.onAnswerChange()" edit-form="vm.editForm"></div><div ng-switch-when="decimal"><questionnaire-answer-decimal-question question="vm.question" viewonly="vm.viewonly" questionnaire="vm.questionnaire" on-answer-change="vm.onAnswerChange()" edit-form="vm.editForm"></div><div ng-switch-when="freetext"><questionnaire-answer-freetext-question question="vm.question" viewonly="vm.viewonly" questionnaire="vm.questionnaire" on-answer-change="vm.onAnswerChange()" edit-form="vm.editForm"></div><div ng-switch-when="multi"><questionnaire-answer-multi-question question="vm.question" viewonly="vm.viewonly" questionnaire="vm.questionnaire" on-answer-change="vm.onAnswerChange()" edit-form="vm.editForm"></div><div ng-switch-default=""></div></div></div><div ng-repeat="question in vm.comparisons" ng-switch="question.questionType" ng-if="question.id == vm.question.id" class="half-column" style="padding-left: 2em"><div ng-switch-when="integer"><questionnaire-answer-integer-question questionnaire="vm.questionnaire" question="question" viewonly="true"></div><div ng-switch-when="decimal"><questionnaire-answer-decimal-question questionnaire="vm.questionnaire" question="question" viewonly="true"></div><div ng-switch-when="freetext"><questionnaire-answer-freetext-question questionnaire="vm.questionnaire" question="question" viewonly="true"></div><div ng-switch-when="multi"><questionnaire-answer-multi-question questionnaire="vm.questionnaire" question="question" viewonly="true"></div><div ng-switch-default=""></div></div></div>');
$templateCache.put('app/components/questionnaire-answer-section/questionnaire-answer-section.html','<div class="questionnaireAnswerSection" ng-cloak=""><div class="form-group questionnaireAnswerQuestion" ng-repeat="question in $ctrl.section.questions | orderBy:\'listIndex\'"><questionnaire-answer-question question="question" comparisons="$ctrl.comparisons" viewonly="$ctrl.viewonly" on-answer-change="$ctrl.onAnswerChange()" questionnaire="$ctrl.questionnaire" edit-form="$ctrl.editForm"><hr ng-if="!$last"></div></div>');
$templateCache.put('app/components/questionnaire-answers-view/questionnaire-answers-view.component.html','<div class="questionnaire-answer questionnaire-form"><div class="panel panel-default"><div class="panel-body" ng-repeat="section in vm.questionnaireAnswer.questionnaire.sections"><questionnaire-answer-section section="section" questionnaire-type="$ctrl.questionnaireAnswer.questionnaire.questionnaireType" comparisons="null" viewonly="true"></div></div></div>');
$templateCache.put('app/components/ticket-material/ticket-material.component.html','<table class="table table-ticketmaterial-view"><tbody><tr ng-repeat="material in $ctrl.ticketMaterials | orderBy: \'listIndex\'"><td><a ng-if="material.linkUrl" ng-href="{{material.linkUrl | ticketMaterialLinkUrlAddProtocoll}}" target="_blank" title="{{material.linkUrl}}" class="materialLink"><span class="glyphicon glyphicon-new-window"></span> {{material.linkUrl}} </a><a ng-if="material.fileContentContentType" ng-href="/api/ticket-materials/download/{{material.id}}/{{material.name | ticketMaterialEncodeFilename}}?inline=true" target="_blank"><span class="glyphicon glyphicon-file"></span> {{material.name}}</a></td><td><a ng-if="material.fileContentContentType" ng-href="/api/ticket-materials/download/{{material.id}}/{{material.name | ticketMaterialEncodeFilename}}?inline=false"><span class="glyphicon glyphicon-save"></span> <span data-translate="abcQualityMatchApp.ticket.materialDownLoadLink">download</span></a></td></tr></tbody></table>');
$templateCache.put('app/components/user-select/user-select-component.html','<div class="anomaly-event-select has-feedback"><input type="text" autocomplete="off" ng-model="$ctrl.user" placeholder="{{$ctrl.placeholder}}" uib-typeahead="user as user | fullUserName for user in $ctrl.getUsers($viewValue)" typeahead-on-select="$ctrl.setSelected()" typeahead-loading="loadingUsers" typeahead-no-results="noResults" typeahead-wait-ms="150" typeahead-editable="false" typeahead-focus-first="false" class="form-control" ng-disabled="$ctrl.viewonly"> <i ng-show="loadingUsers" class="glyphicon glyphicon-refresh spinner form-control-feedback"></i> <i ng-show="!loadingUsers" class="glyphicon glyphicon-user search form-control-feedback"></i></div>');
$templateCache.put('app/components/users-multiple-select/users-multiple-select-component.html','<table class="table table-condensed table-hover users-multiple-select"><tbody><tr ng-repeat="user in $ctrl.users track by user.id"><td>{{user|fullUserName}}</td><td><button type="button" class="btn btn-danger btn-sm" ng-click="$ctrl.deleteUser($index)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete">Delete</span></button></td></tr></tbody><tfoot><tr><td colspan="2"><user-select user="$ctrl.newUser" on-select="$ctrl.addUser()"></user-select></td></tr></tfoot></table>');
$templateCache.put('app/components/util/confirmed-delete-dialog.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeDialog()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p ng-show="vm.customMessage">{{vm.customMessage}}</p><p ng-hide="vm.customMessage" data-translate="entity.delete.genericConfirmQuestion">Are you sure you want to delete this?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeDialog()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-danger" ng-click="vm.confirmDelete()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div>');
$templateCache.put('app/components/util/confirmed-undelete-dialog.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeDialog()">&times;</button><h4 class="modal-title" data-translate="entity.undelete.title">Confirm undelete</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>{{vm.customMessage}}</p><p ng-hide="vm.customMessage" data-translate="entity.undelete.genericConfirmQuestion">Are you sure you want to undelete this?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeDialog()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-warning" ng-click="vm.confirmUndelete()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp;<span data-translate="entity.action.undelete">Delete</span></button></div></div>');
$templateCache.put('app/document/document-tree/document-tree.html','<div class="document"><h2 data-translate="abcQualityMatchApp.documentFolder.home.managementTitle">Document management</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" type="button" ng-click="vm.openCreateNewFolderDialog()"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.document.addFolder">Add folder</span></button></div></div></div><br><form class="listing-filters"><fieldset><div class="form-group has-feedback"><input class="form-control" type="text" ng-model="vm.searchTerms" ng-change="vm.filterBySearchTerms(vm.searchTerms)" ng-model-options="{ debounce: 1000 }"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div><br><div><span has-any-authority="ROLE_COMPANY_ADMIN"><input type="checkbox" id="showDeleted" ng-model="vm.showDeleted" ng-change="vm.reload()"><label for="showDeleted"><span data-translate="abcQualityMatchApp.document.showDeleted"></span></label></span></div></fieldset></form><div class="table-responsive"><table class="jh-table table table-hover treeTable"><thead><tr><th><span data-translate="abcQualityMatchApp.documentFile.name">name</span></th><th><span data-translate="abcQualityMatchApp.documentFile.state">state</span></th><th><span data-translate="abcQualityMatchApp.documentFile.publishedDate">publishedDate</span></th><th><span data-translate="abcQualityMatchApp.documentFile.version">version</span></th><th><span data-translate="abcQualityMatchApp.documentFile.validityEndDate">validityEndDate</span></th><th><span data-translate="abcQualityMatchApp.documentFile.maintainers">maintainers</span></th><th><span data-translate="abcQualityMatchApp.documentFile.classification">classification</span></th><th></th></tr></thead><tbody ng-repeat="fsItem in vm.fsItems track by fsItem.trackingId" data-nestinglevel="{{fsItem.nestingLevel}}"><tr class="folder" ng-if="fsItem.rowType == \'folder\' && ((!vm.searchTerms && (fsItem.nestingLevel == 0 || fsItem.parentFolder.open)) || (vm.searchTerms && fsItem.filterMatch || fsItem.parentFolder.open))"><td class="folderName"><span ng-click="vm.folderClick(fsItem)" style="margin-left:{{fsItem.nestingLevel * 1.2}}em"><span class="glyphicon" ng-class="{\'glyphicon-folder-close\': !fsItem.open, \'glyphicon-folder-open\': fsItem.open}"></span>&nbsp; <span class="fsItemName" ng-class="{\'deleted\': fsItem.deleted}" ng-bind-html="fsItem.name | highlightMatch:vm.searchTerms"></span></span></td><td colspan="6"></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button class="btn btn-info" ng-if="!fsItem.deleted && fsItem.writable" ng-click="vm.openCreateNewFileDialog(fsItem.id)"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.document.addFile">Add file</span></button> <button ng-click="vm.openEditFolderDialog(fsItem.id)" ng-if="!fsItem.deleted && fsItem.writable" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="button" ng-if="!fsItem.deleted && fsItem.writable" confirmed-delete="vm.deleteDocumentFolder(fsItem.id)" confirmed-delete-message="abcQualityMatchApp.documentFolder.delete.question" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button> <button class="btn btn-warning" ng-if="fsItem.deleted && fsItem.writable" ng-disabled="fsItem.parentFolder.deleted" has-any-authority="ROLE_COMPANY_ADMIN, DOCUMENT_ADMIN" confirmed-undelete="vm.undeleteFolder(fsItem.id)" confirmed-undelete-message="abcQualityMatchApp.documentFolder.undelete.question"><span class="glyphicon glyphicon-asterisk"></span> <span data-translate="entity.action.undelete">undelete</span></button></div></td></tr><tr ng-if="fsItem.rowType == \'file\' && ((fsItem.parentFolder.open) || (vm.searchTerms && fsItem.filterMatch))"><td class="fileName"><span style="padding-left:{{(fsItem.parentFolder.nestingLevel +1) * 1.2}}em"><a class="btn btn-link" ng-href="/api/document-files/download/{{fsItem.id}}/{{fsItem.fileName| documentFileEncodeFilename}}?inline=true" target="_blank" title="{{\'entity.action.view\' | translate}}"><span class="glyphicon glyphicon-file"></span>&nbsp; <span class="fsItemName" ng-class="{\'deleted\': fsItem.deleted}" ng-bind-html="fsItem.name | highlightMatch:vm.searchTerms"></span></a></span></td><td>{{\'abcQualityMatchApp.documentFile.states.\' + fsItem.state | translate}}</td><td>{{fsItem.publishedDate | date: \'shortDate\'}}</td><td>{{fsItem.version}}</td><td><span ng-if="fsItem.validityState == \'PAST_WARN_DATE\' " class="text-warning">{{fsItem.validityEndDate | date: \'shortDate\'}} <span class="glyphicon glyphicon-warning-sign"></span> </span><span ng-if="fsItem.validityState == \'EXPIRED\' " class="text-danger">{{fsItem.validityEndDate | date: \'shortDate\'}} <span class="glyphicon glyphicon-alert"></span> </span><span ng-if="fsItem.validityState == \'VALID\' ">{{fsItem.validityEndDate | date: \'shortDate\'}}</span></td><td><ul class="list-unstyled"><li ng-repeat="user in fsItem.maintainers  | orderBy:\'lastName\' track by user.id">{{user|fullUserName}}</li></ul></td><td><span ng-bind-html="fsItem.classification | highlightMatch:vm.searchTerms"></span></td><td><div class="btn-group flex-btn-group-container"><a class="btn btn-primary btn-sm" ng-if="!fsItem.deleted && fsItem.parentFolder.writable" ui-sref="document-tree.file-versioning({rootVersionId: fsItem.rootVersionId})"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span> </a><button type="button" class="btn btn-danger btn-sm" ng-if="!fsItem.deleted && fsItem.parentFolder.writable" confirmed-delete="vm.deleteDocumentFile(fsItem.id)" confirmed-delete-message="abcQualityMatchApp.documentFile.delete.question"><span class="glyphicon glyphicon-remove-circle"></span> <span data-translate="entity.action.delete">Delete</span></button> <button class="btn btn-warning" ng-if="fsItem.deleted && fsItem.parentFolder.writable" ng-disabled="fsItem.parentFolder.deleted" confirmed-undelete="vm.undeleteFile(fsItem.id)" confirmed-undelete-message="abcQualityMatchApp.documentFile.undelete.question"><span class="glyphicon glyphicon-asterisk"></span> <span data-translate="entity.action.undelete">undelete</span></button></div></td></tr></tbody><tfoot><tr ng-if="vm.searchTerms && vm.searchMatchCount > 0"><td colspan="7"><span class="text-muted" data-translate="abcQualityMatchApp.document.searchResults" data-translate-values="{searchTerms: \'{{vm.searchTerms}}\'}"></span><br><button type="button" class="btn btn-default btn-sm" ng-click="vm.filterBySearchTerms(\'\')"><span data-translate="abcQualityMatchApp.document.clearSearch"></span></button></td></tr><tr ng-if="vm.searchTerms && vm.searchMatchCount === 0"><td colspan="7"><span class="text-muted" data-translate="abcQualityMatchApp.document.searchNoResults" data-translate-values="{searchTerms: \'{{vm.searchTerms}}\'}"></span><br><button type="button" class="btn btn-default btn-sm" ng-click="vm.filterBySearchTerms(\'\')"><span data-translate="abcQualityMatchApp.document.clearSearch"></span></button></td></tr></tfoot></table></div></div>');
$templateCache.put('app/document/notable-documents-list-component/notable-documents-list-component.html','<div class="dashboard-widget panel panel-default document"><div class="dashboard-wigdet-header panel-heading"><h4 class="panel-title" data-translate="abcQualityMatchApp.document.notableView.title"></h4></div><div class="dashboard widget-body panel-body"><div class="table-responsive uib-dropdown-friendly"><table class="table table-hover table-condensed notable-files-table"><tbody><tr><th><span data-translate="abcQualityMatchApp.document.notableView.newPublishedFiles">newPublishedFiles</span></th><th><span data-translate="abcQualityMatchApp.documentFile.publishedDate">publishedDate</span></th><th>&nbsp;</th></tr><tr ng-repeat="file in vm.notableFiles.recentlyPublished"><td class="fileName"><span><a class="btn btn-link" ng-href="/api/document-files/download/{{file.id}}/{{file.fileName| documentFileEncodeFilename}}?inline=true" target="_blank" title="{{\'entity.action.view\' | translate}}"><span class="glyphicon glyphicon-file"></span>&nbsp; <span class="fsItemName">{{file.name}}</span></a></span></td><td>{{file.publishedDate | date:\'shortDate\'}}</td><td></td></tr><tr ng-if="vm.notableFiles.newPublishedFiles.length == 0"><td colspan="2"><span class="text-muted" data-translate="abcQualityMatchApp.document.notableView.noNewFiles"></span></td></tr></tbody><tbody><tr><th><span data-translate="abcQualityMatchApp.document.notableView.expiringFiles">expiringFiles</span></th><th><span data-translate="abcQualityMatchApp.documentFile.validityEndDate">validityEndDate</span></th><th>&nbsp;</th></tr><tr ng-repeat="file in vm.notableFiles.expiring"><td class="fileName"><span><a class="btn btn-link" ng-href="/api/document-files/download/{{file.id}}/{{file.fileName| documentFileEncodeFilename}}?inline=true" target="_blank" title="{{\'entity.action.view\' | translate}}"><span class="glyphicon glyphicon-file"></span>&nbsp; <span class="fsItemName">{{file.name}}</span></a></span></td><td><span ng-if="file.validityState == \'PAST_WARN_DATE\' " class="text-warning">{{file.validityEndDate | date: \'shortDate\'}} <span class="glyphicon glyphicon-warning-sign"></span> </span><span ng-if="file.validityState == \'EXPIRED\' " class="text-danger">{{file.validityEndDate | date: \'shortDate\'}} <span class="glyphicon glyphicon-alert"></span> </span><span ng-if="file.validityState == \'VALID\' ">{{file.validityEndDate | date: \'shortDate\'}}</span></td><td><a class="btn btn-primary btn-sm" ui-sref="document-tree.file-versioning({rootVersionId: file.rootVersionId, tab:\'current\'})"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></a></td></tr><tr ng-if="vm.notableFiles.expiring.length == 0"><td colspan="2"><span class="text-muted" data-translate="abcQualityMatchApp.document.notableView.noExpiringFiles"></span></td></tr></tbody><tbody><tr><th><span data-translate="abcQualityMatchApp.document.notableView.actionableFiles">actionableFiles</span></th><th><span data-translate="abcQualityMatchApp.documentFile.state">state</span></th><th>&nbsp;</th></tr><tr ng-repeat="file in vm.notableFiles.waitingInspection"><td class="fileName"><span><a class="btn btn-link" ng-href="/api/document-files/download/{{file.id}}/{{file.fileName| documentFileEncodeFilename}}?inline=true" target="_blank" title="{{\'entity.action.view\' | translate}}"><span class="glyphicon glyphicon-file"></span>&nbsp; <span class="fsItemName">{{file.name}}</span></a></span></td><td>{{\'abcQualityMatchApp.documentFile.states.\' + file.state | translate}}</td><td><button class="btn btn-primary btn-sm" ng-click="vm.openStateChangeDialog(file, \'inspect\')"><span class="hidden-xs hidden-sm" data-translate="abcQualityMatchApp.document.inspect"></span></button></td></tr><tr ng-repeat="file in vm.notableFiles.waitingApproval"><td class="fileName"><span><a class="btn btn-link" ng-href="/api/document-files/download/{{file.id}}/{{file.fileName| documentFileEncodeFilename}}?inline=true" target="_blank" title="{{\'entity.action.view\' | translate}}"><span class="glyphicon glyphicon-file"></span>&nbsp; <span class="fsItemName">{{file.name}}</span></a></span></td><td>{{\'abcQualityMatchApp.documentFile.states.\' + file.state | translate}}</td><td><button class="btn btn-primary btn-sm" ng-click="vm.openStateChangeDialog(file, \'approve\')"><span class="hidden-xs hidden-sm" data-translate="abcQualityMatchApp.document.approve"></span></button></td></tr><tr ng-repeat="file in vm.notableFiles.waitingPublication"><td class="fileName"><span><a class="btn btn-link" ng-href="/api/document-files/download/{{file.id}}/{{file.fileName| documentFileEncodeFilename}}?inline=true" target="_blank" title="{{\'entity.action.view\' | translate}}"><span class="glyphicon glyphicon-file"></span>&nbsp; <span class="fsItemName">{{file.name}}</span></a></span></td><td>{{\'abcQualityMatchApp.documentFile.states.\' + file.state | translate}}</td><td><button class="btn btn-primary btn-sm" ng-click="vm.openStateChangeDialog(file, \'publish\')"><span class="hidden-xs hidden-sm" data-translate="abcQualityMatchApp.document.publish"></span></button></td></tr><tr ng-if="vm.notableFiles.waitingApproval.length == 0 && vm.notableFiles.waitingInspection.length == 0 && vm.notableFiles.waitingPublication.length == 0"><td colspan="2"><span class="text-muted" data-translate="abcQualityMatchApp.document.notableView.noActionableFiles"></span></td></tr></tbody></table></div></div></div><div class="dashboard-widget-footer panel-footer"></div>');
$templateCache.put('app/document/state-change-dialog/document-state-change-dialog.html','<div class="document document-edit-dialog"><form class="edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">{{\'abcQualityMatchApp.document.stateChangeDialogTitle.\' + vm.useCase +\'.title\' | translate}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.documentFile.file">fileName</span></dt><dd><span><a class="btn btn-link" ng-href="/api/document-files/download/{{vm.documentFile.id}}/{{vm.documentFile.fileName| documentFileEncodeFilename}}?inline=true" target="_blank" title="{{\'entity.action.view\' | translate}}">{{vm.documentFile.fileName}} </a></span><a class="btn btn-default btn-sm" ng-href="/api/document-files/download/{{vm.documentFile.id}}/{{vm.documentFile.fileName| documentFileEncodeFilename}}?inline=false"><span class="glyphicon glyphicon-save"></span> <span data-translate="abcQualityMatchApp.document.documentFileDownLoadLink">download</span></a></dd><dt><span data-translate="abcQualityMatchApp.documentFile.name">Name</span></dt><dd><span>{{vm.documentFile.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.description">description</span></dt><dd><span>{{vm.documentFile.description}}</span></dd><dt>&nbsp;</dt><dd><button type="button" ng-disabled="vm.isSaving" class="btn btn-primary" ng-click="vm.save()"><span class="glyphicon glyphicon-ok"></span> <span>{{\'abcQualityMatchApp.document.stateChangeDialogTitle.\' + vm.useCase + \'.execute\' | translate}}</span></button></dd></dl></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="entity.action.cancel">Cancel</span></button></div></form></div>');
$templateCache.put('app/information/anomaly/anomaly.html','<div class="anomaly-event"><h2 data-translate="abcQualityMatchApp.anomalyEvent.home.title">Information</h2><jhi-alert></jhi-alert><form ng-submit="vm.refreshSearch()" class="listing-filters"><fieldset><legend data-translate="abcQualityMatchApp.anomalyEvent.findByDateLimits"></legend><div class="timespan-limit"><div class="input-group date-select-container"><input id="field_fromDate" type="text" class="form-control" name="fromDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.filteringFromDate" is-open="vm.datePickerOpenStatus.fromDate" ng-change="vm.refreshSearch()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div>-<div class="input-group date-select-container"><input id="field_toDate" type="text" class="form-control" name="toDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.filteringToDate" is-open="vm.datePickerOpenStatus.toDate" ng-change="vm.refreshSearch()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></fieldset><fieldset><legend data-translate="abcQualityMatchApp.anomalyEvent.findByTextLegend"></legend><div class="seachField"><input class="form-control" type="text" ng-model="vm.filtering.searchTerm" id="seachTerm" placeholder="{{\'abcQualityMatchApp.anomalyEvent.findByText\'|translate }}"> <button type="submit" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-search"></span></button></div></fieldset><fieldset><legend data-translate="abcQualityMatchApp.anomalyEvent.findByRestrictionsLegend"></legend><div><user-select user="vm.filterAnswerAuthorUser" placeholder="{{\'abcQualityMatchApp.anomalyEvent.findByUser\'| translate}}"></user-select></div><div class="select-container"><select class="form-control" id="field_filteringQuestionnaire" name="filteringQuestionnaire" ng-model="vm.filtering.questionnaireId" ng-change="vm.refreshSearch()"><option value="" class="placeholder" data-translate="abcQualityMatchApp.anomalyEvent.findByQuestionnaire">questionnaire</option><option ng-repeat="questionnaire in vm.allQuestionnaires" value="{{questionnaire.id}}">{{questionnaire.title}}</option></select></div><div class="select-container"><select class="form-control" id="field_filteringTask" name="filteringTask" ng-model="vm.filtering.taskId" ng-change="vm.refreshSearch()"><option value="" class="placeholder" data-translate="abcQualityMatchApp.anomalyEvent.findByTask">task</option><option ng-repeat="task in vm.tasks" value="{{task.id}}">{{task.title}}</option></select></div></fieldset></form><div class="table-responsive uib-dropdown-friendly"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th></th><th jh-sort-by="(answer_time)"><span data-translate="abcQualityMatchApp.anomalyEvent.answerTime">answertime</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(answerer)"><span data-translate="abcQualityMatchApp.anomalyEvent.answerer">answerer</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(ticket_title)"><span data-translate="abcQualityMatchApp.anomalyEvent.ticketTitle">Ticket</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(questionnaire_title)"><span data-translate="abcQualityMatchApp.anomalyEvent.questionnaireTitle">Questionnaire</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(question_title)"><span data-translate="abcQualityMatchApp.anomalyEvent.questionTitle">questiontitle</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(answer_value)"><span data-translate="abcQualityMatchApp.anomalyEvent.value">value</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(anomaly_category_name)"><span data-translate="abcQualityMatchApp.anomalyEvent.anomalyCategory">value</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(reported)"><span data-translate="abcQualityMatchApp.anomalyEvent.reported.title">reported</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="anomaly in vm.anomaly"><td><input type="checkbox" ng-model="anomaly.selectionChecked"></td><td>{{anomaly.answerTime| date:\'short\'}}</td><td>{{anomaly.answerer}}</td><td>{{anomaly.ticketTitle}}</td><td>{{anomaly.questionnaireTitle}}</td><td>{{anomaly.questionTitle}}</td><td>{{anomaly.value}}</td><td>{{anomaly.anomalyCategoryName}}</td><td>{{anomaly|anomalyReported}}</td><td class="text-right"><div class="btn-group flex-btn-group-container" ng-if="anomaly.reported"><div class="btn-group" uib-dropdown><button id="{{\'newAnomalyInformationButton\' + anomaly.row}}" class="btn btn-sm btn-primary" uib-dropdown-toggle><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.informationEvent.new">Tee ilmoitus </span><span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="{{\'newAnomalyInformationButton\' + anomaly.row}}"><li role="menuitem" ng-repeat="questionnaire in vm.informationQuestionnaires track by questionnaire.id"><a ui-sref="newInformation({questionnaireId: questionnaire.id, anomalyQuestionnaireAnswerId: anomaly.qaId, anomalyAnswerId: anomaly.answerId, returnToView: \'anomaly\', questionnaireSectionTitle: anomaly.questionnaireSectionTitle, questionTitle:anomaly.questionTitle})">{{questionnaire.title}}</a></li></ul></div><button class="btn btn-sm btn-danger" ng-click="vm.reject(anomaly.qaId, anomaly.answerId)"><span class="glyphicon glyphicon-remove-circle"></span> <span data-translate="abcQualityMatchApp.anomalyEvent.acknowledge">Acknowledge</span></button></div></td></tr></tbody><tfoot><tr><td colspan="9"><button class="btn btn-sm btn-default to-root-cause-analysis-button" ng-click="vm.createRootCauseAnalysisForSelected()" has-any-authority="ROLE_COMPANY_ADMIN,ROOT_CAUSE_ANALYSIS"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.information.createRootCauseAnalysisForSelected">do root cause analysis</span></button> <a download ng-href="/api/questionnaire-answers/anomaly-events-pdf{{vm.pdfDownloadParameters | toQueryString}}"><span class="glyphicon glyphicon-download-alt"></span> <span data-translate="abcQualityMatchApp.anomalyEvent.downloadPdfLink">pdf download</span></a> <a download ng-href="api/questionnaire-answers/anomaly-events-spreadsheet{{vm.pdfDownloadParameters | toQueryString }}"><span class="glyphicon glyphicon-download-alt"></span> <span data-translate="abcQualityMatchApp.anomalyEvent.downloadExcelLink"></span></a></td></tr></tfoot></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-6"><span class="abc img-responsive img-rounded"></span></div><div class="col-md-6"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-6"><span class="abc img-responsive img-rounded"></span></div><div class="col-md-6"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div id="page_top" class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img ng-if="vm.hasLogo" class="logo-img" ng-src="{{vm.logoUrl}}" alt="logo"> <img ng-if="!vm.hasLogo" class="logo-img" ng-src="{{vm.defaultLogoUrl}}" alt="logo"> <span class="navbar-brand-name hidden-xs" data-translate="global.title">ABC QualityMatch</span> <span class="navbar-version hidden-xs" ng-show="{{ENV === \'dev\'}}">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ng-switch-when="true" has-authority="ROLE_ADMIN"><select ng-change="companySelected($root.selectedCompany)" class="form-control" ng-model="$root.selectedCompany" ng-options="company.name for company in $root.userCompanies"></select></li><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" ng-show="{{ENV === \'dev\'}}"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'functions_menu\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="functions_menu"><span><span class="glyphicon glyphicon-th-list"></span> <span data-translate="global.menu.functions.main">Functions </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="task" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.functions.task">Task management</span></a></li><li ui-sref-active="active"><a ui-sref="task-list" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.functions.task-list">Task List</span></a></li><li class="divider" has-any-authority="ROLE_COMPANY_ADMIN,VERIFICATION,VERIFICATION_BY_PRODUCT_LINE"></li><li ui-sref-active="active" has-any-authority="ROLE_COMPANY_ADMIN,VERIFICATION,VERIFICATION_BY_PRODUCT_LINE"><a ui-sref="task-verification-list" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.functions.task-verification-list">Task Verification List</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_COMPANY_ADMIN,VERIFICATION,VERIFICATION_BY_PRODUCT_LINE,TASK_EXECUTIONS_VIEW"><a ui-sref="task-execution-counts" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.functions.task-execution-counts">Task execution counts</span></a></li><li class="divider"></li><li ui-sref-active="active"><a ui-sref="information" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.functions.information">Information management</span></a></li><li ui-sref-active="active"><a ui-sref="anomaly" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.functions.anomaly">Anomaly management</span></a></li><li class="divider" has-any-authority="ROLE_COMPANY_ADMIN,PROJECT"></li><li ui-sref-active="active" has-any-authority="ROLE_COMPANY_ADMIN,PROJECT"><a ui-sref="project" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.functions.projects">Projects</span></a></li><li class="divider" has-any-authority="ROLE_COMPANY_ADMIN,ROOT_CAUSE_ANALYSIS"></li><li ui-sref-active="active" has-any-authority="ROLE_COMPANY_ADMIN,ROOT_CAUSE_ANALYSIS"><a ui-sref="root-cause-analysis" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.functions.rootCauseAnalysis">Root Cause Analysis</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'report_menu\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" has-any-authority="ROLE_COMPANY_ADMIN,REPORT"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="report_menu"><span><span class="glyphicon glyphicon-th-list"></span> <span data-translate="global.menu.reports.main">Reports </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.reports.home">Home</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'document_menu\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="document_menu"><span><span class="glyphicon glyphicon-th-list"></span> <span data-translate="global.menu.documents.main">Documents </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="document-tree-view" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-folder-close"></span>&nbsp; <span data-translate="global.menu.documents.home">Home</span></a></li><li ui-sref-active="active"><a ui-sref="document-tree" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-folder-close"></span>&nbsp; <span data-translate="global.menu.documents.tree-edit">tree edit</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'training_menu\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="training-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span data-translate="global.menu.training.main">Training </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="trainee-available" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.training.available"></span></a></li><li ui-sref-active="active"><a ui-sref="trainee-records" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.training.userTrainingRecord"></span></a></li><li class="divider" has-any-authority="ROLE_COMPANY_ADMIN,TRAINING_MANAGEMENT"></li><li ui-sref-active="active" has-any-authority="ROLE_COMPANY_ADMIN,TRAINING_MANAGEMENT"><a ui-sref="training-record" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.training.trainingRecordMangement">Training Record</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_COMPANY_ADMIN,TRAINING_MANAGEMENT"><a ui-sref="training-requirements" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.training.trainingRequirements">Training Requirements</span></a></li><li class="divider" has-any-authority="ROLE_COMPANY_ADMIN,TRAINING_MANAGEMENT"></li><li ui-sref-active="active" has-any-authority="ROLE_COMPANY_ADMIN,TRAINING_MANAGEMENT"><a ui-sref="training-event" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.training.trainingEventMangement">Training Events</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_COMPANY_ADMIN,TRAINING_MANAGEMENT"><a ui-sref="training" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span data-translate="global.menu.training.trainingManagement">Training</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'company_admin\')}" ng-switch-when="true" has-authority="ROLE_COMPANY_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="company-admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span data-translate="global.menu.company_admin.main">Company Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.company_admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="user-group" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.company_admin.userGroup">User Group</span></a></li><li class="divider"></li><li ui-sref-active="active"><a ui-sref="factory" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span> <span data-translate="global.menu.company_admin.factory">Factory</span></a></li><li ui-sref-active="active"><a ui-sref="production-unit" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.company_admin.productionUnit">Production Unit</span></a></li><li ui-sref-active="active"><a ui-sref="product-line" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.company_admin.productLine">Product Line</span></a></li><li ui-sref-active="active"><a ui-sref="product" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.company_admin.product">Product</span></a></li><li ui-sref-active="active"><a ui-sref="reason-code" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.company_admin.reasonCode">Reason Code</span></a></li><li class="divider"></li><li ui-sref-active="active"><a ui-sref="ticket-state({ticketType:\'INFORMATION\'})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.company_admin.informationWorkflow">Information Workflow</span></a></li><li ui-sref-active="active"><a ui-sref="issue-significance" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.company_admin.issueSignificance">Issue Significance</span></a></li><li class="divider"></li><li ui-sref-active="active"><a ui-sref="ticket-state({ticketType:\'TASK\'})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.company_admin.taskWorkflow">Task Workflow</span></a></li><li ui-sref-active="active"><a ui-sref="ticket-state({ticketType:\'PROJECT\'})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.company_admin.projectWorkflow">Project Workflow</span></a></li><li ui-sref-active="active"><a ui-sref="ticket-state({ticketType:\'PROJECT_PHASE\'})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.company_admin.projectPhaseWorkflow">Projectphase Workflow</span></a></li><li ui-sref-active="active"><a ui-sref="root-cause-analysis-factor" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.company_admin.rootCauseAnalysisFactor">Root Cause Analysis Factor</span></a></li><li class="divider"></li><li ui-sref-active="active"><a ui-sref="questionnaire-company({companyId:$root.getSelectedCompany().id})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.company_admin.questionnaires">Questionnaires</span></a></li><li ui-sref-active="active"><a ui-sref="anomaly-category" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.anomalyCategory">Anomaly Category</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="company" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.admin.companyManagement">Company management</span></a></li><li ui-sref-active="active"><a ui-sref="questionnaire-admin" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.templateQuestionnaires">template Questionnaires</span></a></li><li ui-sref-active="active"><a ui-sref="questionnaire-group" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.admin.questionnaireGroup">Questionnaire Group</span></a></li><li class="divider"></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>{{vm.currentAccount | fullUserName}}</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li class="divider"></li><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li><li ng-if="false" ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/project/project/project-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.project.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.project.delete.question" translate-values="{id: \'{{vm.project.id}}\'}">Are you sure you want to delete this Project?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/project/project/project-detail.html','<div><h2><span data-translate="abcQualityMatchApp.project.detail.title">Project</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.project.detail.title">Title</span></dt><dd>{{vm.project.ticket.title}}</dd><dt><span data-translate="abcQualityMatchApp.project.description">Description</span></dt><dd>{{vm.project.ticket.description}}</dd><dt><span data-translate="abcQualityMatchApp.ticket.materials">Material</span></dt><dd><div><ticket-material ticket="vm.project.ticket"></ticket-material></div></dd><dt><span data-translate="abcQualityMatchApp.project.startPoint">Start Point</span></dt><dd><span>{{vm.project.startPoint}}</span></dd><dt><span data-translate="abcQualityMatchApp.project.goal">Goal</span></dt><dd><span>{{vm.project.goal}}</span></dd><dt><span data-translate="abcQualityMatchApp.project.startDate">Start Date</span></dt><dd><span>{{vm.project.startDate| date:\'mediumDate\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.project.endDate">End Date</span></dt><dd><span>{{vm.project.endDate| date:\'mediumDate\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.project.doneTime">Done Time</span></dt><dd><span>{{vm.project.ticket.doneTime | date:\'short\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.ticket.assignedTo">Assigned to</span></dt><dd>{{vm.project.ticket.assignedTo| fullUserName}}</dd><dt><span data-translate="abcQualityMatchApp.ticket.assignedToUserGroup">Assigned to Usergroup</span></dt><dd>{{vm.project.ticket.assignedToUserGroup.name}}</dd><dt><span data-translate="abcQualityMatchApp.ticket.state">State</span></dt><dd>{{vm.project.ticket.state.name}}</dd><div ng-if="vm.project.information"><dt><span data-translate="abcQualityMatchApp.project.information">Information</span></dt><dd><br><br><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.information.title">Title</span></dt><dd>{{vm.project.information.ticket.title}}</dd><dt><span data-translate="abcQualityMatchApp.ticket.description">Description</span></dt><dd>{{vm.project.information.ticket.description}}</dd></dl></dd></div><dt><span data-translate="abcQualityMatchApp.project.phaseSituation">Phase situation</span></dt><dd>{{vm.project.doneCount}}/{{vm.project.allCount}}</dd><dt><span data-translate="abcQualityMatchApp.project.phases">Phases</span></dt><dd><button type="button" ui-sref="project-detail.phase-new({id:vm.project.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs hidden-sm" data-translate="abcQualityMatchApp.project.addPhase">Add phase</span></button><br><br><div ng-repeat="phase in vm.phases track by phase.id"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.projectPhase.detail.title">Title</span></dt><dd>{{phase.ticket.title}} <button type="button" ui-sref="project-detail.phase-edit({id:vm.project.id, phaseId:phase.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button> <button type="submit" confirmed-delete="vm.deletePhase(phase)" confirmed-delete-message="abcQualityMatchApp.projectPhase.delete.question" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></dd><dt><span data-translate="abcQualityMatchApp.projectPhase.description">Description</span></dt><dd>{{phase.ticket.description}}</dd><dt><span data-translate="abcQualityMatchApp.projectPhase.startPoint">Start Point</span></dt><dd><span>{{phase.startPoint}}</span></dd><dt><span data-translate="abcQualityMatchApp.projectPhase.goal">Goal</span></dt><dd><span>{{phase.goal}}</span></dd><dt><span data-translate="abcQualityMatchApp.projectPhase.startDate">Start Date</span></dt><dd><span>{{phase.startDate| date:\'mediumDate\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.projectPhase.endDate">End Date</span></dt><dd><span>{{phase.endDate| date:\'mediumDate\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.project.doneTime">Done Time</span></dt><dd><span>{{phase.ticket.doneTime| date:\'short\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.ticket.assignedTo">Assigned to</span></dt><dd>{{phase.ticket.assignedTo| fullUserName}}</dd><dt><span data-translate="abcQualityMatchApp.ticket.assignedToUserGroup">Assigned to Usergroup</span></dt><dd>{{phase.ticket.assignedToUserGroup.name}}</dd><dt><span data-translate="abcQualityMatchApp.ticket.state">State</span></dt><dd>{{phase.ticket.state.name}}</dd><dt><span data-translate="abcQualityMatchApp.projectPhase.taskSituation">Task situation</span></dt><dd>{{phase.doneCount}}/{{phase.allCount}}</dd><dt><span data-translate="abcQualityMatchApp.projectPhase.tasks">Tasks</span></dt><dd><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="abcQualityMatchApp.ticket.title">Title</span></th><th><span data-translate="abcQualityMatchApp.ticket.description">Description</span></th><th><span data-translate="abcQualityMatchApp.ticket.assignedTo">Assigned To</span></th><th><span data-translate="abcQualityMatchApp.ticket.assignedToUserGroup">Assigned To User Group</span></th><th><span data-translate="abcQualityMatchApp.task.start">Start</span></th><th><span data-translate="abcQualityMatchApp.task.end">End</span></th><th><span data-translate="abcQualityMatchApp.ticket.doneTime">Done Time</span></th><th><span data-translate="abcQualityMatchApp.ticket.state">State</span></th><th><span data-translate="abcQualityMatchApp.task.type">Type</span></th><th><button type="button" ui-sref="project-detail.task-new({id: vm.project.id, phaseId:phase.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs hidden-sm" data-translate="abcQualityMatchApp.project.addTask">Add task</span></button></th></tr></thead><tbody><tr ng-repeat="task in phase.tasks track by task.id"><td>{{task.mainTicket.title}}</td><td>{{task.mainTicket.description}}</td><td>{{task.mainTicket.assignedTo| fullUserName}}</td><td>{{task.mainTicket.assignedToUserGroup.name}}</td><td ng-if="task.allDay">{{task.start| date:\'shortDate\'}}</td><td ng-if="!task.allDay">{{task.start| date:\'short\'}}</td><td ng-if="task.allDay">{{task.end| date:\'shortDate\'}}</td><td ng-if="!task.allDay">{{task.end| date:\'short\'}}</td><td>{{task.mainTicket.doneTime | date: \'short\'}}</td><td>{{task.mainTicket.state.name}}</td><td ng-if="task.recurrence != null" data-translate="abcQualityMatchApp.task.recurringTask">Recurring</td><td ng-if="task.recurrence == null" data-translate="abcQualityMatchApp.task.singleTask">Normal</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ui-sref="project-detail.task-edit({id: vm.project.id, phaseId:phase.id, taskId:task.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button> <button type="button" ui-sref="project-detail.task-delete({id: vm.project.id, phaseId:phase.id, taskId:task.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></dd></dl></div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="project-detail.edit({id:vm.project.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/project/project/project-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectLabel" data-translate="abcQualityMatchApp.project.home.createOrEditLabel">Create or edit a Project</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group question-row"><label class="control-label required" data-translate="abcQualityMatchApp.project.detail.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.project.ticket.title" maxlength="255" required><div><p class="help-block" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group question-row"><label class="control-label" data-translate="abcQualityMatchApp.project.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.project.ticket.description" maxlength="600"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.ticket.materials">Materials</label><div><table class="table table-ticketmaterial"><tbody><tr ng-repeat="material in vm.ticketMaterials| orderBy: \'listIndex\'"><td><a ng-if="material.linkUrl" ng-href="{{material.linkUrl| ticketMaterialLinkUrlAddProtocoll}}" target="_blank" title="{{material.linkUrl}}" class="materialLink"><span class="glyphicon glyphicon-new-window"></span> {{material.linkUrl}} </a><a ng-if="!material.linkUrl" ng-href="/api/ticket-materials/download/{{material.id}}/{{material.name| ticketMaterialEncodeFilename}}?inline=true" target="_blank"><span class="glyphicon glyphicon-file"></span> {{material.name}}</a></td><td><a ng-if="!material.linkUrl" ng-href="/api/ticket-materials/download/{{material.id}}/{{material.name| ticketMaterialEncodeFilename}}?inline=false"><span class="glyphicon glyphicon-save"></span> <span data-translate="abcQualityMatchApp.ticket.materialDownLoadLink">download</span></a></td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteTicketMaterial(material)" data-translate="entity.action.delete">Delete</button></td></tr></tbody><tfoot><tr><td colspan="2"><div class="alert alert-info material-upload-alert" ng-show="vm.uploadingTicketMaterial"><div class="upload-spinner"></div><div><strong data-translate="abcQualityMatchApp.ticket.materialDownInProgressTitle">Uploading</strong><br><span data-translate="abcQualityMatchApp.ticket.materialDownInProgressMessage">Please wait</span></div></div><div class="alert alert-danger" ng-show="vm.selectedFileTooLarge"><span data-translate="abcQualityMatchApp.ticket.materialFileIsTooLargeMessage">File too large</span></div></td><td><div class="btn-group" uib-dropdown is-open="status.isopen"><button id="single-button" type="button" class="btn btn-primary btn-sm" uib-dropdown-toggle><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="single-button"><li role="menuitem" ngf-select ngf-change="vm.setFileContent($file, $invalidFiles)" ngf-max-size="20MB"><span class="btn" data-translate="abcQualityMatchApp.ticket.addTicketMaterialFileButton">add file</span></li><!--                                      <li role="menuitem" ng-click="vm.showAddMaterialLinkDialog()">\n                                                                                  <span class="btn" data-translate="abcQualityMatchApp.ticket.addTicketMaterialLinkButton">add link</span>\n                                                                              </li>--></ul></div></td></tr></tfoot></table></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.project.startPoint" for="field_startPoint">Start Point</label><input type="text" class="form-control" name="startPoint" id="field_startPoint" ng-model="vm.project.startPoint" maxlength="255"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.project.goal" for="field_goal">Goal</label><input type="text" class="form-control" name="goal" id="field_goal" ng-model="vm.project.goal" maxlength="255"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.project.startDate" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.project.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.project.endDate" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.project.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.project.doneTime" for="field_doneTime">Done Time</label><div class="input-group"><input id="field_doneTime" type="text" class="form-control" name="doneTime" datetime-picker="{{dateformat}}" ng-model="vm.project.ticket.doneTime" is-open="vm.datePickerOpenStatus.doneTime" timepicker-options="vm.picker.timepickerOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'doneTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group question-row"><label data-translate="abcQualityMatchApp.ticket.assignedTo" for="field_assignedTo">Assigned To</label><user-select id="field_assignedTo" user="vm.project.ticket.assignedTo"></user-select></div><div class="form-group question-row"><label data-translate="abcQualityMatchApp.ticket.assignedToUserGroup" for="field_assignedToUserGroup">Assigned To User Group</label><select class="form-control" id="field_assignedToUserGroup" name="assignedToUserGroup" ng-model="vm.project.ticket.assignedToUserGroup" ng-options="userGroup as userGroup.name for userGroup in vm.usergroups track by userGroup.id"><option value=""></option></select></div><div class="form-group question-row"><label data-translate="abcQualityMatchApp.ticket.state" for="field_state">State</label><select class="form-control required" id="field_state" name="state" ng-model="vm.project.ticket.state" ng-options="ticketState as ticketState.name for ticketState in vm.ticketstates track by ticketState.id" required></select><div><p class="help-block" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/project/project/projects.html','<div><h2 data-translate="abcQualityMatchApp.project.home.title">Projects</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="project.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.project.home.createLabel">Create new Project</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="ticket.title"><span data-translate="abcQualityMatchApp.project.detail.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="startDate"><span data-translate="abcQualityMatchApp.project.startDate">State</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="endDate"><span data-translate="abcQualityMatchApp.project.endDate">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ticket.assignedTo.lastName"><span data-translate="abcQualityMatchApp.ticket.assignedTo">State</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ticket.assignedToUserGroup.name"><span data-translate="abcQualityMatchApp.ticket.assignedToUserGroup">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="ticket.state.name"><span data-translate="abcQualityMatchApp.ticket.state">State</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="doneTime"><span data-translate="abcQualityMatchApp.project.doneTime">Done Time</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="project in vm.projects track by project.id"><td>{{project.ticket.title}}</td><td>{{project.startDate| date:\'mediumDate\'}}</td><td>{{project.endDate| date:\'mediumDate\'}}</td><td>{{project.ticket.assignedTo| fullUserName}}</td><td>{{project.ticket.assignedToUserGroup.name}}</td><td>{{project.ticket.state.name}}</td><td>{{project.ticket.doneTime | date:\'short\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="project-detail({id:project.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="project.edit({id:project.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" confirmed-delete="vm.deleteProject(project)" confirmed-delete-message="abcQualityMatchApp.project.delete.question" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/project/project-phase/project-phase-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectPhaseLabel" data-translate="abcQualityMatchApp.projectPhase.home.createOrEditLabel">Create or edit a Project Phase</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.ticket.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.projectPhase.ticket.title" maxlength="255" required><div><p class="help-block" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.projectPhase.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.projectPhase.ticket.description" maxlength="600"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.projectPhase.startPoint" for="field_startPoint">Start Point</label><input type="text" class="form-control" name="startPoint" id="field_startPoint" ng-model="vm.projectPhase.startPoint" maxlength="255"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.projectPhase.goal" for="field_goal">Goal</label><input type="text" class="form-control" name="goal" id="field_goal" ng-model="vm.projectPhase.goal" maxlength="255"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.projectPhase.startDate" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.projectPhase.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.projectPhase.endDate" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.projectPhase.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.project.doneTime" for="field_endDate">Done Time</label><div class="input-group"><input id="field_doneTime" type="text" class="form-control" name="doneTime" datetime-picker="{{dateformat}}" ng-model="vm.projectPhase.ticket.doneTime" is-open="vm.datePickerOpenStatus.doneTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'doneTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="abcQualityMatchApp.ticket.assignedTo" for="field_assignedTo">Assigned To</label><user-select id="field_assignedTo" user="vm.projectPhase.ticket.assignedTo"></user-select></div><div class="form-group"><label data-translate="abcQualityMatchApp.ticket.assignedToUserGroup" for="field_assignedToUserGroup">Assigned To User Group</label><select class="form-control" id="field_assignedToUserGroup" name="assignedToUserGroup" ng-model="vm.projectPhase.ticket.assignedToUserGroup" ng-options="userGroup as userGroup.name for userGroup in vm.usergroups track by userGroup.id"><option value=""></option></select></div><div class="form-group"><label data-translate="abcQualityMatchApp.ticket.state" for="field_state">State</label><select class="form-control" id="field_state" name="state" ng-model="vm.projectPhase.ticket.state" ng-options="ticketState as ticketState.name for ticketState in vm.ticketstates track by ticketState.id" required></select><div><p class="help-block" ng-show="editForm.state.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/questionnaire-edit/questions/question-decimal.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" id="myQuestionLabel" data-translate="question.home.createOrEditLabel">Create or edit a Question</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" data-translate="question.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.question.title"></div><div class="form-group"><label class="control-label" data-translate="question.text" for="field_text">Text</label><input type="text" class="form-control" name="text" id="field_text" ng-model="vm.question.text"></div><div class="form-group"><label class="control-label" for="field_required"><input type="checkbox" name="required" id="field_required" ng-model="vm.question.required"> <span data-translate="question.required"></span></label></div><div class="form-group"><label class="control-label" for="field_allows_adding_attachments"><input type="checkbox" name="allows_adding_attachments" id="field_allows_adding_attachments" ng-model="vm.question.allowsAddingAttachments"> <span data-translate="question.attachment"></span></label></div><div class="form-group"><label class="control-label" data-translate="question.standardReference" for="standard_reference">Standard reference</label><input maxlength="255" type="text" class="form-control" name="standard_reference" id="standard_reference" ng-model="vm.question.standardReference"></div><!--\n        edellisten tekij\xF6iden j\xE4ljilt\xE4 tekem\xE4tt\xE4\n      <div class="form-group">\n            <label class="control-label" data-translate="question.unit" for="field_unit">Unit</label>\n            <input type="text" class="form-control" name="unit" id="field_unit"\n                    ng-model="vm.question.unit"\n                     />\n        </div>\n        <div class="form-group" >\n            <label class="control-label required" data-translate="question.interpretation" for="field_interpretation">Interpretation</label>\n            <select class="form-control" name="interpretation" ng-model="vm.question.interpretation" id="field_interpretation" required>\n                <option value="NONE" data-translate="question.intepretation.NONE">NONE</option>\n                <option value="LOW_IS_GOOD" data-translate="question.intepretation.LOW_IS_GOOD">LOW_IS_GOOD</option>\n                <option value="HIGH_IS_GOOD" data-translate="question.intepretation.HIGH_IS_GOOD">HIGH_IS_GOOD</option>\n            </select>\n            <div ng-show="editForm.interpretation.$invalid">\n                <p class="help-block"\n                    ng-show="editForm.interpretation.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="question.minimumValue" for="field_minimumValue">Minimum Value</label><input type="number" class="form-control" name="minimumValue" id="field_minimumValue" ng-model="vm.question.minimumValue"></div><div class="form-group"><label class="control-label" data-translate="question.maximumValue" for="field_maximumValue">Maximum Value</label><input type="number" class="form-control" name="maximumValue" id="field_maximumValue" ng-model="vm.question.maximumValue"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/questionnaire-edit/questions/question-freetext.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" id="myQuestionLabel" data-translate="question.home.createOrEditLabel">Create or edit a Question</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="question.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.question.title"></div><div class="form-group"><label class="control-label" data-translate="question.text" for="field_text">Text</label><input type="text" class="form-control" name="text" id="field_text" ng-model="vm.question.text"></div><div class="form-group"><label class="control-label" for="field_required"><input type="checkbox" name="required" id="field_required" ng-model="vm.question.required"> <span data-translate="question.required"></span></label></div><div class="form-group"><label class="control-label" for="field_allows_adding_attachments"><input type="checkbox" name="allows_adding_attachments" id="field_allows_adding_attachments" ng-model="vm.question.allowsAddingAttachments"> <span data-translate="question.attachment"></span></label></div><div class="form-group"><label class="control-label" data-translate="question.standardReference" for="standard_reference">Standard reference</label><input maxlength="255" type="text" class="form-control" name="standard_reference" id="standard_reference" ng-model="vm.question.standardReference"></div><div class="form-group"><label class="control-label" data-translate="question.freetext.size" for="field_size">Size</label><select class="form-control" name="size" ng-model="vm.question.size" id="field_size"><option value="LONG" data-translate="question.freetext.LONG">LONG</option><option value="SHORT" data-translate="question.freetext.SHORT">SHORT</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/questionnaire-edit/questions/question-integer.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" id="myQuestionLabel" data-translate="question.home.createOrEditLabel">Create or edit a Question</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" data-translate="question.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.question.title"></div><div class="form-group"><label class="control-label" data-translate="question.text" for="field_text">Text</label><input type="text" class="form-control" name="text" id="field_text" ng-model="vm.question.text"></div><div class="form-group"><label class="control-label" for="field_required"><input type="checkbox" name="required" id="field_required" ng-model="vm.question.required"> <span data-translate="question.required"></span></label></div><div class="form-group"><label class="control-label" for="field_allows_adding_attachments"><input type="checkbox" name="allows_adding_attachments" id="field_allows_adding_attachments" ng-model="vm.question.allowsAddingAttachments"> <span data-translate="question.attachment"></span></label></div><div class="form-group"><label class="control-label" data-translate="question.standardReference" for="standard_reference">Standard reference</label><input maxlength="255" type="text" class="form-control" name="standard_reference" id="standard_reference" ng-model="vm.question.standardReference"></div><!--\n        <div class="form-group">\n            <label class="control-label" data-translate="question.unit" for="field_unit">Unit</label>\n            <input type="text" class="form-control" name="unit" id="field_unit"\n                   ng-model="vm.question.unit"\n                   />\n        </div>\n        <div class="form-group">\n            <label class="control-label required" data-translate="question.interpretation" for="field_interpretation">Interpretation</label>\n            <select class="form-control" name="interpretation" ng-model="vm.question.interpretation" id="field_interpretation" required>\n                <option value="NONE" data-translate="question.intepretation.NONE">NONE</option>\n                <option value="LOW_IS_GOOD" data-translate="question.intepretation.LOW_IS_GOOD">LOW_IS_GOOD</option>\n                <option value="HIGH_IS_GOOD" data-translate="question.intepretation.HIGH_IS_GOOD">HIGH_IS_GOOD</option>\n            </select>\n            <div ng-show="editForm.interpretation.$invalid">\n                <p class="help-block"\n                   ng-show="editForm.interpretation.$error.required" data-translate="entity.validation.required">\n                    This field is required.\n                </p>\n            </div>\n        </div>\n        --><div class="form-group"><label class="control-label" data-translate="question.minimumValue" for="field_minimumValue">Minimum Value</label><input type="number" class="form-control" name="minimumValue" id="field_minimumValue" ng-model="vm.question.minimumValue"></div><div class="form-group"><label class="control-label" data-translate="question.maximumValue" for="field_maximumValue">Maximum Value</label><input type="number" class="form-control" name="maximumValue" id="field_maximumValue" ng-model="vm.question.maximumValue"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/questionnaire-edit/questions/question-multi.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" id="myQuestionLabel" data-translate="question.home.createOrEditLabel">Create or edit a Question</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" data-translate="question.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.question.title"></div><div class="form-group"><label class="control-label" data-translate="question.text" for="field_text">Text</label><input type="text" class="form-control" name="text" id="field_text" ng-model="vm.question.text"></div><div class="form-group"><label class="control-label" for="field_required"><input type="checkbox" name="required" id="field_required" ng-model="vm.question.required"> <span data-translate="question.required"></span></label></div><div class="form-group"><label class="control-label" for="field_allows_adding_attachments"><input type="checkbox" name="allows_adding_attachments" id="field_allows_adding_attachments" ng-model="vm.question.allowsAddingAttachments"> <span data-translate="question.attachment"></span></label></div><div class="form-group"><label class="control-label" data-translate="question.standardReference" for="standard_reference">Standard reference</label><input maxlength="255" type="text" class="form-control" name="standard_reference" id="standard_reference" ng-model="vm.question.standardReference"></div><div class="form-group"><label class="control-label" data-translate="question.multi.renderType" for="field_renderType">Render Type</label><select class="form-control" name="renderType" ng-model="vm.question.renderType" id="field_renderType"><option value="CHECKBOX" data-translate="question.multi.renderTypes.CHECKBOX">CHECKBOX</option><option value="DROPDOWN" data-translate="question.multi.renderTypes.DROPDOWN">DROPDOWN</option><option value="RADIOBUTTON" data-translate="question.multi.renderTypes.RADIOBUTTON">RADIOBUTTON</option><option value="SINGLE_BUTTON" data-translate="question.multi.renderTypes.SINGLE_BUTTON">SINGLE BUTTON</option></select></div><div class="form-group"><h3 data-translate="question.multi.options">Options</h3><table class="table table-striped"><thead><tr><th data-translate="question.multi.optionValue">Value</th><th data-translate="question.multi.defaultSelection">Default</th><th data-translate="question.multi.anomalyOption">Anomaly</th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat="option in vm.question.options  | orderBy: \'listIndex\'"><td><input type="text" ng-model="option.name" class="form-control"></td><td ng-if="option.defaultSelection"><span class="glyphicon glyphicon-ok" ng-click="vm.setDefault($index)" style="color:lightgreen;font-size: 20px"></span></td><td ng-if="!option.defaultSelection"><span class="glyphicon glyphicon-ok" ng-click="vm.setDefault($index)" style="color:lightgray;font-size: 20px"></span></td><td ng-if="option.anomalyOption && vm.questionnaireType == \'NORMAL\'"><span class="glyphicon glyphicon-exclamation-sign" ng-click="vm.setAnomaly($index)" style="color:red;font-size: 20px"></span></td><td ng-if="!option.anomalyOption && vm.questionnaireType == \'NORMAL\'"><span class="glyphicon glyphicon-exclamation-sign" ng-click="vm.setAnomaly($index)" style="color:lightgray;font-size: 20px"></span></td><td><button ng-disabled="$index == 0" type="button" class="btn-sm btn-primary" ng-click="vm.moveOption($index, \'up\')"><span class="glyphicon glyphicon-chevron-up"></span></button> <button ng-disabled="$index == vm.question.options.length -1" type="button" class="btn-sm btn-primary" ng-click="vm.moveOption($index, \'down\')"><span class="glyphicon glyphicon-chevron-down"></span></button> <button type="button" class="btn btn-danger btn-sm" confirmed-delete="vm.deleteOption($index)" confirmed-delete-message="abcQualityMatchApp.questionnaire.deleteQuestionMultiplechoiceConfirmation"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete">Delete</span></button></td></tr><tr><td colspan="3">&nbsp;</td><td><button type="button" class="btn-sm btn-primary" ng-click="event.preventDefault();vm.addNewOption()"><span class="glyphicon glyphicon-plus"></span></button></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/questionnaire-edit/section/questionnaire-edit-section-dialog.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeDialog()">&times;</button><h4 class="modal-title" data-translate="questionnaireEdit.newSection">New Section</h4></div><div class="modal-body"><div class="form-group"><label data-translate="questionnaireEdit.sectionName"></label><input type="text" class="form-control" ng-model="vm.newSectionName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeDialog()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div>');
$templateCache.put('app/task/task-execution-counts/task-execution-counts.html','<div><h2 data-translate="abcQualityMatchApp.task.taskExecutions.title">Verified tasks.</h2><form ng-submit="vm.refreshSearch()" class="listing-filters"><fieldset><legend data-translate="abcQualityMatchApp.task.taskExecutions.findByDateLimits"></legend><div class="timespan-limit"><div class="input-group date-select-container"><input id="field_fromDate" type="text" class="form-control" name="fromDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.filtering.fromDate" is-open="vm.datePickerOpenStatus.fromDate" ng-change="vm.refreshSearch()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div>-<div class="input-group date-select-container"><input id="field_toDate" type="text" class="form-control" name="toDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.filtering.toDate" is-open="vm.datePickerOpenStatus.toDate" ng-change="vm.refreshSearch()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></fieldset></form><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="(title)"><span data-translate="abcQualityMatchApp.task.taskExecutions.task">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(recurring_task)"><span data-translate="abcQualityMatchApp.task.taskExecutions.recurringTask">recurringTask</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(done_count)"><span data-translate="abcQualityMatchApp.task.taskExecutions.doneCount">doneCount</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(verified_count)" class="text-right"><span data-translate="abcQualityMatchApp.task.taskExecutions.verifiedCount">verifiedCount</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="taskExec in vm.taskExecutions"><td><span class="long-text">{{taskExec.title}}</span></td><td class="hidden-xs" style="padding-left: 2em">{{taskExec.recurringTask |checkMark}}</td><td class=""><table><tr><td><span data-translate="abcQualityMatchApp.task.taskExecutions.doneCount"></span></td><td class="text-right">{{taskExec.doneCount}}/{{taskExec.totalCount}}</td></tr><tr class="text-muted"><td><span data-translate="abcQualityMatchApp.task.taskExecutions.doneLateCount"></span></td><td class="text-right">{{taskExec.doneLateCount}}</td></tr><tr class="text-muted"><td><span data-translate="abcQualityMatchApp.task.taskExecutions.doneOnTimeCount"></span></td><td class="text-right">{{taskExec.doneOnTimeCount}}</td></tr></table></td><td class="text-right">{{taskExec.verifiedCount}}/{{taskExec.verifiableTotalCount}}</td><td><button type="submit" ui-sref="task-executions-tables(vm.getParametersForTaskVerification(taskExec.taskId))" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/task/task-fulfilment/task-fulfilment.html','<div class="questionnaire-answer questionnaire-form"><form name="editForm" novalidate><div><h2>{{vm.questionnaire.title}}</h2><div class="description-view">{{vm.questionnaire.description}}</div></div><div class="row" ng-if="vm.comparisonQuestionnaireAnswer"><div class="half-column">&nbsp;</div><div class="half-column"><p><span data-translate="abcQualityMatchApp.ticket.comparison"></span>: {{vm.comparisonQuestionnaireAnswer.answerTime| date: \'short\'}}</p></div><div class="clear-column"></div></div><div class="row"><questionnaire-answer questionnaire="vm.questionnaire" on-answer-change="vm.onAnswerChange()" edit-form="editForm" comparisons="vm.comparisons"></div><div class="form-group"><label><input type="checkbox" id="field_manualAnomaly" ng-model="vm.manualAnomaly" name="manualAnomaly"> <span data-translate="abcQualityMatchApp.anomalyEvent.manualAnomaly">manual anomaly</span></label></div><br><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.ticket.state" for="field_taskState">State</label><select id="field_taskState" name="taskState" ng-required class="form-control" ng-model="vm.ticketState" ng-options="state as state.name for state in vm.taskFulfillmentDTO.settableTaskTicketStates track by state.id"></select><br ng-if="vm.containsUnansweredQuestions"><div ng-if="vm.containsUnansweredQuestions" class="alert alert-warning"><span data-translate="abcQualityMatchApp.task.fulfillment.containsUnansweredQuestions"></span></div></div><div class="row"><div class="pull-right"><button ng-click="vm.saveAnswers()" class="btn btn-primary" ng-disabled="editForm.$invalid || (vm.containsUnansweredQuestions && vm.ticketState.ticketStateType !== \'IN_PROGRESS\' )"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">save</span></button> <button type="button" class="btn btn-default" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">cancel</span></button></div></div></form></div>');
$templateCache.put('app/task/task-list/task-list.html','<div><h2 data-translate="abcQualityMatchApp.taskEvent.task-list.home.title">Information</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="(start_time)"><span data-translate="abcQualityMatchApp.taskEvent.start">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(end_time)"><span data-translate="abcQualityMatchApp.taskEvent.end">Ticket</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tic.title"><span data-translate="abcQualityMatchApp.taskEvent.task">Questionnaire</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tics.name"><span data-translate="abcQualityMatchApp.taskEvent.ticketState">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(assigned_to)"><span data-translate="abcQualityMatchApp.taskEvent.assignedTo">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(assigned_to_user_group)"><span data-translate="abcQualityMatchApp.taskEvent.assignedToUserGroup">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="task in vm.taskEvents"><td ng-if="task.allDay">{{task.start| date:\'shortDate\'}}</td><td ng-if="!task.allDay">{{task.start| date:\'short\'}}</td><td ng-if="task.allDay">{{task.end| date:\'shortDate\'}}</td><td ng-if="!task.allDay">{{task.end| date:\'short\'}}</td><td><span class="long-text">{{task.title}}</span></td><td>{{task.state}}</td><td>{{task.assignedTo}}</td><td>{{task.assignedToUserGroup}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><span has-group="{{task.assignedToUserGroupId}}" has-user-id="{{task.assignedToId}}" ng-if="(task.stateType == \'NEW\' || task.stateType == \'IN_PROGRESS\')"><button ng-if="task.questionnaireId" class="btn-sm btn-primary" ui-sref="task-fulfilment({id: task.questionnaireId, answerId: task.answerId, taskId:task.taskId, recurrenceDateId:task.recurrenceDateId, returnToView: \'task-list\'})"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-if="!task.questionnaireId" class="btn-sm btn-success" ng-click="vm.confirm(task.taskId, task.recurrenceDateId)"><span class="glyphicon glyphicon-ok"></span></button></span></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/task/task-verification/task-verification.html','<div><form name="editForm" role="form" novalidate show-validation><h2 data-translate="abcQualityMatchApp.taskVerification.home.title">Information</h2><jhi-alert></jhi-alert><br><dl class="dl-horizontal jh-entity-details" ng-switch="vm.task.freq != undefined"><dt><span data-translate="abcQualityMatchApp.questionnaire.detail.title">Title</span></dt><dd><span ng-if="vm.tasks[0].parentTask">{{vm.tasks[0].parentTask.mainTicket.title}}</span> <span ng-if="!vm.tasks[0].parentTask">{{vm.tasks[0].mainTicket.title}}</span></dd><dt><span data-translate="abcQualityMatchApp.task.detail.title">Description</span></dt><dd><span ng-if="vm.tasks[0].parentTask">{{vm.tasks[0].parentTask.questionnaire.title}}</span> <span ng-if="!vm.tasks[0].parentTask">{{vm.tasks[0].questionnaire.title}}</span></dd></dl><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="abcQualityMatchApp.taskVerification.subject">subject</span></th><th ng-repeat="task in vm.tasks" ng-class="vm.taskClassCheck(task)">{{task.start | date:\'short\'}} - {{task.end | date:\'short\'}}<br><span ng-show="task.mainTicket.doneTime" style="white-space: nowrap"><span data-translate="abcQualityMatchApp.ticket.doneTime"></span> {{task.mainTicket.doneTime| date:\'short\'}}</span></th></tr></thead><tbody><tr ng-repeat="question in vm.questions"><td>{{question.title}}</td><td ng-repeat="answer in question.answerArray track by $index" ng-class="vm.answerClassCheck(answer)">{{vm.roundAnswerValueIfDecimal(answer.answerType, answer.value)}} <a ng-if="answer.informationQuestionnaireId" class="btn btn-sm btn-primary" target="_blank" ui-sref="editInformation({id: answer.informationId})"><span class="glyphicon glyphicon-pencil"></span> <span data-translate="abcQualityMatchApp.information.detail.title">Information</span></a></td><td ng-repeat="answer in question.answerArray track by $index" ng-class="vm.answerClassCheck(answer)"><div ng-click="storageFile.visible = !storageFile.visible" ng-repeat="storageFile in answer.storageFiles track by $index">{{storageFile.fileName}} <img height="120px" ng-if="storageFile.visible" ng-src="data:{{storageFile.contentType}};base64,{{storageFile.content}}"></div></td></tr><tr><td><span data-translate="abcQualityMatchApp.taskVerification.state">State</span></td><td ng-repeat="task in vm.verificationTasks"><select class="form-control" ng-model="task.state" ng-options="ticketState as ticketState.name for ticketState in vm.ticketStates track by ticketState.id" required></select></td></tr><tr><td><span data-translate="abcQualityMatchApp.taskVerification.comment">Comment</span></td><td ng-repeat="task in vm.verificationTasks"><textarea rows="5" class="form-control" ng-model="task.comment" maxlength="255"></textarea></td></tr><tr ng-if="vm.verificationTasks.length > 1"><td><span data-translate="abcQualityMatchApp.taskVerification.copy">Copy state and result</span></td><td ng-repeat="task in vm.verificationTasks"><button ng-if="$first" ng-click="vm.copy()" class="btn btn-primary"><span data-translate="entity.action.copy">Copy</span> <span class="glyphicon glyphicon-arrow-right"></span></button> <input ng-if="!$first" type="checkbox" ng-model="task.copy"> <span ng-if="!$first" data-translate="abcQualityMatchApp.taskVerification.copyhere">Copy here</span></td></tr><tr><td colspan="{{1 + vm.verificationTasks.length}}" style="text-align:right"><button type="button" class="btn btn-default" ui-sref="home"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Peruuta</span></button> <button ng-click="vm.save()" class="btn btn-primary" ng-disabled="editForm.$invalid"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Tallenna</span></button></td></tr></tbody></table></div><dl class="dl-horizontal jh-entity-details" ng-switch="vm.task.freq != undefined"><dt><span data-translate="abcQualityMatchApp.taskVerification.legend.title">Description</span></dt><dd><div class="alert alert-warning" style="width:50%" data-translate="abcQualityMatchApp.taskVerification.legend.confirmedAnomaly"></div><div class="alert alert-danger" style="width:50%" data-translate="abcQualityMatchApp.taskVerification.legend.anomaly"></div></dd></dl></form></div>');
$templateCache.put('app/task/task-verification-list/task-verification-list.html','<div><h2 data-translate="abcQualityMatchApp.taskVerification.list.title">Information</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><!--QMYP-522 jh-sort-by="tic.title" --><span data-translate="abcQualityMatchApp.taskVerification.taskEvent.ticketTitle">Teht\xE4v\xE4</span></th><th><span data-translate="abcQualityMatchApp.ticket.doneTime">doneTime</span></th><th><span data-translate="abcQualityMatchApp.taskVerification.taskEvent.notVerified">Todentamattomat</span></th><th><span data-translate="abcQualityMatchApp.taskVerification.taskEvent.verified">Todennetut</span></th><th></th></tr></thead><tbody><tr ng-repeat="event in vm.taskVerifications"><td>{{event.title}}</td><td>{{event.doneTimeMin | date:\'short\'}}</td><td>{{event.notVerified}}</td><td>{{event.verified}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button class="btn-sm btn-primary" ui-sref="task-verification({parentTaskId: event.taskId, questionnaireId: event.questionnaireId})" ng-if="event.notVerified > 0"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/training-main/trainee/trainee-availabe-training.html','<div><h2 data-translate="abcQualityMatchApp.training.availableTraining.title">Availabe training</h2><jhi-alert></jhi-alert><br><div class="alert alert-info" style="margin-bottom:1em" ng-show="vm.failureReason != null"><span data-translate="{{\'abcQualityMatchApp.trainingEventSignup.error.reason.\' + vm.failureReason}}">{{vm.failureReason}}</span></div><h3 data-translate="abcQualityMatchApp.training.availableTraining.independentStudiesTitle">Independent studies</h3><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="abcQualityMatchApp.trainingEvent.training">Name</span></th><th><span data-translate="abcQualityMatchApp.training.trainingPoints">Training Points</span></th><th><span data-translate="abcQualityMatchApp.training.organization">Organization</span></th><th><span data-translate="abcQualityMatchApp.training.primaryInstructor">Primary Instructor</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="trainingIndependentStudyAvailable in vm.independentStudyTrainings track by trainingIndependentStudyAvailable.id"><td>{{trainingIndependentStudyAvailable.name}}</td><td>{{trainingIndependentStudyAvailable.trainingPoints}}</td><td>{{trainingIndependentStudyAvailable.organization}}</td><td>{{trainingIndependentStudyAvailable.primaryInstructor | fullUserName}}</td><td><ul class="list-unstyled"><li ng-if="trainingIndependentStudyAvailable.userTrainingState.stillValid"><span ng-if="trainingIndependentStudyAvailable.userTrainingState.validToDate == null" data-translate="abcQualityMatchApp.trainingEvent.userTrainingState.isPerpetuallyValid"></span> <span ng-if="trainingIndependentStudyAvailable.userTrainingState.validToDate != null" data-translate="abcQualityMatchApp.trainingEvent.userTrainingState.isValidUntill" data-translate-values="{validToDate: \'{{trainingIndependentStudyAvailable.userTrainingState.validToDate | date: \'shortDate\'}}\'}"></span></li><li ng-if="!trainingIndependentStudyAvailable.userTrainingState.stillValid"><span ng-if="trainingIndependentStudyAvailable.userTrainingState.trainingStatus == \'REQUIRED\'" data-translate="abcQualityMatchApp.trainingEvent.userTrainingState.required" class="text-warning"></span> <span ng-if="trainingIndependentStudyAvailable.userTrainingState.trainingStatus == \'SUGGESTED\'" data-translate="abcQualityMatchApp.trainingEvent.userTrainingState.suggested"></span></li><li ng-if="trainingIndependentStudyAvailable.userTrainingState.eventSignedUp"><span class="text-success" data-translate="abcQualityMatchApp.trainingEvent.userTrainingState.isSignedUp"></span></li></ul></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="trainee-independent-study-signup({trainingId:trainingIndependentStudyAvailable.id, signedUp: trainingIndependentStudyAvailable.userTrainingState.eventSignedUp})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="button" ng-click="vm.confirmSignupToIndependentStudyTraining(trainingIndependentStudyAvailable)" ng-disabled="vm.isSigningUp  || trainingIndependentStudyAvailable.userTrainingState.eventSignedUp" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-check"></span> <span data-translate="abcQualityMatchApp.training.signupToTrainigButton">SIGN-UP</span></button></div></td></tr></tbody></table></div><br><h3 data-translate="abcQualityMatchApp.training.availableTraining.otherStudiesTitle">Other studies</h3><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="(training.training_type)"><span data-translate="abcQualityMatchApp.training.trainingType">type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(training.name)"><span data-translate="abcQualityMatchApp.trainingEvent.training">Training</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(instructor.last_name)"><span data-translate="abcQualityMatchApp.trainingEvent.instructor">Instructor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(location)"><span data-translate="abcQualityMatchApp.trainingEvent.location">Location</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(duration)"><span data-translate="abcQualityMatchApp.trainingEvent.duration">Duration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(start)"><span data-translate="abcQualityMatchApp.trainingEvent.start">Start</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(end)"><span data-translate="abcQualityMatchApp.trainingEvent.end">End</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="trainingEventAvailable in vm.trainingEvents track by trainingEventAvailable.id"><td data-translate="{{\'abcQualityMatchApp.TrainingType.\' + trainingEventAvailable.training.trainingType}}">{{trainingEventAvailable.training.trainingType}}</td><td>{{trainingEventAvailable.training.name}}</td><td>{{trainingEventAvailable | trainingEventInstructor}}</td><td>{{trainingEventAvailable.location}}</td><td>{{trainingEventAvailable.duration}}</td><td>{{trainingEventAvailable.start | date:\'shortDate\'}}</td><td>{{trainingEventAvailable.end | date:\'shortDate\'}}</td><td><ul class="list-unstyled"><li ng-if="trainingEventAvailable.userTrainingState.stillValid"><span ng-if="trainingEventAvailable.userTrainingState.validToDate == null" data-translate="abcQualityMatchApp.trainingEvent.userTrainingState.isPerpetuallyValid"></span> <span ng-if="trainingEventAvailable.userTrainingState.validToDate != null" data-translate="abcQualityMatchApp.trainingEvent.userTrainingState.isValidUntill" data-translate-values="{validToDate: \'{{trainingEventAvailable.userTrainingState.validToDate | date: \'shortDate\'}}\'}"></span></li><li ng-if="!trainingEventAvailable.userTrainingState.stillValid"><span ng-if="trainingEventAvailable.userTrainingState.trainingStatus == \'REQUIRED\'" data-translate="abcQualityMatchApp.trainingEvent.userTrainingState.required" class="text-warning"></span> <span ng-if="trainingEventAvailable.userTrainingState.trainingStatus == \'SUGGESTED\'" data-translate="abcQualityMatchApp.trainingEvent.userTrainingState.suggested"></span></li><li ng-if="trainingEventAvailable.userTrainingState.eventSignedUp"><span class="text-success" data-translate="abcQualityMatchApp.trainingEvent.userTrainingState.isSignedUp"></span></li></ul></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="trainee-training-event-signup({trainingEventId:trainingEventAvailable.id, signedUp: trainingEventAvailable.userTrainingState.eventSignedUp})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view">View</span></button> <button type="button" ng-click="vm.confirmSignupToTrainingEvent(trainingEventAvailable)" ng-disabled="vm.isSigningUp || trainingEventAvailable.userTrainingState.eventSignedUp" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-check"></span> <span data-translate="abcQualityMatchApp.training.signupToTrainigButton">SIGN-UP</span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/training-main/trainee/trainee-exam-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="training"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTrainingRecordLabel"><span>{{vm.trainingRecord.trainingEvent.training.name}}</span></h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="abcQualityMatchApp.training.examQuestions">exam</label><div class="table-responsive"><table class="table table-exam-questions-use" id="examQuestionsTable"><tbody><tr ng-repeat="examQuestion in vm.trainingRecord.trainingEvent.training.examQuestions | orderBy: \'listIndex\'"><td>{{$index + 1}}.</td><td>{{examQuestion.questionText}}</td><td><label><input type="radio" ng-model="examQuestion.answer" ng-value="true"><span data-translate="abcQualityMatchApp.trainingExamQuestion.expectedAnswer_true">true</span></label><br><label><input type="radio" ng-model="examQuestion.answer" ng-value="false"><span data-translate="abcQualityMatchApp.trainingExamQuestion.expectedAnswer_false">false</span></label></td></tr></tbody><tfoot><tr><td colspan="2"></td><td><button type="button" class="btn-sm btn-primary" ng-click="event.preventDefault();vm.checkExam()" ng-disabled="editForm.$invalid || vm.isSaving"><span class="glyphicon glyphicon-check"></span>&nbsp;<span data-translate="abcQualityMatchApp.trainingExamQuestion.checkExamButton">check</span></button></td></tr></tfoot></table></div><div class="alert alert-warning" ng-show="vm.examCheckPassed === false"><strong data-translate="abcQualityMatchApp.trainingExamQuestion.examFailedMessageTitle">Failed</strong> <span data-translate="abcQualityMatchApp.trainingExamQuestion.examFailedMessageText">failed</span>.</div><div class="alert alert-success" ng-show="vm.examCheckPassed === true"><strong data-translate="abcQualityMatchApp.trainingExamQuestion.examPassedMessageTitle">Passed</strong> <span data-translate="abcQualityMatchApp.trainingExamQuestion.examPassedMessageText">passed</span>.</div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div></form>');
$templateCache.put('app/training-main/trainee/trainee-records.html','<div class="training"><h2 data-translate="abcQualityMatchApp.trainingRecord.myTrainingsTitle">Training Records</h2><jhi-alert></jhi-alert><br><h3 data-translate="abcQualityMatchApp.trainingRecord.traineeSignupsTitle">Sign-ups</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th><span data-translate="abcQualityMatchApp.training.trainingType">type</span></th><th><span data-translate="abcQualityMatchApp.trainingRecord.training">Training</span></th><th><span data-translate="abcQualityMatchApp.trainingEvent.start">start</span></th><th><span data-translate="abcQualityMatchApp.trainingEvent.end">end</span></th><th><span data-translate="abcQualityMatchApp.trainingEvent.instructor">Instructor</span></th><th><span data-translate="abcQualityMatchApp.trainingEventSignup.signupDate">Signup Date</span></th><th><span data-translate="abcQualityMatchApp.trainingEventSignup.signupAccepted">accepted"</span></th><th><span data-translate="abcQualityMatchApp.trainingRecord.examPassed">Exam Passed</span></th><th></th></tr></thead><tbody><tr ng-repeat="signup in vm.trainingEventSignups track by signup.id"><td data-translate="{{\'abcQualityMatchApp.TrainingType.\' + signup.trainingEvent.training.trainingType}}">{{signup.trainingEvent.training.trainingType}}</td><td>{{signup.trainingEvent.training.name}}</td><td>{{signup.trainingEvent.start | date:\'shortDate\'}}</td><td>{{signup.trainingEvent.end | date:\'shortDate\'}}</td><td>{{signup.trainingEvent | trainingEventInstructor }}</td><td>{{signup.signupDate | date:\'shortDate\'}}</td><td>{{signup.signupAccepted | checkMark }}</td><td>{{signup.examPassed| checkMark}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="trainee-records-study({signupId:signup.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon glyphicon-check"></span> <span class="hidden-xs hidden-sm" data-translate="abcQualityMatchApp.trainingRecord.studyButton">study</span></button> <button type="submit" confirmed-delete="vm.deleteSignup(signup.id)" confirmed-delete-message="abcQualityMatchApp.trainingEvent.cancelSignupConfirmationQuestion" class="btn btn-danger btn-sm" ng-disabled="vm.deletingSignup"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr><tr ng-show="vm.trainingEventSignups.length == 0"><td colspan="9" data-translate="abcQualityMatchApp.trainingEvent.signupsIsEmpty">no sign-ups</td></tr></tbody></table></div><a ui-sref="trainee-available"><span data-translate="global.menu.training.available"></span></a><br><br><h3 data-translate="abcQualityMatchApp.trainingRecord.traineeTrainingRecordTitle">Completed</h3><div class="examOrSigningAlert alert alert-info" ng-show="vm.trainingRecordsExamRequired.length >0"><strong data-translate="abcQualityMatchApp.trainingRecord.pleaseDoExams"></strong><br><span data-translate="abcQualityMatchApp.trainingRecord.pleaseDoExamsExplanation"></span><table><tr ng-repeat="trainingRecord in vm.trainingRecordsExamRequired track by trainingRecord.id"><td>{{trainingRecord.trainingEvent.training.name}}</td><td><button type="submit" ui-sref="trainee-records.exam({id:trainingRecord.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon glyphicon-check"></span> <span class="hidden-xs hidden-sm" data-translate="abcQualityMatchApp.trainingRecord.doExamButton">exam</span></button></td></tr></table></div><div class="examOrSigningAlert alert alert-success" ng-show="vm.trainingRecordsSigningRequired.length >0"><strong data-translate="abcQualityMatchApp.trainingRecord.pleaseSignTrainings"></strong><br><span data-translate="abcQualityMatchApp.trainingRecord.pleaseSignTrainingsExplanation"></span><table><tr ng-repeat="trainingRecord in vm.trainingRecordsSigningRequired track by trainingRecord.id"><td>{{trainingRecord.trainingEvent.training.name}}</td><td><button type="submit" ui-sref="trainee-records.sign({id:trainingRecord.id})" class="btn btn-success btn-sm"><span class="glyphicon glyphicon glyphicon-ok"></span> <span class="hidden-xs hidden-sm" data-translate="abcQualityMatchApp.trainingRecord.doSignButton">sign</span></button></td></tr></table></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="trainingEvent.training.trainingType"><span data-translate="abcQualityMatchApp.training.trainingType">type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.training.name"><span data-translate="abcQualityMatchApp.trainingRecord.training">Training</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="signupDate"><span data-translate="abcQualityMatchApp.trainingRecord.signupDate">Signup Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.start"><span data-translate="abcQualityMatchApp.trainingEvent.start">start</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.end"><span data-translate="abcQualityMatchApp.trainingEvent.end">end</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validToDate"><span data-translate="abcQualityMatchApp.trainingEvent.validToDateColumnLabel">Valid To Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.duration"><span data-translate="abcQualityMatchApp.trainingEvent.duration">duration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.training.organization"><span data-translate="abcQualityMatchApp.training.organization">organization</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.instructor.lastName"><span data-translate="abcQualityMatchApp.trainingEvent.instructor">Instructor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.training.trainingPoints"><span data-translate="abcQualityMatchApp.training.trainingPoints">Training Points</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="examPassed"><span data-translate="abcQualityMatchApp.trainingRecord.examPassed">Exam Passed</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="traineeSignedDate"><span data-translate="abcQualityMatchApp.trainingRecord.traineeSignedDate">Trainee Signed</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="trainingRecord in vm.trainingRecords track by trainingRecord.id" ng-class="{info: !trainingRecord.examPassed, success: trainingRecord.traineeSignedDate == null && trainingRecord.examPassed}"><td data-translate="{{\'abcQualityMatchApp.TrainingType.\' + trainingRecord.trainingEvent.training.trainingType}}">{{trainingRecord.trainingEvent.training.trainingType}}</td><td>{{trainingRecord.trainingEvent.training.name}}</td><td>{{trainingRecord.signupDate | date:\'shortDate\'}}</td><td>{{trainingRecord.trainingEvent.start | date:\'shortDate\'}}</td><td>{{trainingRecord.trainingEvent.end | date:\'shortDate\'}}</td><td>{{trainingRecord.validToDate | date:\'shortDate\'}}</td><td>{{trainingRecord.trainingEvent.duration}}</td><td>{{trainingRecord.trainingEvent.training.organization}}</td><td>{{trainingRecord.trainingEvent | trainingEventInstructor }}</td><td>{{trainingRecord.trainingEvent.training.trainingPoints}}</td><td>{{trainingRecord.examPassed| checkMark}}</td><td>{{trainingRecord.traineeSignedDate | date:\'shortDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="trainee-records.exam({id:trainingRecord.id})" ng-hide="trainingRecord.examPassed" class="btn btn-info btn-sm"><span class="glyphicon glyphicon glyphicon-check"></span> <span class="hidden-xs hidden-sm" data-translate="abcQualityMatchApp.trainingRecord.doExamButton">exam</span></button> <button type="submit" ui-sref="trainee-records.sign({id:trainingRecord.id})" ng-hide="trainingRecord.traineeSignedDate != null || !trainingRecord.examPassed" class="btn btn-success btn-sm"><span class="glyphicon glyphicon glyphicon-ok"></span> <span class="hidden-xs hidden-sm" data-translate="abcQualityMatchApp.trainingRecord.doSignButton">sign</span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/training-main/trainee/trainee-sign-dialog.html','<form name="signForm" role="form" novalidate ng-submit="vm.save()" show-validation class="training"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.trainingRecord.trainingEvent.training.name}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="alert alert-success" ng-show="vm.trainingRecord.traineeSignedDate"><span data-translate="abcQualityMatchApp.trainingRecord.alreadySignedMessage">Already signed</span></div><div class="form-group" ng-show="vm.trainingRecord.trainingEvent.checklistItems.length > 0"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.checklistItems">checklist</label><ol class="checklist-list"><li ng-repeat="checklistItem in vm.trainingRecord.trainingEvent.checklistItems | orderBy: \'listIndex\'"><span class="item-content"><span class="item-text">{{checklistItem.name}}</span> <span class="time-estimate" ng-if="checklistItem.timeEstimate">{{checklistItem.timeEstimate}}</span></span></li></ol></div><div class="form-group"><label class="control-label">&nbsp;</label><input id="signTraining" type="checkbox" name="sign" ng-model="vm.signed" ng-disabled="vm.trainingRecord.traineeSignedDate"><label for="signTraining" class="training-singup-pledge-label"><span data-translate="abcQualityMatchApp.trainingRecord.signingCheckbox">signing</span></label></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="vm.trainingRecord.traineeSignedDate  || vm.isSaving || !vm.signed" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/training-main/trainee/trainee-study.html','<div class="training"><h2><span>{{vm.trainingEvent.training.name}}</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.training.materials">Materials</span></dt><dd><div><training-material training="vm.trainingEvent.training"></training-material></div></dd><dt><span data-translate="abcQualityMatchApp.training.checklistItems">Checklist</span></dt><dd><ol class="checklist-list"><li ng-repeat="checklistItem in vm.trainingEvent.checklistItems | orderBy: \'listIndex\'"><span class="item-checkmarker">{{checklistItem.completed | checkMark}} &nbsp;</span> <span class="item-content"><span class="item-text">{{checklistItem.name}}</span> <span class="time-estimate" ng-if="checklistItem.timeEstimate">{{checklistItem.timeEstimate}}</span></span></li></ol></dd><dt><span data-translate="abcQualityMatchApp.training.examQuestions">exam</span></dt><dd><div ng-hide="vm.examCheckPassed === true" class="table-responsive"><label ng-if="vm.showExam === false" class="traininglabel"><input type="checkbox" ng-click="vm.confirmMaterials()" name="showexam" id="field_showExam"> <span data-translate="abcQualityMatchApp.trainingExamQuestion.verifyExam"></span></label><table ng-if="vm.showExam" class="table table-exam-questions-use" id="examQuestionsTable"><tbody><tr ng-repeat="examQuestion in vm.trainingEvent.training.examQuestions | orderBy: \'listIndex\'"><td>{{$index + 1}}.</td><td>{{examQuestion.questionText}}</td><td><label><input type="radio" ng-model="examQuestion.answer" ng-value="true"><span data-translate="abcQualityMatchApp.trainingExamQuestion.expectedAnswer_true">true</span></label><br><label><input type="radio" ng-model="examQuestion.answer" ng-value="false"><span data-translate="abcQualityMatchApp.trainingExamQuestion.expectedAnswer_false">false</span></label></td></tr></tbody><tfoot><tr><td colspan="2"></td><td><button type="button" class="btn-sm btn-primary" ng-click="event.preventDefault();vm.checkExam()" ng-disabled="vm.examCheckPassed || vm.isSaving"><span class="glyphicon glyphicon-check"></span>&nbsp;<span data-translate="abcQualityMatchApp.trainingExamQuestion.checkExamButton">check</span></button></td></tr></tfoot></table></div><div class="alert alert-warning" ng-show="vm.examCheckPassed === false"><strong data-translate="abcQualityMatchApp.trainingExamQuestion.examFailedMessageTitle">Failed</strong> <span data-translate="abcQualityMatchApp.trainingExamQuestion.examFailedMessageText">failed</span>.</div><div class="alert alert-success" ng-show="vm.examCheckPassed === true"><strong data-translate="abcQualityMatchApp.trainingExamQuestion.examPassedMessageTitle">Passed</strong> <span data-translate="abcQualityMatchApp.trainingExamQuestion.examPassedMessageText">passed</span>.</div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/training-main/trainee/trainee-training-signup-confirm-dialog.html','<form name="addLinkForm" role="form" novalidate ng-submit="vm.confirm()" show-validation class="training"><div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeDialog()">&times;</button><h4 class="modal-title" data-translate="abcQualityMatchApp.training.confirmSignupDialog.title">Signup</h4></div><div class="modal-body"><p data-translate="abcQualityMatchApp.training.confirmSignupDialog.message">confirm?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeDialog()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.confirm()"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span data-translate="abcQualityMatchApp.training.confirmSignupDialog.signupButton">Save</span></button></div></div></form>');
$templateCache.put('app/training-main/trainee/trainee-training-signup.html','<div class="training"><h2>{{vm.training.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.training.name">Name</span></dt><dd><span>{{vm.training.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.training.organization">Organization</span></dt><dd><span>{{vm.training.organization}}</span></dd><dt><span data-translate="abcQualityMatchApp.training.primaryInstructor">Primary Instructor</span></dt><dd>{{vm.training.primaryInstructor | fullUserName}}</dd><dt><span data-translate="abcQualityMatchApp.training.trainingType">Training Type</span></dt><dd><span data-translate="{{\'abcQualityMatchApp.TrainingType.\' + vm.training.trainingType}}">{{vm.training.trainingType}}</span></dd><dt><span data-translate="abcQualityMatchApp.training.trainingPoints">Training Points</span></dt><dd><span>{{vm.training.trainingPoints}}</span></dd><dt><span data-translate="abcQualityMatchApp.training.materials">Materials</span></dt><dd><div><training-material training="vm.training"></training-material></div></dd><dt><span data-translate="abcQualityMatchApp.training.checklistItems">Checklist</span></dt><dd><ol class="checklist-list"><li ng-repeat="checklistItem in vm.training.checklistItems | orderBy: \'listIndex\'"><span class="item-content"><span class="item-text">{{checklistItem.name}}</span> <span class="time-estimate" ng-if="checklistItem.timeEstimate">{{checklistItem.timeEstimate}}</span></span></li></ol></dd><dt><span data-translate="abcQualityMatchApp.training.examPassRequiredPercent">Exam Pass Required Percent</span></dt><dd><span>{{vm.training.examPassRequiredPercent}} <span ng-show="vm.training.examPassRequiredPercent">%</span></span></dd><dt><span>&nbsp;</span></dt><dd><div class="alert alert-info" style="margin-bottom:1em" ng-show="vm.failureReason != null"><span data-translate="{{\'abcQualityMatchApp.trainingEventSignup.error.reason.\' + vm.failureReason}}">{{vm.failureReason}}</span></div><button type="button" class="btn btn-primary" ng-click="vm.confirmSignup()" ng-disabled="vm.isSaving || vm.signedUp"><span class="glyphicon glyphicon-check"></span> <span data-translate="abcQualityMatchApp.training.signupToTrainigButton">SIGN-UP</span></button></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/training-main/training/training-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.training.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.training.delete.question" translate-values="{id: \'{{vm.training.name}}\'}">Are you sure you want to delete this Training?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/training-main/training/training-detail.html','<div class="training"><h2><span data-translate="abcQualityMatchApp.training.detail.title">Training</span> {{vm.training.name}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.training.name">Name</span></dt><dd><span>{{vm.training.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.training.organization">Organization</span></dt><dd><span>{{vm.training.organization}}</span></dd><dt><span data-translate="abcQualityMatchApp.training.primaryInstructor">Primary Instructor</span></dt><dd>{{vm.training.primaryInstructor | fullUserName}}</dd><dt><span data-translate="abcQualityMatchApp.training.trainingType">Training Type</span></dt><dd><span data-translate="{{\'abcQualityMatchApp.TrainingType.\' + vm.training.trainingType}}">{{vm.training.trainingType}}</span></dd><dt><span data-translate="abcQualityMatchApp.training.trainingPoints">Training Points</span></dt><dd><span>{{vm.training.trainingPoints}}</span></dd><dt><span data-translate="abcQualityMatchApp.training.validForYears">Valid For Years</span></dt><dd><span>{{vm.training.validForYears}}</span></dd><dt><span data-translate="abcQualityMatchApp.training.materials">Materials</span></dt><dd><div><training-material training="vm.training"></training-material></div></dd><dt><span data-translate="abcQualityMatchApp.training.checklistItems">Checklist</span></dt><dd><ol class="checklist-list"><li ng-repeat="checklistItem in vm.training.checklistItems | orderBy: \'listIndex\'"><span class="item-content"><span class="item-text">{{checklistItem.name}}</span> <span class="time-estimate" ng-if="checklistItem.timeEstimate">{{checklistItem.timeEstimate}}</span></span></li></ol></dd><dt><span data-translate="abcQualityMatchApp.training.examQuestions">exam</span></dt><dd><ol class="exam-questions-list"><li ng-repeat="examQuestion in vm.training.examQuestions | orderBy: \'listIndex\'"><span>{{examQuestion.questionText}}</span></li></ol></dd><dt><span data-translate="abcQualityMatchApp.training.examPassRequiredPercent">Exam Pass Required Percent</span></dt><dd><span>{{vm.training.examPassRequiredPercent}} <span ng-show="vm.training.examPassRequiredPercent">%</span></span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="training-detail.edit({id:vm.training.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/training-main/training/training-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="training"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTrainingLabel" data-translate="abcQualityMatchApp.training.home.createOrEditLabel">Create or edit a Training</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.training.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.training.name" required ng-minlength="1"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p></div></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.training.trainingType" for="field_trainingType">Training Type</label><select class="form-control" name="trainingType" ng-model="vm.training.trainingType" id="field_trainingType" required ng-disabled="vm.training.id > 0"><option value="INDEPENDENT" data-translate="abcQualityMatchApp.TrainingType.INDEPENDENT">INDEPENDENT</option><option value="COURSE" data-translate="abcQualityMatchApp.TrainingType.COURSE">COURSE</option><option value="TASK_TUTORING" data-translate="abcQualityMatchApp.TrainingType.TASK_TUTORING">TASK_TUTORING</option><option value="INTRO_TUTORING" data-translate="abcQualityMatchApp.TrainingType.INTRO_TUTORING">INTRO_TUTORING</option></select><div ng-show="editForm.trainingType.$invalid"><p class="help-block" ng-show="editForm.trainingType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.training.organization" for="field_organization">Organization</label><input type="text" class="form-control" name="organization" id="field_organization" ng-model="vm.training.organization"></div><div class="form-group"><label data-translate="abcQualityMatchApp.training.primaryInstructor" for="field_primaryInstructor">Primary Instructor</label><user-select id="field_primaryInstructor" user="vm.training.primaryInstructor"></user-select></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.training.trainingPoints" for="field_trainingPoints">Training Points</label><input type="number" class="form-control training-points-input" name="trainingPoints" id="field_trainingPoints" ng-model="vm.training.trainingPoints" min="0"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.training.validForYears" for="field_validForYears">Valid For Years</label><input type="number" class="form-control valid-for-years-input" name="validForYears" id="field_validForYears" ng-model="vm.training.validForYears" min="0"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.training.materials">Materials</label><div><table class="table table-trainingmaterial"><tbody><tr ng-repeat="material in vm.trainingMaterials | orderBy: \'listIndex\'"><td><a ng-if="material.linkUrl" ng-href="{{material.linkUrl | trainingMaterialLinkUrlAddProtocoll}}" target="_blank" title="{{material.linkUrl}}" class="materialLink"><span class="glyphicon glyphicon-new-window"></span> {{material.linkUrl}} </a><a ng-if="!material.linkUrl" ng-href="/api/training-materials/download/{{material.id}}/{{material.name | trainingMaterialEncodeFilename}}?inline=true" target="_blank"><span class="glyphicon glyphicon-file"></span> {{material.name}}</a></td><td><a ng-if="!material.linkUrl" ng-href="/api/training-materials/download/{{material.id}}/{{material.name | trainingMaterialEncodeFilename}}?inline=false"><span class="glyphicon glyphicon-save"></span> <span data-translate="abcQualityMatchApp.training.materialDownLoadLink">download</span></a></td><td><button type="button" class="btn btn-danger btn-sm" confirmed-delete="vm.deleteTrainingMaterial(material)" data-translate="entity.action.delete">Delete</button></td></tr></tbody><tfoot><tr><td colspan="2"><div class="alert alert-info material-upload-alert" ng-show="vm.uploadingTrainingMaterial"><div class="upload-spinner"></div><div><strong data-translate="abcQualityMatchApp.training.materialDownInProgressTitle">Uploading</strong><br><span data-translate="abcQualityMatchApp.training.materialDownInProgressMessage">Please wait</span></div></div><div class="alert alert-danger" ng-show="vm.selectedFileTooLarge"><span data-translate="abcQualityMatchApp.training.materialFileIsTooLargeMessage">File too large</span></div></td><td><div class="btn-group" uib-dropdown is-open="status.isopen"><button id="single-button" type="button" class="btn btn-primary" uib-dropdown-toggle><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="single-button"><li role="menuitem" ngf-select ngf-change="vm.setFileContent($file, $invalidFiles)" ngf-max-size="20MB"><span class="btn" data-translate="abcQualityMatchApp.training.addTrainingMaterialFileButton">add file</span></li><li role="menuitem" ng-click="vm.showAddMaterialLinkDialog()"><span class="btn" data-translate="abcQualityMatchApp.training.addTrainingMaterialLinkButton">add link</span></li></ul></div></td></tr></tfoot></table></div></div><div class="form-group"><label data-translate="abcQualityMatchApp.training.checklistItems">Checklist</label><table class="table table-checklist-edit"><tbody><tr ng-repeat="checklistItem in vm.training.checklistItems | orderBy: \'listIndex\'"><td>{{$index + 1}}.</td><td><textarea ng-model="checklistItem.name" placeholder="{{ \'abcQualityMatchApp.training.checklistItemName_placeholder\' | translate }}" rows="3" maxlength="255" class="form-control"></textarea><input type="text" ng-model="checklistItem.timeEstimate" class="form-control" placeholder="{{\'abcQualityMatchApp.training.checklistItemTimeEstimate_placeholder\' | translate}}"></td><td><button ng-disabled="$index === 0" type="button" class="btn-sm btn-primary" ng-click="vm.moveChecklistItem($index, \'up\')"><span class="glyphicon glyphicon-chevron-up"></span></button> <button ng-disabled="$index === vm.training.checklistItems.length -1" type="button" class="btn-sm btn-primary" ng-click="vm.moveChecklistItem($index, \'down\')"><span class="glyphicon glyphicon-chevron-down"></span></button> <button type="button" class="btn btn-danger btn-sm" confirmed-delete="vm.deleteChecklistItem($index)" confirmed-delete-message="abcQualityMatchApp.training.checklistItems_deleteConfirm" data-translate="entity.action.delete">Delete</button></td></tr></tbody><tfoot><tr><td colspan="2"></td><td><button type="button" class="btn-sm btn-primary" ng-click="event.preventDefault();vm.addNewChecklistItemName()"><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span></button></td></tr></tfoot></table></div><div class="form-group"><label data-translate="abcQualityMatchApp.training.examQuestions">Exam Questions</label><table class="table table-checklist-edit" id="examQuestionsTable"><thead><tr><th></th><th data-translate="abcQualityMatchApp.trainingExamQuestion.questionText">question text</th><th data-translate="abcQualityMatchApp.trainingExamQuestion.expectedAnswer">correct answer</th></tr></thead><tbody><tr ng-repeat="examQuestion in vm.training.examQuestions | orderBy: \'listIndex\'"><td>{{$index + 1}}.</td><td><textarea ng-model="examQuestion.questionText" placeholder="{{ \'abcQualityMatchApp.training.examQuestionText_placeholder\' | translate }}" rows="2" maxlength="255"></textarea></td><td><label><input type="radio" ng-model="examQuestion.expectedAnswer" ng-value="true"><span data-translate="abcQualityMatchApp.trainingExamQuestion.expectedAnswer_true">true</span></label><br><label><input type="radio" ng-model="examQuestion.expectedAnswer" ng-value="false"><span data-translate="abcQualityMatchApp.trainingExamQuestion.expectedAnswer_false">false</span></label></td><td><button ng-disabled="$index === 0" type="button" class="btn-sm btn-primary" ng-click="vm.moveExamQuestion($index, \'up\')"><span class="glyphicon glyphicon-chevron-up"></span></button> <button ng-disabled="$index === vm.training.examQuestions.length -1" type="button" class="btn-sm btn-primary" ng-click="vm.moveExamQuestion($index, \'down\')"><span class="glyphicon glyphicon-chevron-down"></span></button> <button type="button" class="btn btn-danger btn-sm" confirmed-delete="vm.deleteExamQuestion($index)" confirmed-delete-message="abcQualityMatchApp.training.examQuestions_deleteConfirm" data-translate="entity.action.delete">Delete</button></td></tr></tbody><tfoot><tr><td colspan="3"></td><td><button type="button" class="btn-sm btn-primary" ng-click="event.preventDefault();vm.addExamQuestion()"><span class="glyphicon glyphicon-plus"></span> <span data-translate="entity.action.add">add</span></button></td></tr></tfoot></table></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.training.examPassRequiredPercentLongLabel" for="field_examPassRequiredPercent">Exam Pass Required Percent</label><span class="exam-pass-percent"><input type="number" class="form-control" name="examPassRequiredPercent" id="field_examPassRequiredPercent" min="0" max="100" ng-model="vm.training.examPassRequiredPercent"> %</span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.uploadingTrainingMaterial" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/training-main/training/training-material-add-link-dialog.html','<form name="addLinkForm" role="form" novalidate ng-submit="vm.save()" show-validation class="training"><div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeDialog()">&times;</button><h4 class="modal-title" data-translate="abcQualityMatchApp.training.addTrainingMaterialLink">Add material</h4></div><div class="modal-body"><div class="form-group"><label for="materialLink" data-translate="abcQualityMatchApp.training.addMaterialLinkUrl"></label><input id="materialLink" name="materialLink" type="text" class="form-control" ng-model="vm.newTrainingMaterialLinkUrl" required ng-minlength="1"></div><div ng-show="addLinkForm.materialLink.$invalid"><p class="help-block" ng-show="addLinkForm.materialLink.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="addLinkForm.materialLink.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeDialog()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.save()" ng-disabled="addLinkForm.$invalid"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/training-main/training/training-material.component.html','<table class="table table-trainingmaterial-view"><tbody><tr ng-repeat="material in $ctrl.trainingMaterials | orderBy: \'listIndex\'"><td><a ng-if="material.linkUrl" ng-href="{{material.linkUrl | trainingMaterialLinkUrlAddProtocoll}}" target="_blank" title="{{material.linkUrl}}" class="materialLink"><span class="glyphicon glyphicon-new-window"></span> {{material.linkUrl}} </a><a ng-if="material.fileContentContentType" ng-href="/api/training-materials/download/{{material.id}}/{{material.name | trainingMaterialEncodeFilename}}?inline=true" target="_blank"><span class="glyphicon glyphicon-file"></span> {{material.name}}</a></td><td><a ng-if="material.fileContentContentType" ng-href="/api/training-materials/download/{{material.id}}/{{material.name | trainingMaterialEncodeFilename}}?inline=false"><span class="glyphicon glyphicon-save"></span> <span data-translate="abcQualityMatchApp.training.materialDownLoadLink">download</span></a></td></tr></tbody></table>');
$templateCache.put('app/training-main/training/trainings.html','<div><h2 data-translate="abcQualityMatchApp.training.home.title">Trainings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="training.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.training.home.createLabel">Create new Training</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="abcQualityMatchApp.training.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingType"><span data-translate="abcQualityMatchApp.training.trainingType">Training Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="organization"><span data-translate="abcQualityMatchApp.training.organization">Organization</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="primaryInstructor.lastName"><span data-translate="abcQualityMatchApp.training.primaryInstructor">Primary Instructor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingPoints"><span data-translate="abcQualityMatchApp.training.trainingPoints">Training Points</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="examPassRequiredPercent"><span data-translate="abcQualityMatchApp.training.examPassRequiredPercent">Exam Pass Required Percent</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="training in vm.trainings track by training.id"><td>{{training.name}}</td><td data-translate="{{\'abcQualityMatchApp.TrainingType.\' + training.trainingType}}">{{training.trainingType}}</td><td>{{training.organization}}</td><td>{{training.primaryInstructor | fullUserName}}</td><td>{{training.trainingPoints}}</td><td>{{training.examPassRequiredPercent}} <span ng-show="training.examPassRequiredPercent">%</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="training-detail({id:training.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="training.edit({id:training.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="training.delete({id:training.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/training-main/training-event/training-event-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trainingEvent.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.trainingEvent.delete.question" translate-values="{id: \'{{vm.trainingEvent | trainingEventViewFormat}}\'}">Are you sure you want to delete this Training Event?</p></div><div class="alert alert-warning" ng-show="vm.showDeleteHint"><strong data-translate="abcQualityMatchApp.trainingEvent.cantDeleteBecauseContainsTrainingRecords"></strong> <span data-translate="abcQualityMatchApp.trainingEvent.deleteTrainingRecordsFirst"></span></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/training-main/training-event/training-event-detail.html','<div class="training"><h2><span data-translate="abcQualityMatchApp.trainingEvent.detail.title">Training Event</span> {{vm.trainingEvent |trainingEventViewFormat }}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.trainingEvent.training">Training</span></dt><dd>{{vm.trainingEvent.training.name}}</dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.instructor">Instructor</span></dt><dd>{{vm.trainingEvent.instructor | fullUserName}}</dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.outsideInstructor">Outside Instructor</span></dt><dd>{{vm.trainingEvent.outsideInstructor}}</dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.location">Location</span></dt><dd><span>{{vm.trainingEvent.location}}</span></dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.duration">Duration</span></dt><dd><span>{{vm.trainingEvent.duration}}</span> <span ng-show="vm.trainingEvent.duration != null" data-translate="abcQualityMatchApp.trainingEvent.hours">Hours</span></dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.start">Start</span></dt><dd><span>{{vm.trainingEvent.start | date:\'short\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.end">End</span></dt><dd><span>{{vm.trainingEvent.end | date:\'short\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.validToDate">Valid To Date</span></dt><dd><span>{{vm.trainingEvent.validToDate | date:\'shortDate\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.allowSignups">Allow signups</span></dt><dd><span>{{vm.trainingEvent.allowSignups | checkMark}}</span></dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.signupLimitedToUserGroups.label">Usergroup limits</span></dt><dd><ul><li ng-repeat="groupLimit in vm.trainingEvent.userGroupSignupLimits">{{groupLimit.userGroup.name}}</li><li ng-show="vm.trainingEvent.userGroupSignupLimits.length == 0"><span data-translate="abcQualityMatchApp.trainingEvent.signupLimitedToUserGroups.noLimits"></span></li></ul></dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.signups">signups</span></dt><dd><div class="table-responsive"><table class="table table-signup-view"><thead><tr><th data-translate="abcQualityMatchApp.trainingEventSignup.user">user</th><th data-translate="abcQualityMatchApp.trainingEventSignup.signupDate">signupdate</th><th data-translate="abcQualityMatchApp.trainingEventSignup.signupAccepted">accepted"</th><th data-translate="abcQualityMatchApp.trainingEventSignup.examPassed">passed"</th></tr></thead><tbody><tr ng-repeat="signup in vm.trainingEvent.signups | orderBy: \'signupDate\'"><td>{{signup.user | fullUserName}}</td><td>{{signup.signupDate | date:\'short\'}}</td><td>{{signup.signupAccepted | checkMark }}</td><td>{{signup.examPassed | checkMark }}</td></tr><tr ng-show="vm.trainingEvent.signups.length == 0"><td colspan="3">{{\'abcQualityMatchApp.trainingEvent.signupsIsEmpty\'| translate}}</td></tr></tbody></table></div></dd><dt><span data-translate="abcQualityMatchApp.training.checklistItems">Checklist</span></dt><dd><ol class="checklist-list"><li ng-repeat="checklistItem in vm.trainingEvent.checklistItems | orderBy: \'listIndex\'"><span>{{checklistItem.completed | checkMark}} &nbsp;</span> <span class="item-content"><span class="item-text">{{checklistItem.name}}</span> <span class="time-estimate" ng-if="checklistItem.timeEstimate">{{checklistItem.timeEstimate}}</span></span></li></ol></dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.ended">Ended</span></dt><dd><span>{{vm.trainingEvent.ended | checkMark}}</span></dd><dt><span data-translate="abcQualityMatchApp.trainingEvent.teachingTimeSpend">teachingTimeSpend</span></dt><dd><span>{{vm.trainingEvent.teachingTimeSpend | number:1}}</span> <span ng_show="vm.trainingEvent.teachingTimeSpend != null" data-translate="unit.hours">hours</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="training-event-detail.edit({id:vm.trainingEvent.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/training-main/training-event/training-event-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation class="training"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTrainingEventLabel" data-translate="abcQualityMatchApp.trainingEvent.home.createOrEditLabel">Create or edit a Training Event</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><div class="input-group"><span>{{vm.trainingEvent.training.name}}</span><br><span data-translate="{{\'abcQualityMatchApp.TrainingType.\' + vm.trainingEvent.training.trainingType}}">{{vm.trainingEvent.training.trainingType}}</span></div></div><div class="form-group"><div class="input-group"><label class="control-label required" data-translate="abcQualityMatchApp.trainingEvent.instructor" for="field_instructor">Instructor</label><user-select id="field_instructor" user="vm.trainingEvent.instructor"></user-select></div></div><div ng-show="!vm.trainingEvent.instructor"><p class="help-block" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><div class="input-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.outsideInstructor" for="field_outsideInstructor">Outside Instructor</label><input type="text" class="form-control" name="outsideInstructor" id="field_outsideInstructor" ng-model="vm.trainingEvent.outsideInstructor" maxlength="255"></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.start" for="field_start">Start</label><div class="input-group"><input id="field_start" type="text" class="form-control" name="start" datetime-picker="{{dateformat}}" ng-model="vm.trainingEvent.start" is-open="vm.datePickerOpenStatus.start"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'start\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.end" for="field_end">End</label><div class="input-group"><input id="field_end" type="text" class="form-control" name="end" datetime-picker="{{dateformat}}" ng-model="vm.trainingEvent.end" is-open="vm.datePickerOpenStatus.end"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'end\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.location" for="field_location">Location</label><input type="text" class="form-control" name="location" id="field_location" ng-model="vm.trainingEvent.location"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.duration" for="field_duration">Duration</label><div class="duration"><input type="number" class="form-control" name="duration" id="field_duration" step="0.5" ng-model="vm.trainingEvent.duration"> <span data-translate="abcQualityMatchApp.trainingEvent.hours">Hours</span></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.validToDate" for="field_validToDate">Valid To Date</label><div class="input-group"><input id="field_validToDate" type="text" class="form-control" name="validToDate" datetime-picker="{{dateformat}}" ng-model="vm.trainingEvent.validToDate" is-open="vm.datePickerOpenStatus.validToDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validToDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label><input type="checkbox" name="allowSignups" ng-model="vm.trainingEvent.allowSignups" ng-disabled="vm.trainingEvent.training.trainingType == \'INDEPENDENT\'"> <span data-translate="abcQualityMatchApp.trainingEvent.allowSignups">Allow signups</span></label></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.signupLimitedToUserGroups.label">Singup limits to user groups</label><table class="table user-group-signup-limits-edit"><body><tr ng-repeat="groupLimit in vm.trainingEvent.userGroupSignupLimits"><td>{{groupLimit.userGroup.name}}</td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteSignupLimitGroup($index)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete">Delete</span></button></td></tr><tr><td colspan="2" ng-show="vm.trainingEvent.userGroupSignupLimits.length == 0"><span data-translate="abcQualityMatchApp.trainingEvent.signupLimitedToUserGroups.noLimits"></span></td></tr></body><tfoot><tr><td colspan="2"><select name="newUserGroupLimit" class="form-control" ng-model="vm.newUserGroupForSignupLimitLimit" ng-options="group.name for group in vm.userGroupSelectList" ng-change="vm.addUserGroupLimit()"><option value="" disabled="disabled" selected="selected" data-translate="abcQualityMatchApp.trainingEvent.signupLimitedToUserGroups.addUserGroupLimitPlaceholder"></option></select></td></tr></tfoot></table></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.signups">signups</label><div class="table-responsive"><table class="table table-signup-edit"><thead><tr><th data-translate="abcQualityMatchApp.trainingEventSignup.user">user</th><th data-translate="abcQualityMatchApp.trainingEventSignup.signupDate">signupdate</th><th data-translate="abcQualityMatchApp.trainingEventSignup.signupAccepted" ng-show="vm.trainingEvent.training.trainingType != \'INDEPENDENT\'">accepted"</th><th></th></tr></thead><tbody><tr ng-repeat="signup in vm.trainingEvent.signups | orderBy: \'signup.id\'"><td>{{signup.user | fullUserName}}</td><td>{{signup.signupDate | date:\'medium\'}}</td><td><input type="checkbox" ng-model="signup.signupAccepted" ng-if="vm.trainingEvent.training.trainingType != \'INDEPENDENT\'"></td><td><button type="button" class="btn btn-danger btn-sm" confirmed-delete="vm.deleteSignup($index)" confirmed-delete-message="abcQualityMatchApp.trainingEvent.signups_deleteConfirm" data-translate="entity.action.delete" ng-if="vm.trainingEvent.training.trainingType != \'INDEPENDENT\'">Delete</button></td></tr><tr ng-show="vm.trainingEvent.signups.length == 0"><td colspan="4">{{\'abcQualityMatchApp.trainingEvent.signupsIsEmpty\'| translate}}</td></tr></tbody><tfoot><tr ng-if="vm.trainingEvent.training.trainingType != \'INDEPENDENT\'"><td colspan="4"><user-select on-select="vm.addSignup()" user="vm.newSignup.user"></user-select></td></tr></tfoot></table></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.checklistItems ">checklist</label><ol class="checklist-list"><li ng-repeat="checklistItem in vm.trainingEvent.checklistItems | orderBy: \'listIndex\'"><label><input type="checkbox" ng-model="checklistItem.completed"> <span class="item-content"><span class="item-text">{{checklistItem.name}}</span> <span class="time-estimate" ng-if="checklistItem.timeEstimate">{{checklistItem.timeEstimate}}</span></span></label></li></ol><div ng-show="vm.trainingEvent.checklistItems.length == 0">{{\'abcQualityMatchApp.trainingEvent.checklistItemsIsEmpty\'| translate}}</div></div><div class="form-group"><label><input type="checkbox" name="ended" ng-model="vm.trainingEvent.ended" ng-disabled="!vm.trainingEvent.ended"> <span data-translate="abcQualityMatchApp.trainingEvent.ended">Ended</span></label></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.teachingTimeSpend" for="field_teachingTimeSpend">teachingTimeSpend</label><span class="teaching-time-spend"><input type="number" class="form-control" name="teachingTimeSpend" id="field_teachingTimeSpend" ng-model="vm.trainingEvent.teachingTimeSpend" step=".1"> <span data-translate="unit.hours">hours</span></span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || !vm.trainingEvent.instructor" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/training-main/training-event/training-event-instructor-view.html','<form name="instuctorForm" role="form" novalidate ng-submit="vm.save()" show-validation class="training"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTrainingEventLabel">{{vm.trainingEvent.training.name}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.training.materials">Materials</label><div><training-material training="vm.trainingEvent.training"></training-material></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.checklistItems ">checklist</label><ol class="checklist-list"><li ng-repeat="checklistItem in vm.trainingEvent.checklistItems | orderBy: \'listIndex\'"><label><input type="checkbox" ng-model="checklistItem.completed"> <span class="item-content"><span class="item-text">{{checklistItem.name}}</span> <span class="time-estimate" ng-if="checklistItem.timeEstimate">{{checklistItem.timeEstimate}}</span></span></label></li></ol><div ng-show="vm.trainingEvent.checklistItems.length == 0">{{\'abcQualityMatchApp.trainingEvent.checklistItemsIsEmpty\'| translate}}</div></div><br><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingEvent.teachingTimeSpend" for="field_teachingTimeSpend">teachingTimeSpend</label><span class="teaching-time-spend"><input type="number" class="form-control" name="teachingTimeSpend" id="field_teachingTimeSpend" ng-model="vm.trainingEvent.teachingTimeSpend" step=".1"> <span data-translate="unit.hours">hours</span></span></div><br><div class="form-group"><label class="control-label"><input type="checkbox" ng-model="vm.endTraining" name="endTraining"> <span data-translate="abcQualityMatchApp.trainingEvent.endTrainigCheckbox">End training</span></label></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/training-main/training-event/training-events.html','<div><h2 data-translate="abcQualityMatchApp.trainingEvent.home.title">Training Events</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><div class="btn-group" uib-dropdown is-open="status.isopen"><button id="single-button" type="button" class="btn btn-primary" uib-dropdown-toggle ng-disabled="disabled"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.trainingEvent.home.createLabel">Create new Training Event</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="single-button"><li ng-repeat="training in vm.trainings  | orderBy: \'name\'" role="menuitem"><a ui-sref="training-event.new({trainingId:training.id})">{{training.name}}</a></li><li role="menuitem" ng-show="vm.trainings.length == 0"><span>{{\'abcQualityMatchApp.trainingEvent.noTrainings\'| translate}}</span></li></ul></div></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="training.name"><span data-translate="abcQualityMatchApp.trainingEvent.training">Training</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="training.trainingType"><span data-translate="abcQualityMatchApp.training.trainingType">Training Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="instructor.lastName"><span data-translate="abcQualityMatchApp.trainingEvent.instructor">Instructor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="location"><span data-translate="abcQualityMatchApp.trainingEvent.location">Location</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="duration"><span data-translate="abcQualityMatchApp.trainingEvent.duration">Duration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="start"><span data-translate="abcQualityMatchApp.trainingEvent.start">Start</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="end"><span data-translate="abcQualityMatchApp.trainingEvent.end">End</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validToDate"><span data-translate="abcQualityMatchApp.trainingEvent.validToDateColumnLabel">Valid To Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="end"><span data-translate="abcQualityMatchApp.trainingEvent.allowSignups">Sign-ups allowed</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="end"><span data-translate="abcQualityMatchApp.trainingEvent.ended">Ended</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="teachingTimeSpend"><span data-translate="abcQualityMatchApp.trainingEvent.teachingTimeSpend">teachingTimeSpend</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="trainingEvent in vm.trainingEvents track by trainingEvent.id"><td>{{trainingEvent.training.name}}</td><td data-translate="{{\'abcQualityMatchApp.TrainingType.\' + trainingEvent.training.trainingType}}">{{training.trainingType}}</td><td>{{trainingEvent | trainingEventInstructor }}</td><td>{{trainingEvent.location}}</td><td style="white-space: pre !important">{{trainingEvent.duration}} <span ng-show="trainingEvent.duration != null" data-translate="abcQualityMatchApp.trainingEvent.hours">Hours</span></td><td>{{trainingEvent.start | date:\'shortDate\'}}</td><td>{{trainingEvent.end | date:\'shortDate\'}}</td><td>{{trainingEvent.validToDate | date:\'shortDate\'}}</td><td>{{trainingEvent.allowSignups | checkMark}}</td><td>{{trainingEvent.ended | checkMark}}</td><td>{{trainingEvent.teachingTimeSpend | number:1 }} <span ng_show="trainingEvent.teachingTimeSpend != null" data-translate="unit.hours">hours</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="training-event.instuctor-view({id:trainingEvent.id})" class="btn btn-default btn-sm" ng-hide="trainingEvent.training.trainingType == \'INDEPENDENT\'" ng-disabled="trainingEvent.ended"><span class="glyphicon glyphicon glyphicon-list"></span> <span class="hidden-xs hidden-sm" data-translate="abcQualityMatchApp.trainingEvent.sessionButton">Session</span></button> <button type="submit" ui-sref="training-event-detail({id:trainingEvent.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="training-event.edit({id:trainingEvent.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="training-event.delete({id:trainingEvent.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/training-main/training-record/training-record-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.trainingRecord.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="abcQualityMatchApp.trainingRecord.delete.question" translate-values="{id: \'{{vm.trainingRecord.id}}\'}">Are you sure you want to delete this Training Record?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/training-main/training-record/training-record-detail.html','<div><h2><span data-translate="abcQualityMatchApp.trainingRecord.detail.title">Training Record</span></h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.trainingRecord.trainingEvent">Training Event</span></dt><dd>{{vm.trainingRecord.trainingEvent | trainingEventViewFormat}}</dd><dt><span data-translate="abcQualityMatchApp.trainingRecord.trainee">Trainee</span></dt><dd>{{vm.trainingRecord.trainee | fullUserName}}</dd><dt><span data-translate="abcQualityMatchApp.trainingRecord.signupDate">Signup Date</span></dt><dd><span>{{vm.trainingRecord.signupDate | date:\'medium\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.trainingRecord.examPassed">Exam Passed</span></dt><dd><span>{{vm.trainingRecord.examPassed| checkMark}}</span></dd><dt><span data-translate="abcQualityMatchApp.trainingRecord.traineeSignedDate">Trainee Signed</span></dt><dd><span>{{vm.trainingRecord.traineeSignedDate | date:medium}}</span></dd><dt><span data-translate="abcQualityMatchApp.trainingRecord.validToDate">Valid To Date</span></dt><dd><span>{{vm.trainingRecord.validToDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="training-record-detail.edit({id:vm.trainingRecord.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/training-main/training-record/training-record-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTrainingRecordLabel" data-translate="abcQualityMatchApp.trainingRecord.home.createOrEditLabel">Create or edit a Training Record</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.trainingRecord.trainingEvent" for="field_trainingEvent">Training Event</label><div ng-if="vm.isIndependentStudy"><span>{{vm.trainingRecord.trainingEvent| trainingEventViewFormat}}</span></div><select ng-if="!vm.isIndependentStudy" class="form-control" id="field_trainingEvent" name="trainingEvent" ng-model="vm.trainingRecord.trainingEvent" ng-options="trainingEvent as (trainingEvent | trainingEventViewFormat)  for trainingEvent in vm.trainingevents track by trainingEvent.id" required><option value=""></option></select><div ng-show="editForm.trainingEvent.$invalid"><p class="help-block" ng-show="editForm.trainingEvent.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.trainingRecord.trainee">Trainee</label><user-select user="vm.trainingRecord.trainee"></user-select><div ng-show="!vm.trainingRecord.trainee"><p class="help-block" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingRecord.validToDate" for="field_validToDate">Valid To Date</label><div class="input-group"><input id="field_validToDate" type="text" class="form-control" name="validToDate" datetime-picker="{{dateformat}}" ng-model="vm.trainingRecord.validToDate" is-open="vm.datePickerOpenStatus.validToDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validToDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingRecord.signupDate" for="field_signupDate">Signup Date</label><div class="input-group"><input id="field_signupDate" type="text" class="form-control" name="signupDate" datetime-picker="{{dateformat}}" ng-model="vm.trainingRecord.signupDate" is-open="vm.datePickerOpenStatus.signupDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'signupDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_examPassed"><input type="checkbox" name="examPassed" id="field_examPassed" ng-model="vm.trainingRecord.examPassed"> <span data-translate="abcQualityMatchApp.trainingRecord.examPassed">Exam Passed</span></label></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.trainingRecord.traineeSignedDate" for="field_traineeSignedDate">Trainee signed date</label><div class="input-group"><input id="field_traineeSignedDate" type="text" class="form-control" name="traineeSignedDate" datetime-picker="{{dateformat}}" ng-model="vm.trainingRecord.traineeSignedDate" is-open="vm.datePickerOpenStatus.traineeSignedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'traineeSignedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || !vm.trainingRecord.trainee" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/training-main/training-record/training-records.html','<div><h2 data-translate="abcQualityMatchApp.trainingRecord.home.title">Training Records</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="training-record.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.trainingRecord.home.createLabel">Create new Training Record</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="trainingEvent.training.trainingType"><span data-translate="abcQualityMatchApp.training.trainingType">type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.training.name"><span data-translate="abcQualityMatchApp.trainingRecord.training">Training</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="signupDate"><span data-translate="abcQualityMatchApp.trainingRecord.signupDate">Signup Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.start"><span data-translate="abcQualityMatchApp.trainingEvent.start">start</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.end"><span data-translate="abcQualityMatchApp.trainingEvent.end">end</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="validToDate"><span data-translate="abcQualityMatchApp.trainingEvent.validToDateColumnLabel">Valid To Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.duration"><span data-translate="abcQualityMatchApp.trainingEvent.duration">duration</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.training.organization"><span data-translate="abcQualityMatchApp.training.organization">organization</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.instructor.lastName"><span data-translate="abcQualityMatchApp.trainingEvent.instructor">Instructor</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainingEvent.training.trainingPoints"><span data-translate="abcQualityMatchApp.training.trainingPoints">Training Points</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="examPassed"><span data-translate="abcQualityMatchApp.trainingRecord.examPassed">Exam Passed</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="traineeSignedDate"><span data-translate="abcQualityMatchApp.trainingRecord.traineeSignedDate">Trainee Signed date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="trainee.lastName"><span data-translate="abcQualityMatchApp.trainingRecord.trainee">Trainee</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="trainingRecord in vm.trainingRecords track by trainingRecord.id"><td data-translate="{{\'abcQualityMatchApp.TrainingType.\' + trainingRecord.trainingEvent.training.trainingType}}">{{trainingRecord.trainingEvent.training.trainingType}}</td><td>{{trainingRecord.trainingEvent.training.name}}</td><td>{{trainingRecord.signupDate | date:\'shortDate\'}}</td><td>{{trainingRecord.trainingEvent.start | date:\'shortDate\'}}</td><td>{{trainingRecord.trainingEvent.end | date:\'shortDate\'}}</td><td>{{trainingRecord.validToDate | date:\'shortDate\'}}</td><td>{{trainingRecord.trainingEvent.duration}}</td><td>{{trainingRecord.trainingEvent.training.organization}}</td><td>{{trainingRecord.trainingEvent | trainingEventInstructor }}</td><td>{{trainingRecord.trainingEvent.training.trainingPoints}}</td><td>{{trainingRecord.examPassed | checkMark}}</td><td>{{trainingRecord.traineeSignedDate | date:"shortDate"}}</td><td>{{trainingRecord.trainee | fullUserName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="training-record-detail({id:trainingRecord.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="training-record.edit({id:trainingRecord.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="training-record.delete({id:trainingRecord.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/training-main/training-requirements/training-requirements.html','<div class="training"><h2 data-translate="abcQualityMatchApp.training.trainingRequirements.title">Training needs</h2><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="(u.last_name)"><span data-translate="abcQualityMatchApp.training.trainingRequirements.user">User</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(training_name)"><span data-translate="abcQualityMatchApp.training.trainingRequirements.training">Training</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(valid_to_date)"><span data-translate="abcQualityMatchApp.training.trainingRequirements.validDate">Valid</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="(required)"><span data-translate="abcQualityMatchApp.training.trainingRequirements.required">Required</span><span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="requirements in vm.trainingRequirements"><td>{{requirements.lastName}}, {{requirements.firstName}}</td><td>{{requirements.trainingName}}</td><td><span ng-if="requirements.missingEntirely" data-translate="abcQualityMatchApp.training.trainingRequirements.missing">Missing</span> <span ng-if="!requirements.missingEntirely">{{requirements.validToDate | date: \'short\'}}</span></td><td>{{requirements.required | checkMark}}</td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/company_admin/product/import-dialog/product-import-dialog.html','<form name="importForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="abcQualityMatchApp.product.importTitle"></h4></div><div class="modal-body"><button ngf-select ngf-change="vm.setFileContent($file, $invalidFiles)" ngf-max-size="20MB" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-file"></span> <span data-translate="abcQualityMatchApp.product.addFileButton">File</span></button><label ng-if="vm.fileContent">{{ vm.filename }}</label><label ng-if="!vm.fileContent"><span data-translate="abcQualityMatchApp.product.importInfo"></span></label><br><br><div class="alert alert-info"><span>Tiedostossa ensimm\xE4isen sarakkeen tulee olla tuotteen nimi ja toisena sarakkeena on oltava tuotenumero, kuten ladattavassa listauksessa.</span><br><br><span>Jos tuotavalla tuotenumerolla on jo olemassa oleva tuote, sen nimi p\xE4ivitet\xE4\xE4n.</span></div><div class="form-group"><label for="setArchiveCheckbox"><input type="checkbox" id="setArchiveCheckbox" ng-model="vm.archived"> <span translate="abcQualityMatchApp.product.archiveMissingProducts">Archive missing products</span></label></div></div><div ng-if="vm.importFail" class="alert alert-danger"><span ng-if="vm.errorType == \'TEXT_TOO_LONG\'" data-translate="abcQualityMatchApp.product.importLongError" data-translate-values="vm.errorData"></span> <span ng-if="vm.errorType == \'MISSING_REQUIRED_DATA\'" data-translate="abcQualityMatchApp.product.importMissingDataError" data-translate-values="vm.errorData"></span> <span ng-if="vm.errorType == \'DUPLICATE_NUMBER_IN_EXCEL\'" data-translate="abcQualityMatchApp.product.importDuplicateNumberError" data-translate-values="vm.errorData"></span> <span ng-if="vm.errorType == \'UNEXPECTED_ERROR\'" data-translate="abcQualityMatchApp.product.unexpectedImportError"></span> <span ng-if="vm.errorType == \'EMPTY_EXCEL_FILE\'" data-translate="abcQualityMatchApp.product.emptyExcelError"></span> <span ng-if="vm.errorType == \'MULTIPLE_DUPLICATE_NUMBERS\'" data-translate="abcQualityMatchApp.product.multipleDuplicateNumbers" data-translate-values="vm.errorData"></span></div><span class="alert alert-danger" ng-if="vm.badFile" data-translate="abcQualityMatchApp.product.badFileError"></span><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="!vm.fileContent" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Import</span></button></div></form>');
$templateCache.put('app/components/home/anomalies/anomalies.html','<div class="dashboard-widget panel panel-default"><div class="dashboard-wigdet-header panel-heading"><h4 class="panel-title" data-translate="abcQualityMatchApp.anomalyEvent.title">Poikkeamat</h4></div><div class="dashboard widget-body panel-body"><div class="table-responsive uib-dropdown-friendly"><table class="table table-hover table-condensed"><thead><tr><th><span data-translate="abcQualityMatchApp.anomalyEvent.answerTime">Aika</span></th><th><span data-translate="abcQualityMatchApp.anomalyEvent.ticketTitle">Teht\xE4v\xE4</span></th><th><span data-translate="abcQualityMatchApp.anomalyEvent.questionnaireTitle">Lomake</span></th><th><span data-translate="abcQualityMatchApp.anomalyEvent.questionTitle">Kysymys</span></th><th><span data-translate="abcQualityMatchApp.anomalyEvent.value">Vastaus</span></th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat="anomaly in vm.anomalies"><td>{{anomaly.answerTime| date:\'shortDate\'}}</td><td><span class="long-text">{{anomaly.ticketTitle}}</span></td><td><span class="long-text">{{anomaly.questionnaireTitle}}</span></td><td><span class="long-text">{{anomaly.questionTitle}}</span></td><td>{{anomaly.value}}</td><td><div class="btn-group" uib-dropdown><button id="{{\'newAnomalyInformationButton\' + anomaly.row}}" class="btn-sm btn-primary" uib-dropdown-toggle><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.informationEvent.new">Tee ilmoitus </span><span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="{{\'newAnomalyInformationButton\' + anomaly.row}}"><li role="menuitem" ng-repeat="questionnaire in vm.informationQuestionnaires track by questionnaire.id"><a ui-sref="newInformation({questionnaireId: questionnaire.id, anomalyQuestionnaireAnswerId: anomaly.qaId, anomalyAnswerId: anomaly.answerId})">{{questionnaire.title}}</a></li></ul></div><button class="btn-sm btn-danger" ng-click="vm.reject(anomaly.qaId, anomaly.answerId)"><span class="glyphicon glyphicon-remove-circle"></span> <span data-translate="abcQualityMatchApp.anomalyEvent.acknowledge">Acknowledge</span></button></td></tr></tbody></table></div></div><div class="dashboard-widget-footer panel-footer"><button class="btn-sm btn-primary" ui-sref="anomaly"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs" data-translate="abcQualityMatchApp.anomalyEvent.all">Kaikki poikkeamat</span></button></div></div>');
$templateCache.put('app/components/home/informations/informations.html','<div class="dashboard-widget panel panel-default"><div class="dashboard-wigdet-header panel-heading"><h4 class="panel-title" data-translate="abcQualityMatchApp.informationEvent.dashboardWidgetTitle">new informations</h4></div><div class="dashboard widget-body panel-body"><div class="table-responsive"><table class="table table-hover table-condensed"><thead><tr><th><span data-translate="abcQualityMatchApp.information.submitDate">submitDate</span></th><th><span data-translate="abcQualityMatchApp.informationEvent.name">Otsikko</span></th><th><span data-translate="abcQualityMatchApp.informationEvent.type">Tyyppi</span></th><th><span data-translate="abcQualityMatchApp.informationEvent.state">Tila</span></th><th class="hidden-xs"><span data-translate="abcQualityMatchApp.informationEvent.creator">Ilmoittaja</span></th><th class="hidden-xs"><span data-translate="abcQualityMatchApp.informationEvent.assignedTo">Vastuutettu</span></th><th class="hidden-xs"><span data-translate="abcQualityMatchApp.informationEvent.assignedToUserGroup">Vastuutettu k\xE4ytt\xE4j\xE4ryhm\xE4</span></th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat="information in vm.informations"><td>{{information.submitDate| date:\'short\'}}</td><td>{{information.title}}</td><td data-translate="{{\'abcQualityMatchApp.QuestionnaireType.\' + information.questionnaireType}}">>{{information.questionnaireType}}</td><td>{{information.state}}</td><td class="hidden-xs">{{information.modifier}}</td><td class="hidden-xs">{{information.assignedTo}}</td><td class="hidden-xs">{{information.assignedToUserGroup}}</td><td><button ng-if="information.currentUserEditAllowed" class="btn-sm btn-primary" ui-sref="editInformation({id: information.id})"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-if="!information.currentUserEditAllowed" class="btn-sm btn-info" ui-sref="editInformation({id: information.id})"><span class="glyphicon glyphicon-eye-open"></span></button></td></tr></tbody></table></div></div><div class="dashboard-widget-footer panel-footer"><div class="btn-group" uib-dropdown><button id="newInformationButton" class="btn-sm btn-primary" uib-dropdown-toggle><span class="glyphicon glyphicon-plus"></span> <span data-translate="abcQualityMatchApp.informationEvent.new">Tee ilmoitus </span><span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="newInformationButton"><li role="menuitem" ng-repeat="questionnaire in vm.informationQuestionnaires track by questionnaire.id"><a ui-sref="newInformation({questionnaireId: questionnaire.id})">{{questionnaire.title}}</a></li></ul></div><button class="btn-sm btn-primary" ui-sref="information"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs" data-translate="abcQualityMatchApp.informationEvent.all">Kaikki ilmoitukset</span></button></div></div>');
$templateCache.put('app/components/home/projects/open-projects.html','<div class="dashboard-widget panel panel-default"><div class="dashboard-wigdet-header panel-heading"><h4 class="panel-title" data-translate="abcQualityMatchApp.project.latest.title">Avoimet projektit</h4></div><div class="dashboard widget-body panel-body"><div class="table-responsive"><table class="table table-hover table-condensed"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="abcQualityMatchApp.project.detail.title">Title</span></th><th><span data-translate="abcQualityMatchApp.project.startDate">State</span></th><th><span data-translate="abcQualityMatchApp.project.endDate">Title</span></th><th><span data-translate="abcQualityMatchApp.ticket.state">State</span></th><th></th></tr></thead><tbody><tr ng-repeat="project in vm.projects track by project.id"><td>{{project.ticket.title}}</td><td>{{project.startDate| date:\'mediumDate\'}}</td><td>{{project.endDate| date:\'mediumDate\'}}</td><td>{{project.ticket.state.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="project-detail({id:project.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button></div></td></tr></tbody></table></div></div><div class="dashboard-widget-footer panel-footer"><button class="btn-sm btn-primary" ui-sref="project"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs" data-translate="abcQualityMatchApp.project.latest.all">Kaikki projektit</span></button></div></div>');
$templateCache.put('app/components/home/tasks/tasks.html','<div class="dashboard-widget panel panel-default"><div class="dashboard-wigdet-header panel-heading"><h4 class="panel-title" data-translate="abcQualityMatchApp.taskEvent.title">Teht\xE4v\xE4t</h4></div><div class="dashboard widget-body panel-body"><div class="table-responsive"><table class="table table-hover table-condensed"><thead><tr><th><span data-translate="abcQualityMatchApp.taskEvent.start">Alkaa</span></th><th><span data-translate="abcQualityMatchApp.taskEvent.end">Loppuu</span></th><th><span data-translate="abcQualityMatchApp.taskEvent.task">Teht\xE4v\xE4</span></th><th><span data-translate="abcQualityMatchApp.taskEvent.ticketState">Tila</span></th><th>&nbsp;</th></tr></thead><tbody ng-repeat="category in vm.dateCategories"><tr><th colspan="5"><span data-translate="{{\'abcQualityMatchApp.taskEvent.dateCategory.\' + category.dateCategory}}">{{category.dateCategory}}</span></th></tr><tr ng-repeat="task in category.children" ng-class="vm.taskClassCheck(task)"><td ng-if="task.allDay">{{task.start| date:\'shortDate\'}}</td><td ng-if="!task.allDay">{{task.start| date:\'short\'}}</td><td ng-if="task.allDay">{{task.end| date:\'shortDate\'}}</td><td ng-if="!task.allDay">{{task.end| date:\'short\'}}</td><td><span class="long-text">{{task.title}}</span></td><td>{{task.state}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-if="task.questionnaireId" class="btn-sm btn-primary" ui-sref="task-fulfilment({id: task.questionnaireId, answerId: task.answerId, taskId:task.taskId, recurrenceDateId:task.recurrenceDateId})"><span class="glyphicon glyphicon-pencil"></span></button> <button ng-if="!task.questionnaireId" class="btn-sm btn-success" ng-click="vm.confirm(task.taskId, task.recurrenceDateId)"><span class="glyphicon glyphicon-ok"></span></button></div></td></tr><tr><th colspan="5">&nbsp;</th></tr></tbody></table></div></div><div class="dashboard-widget-footer panel-footer"><button class="btn-sm btn-primary" ui-sref="task-list"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs" data-translate="abcQualityMatchApp.taskEvent.all">Kaikki teht\xE4v\xE4t</span></button></div></div>');
$templateCache.put('app/components/home/verification-events/verification-events.html','<div class="dashboard-widget panel panel-default"><div class="dashboard-wigdet-header panel-heading"><h4 class="panel-title" data-translate="abcQualityMatchApp.taskVerification.taskEvent.title">Ilmoitukset</h4></div><div class="dashboard widget-body panel-body"><div class="table-responsive"><table class="table table-hover table-condensed"><thead><tr><th><span data-translate="abcQualityMatchApp.taskVerification.taskEvent.ticketTitle">Teht\xE4v\xE4</span></th><th><span data-translate="abcQualityMatchApp.ticket.doneTime">doneTime</span></th><th><span data-translate="abcQualityMatchApp.taskVerification.taskEvent.notVerified">Todentamattomat</span></th><th>&nbsp;</th></tr></thead><tbody><tr ng-repeat="event in vm.taskVerifications"><td>{{event.title}}</td><td>{{event.doneTimeMin | date:\'short\'}}</td><td>{{event.notVerified}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button class="btn-sm btn-primary" ui-sref="task-verification({parentTaskId: event.taskId, questionnaireId: event.questionnaireId})"><span class="glyphicon glyphicon-pencil"></span></button></div></td></tr></tbody></table></div></div><div class="dashboard-widget-footer panel-footer"><button class="btn-sm btn-primary" ui-sref="task-verification-list"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs" data-translate="abcQualityMatchApp.taskVerification.all">Kaikki todennettavat</span></button></div></div>');
$templateCache.put('app/components/report/stats/stats.html','<div class="dashboard-widget panel panel-default reporting"><div class="dashboard-wigdet-header panel-heading"><h4 class="panel-title" data-translate="abcQualityMatchApp.report.stats.title">Stats</h4></div><div class="dashboard widget-body panel-body"><div class="table-responsive uib-dropdown-friendly"><table class="table table-hover table-condensed statistics"><thead><tr><th><span data-translate="abcQualityMatchApp.report.stats.stat">Stat</span></th><th><span data-translate="abcQualityMatchApp.report.stats.fromStartOfYear">fromStartOfYear</span></th><th><span data-translate="abcQualityMatchApp.report.stats.lastMonth">lastMonth</span></th><th><span data-translate="abcQualityMatchApp.report.stats.thisMonth">thisMonth</span></th></tr></thead><tbody><tr><th data-translate="abcQualityMatchApp.report.stats.anomalies">Anomalies</th><td class="count">{{vm.stats.anomalies.fromStartOfYear}}</td><td class="count">{{vm.stats.anomalies.lastMonth}}</td><td class="count">{{vm.stats.anomalies.thisMonth}}</td></tr><tr ng-repeat="sub in vm.stats.anomalies.subRows" class="sub-row"><td>{{sub.name}}</td><td class="count">{{sub.fromStartOfYear}}</td><td class="count">{{sub.lastMonth}}</td><td class="count">{{sub.thisMonth}}</td></tr></tbody><tbody><tr><th data-translate="abcQualityMatchApp.report.stats.measurements">Measurements</th><td class="count">{{vm.stats.measurements.fromStartOfYear}}</td><td class="count">{{vm.stats.measurements.lastMonth}}</td><td class="count">{{vm.stats.measurements.thisMonth}}</td></tr><tr ng-repeat="sub in vm.stats.measurements.subRows" class="sub-row"><td>{{sub.name}}</td><td class="count">{{sub.fromStartOfYear}}</td><td class="count">{{sub.lastMonth}}</td><td class="count">{{sub.thisMonth}}</td></tr></tbody><tbody><tr><th data-translate="abcQualityMatchApp.report.stats.informations">Informations</th><td class="count">{{vm.stats.informations.fromStartOfYear}}</td><td class="count">{{vm.stats.informations.lastMonth}}</td><td class="count">{{vm.stats.informations.thisMonth}}</td></tr><tr ng-repeat="sub in vm.stats.informations.subRows" class="sub-row"><td>{{sub.name}}</td><td class="count">{{sub.fromStartOfYear}}</td><td class="count">{{sub.lastMonth}}</td><td class="count">{{sub.thisMonth}}</td></tr></tbody><tbody><tr><th data-translate="abcQualityMatchApp.report.stats.rootCauseAnalyses">rootCauseAnalyses</th><td class="count">{{vm.stats.rootCauseAnalyses.fromStartOfYear}}</td><td class="count">{{vm.stats.rootCauseAnalyses.lastMonth}}</td><td class="count">{{vm.stats.rootCauseAnalyses.thisMonth}}</td></tr><tr ng-repeat="sub in vm.stats.rootCauseAnalyses.subRows" class="sub-row"><td colspan="4">{{sub.name}}</td></tr></tbody><tbody><tr><th data-translate="abcQualityMatchApp.report.stats.correctiveProjects">correctiveProjects</th><td class="count">{{vm.stats.correctiveProjects.fromStartOfYear}}</td><td class="count">{{vm.stats.correctiveProjects.lastMonth}}</td><td class="count">{{vm.stats.correctiveProjects.thisMonth}}</td></tr><tr ng-repeat="sub in vm.stats.correctiveProjects.subRows" class="sub-row"><td colspan="4">{{sub.name}}</td></tr></tbody><tbody><tr><th data-translate="abcQualityMatchApp.report.stats.correctiveTasks">correctiveTasks</th><td class="count">{{vm.stats.correctiveTasks.fromStartOfYear}}</td><td class="count">{{vm.stats.correctiveTasks.lastMonth}}</td><td class="count">{{vm.stats.correctiveTasks.thisMonth}}</td></tr><tr ng-repeat="sub in vm.stats.correctiveTasks.subRows" class="sub-row"><td colspan="4">{{sub.name}}</td></tr></tbody></table></div></div><div class="dashboard-widget-footer panel-footer"></div></div>');
$templateCache.put('app/document/document-tree/document-file/document-file-detail.html','<div class="document"><h2><span data-translate="abcQualityMatchApp.documentFile.detail.title">Title</span></h2><hr><jhi-alert-error></jhi-alert-error><uib-tabset active="vm.activeTab"><uib-tab index="vm.TAB_INDEXES.current"><uib-tab-heading><span data-translate="abcQualityMatchApp.documentFile.versioningTabTitle.currentVersion"></span></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div ng-if="vm.documentFileVersioning.currentVersion"><document-file-details-view document-file="vm.documentFileVersioning.currentVersion"></document-file-details-view><button type="button" ng-click="vm.editCurrentVersion()" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div><div ng-if="!vm.documentFileVersioning.currentVersion" class="alert alert-info"><span data-translate="abcQualityMatchApp.documentFile.noCurrentVersionHelp"></span></div></div></div></uib-tab><uib-tab index="vm.TAB_INDEXES.next"><uib-tab-heading><span data-translate="abcQualityMatchApp.documentFile.versioningTabTitle.nextVersion"></span></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div ng-if="vm.documentFileVersioning.nextVersion"><document-file-details-view document-file="vm.documentFileVersioning.nextVersion"></document-file-details-view><button type="button" ng-click="vm.editNextVersion()" class="btn btn-primary versioningCreateEditButton"><span class="glyphicon glyphicon-pencil"></span> <span data-translate="entity.action.edit">Edit</span></button></div><div ng-if="!vm.documentFileVersioning.nextVersion"><button type="button" ng-click="vm.createNextVersion()" class="btn btn-primary versioningCreateEditButton"><span class="glyphicon glyphicon-pencil"></span> <span data-translate="abcQualityMatchApp.documentFile.createNewVersion"></span></button></div></div></div></uib-tab><uib-tab index="vm.TAB_INDEXES.archived"><uib-tab-heading><span data-translate="abcQualityMatchApp.documentFile.versioningTabTitle.archived"></span></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><table class="table table-hover table-condensed"><thead><tr><th><span data-translate="abcQualityMatchApp.documentFile.name">name</span></th><th><span data-translate="abcQualityMatchApp.documentFile.publishedDate">publishedDate</span></th><th><span data-translate="abcQualityMatchApp.documentFile.version">version</span></th><th><span data-translate="abcQualityMatchApp.documentFile.validityEndDate">validityEndDate</span></th><th><span data-translate="abcQualityMatchApp.documentFile.maintainers">maintainers</span></th><th><span data-translate="abcQualityMatchApp.documentFile.classification">classification</span></th><th></th></tr></thead><tbody ng-repeat="fsItem in vm.documentFileVersioning.archivedVersions track by fsItem.id"><tr><td class="fileName"><span><a class="btn btn-link" ng-href="/api/document-files/download/{{fsItem.id}}/{{fsItem.fileName| documentFileEncodeFilename}}?inline=true" target="_blank" title="{{\'entity.action.view\' | translate}}"><span class="glyphicon glyphicon-file"></span>&nbsp;{{fsItem.name}}</a></span></td><td>{{fsItem.publishedDate | date: \'shortDate\'}}</td><td>{{fsItem.version}}</td><td>{{fsItem.validityEndDate | date: \'shortDate\'}}</td><td><ul class="list-unstyled"><li ng-repeat="user in fsItem.maintainers  | orderBy:\'lastName\' track by user.id">{{user|fullUserName}}</li></ul></td><td>{{fsItem.classification}}</td><td><button ng-click="vm.toggleArchivedVisible($index)" class="btn btn-info btn-sm" type="button"><span ng-show="!vm.archivedVisible[$index]"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span> </span><span ng-show="vm.archivedVisible[$index]"><span class="glyphicon glyphicon-eye-close"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.close"></span></span></button></td></tr><tr ng-if="vm.archivedVisible[$index]"><td colspan="7"><document-file-details-view document-file="fsItem"></document-file-details-view></td></tr></tbody></table></div></div></uib-tab></uib-tabset><hr><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/document/document-tree/document-folder/document-folder-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentFolderLabel" data-translate="abcQualityMatchApp.documentFolder.home.createOrEditLabel">Create or edit a Document Folder</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.documentFolder.parentFolder">parentFolder</label><document-folder-select folder-id="vm.documentFolder.parentFolderId" disable-from-folder-id="vm.documentFolder.id" valid-selection="vm.validParentFolderSelected" allow-initial-value="vm.documentFolder.id != null"></document-folder-select></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.documentFolder.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.documentFolder.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFolder.permissions">Permissions</label><p ng-if="vm.documentFolder.parentFolder" data-translate="abcQualityMatchApp.documentFolder.subPermission">See parent folder permissions</p><div class="table-responsive" ng-if="!vm.documentFolder.parentFolder"><table class="table table-signup-edit"><thead><tr><th data-translate="abcQualityMatchApp.documentFolder.userGroup">Usergroup</th><th data-translate="abcQualityMatchApp.documentFolder.readPermission">Read</th><th data-translate="abcQualityMatchApp.documentFolder.writePermission">Write</th><th></th></tr></thead><tbody><tr ng-repeat="permission in vm.documentFolder.permissions | orderBy: \'permission.userGroup.name\'"><td>{{permission.userGroup.name}}</td><td><span class="glyphicon glyphicon-check"></span></td><td><input type="checkbox" ng-model="permission.writePermission"></td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deletePermission($index)"><span class="glyphicon glyphicon-remove-circle"></span> <span data-translate="entity.action.delete">Delete</span></button></td></tr><tr ng-show="vm.documentFolder.permissions.length == 0"><td colspan="4">{{\'abcQualityMatchApp.documentFolder.noPermissions\'| translate}}</td></tr></tbody><tfoot><tr><td colspan="4"><select name="newUserGroup" class="form-control" ng-model="vm.newPermission.userGroup" ng-options="userGroup as userGroup.name for userGroup in vm.userGroups track by userGroup.id" ng-change="vm.addPermission()"><option value="" disabled="disabled" selected="selected">{{\'abcQualityMatchApp.documentFolder.permissionsAddUserGroupSelectPlaceholder\'| translate}}</option></select></td></tr></tfoot></table></div><div class="form-group"><label for="field_publicFolder"><input type="checkbox" id="field_publicFolder" ng-model="vm.documentFolder.publicFolder" name="publicFolder"> <span translate="abcQualityMatchApp.documentFolder.publicFolder">Public Folder</span></label><div class="alert alert-warning"><span data-translate="abcQualityMatchApp.documentFolder.permissionWarning"></span></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || !vm.validParentFolderSelected" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/document/document-tree/tree-view/document-tree-view.html','<div class="document"><h2 data-translate="abcQualityMatchApp.documentFolder.home.title">Documents</h2><jhi-alert></jhi-alert><form class="listing-filters"><fieldset><div class="form-group has-feedback"><div><input class="form-control" type="text" ng-model="vm.searchTerms" ng-change="vm.filterBySearchTerms(vm.searchTerms)" ng-model-options="{ debounce: 1000 }" title="{{\'abcQualityMatchApp.document.searchTooltip\'| translate}}" placeholder="{{\'abcQualityMatchApp.document.searchPlaceholder\'| translate}}"> <span class="glyphicon glyphicon-search form-control-feedback"></span></div></div></fieldset></form><div class="table-responsive"><table class="jh-table table table-hover treeTable"><thead><tr><th colspan="2"><span data-translate="abcQualityMatchApp.documentFile.name">name</span></th><th><span data-translate="abcQualityMatchApp.documentFile.publishedDate">publishedDate</span></th><th><span data-translate="abcQualityMatchApp.documentFile.version">version</span></th><th><span data-translate="abcQualityMatchApp.documentFile.validityEndDate">validityEndDate</span></th><th><span data-translate="abcQualityMatchApp.documentFile.maintainers">maintainers</span></th><th><span data-translate="abcQualityMatchApp.documentFile.classification">classification</span></th></tr></thead><tbody ng-repeat="fsItem in vm.fsItems track by $index" data-nestinglevel="{{fsItem.nestingLevel}}"><tr class="folder" ng-if="fsItem.rowType == \'folder\' && ((!vm.searchTerms && (fsItem.nestingLevel == 0 || fsItem.parentFolder.open)) || (vm.searchTerms && fsItem.filterMatch || fsItem.parentFolder.open))"><td class="folderName"><span ng-click="vm.folderClick(fsItem)" style="margin-left:{{fsItem.nestingLevel * 1.2}}em"><span class="glyphicon" ng-class="{\'glyphicon-folder-close\': !fsItem.open, \'glyphicon-folder-open\': fsItem.open}"></span>&nbsp; <span class="fsItemName" ng-bind-html="fsItem.name | highlightMatch:vm.searchTerms"></span></span></td><td colspan="6"></td></tr><tr ng-if="fsItem.rowType == \'file\' && ((fsItem.parentFolder.open) || (vm.searchTerms && fsItem.filterMatch))"><td class="fileName"><span style="padding-left:{{(fsItem.parentFolder.nestingLevel +1) * 1.2}}em"><a class="btn btn-link" ng-href="/api/document-files/download/latest/{{fsItem.rootVersionId}}?inline=true" target="_blank" title="{{\'entity.action.view\' | translate}}"><span class="glyphicon glyphicon-file"></span>&nbsp; <span class="fsItemName" ng-bind-html="fsItem.name | highlightMatch:vm.searchTerms"></span></a></span></td><td><a class="btn btn-default btn-sm" ng-href="/api/document-files/download/latest/{{fsItem.rootVersionId}}?inline=false"><span class="glyphicon glyphicon-save"></span> <span data-translate="abcQualityMatchApp.document.documentFileDownLoadLink">download</span></a></td><td>{{fsItem.publishedDate | date: \'shortDate\'}}</td><td>{{fsItem.version}}</td><td>{{fsItem.validityEndDate | date: \'shortDate\'}}</td><td><ul class="list-unstyled"><li ng-repeat="user in fsItem.maintainers  | orderBy:\'lastName\' track by user.id">{{user|fullUserName}}</li></ul></td><td><span ng-bind-html="fsItem.classification | highlightMatch:vm.searchTerms"></span></td></tr></tbody><tfoot><tr ng-if="vm.searchTerms && vm.searchMatchCount > 0"><td colspan="7"><span class="text-muted" data-translate="abcQualityMatchApp.document.searchResults" data-translate-values="{searchTerms: \'{{vm.searchTerms}}\'}"></span><br><button type="button" class="btn btn-default btn-sm" ng-click="vm.filterBySearchTerms(\'\')"><span data-translate="abcQualityMatchApp.document.clearSearch"></span></button></td></tr><tr ng-if="vm.searchTerms && vm.searchMatchCount === 0"><td colspan="7"><span class="text-muted" data-translate="abcQualityMatchApp.document.searchNoResults" data-translate-values="{searchTerms: \'{{vm.searchTerms}}\'}"></span><br><button type="button" class="btn btn-default btn-sm" ng-click="vm.filterBySearchTerms(\'\')"><span data-translate="abcQualityMatchApp.document.clearSearch"></span></button></td></tr></tfoot></table></div></div>');
$templateCache.put('app/task/task-execution-counts/task-details-dialog/task-details-dialog.html','<div><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="abcQualityMatchApp.task.detail.title"></h4></div><div class="modal-body"><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="abcQualityMatchApp.ticket.title">Title</span></dt><dd><span class="long-text">{{vm.task.title}}</span></dd><dt><span data-translate="abcQualityMatchApp.ticket.description">Description</span></dt><dd><span class="long-text">{{vm.task.description}}</span></dd><dt><span data-translate="abcQualityMatchApp.ticket.materials">Material</span></dt><dd><div><ticket-material task="vm.task"></ticket-material></div></dd><dt><span data-translate="abcQualityMatchApp.task.start">Start</span></dt><dd><span ng-if="vm.task.allDay">{{vm.task.start | date:\'shortDate\'}}</span> <span ng-if="!vm.task.allDay">{{vm.task.start | date:\'short\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.task.end">End</span></dt><dd><span ng-if="vm.task.allDay">{{vm.task.end | date:\'shortDate\'}}</span> <span ng-if="!vm.task.allDay">{{vm.task.end | date:\'short\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.ticket.doneTime">doneTime</span></dt><dd><span>{{vm.task.doneTime | date:\'short\'}}</span></dd><dt ng-if="vm.task.freq != undefined"><span data-translate="abcQualityMatchApp.recurrence.freq">Frequence</span></dt><dd ng-if="vm.task.freq != undefined"><span data-translate="{{\'abcQualityMatchApp.Frequence.\' + vm.task.freq}}">{{vm.task.freq}}</span></dd><dt ng-if="vm.task.freq != undefined"><span data-translate="abcQualityMatchApp.recurrence.recurInterval">Interval</span></dt><dd ng-if="vm.task.freq != undefined"><span>{{vm.task.interval}}</span></dd><dt ng-if="vm.task.freq != undefined"><span data-translate="abcQualityMatchApp.recurrence.recurCount">Count</span></dt><dd ng-if="vm.task.freq != undefined"><span>{{vm.task.count}}</span></dd><dt ng-if="vm.task.freq != undefined"><span data-translate="abcQualityMatchApp.recurrence.until">Until</span></dt><dd ng-if="vm.task.freq != undefined"><span>{{vm.task.until | date:\'short\'}}</span></dd></dl></div><div><questionnaire-answers-view questionnaire-answer="vm.questionnaireAnswer"></questionnaire-answers-view></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="entity.action.cancel">Cancel</span></button></div></div>');
$templateCache.put('app/task/task-execution-counts/task-executions/task-executions.html','<style>.task-execution .task-executions-table > tbody > tr> td:first-child{\n        width: 14em;\n    }\n    .task-execution .task-executions-table > thead > tr > th.planned-time{\n        font-weight: normal;\n    }\n    .task-execution .task-executions-table > thead > tr> th.execution-col,\n    .task-execution .task-executions-table > tbody > tr> td.execution-col{\n        padding-right: 1em;\n        padding-left: 1em;\n    }\n    .task-execution .task-executions-table.table{\n        width: auto;\n    }\n\n    .task-execution .task-executions-table .questionnaire-title{\n        font-weight: bolder;\n    }\n    .task-execution .task-executions-table .question-title{\n        padding-left: 1em;\n\n    }\n\n    .task-execution .task-executions-table .verification-comment,\n    .task-execution .task-executions-table .answer-freetext{\n        max-width: 20em;\n        white-space: pre-line;\n        display: inline-block;\n    }\n    .task-execution .task-executions-table .answer-multiple-choice{\n        white-space: pre-line;\n    }\n\n    .task-execution .color-legends > span{\n        padding: 0.3em;\n    }\n\n    .task-execution .pager{\n        margin-top: 1em;\n        margin-bottom: 1em;\n    }</style><div class="task-execution"><h2><span data-translate="abcQualityMatchApp.task.taskExecutions.title">taskExecutions</span>: {{vm.task.title}}</h2><hr><jhi-alert-error></jhi-alert-error><form ng-submit="vm.refreshSearch()" class="listing-filters"><fieldset><legend data-translate="abcQualityMatchApp.task.taskExecutions.findByDateLimits"></legend><div class="timespan-limit"><div class="input-group date-select-container"><input id="field_fromDate" type="text" class="form-control" name="fromDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.filtering.fromDate" is-open="vm.datePickerOpenStatus.fromDate" ng-change="vm.refreshSearch()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div>-<div class="input-group date-select-container"><input id="field_toDate" type="text" class="form-control" name="toDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.filtering.toDate" is-open="vm.datePickerOpenStatus.toDate" ng-change="vm.refreshSearch()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'toDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></fieldset></form><table class="table table-condensed table-responsive table-hover task-executions-table" ng-repeat="executionsTable in vm.taskExecutionsTables"><thead><tr><th><span data-translate="abcQualityMatchApp.task.taskExecutions.plannedExecutionTime"></span></th><th class="planned-time execution-col" ng-repeat=" taskExec in executionsTable.executions"><span>{{taskExec.startTime | date:\'short\'}}</span> -<br><span>{{taskExec.endTime | date:\'short\'}}</span></th></tr></thead><tbody><tr><td><span data-translate="abcQualityMatchApp.ticket.doneTime"></span></td><td class="execution-col" ng-repeat=" taskExec in executionsTable.executions" ng-class="{danger:taskExec.anomaly && !taskExec.anomalyConfirmed, warning: !taskExec.anomaly && taskExec.anomalyConfirmed }"><span>{{taskExec.doneTime | date:\'short\'}}</span></td></tr><tr><td><span data-translate="abcQualityMatchApp.ticket.state"></span></td><td class="execution-col" ng-repeat=" taskExec in executionsTable.executions"><span>{{taskExec.stateName}}</span></td></tr><tr ng-if="executionsTable.questionnaire"><td><span data-translate="abcQualityMatchApp.task.taskExecutions.verificationComment"></span></td><td class="execution-col" ng-repeat=" taskExec in executionsTable.executions"><span class="verification-comment">{{taskExec.verificationComment}}</span></td></tr></tbody><tbody class="questionnaire-part" ng-if="executionsTable.questionnaire"><tr><td class="questionnaire-title">{{executionsTable.questionnaire.title}}</td><td colspan="{{executionsTable.executions.length}}"></td></tr><tr ng-repeat="question in executionsTable.questionnaire.questions"><td class="question-title">{{question.title}}</td><td class="execution-col" ng-repeat="answer in question.answers track by $index" ng-class="{danger:answer.anomaly && !answer.anomalyConfirmed, warning: !answer.anomaly && answer.anomalyConfirmed }"><div ng-if="answer" ng-switch="answer.answerType"><span ng-switch-when="integer" class="answer-numeric">{{answer.integerValue}}</span> <span ng-switch-when="decimal" class="answer-numeric">{{vm.setFloatPrecision(answer.decimalValue)}}</span> <span ng-switch-when="freetext" class="answer-freetext">{{answer.freeTextValue}}</span> <span ng-switch-when="multi" class="answer-multiple-choice">{{answer.multipleChoiceValue}}</span></div><div ng-click="storageFile.visible = !storageFile.visible" ng-repeat="storageFile in answer.storageFiles track by $index">{{ storageFile.fileName }} <img height="120px" ng-if="storageFile.visible" ng-src="data:{{storageFile.contentType}};base64,{{storageFile.content}}"></div></td></tr></tbody></table><div class="color-legends"><span class="bg-warning" data-translate="abcQualityMatchApp.taskVerification.legend.confirmedAnomaly"></span> <span class="bg-danger" data-translate="abcQualityMatchApp.taskVerification.legend.anomaly"></span></div><div class="pager"><button type="button" ng-disabled="!vm.hasPreviousPage" ng-click="vm.loadPage(vm.page - 1)" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="abcQualityMatchApp.task.taskExecutions.previousPage">previous</span></button> <button type="button" ng-disabled="!vm.hasNextPage" ng-click="vm.loadPage(vm.page +1)" class="btn btn-info">&nbsp;<span data-translate="abcQualityMatchApp.task.taskExecutions.nextPage">next</span> <span class="glyphicon glyphicon-arrow-right"></span></button></div><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/document/document-tree/document-file/details-view/document-file-details-view.html','<dl class="dl-horizontal jh-entity-details document"><dt><span data-translate="abcQualityMatchApp.documentFile.file">fileName</span></dt><dd><span><a class="btn btn-link" ng-href="/api/document-files/download/{{$ctrl.documentFile.id}}/{{$ctrl.documentFile.fileName| documentFileEncodeFilename}}?inline=true" target="_blank" title="{{\'entity.action.view\' | translate}}">{{$ctrl.documentFile.fileName}} </a></span><a class="btn btn-default btn-sm" ng-href="/api/document-files/download/{{$ctrl.documentFile.id}}/{{$ctrl.documentFile.fileName| documentFileEncodeFilename}}?inline=false"><span class="glyphicon glyphicon-save"></span> <span data-translate="abcQualityMatchApp.document.documentFileDownLoadLink">download</span></a></dd><dt><span data-translate="abcQualityMatchApp.documentFile.name">Name</span></dt><dd><span>{{$ctrl.documentFile.name}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.description">description</span></dt><dd><span>{{$ctrl.documentFile.description}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.classification">classification</span></dt><dd><span>{{$ctrl.documentFile.classification}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.validityEndDate">validityEndDate</span></dt><dd><span>{{$ctrl.documentFile.validityEndDate | date:\'shortDate\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.validityEndAlertDate">validityEndAlertDate</span></dt><dd><span>{{$ctrl.documentFile.validityEndAlertDate | date:\'shortDate\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.approvalDate">approvalDate</span></dt><dd><span>{{$ctrl.documentFile.approvalDate | date:\'shortDate\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.publishedDate">publishedDate</span></dt><dd><span>{{$ctrl.documentFile.publishedDate | date:\'shortDate\'}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.authorUser">authorUser</span></dt><dd><span>{{$ctrl.documentFile.authorUser | fullUserName}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.inspectorUser">inspectorUser</span></dt><dd><span>{{$ctrl.documentFile.inspectorUser | fullUserName}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.approverUser">approverUser</span></dt><dd><span>{{$ctrl.documentFile.approverUser | fullUserName}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.state"></span></dt><dd><span>{{\'abcQualityMatchApp.documentFile.states.\' + $ctrl.documentFile.state | translate}}</span></dd><dt><span data-translate="abcQualityMatchApp.documentFile.maintainers"></span></dt><dd><ul class="list-unstyled"><li ng-repeat="user in $ctrl.documentFile.maintainers  | orderBy:\'lastName\' track by user.id">{{user|fullUserName}}</li></ul></dd><dt><span data-translate="abcQualityMatchApp.documentFile.creationMotives"></span></dt><dd><div class="creation-motives">{{$ctrl.documentFile.creationMotives}}</div></dd></dl>');
$templateCache.put('app/document/document-tree/document-file/edit-dialog/document-file-edit-dialog.html','<div class="document document-edit-dialog"><form class="edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" id="myDocumentFileLabel">{{\'abcQualityMatchApp.documentFile.editDialogTitle.\' + vm.useCase | translate}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="alert alert-info" ng-if="vm.useCase == \'newVersion\'"><span data-translate="abcQualityMatchApp.documentFile.newVersionPrefilledContentHelp"></span></div><uib-tabset active="0"><uib-tab index="0" heading="{{\'abcQualityMatchApp.documentFile.tabTitle.file\' |translate}}"><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.documentFile.folder">folder</label><document-folder-select folder-id="vm.documentFile.folderId" allow-initial-value="true"></document-folder-select><div><p class="help-block" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><div class="alert alert-info documentfile-upload-alert" ng-show="vm.preparingSelectedFile"><div class="upload-spinner"></div><div><strong data-translate="abcQualityMatchApp.document.documentFileDownInProgressTitle">Uploading</strong><br><span data-translate="abcQualityMatchApp.document.documentFileDownInProgressMessage">Please wait</span></div></div><div class="alert alert-danger" ng-show="vm.selectedFileTooLarge"><span data-translate="abcQualityMatchApp.document.documentFileIsTooLargeMessage"></span></div><label class="control-label" ng-class="{required: vm.requireFileSelect}" data-translate="abcQualityMatchApp.documentFile.file">file</label><span><span>{{vm.documentFile.fileName}}</span>&nbsp; <button ngf-select ngf-change="vm.setFileContent($file, $invalidFiles)" ngf-max-size="20MB" class="btn btn-primary btn-sm" ng-disabled="vm.preparingSelectedFile" ng-if="vm.allowFileSelect"><span class="glyphicon glyphicon-file"></span> <span data-translate="abcQualityMatchApp.document.addDocumentFileButton">File</span></button></span><div ng-if="!vm.allowFileSelect"><p class="help-block" data-translate="abcQualityMatchApp.documentFile.fileSelectDisabledHelp"></p></div><div ng-if="vm.requireFileSelect"><p class="help-block" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label required" data-translate="abcQualityMatchApp.documentFile.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.documentFile.name" required><div><p class="help-block" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFile.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.documentFile.description"></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFile.classification" for="field_classification">classification</label><input type="text" class="form-control" name="classification" id="field_classification" ng-model="vm.documentFile.classification"></div><hr><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFile.validityEndDate" for="field_validityEndDate">validityEndDate</label><div class="input-group dateInputGroup"><input id="field_validityEndDate" type="text" class="form-control" name="validityEndDate" uib-datepicker-popup ng-model="vm.documentFile.validityEndDate" is-open="vm.datePickerOpenStatus.validityEndDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validityEndDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFile.validityEndAlertDate" for="field_validityEndAlertDate">validityEndAlertDate</label><div class="input-group dateInputGroup"><input id="field_validityEndAlertDate" type="text" class="form-control" name="validityEndAlertDate" uib-datepicker-popup ng-model="vm.documentFile.validityEndAlertDate" is-open="vm.datePickerOpenStatus.validityEndAlertDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'validityEndAlertDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><hr><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFile.authorUser">authorUser</label><user-select user="vm.documentFile.authorUser"></user-select></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFile.maintainers">maintainers</label><users-multiple-select users="vm.documentFile.maintainers"></users-multiple-select></div></uib-tab><uib-tab index="1" heading="{{\'abcQualityMatchApp.documentFile.tabTitle.acceptance\' |translate}}"><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFile.inspectorUser">inspectorUser</label><user-select user="vm.documentFile.inspectorUser"></user-select></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFile.inspectionDate" for="field_inspectionDate">inspectionDate</label><div class="input-group dateInputGroup"><input id="field_inspectionDate" type="text" class="form-control" name="inspectionDate" uib-datepicker-popup ng-model="vm.documentFile.inspectionDate" is-open="vm.datePickerOpenStatus.inspectionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'inspectionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><hr><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFile.approverUser">approverUser</label><user-select user="vm.documentFile.approverUser"></user-select></div><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFile.approvalDate" for="field_approvalDate">approvalDate</label><div class="input-group dateInputGroup"><input id="field_approvalDate" type="text" class="form-control" name="approvalDate" uib-datepicker-popup ng-model="vm.documentFile.approvalDate" is-open="vm.datePickerOpenStatus.approvalDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'approvalDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><hr><div class="form-group"><label class="control-label" data-translate="abcQualityMatchApp.documentFile.publishedDate" for="field_publishedDate">publishedDate</label><div class="input-group dateInputGroup"><input id="field_publishedDate" type="text" class="form-control" name="publishedDate" uib-datepicker-popup ng-model="vm.documentFile.publishedDate" is-open="vm.datePickerOpenStatus.publishedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'publishedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><hr><div class="form-group"><label class="control-label" for="field_state" data-translate="abcQualityMatchApp.documentFile.state">state</label><select class="form-control" name="state" ng-model="vm.documentFile.state" id="field_state" ng-if="vm.allowStateSelect"><option value="DRAFT" data-translate="abcQualityMatchApp.documentFile.states.DRAFT"></option><option value="INSPECTED" data-translate="abcQualityMatchApp.documentFile.states.INSPECTED"></option><option value="APPROVED" data-translate="abcQualityMatchApp.documentFile.states.APPROVED"></option><option value="PUBLISHED" data-translate="abcQualityMatchApp.documentFile.states.PUBLISHED"></option></select><span ng-if="!vm.allowStateSelect">{{\'abcQualityMatchApp.documentFile.states.\' + vm.documentFile.state | translate}}</span><div class="alert alert-warning" ng-if="vm.allowStateSelect && vm.documentFile.state == \'PUBLISHED\' "><span data-translate="abcQualityMatchApp.documentFile.stateChangeToPublishedWarning"></span></div></div></uib-tab><uib-tab index="2" heading="{{\'abcQualityMatchApp.documentFile.tabTitle.creationMotives\' |translate}}"><div class="form-group"><label class="control-label" for="field_creationMotivation" data-translate="abcQualityMatchApp.documentFile.creationMotives">state</label><textarea class="form-control" id="field_creationMotivation" rows="20" ng-model="vm.documentFile.creationMotives"></textarea></div></uib-tab></uib-tabset></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="!vm.documentFile.folderId ||  editForm.$invalid || vm.isSaving || (vm.requireFileSelect && !vm.fileContent)" class="btn btn-primary" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp; <span data-translate="entity.action.save">Save</span></button></div></form></div>');
$templateCache.put('app/document/document-tree/document-folder/document-folder-select-component/document-folder-select-component.html','<div class="btn-group document" uib-dropdown style="display: inline-block"><button id="pathSelectButton" class="btn btn-default" uib-dropdown-toggle><span class="glyphicon glyphicon-folder-close"></span> <span class="folder-select-foldername">{{$ctrl.selectedFolder.name}}</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="pathSelectButton"><li role="menuitem" ng-repeat="folder in $ctrl.folders track by folder.id" ng-class="{\'disabled\': folder.disabled || !folder.writable}" ng-click="$ctrl.selectFolder(folder)"><a href="javascript:void(0)"><span style="padding-left: {{folder.nestingLevel}}em">{{folder.name}}&nbsp;</span></a></li></ul></div>');}]);})();